import { t as e } from "./defineProperty-BHOl9uvt.js";
import t, { css as n } from "styled-components";
import * as r from "react";
import i, { Component as a, Suspense as o, createContext as s, lazy as c, useCallback as l, useContext as u, useEffect as d, useLayoutEffect as f, useMemo as p, useRef as m, useState as h } from "react";
import { Fragment as g, jsx as _, jsxs as v } from "react/jsx-runtime";
import * as y from "react-dom";
import b from "moment";
import x from "@microlink/react";
//#region \0rolldown/runtime.js
var S = Object.create, C = Object.defineProperty, w = Object.getOwnPropertyDescriptor, T = Object.getOwnPropertyNames, E = Object.getPrototypeOf, D = Object.prototype.hasOwnProperty, O = (e, t) => () => (t || (e((t = { exports: {} }).exports, t), e = null), t.exports), k = (e, t, n, r) => {
	if (t && typeof t == "object" || typeof t == "function") for (var i = T(t), a = 0, o = i.length, s; a < o; a++) s = i[a], !D.call(e, s) && s !== n && C(e, s, {
		get: ((e) => t[e]).bind(null, s),
		enumerable: !(r = w(t, s)) || r.enumerable
	});
	return e;
}, A = (e, t, n) => (n = e == null ? {} : S(E(e)), k(t || !e || !e.__esModule || !D.call(e, "default") ? C(n, "default", {
	value: e,
	enumerable: !0
}) : n, e)), j = /* @__PURE__ */ ((e) => typeof require < "u" ? require : typeof Proxy < "u" ? new Proxy(e, { get: (e, t) => (typeof require < "u" ? require : e)[t] }) : e)(function(e) {
	if (typeof require < "u") return require.apply(this, arguments);
	throw Error("Calling `require` for \"" + e + "\" in an environment that doesn't expose the `require` function. See https://rolldown.rs/in-depth/bundling-cjs#require-external-modules for more details.");
}), M = t;
!typeof t.div === "function" && (M = t.default);
var N = M, P = N.div`
  font-family: Helvetica Neue;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 14px;\n          line-height: 18px;\n          letter-spacing: -0.025em;\n        ";
		case "subheading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 12px;\n          line-height: 15px;\n          letter-spacing: -0.04em;\n          ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 14px;\n          line-height: 20px;\n          white-space: pre-line;\n        ";
	}
}};
`, F = Object.defineProperty, I = (e, t) => F(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function L(e, t) {
	let n = r.createContext(t);
	n.displayName = e + "Context";
	let i = /* @__PURE__ */ I((e) => {
		let { children: t, ...i } = e, a = r.useMemo(() => i, Object.values(i));
		return /* @__PURE__ */ _(n.Provider, {
			value: a,
			children: t
		});
	}, "Provider");
	i.displayName = e + "Provider";
	function a(i, a = {}) {
		let { optional: o = !1 } = a, s = r.useContext(n);
		if (s) return s;
		if (t !== void 0) return t;
		if (!o) throw Error(`\`${i}\` must be used within \`${e}\``);
	}
	return I(a, "useContext"), [i, a];
}
I(L, "createContext");
// @__NO_SIDE_EFFECTS__
function ee(e, t = []) {
	let n = [];
	function i(t, i) {
		let a = r.createContext(i);
		a.displayName = t + "Context";
		let o = n.length;
		n = [...n, i];
		let s = /* @__PURE__ */ I((t) => {
			let { scope: n, children: i, ...s } = t, c = n?.[e]?.[o] || a, l = r.useMemo(() => s, Object.values(s));
			return /* @__PURE__ */ _(c.Provider, {
				value: l,
				children: i
			});
		}, "Provider");
		s.displayName = t + "Provider";
		function c(n, s, c = {}) {
			let { optional: l = !1 } = c, u = s?.[e]?.[o] || a, d = r.useContext(u);
			if (d) return d;
			if (i !== void 0) return i;
			if (!l) throw Error(`\`${n}\` must be used within \`${t}\``);
		}
		return I(c, "useContext"), [s, c];
	}
	I(i, "createContext");
	let a = /* @__PURE__ */ I(() => {
		let t = n.map((e) => r.createContext(e));
		return /* @__PURE__ */ I(function(n) {
			let i = n?.[e] || t;
			return r.useMemo(() => ({ [`__scope${e}`]: {
				...n,
				[e]: i
			} }), [n, i]);
		}, "useScope");
	}, "createScope");
	return a.scopeName = e, [i, te(a, ...t)];
}
I(ee, "createContextScope");
function te(...e) {
	let t = e[0];
	if (e.length === 1) return t;
	let n = /* @__PURE__ */ I(() => {
		let n = e.map((e) => ({
			useScope: e(),
			scopeName: e.scopeName
		}));
		return /* @__PURE__ */ I(function(e) {
			let i = n.reduce((t, { useScope: n, scopeName: r }) => {
				let i = n(e)[`__scope${r}`];
				return {
					...t,
					...i
				};
			}, {});
			return r.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
		}, "useComposedScopes");
	}, "createScope");
	return n.scopeName = t.scopeName, n;
}
I(te, "composeContextScopes");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-callback-ref@1.1.4_@types+react@18.3.28_react@18.3.1/node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
var ne = Object.defineProperty, re = (e, t) => ne(e, "name", {
	value: t,
	configurable: !0
});
function R(e) {
	let t = r.useRef(e);
	return r.useEffect(() => {
		t.current = e;
	}), r.useMemo(() => ((...e) => t.current?.(...e)), []);
}
re(R, "useCallbackRef");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-use-layout-effect@1.1.4_@types+react@18.3.28_react@18.3.1/node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var ie = globalThis?.document ? r.useLayoutEffect : () => {}, ae = Object.defineProperty, oe = (e, t) => ae(e, "name", {
	value: t,
	configurable: !0
});
function se(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
oe(se, "setRef");
function ce(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = se(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : se(e[t], null);
			}
		};
	};
}
oe(ce, "composeRefs");
function le(...e) {
	return r.useCallback(ce(...e), e);
}
oe(le, "useComposedRefs");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-slot@1.3.3_@types+react@18.3.28_react@18.3.1/node_modules/@radix-ui/react-slot/dist/index.mjs
var ue = Object.defineProperty, z = (e, t) => ue(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function de(e) {
	let t = r.forwardRef((t, n) => {
		let { children: i, ...a } = t, o = null, s = !1, c = [];
		ve(i) && typeof Se == "function" && (i = Se(i._payload)), r.Children.forEach(i, (e) => {
			if (_e(e)) {
				s = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				ve(n) && typeof Se == "function" && (n = Se(n._payload)), o = me(t, n), c.push(o?.props?.children);
			} else c.push(e);
		}), o ? o = r.cloneElement(o, void 0, c) : !s && r.Children.count(i) === 1 && r.isValidElement(i) && (o = i);
		let l = o ? ge(o) : void 0, u = le(n, l);
		if (!o) {
			if (i || i === 0) throw Error(s ? xe(e) : be(e));
			return i;
		}
		let d = he(a, o.props ?? {});
		return o.type !== r.Fragment && (d.ref = n ? u : l), r.cloneElement(o, d);
	});
	return t.displayName = `${e}.Slot`, t;
}
z(de, "createSlot");
var fe = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function pe(e) {
	let t = /* @__PURE__ */ z((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = fe, t;
}
z(pe, "createSlottable");
var me = /* @__PURE__ */ z((e, t) => {
	if ("child" in e.props) {
		let t = e.props.child;
		return r.isValidElement(t) ? r.cloneElement(t, void 0, e.props.children(t.props.children)) : null;
	}
	return r.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function he(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
z(he, "mergeProps");
function ge(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
z(ge, "getElementRef");
function _e(e) {
	return r.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === fe;
}
z(_e, "isSlottable");
var B = Symbol.for("react.lazy");
function ve(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === B && "_payload" in e && ye(e._payload);
}
z(ve, "isLazyComponent");
function ye(e) {
	return typeof e == "object" && !!e && "then" in e;
}
z(ye, "isPromiseLike");
var be = /* @__PURE__ */ z((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), xe = /* @__PURE__ */ z((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), Se = r.use, Ce = Object.defineProperty, we = (e, t) => Ce(e, "name", {
	value: t,
	configurable: !0
}), Te = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"select",
	"span",
	"svg",
	"ul"
].reduce((e, t) => {
	let n = /* @__PURE__ */ de(`Primitive.${t}`), i = r.forwardRef((e, r) => {
		let { asChild: i, ...a } = e, o = i ? n : t;
		return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ _(o, {
			...a,
			ref: r
		});
	});
	return i.displayName = `Primitive.${t}`, {
		...e,
		[t]: i
	};
}, {});
function Ee(e, t) {
	e && y.flushSync(() => e.dispatchEvent(t));
}
we(Ee, "dispatchDiscreteCustomEvent");
//#endregion
//#region ../../node_modules/.pnpm/@radix-ui+react-avatar@1.2.6_@types+react-dom@18.3.7_@types+react@18.3.28__@types+react_a0a146f510519e989033266fefd208aa/node_modules/@radix-ui/react-avatar/dist/index.mjs
var De = Object.defineProperty, Oe = (e, t) => De(e, "name", {
	value: t,
	configurable: !0
}), ke = "Avatar", [Ae, je] = /* @__PURE__ */ ee(ke), Me = [0, () => void 0], [Ne, Pe] = Ae(ke), Fe = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ Oe(function(e, t) {
	let { __scopeAvatar: n, ...i } = e, [a, o] = r.useState("idle"), [s, c] = He();
	return /* @__PURE__ */ _(Ne, {
		scope: n,
		imageLoadingStatus: a,
		setImageLoadingStatus: o,
		imageCount: s,
		setImageCount: c,
		children: /* @__PURE__ */ _(Te.span, {
			...i,
			ref: t
		})
	});
}, "Avatar")), Ie = "AvatarImage", Le = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ Oe(function(e, t) {
	let { __scopeAvatar: n, src: i, onLoadingStatusChange: a, ...o } = e, s = Pe(Ie, n);
	s.setImageCount;
	let c = Be(i, {
		referrerPolicy: o.referrerPolicy,
		crossOrigin: o.crossOrigin,
		loadingStatus: s.imageLoadingStatus,
		setLoadingStatus: s.setImageLoadingStatus
	}), l = R((e) => {
		a?.(e);
	}), u = r.useRef(c);
	return ie(() => {
		let e = u.current;
		u.current = c, c !== e && l(c);
	}, [c, l]), c === "loaded" ? /* @__PURE__ */ _(Te.img, {
		...o,
		ref: t,
		src: i
	}) : null;
}, "AvatarImage")), Re = "AvatarFallback", ze = /* @__PURE__ */ r.forwardRef(/* @__PURE__ */ Oe(function(e, t) {
	let { __scopeAvatar: n, delayMs: i, ...a } = e, o = Pe(Re, n), [s, c] = r.useState(i === void 0);
	return r.useEffect(() => {
		if (i !== void 0) {
			let e = window.setTimeout(() => c(!0), i);
			return () => window.clearTimeout(e);
		}
	}, [i]), s && o.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ _(Te.span, {
		...a,
		ref: t
	}) : null;
}, "AvatarFallback"));
function Be(e, { loadingStatus: t, setLoadingStatus: n, referrerPolicy: r, crossOrigin: i }) {
	return ie(() => {
		if (!e) {
			n("error");
			return;
		}
		let t = new window.Image(), a = /* @__PURE__ */ Oe((e) => {
			let t = e.currentTarget;
			n(Ve(t));
		}, "handleLoad"), o = /* @__PURE__ */ Oe(() => n("error"), "handleError");
		return t.addEventListener("load", a), t.addEventListener("error", o), r && (t.referrerPolicy = r), t.crossOrigin = i ?? null, t.src = e, n(Ve(t)), () => {
			t.removeEventListener("load", a), t.removeEventListener("error", o), n("idle");
		};
	}, [
		e,
		i,
		r,
		n
	]), t;
}
Oe(Be, "useImageLoadingStatus");
function Ve(e) {
	return e.complete ? e.naturalWidth > 0 ? "loaded" : "error" : "loading";
}
Oe(Ve, "getImageLoadingStatus");
function He() {
	return Me;
}
Oe(He, "useImageCount");
function Ue(e) {}
Oe(Ue, "useUpdateImageCount");
//#endregion
//#region lib/components/Avatar.jsx
var We = N(Fe)`
  display: grid;
  place-content: center;
  height: 100%;

  img {
    width: 100%;
    border-radius: 50%;
  }

  span {
    font-size: 1rem;
  }
`, Ge = ({ src: e, alt: t, ...n }) => {
	let r = t.substring(0, 2).toUpperCase();
	return /* @__PURE__ */ v(We, {
		...n,
		children: [/* @__PURE__ */ _(Le, {
			src: e,
			alt: t
		}), /* @__PURE__ */ _(ze, { children: r })]
	});
}, Ke = ({ username: e, profilePicture: t, locationName: n, small: r, collabs: i }) => {
	if (Array.isArray(i) && i.length > 1) {
		let t = $e(i);
		return /* @__PURE__ */ _("div", {
			className: "sp-flex sp-items-center",
			children: /* @__PURE__ */ v(Ze, { children: [
				/* @__PURE__ */ v(qe, { children: [/* @__PURE__ */ _(Ye, {
					src: i[1].profilePictureUrl,
					alt: e
				}), /* @__PURE__ */ _(Xe, {
					src: i[0].profilePictureUrl,
					alt: e
				})] }),
				" ",
				t
			] })
		});
	}
	return /* @__PURE__ */ v("div", {
		className: "sp-flex sp-items-center",
		children: [/* @__PURE__ */ _("div", {
			className: "sp-rounded-full sp-overflow-hidden sp-m-4",
			style: {
				width: "35px",
				height: "35px"
			},
			children: /* @__PURE__ */ _(Ge, {
				src: t,
				alt: e
			})
		}), /* @__PURE__ */ v("div", {
			className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${r ? "sp-text-white" : ""}`,
			children: [/* @__PURE__ */ _(P, {
				$variant: "heading",
				children: e
			}), n && /* @__PURE__ */ _(P, {
				$variant: "subheading",
				children: n
			})]
		})]
	});
}, qe = N.div`
  overflow: hidden;
  margin-left: 10px;
  margin-right: 4px;
  width: 38px;
  height: 38px;
`, Je = N(Ge)`
  border: 1px solid white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  position: relative;
`, Ye = N(Je)`
  left: 12px;

  > img {
    max-width: 24px;
    max-height: 24px;
  }
`, Xe = N(Je)`
  top: -14px;
  > img {
    max-width: 24px;
    max-height: 24px;
    border: 1px solid white;
  }
`, Ze = N.div`
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: Inter, Helvetica, Arial, sans-serif;
  margin-bottom: 10px;
  margin-top: 10px;
  font-size: 14px;
`, Qe = N.span`
  color: #000000;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
`;
function $e(e) {
	return e.length < 2 ? null : e.length === 2 ? /* @__PURE__ */ _(Qe, { children: `${e[0].username} and ${e[1].username}` }) : /* @__PURE__ */ _(Qe, { children: `${e[0].username} and ${e.length - 1} others` });
}
//#endregion
//#region lib/images/instagram/icon-product.svg?react
var et = (e) => /* @__PURE__ */ _("svg", {
	width: 16,
	height: 20,
	viewBox: "0 0 16 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ _("path", {
		d: "M15.2622 5.61017C15.2411 5.20965 14.9038 4.87236 14.4822 4.87236H11.9526V4.15563C11.9526 1.96327 10.2451 0.0871172 8.0527 0.0027957C5.75494 -0.0815258 3.85771 1.75247 3.85771 4.02915V4.87236H1.30698C1.11726 4.87236 0.927536 4.95668 0.779974 5.08316C0.611331 5.23073 0.527009 5.44153 0.527009 5.63125L0 18.6589C0 18.8697 0.0843216 19.0594 0.231884 19.207C0.379447 19.3546 0.56917 19.4389 0.779974 19.4389H15.22C15.4308 19.4389 15.6206 19.3546 15.7681 19.207C15.9157 19.0594 16 18.8486 16 18.6168L15.2622 5.61017ZM8.11594 1.56274C9.40184 1.68922 10.3505 2.80648 10.3505 4.11347V4.85128H5.43874V4.02915C5.41765 2.5746 6.6614 1.41518 8.11594 1.56274Z",
		fill: "white"
	})
}), tt = (e) => /* @__PURE__ */ _("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 108.56 122.88",
	style: { enableBackground: "new 0 0 108.56 122.88" },
	xmlSpace: "preserve",
	fill: "#fff",
	...e,
	children: /* @__PURE__ */ _("g", { children: /* @__PURE__ */ _("path", { d: "M30.47,16.05h12.47l-6.35-7.16c-1.96-2.21-1.75-5.59,0.46-7.55c2.21-1.96,5.59-1.75,7.55,0.46l9.11,10.27L62.81,1.8 c1.96-2.21,5.34-2.42,7.55-0.46c2.21,1.96,2.42,5.34,0.46,7.55l-6.35,7.16h13.62c8.4,0,16.04,3.43,21.57,8.96 c5.49,5.49,8.9,13.05,8.9,21.35v46.21c0,8.3-3.41,15.86-8.9,21.35c-5.53,5.53-13.16,8.96-21.57,8.96H30.47 c-8.4,0-16.04-3.43-21.57-8.96C3.41,108.43,0,100.87,0,92.57V46.36c0-8.3,3.41-15.86,8.9-21.35 C14.43,19.48,22.07,16.05,30.47,16.05L30.47,16.05z M27.88,75.18c-2.86,0.74-5.78-0.98-6.52-3.84c-0.74-2.86,0.98-5.78,3.84-6.52 l28.8-7.45c2.86-0.74,5.78,0.98,6.52,3.84c0.14,0.53,0.19,1.07,0.17,1.59l-0.32,6.38l19.17-5.52c2.84-0.81,5.79,0.83,6.61,3.67 c0.81,2.84-0.83,5.79-3.67,6.61l-26.02,7.5c-0.64,0.23-1.34,0.34-2.06,0.31c-2.95-0.14-5.23-2.65-5.1-5.6l0.33-6.58L27.88,75.18 L27.88,75.18z M78.09,26.48H30.47c-5.4,0-10.31,2.22-13.88,5.78c-3.6,3.6-5.84,8.59-5.84,14.1v46.21c0,5.51,2.24,10.5,5.84,14.1 c3.57,3.57,8.48,5.78,13.88,5.78h47.61c5.4,0,10.31-2.22,13.88-5.78c3.6-3.6,5.84-8.59,5.84-14.1V46.36c0-5.51-2.24-10.5-5.84-14.1 C88.4,28.69,83.49,26.48,78.09,26.48L78.09,26.48z" }) })
}), nt = (e) => /* @__PURE__ */ _("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 122.14 122.88",
	style: { enableBackground: "new 0 0 122.14 122.88" },
	xmlSpace: "preserve",
	fill: "#fff",
	...e,
	children: /* @__PURE__ */ _("g", { children: /* @__PURE__ */ _("path", { d: "M35.14,0H87c9.65,0,18.43,3.96,24.8,10.32c6.38,6.37,10.34,15.16,10.34,24.82v52.61c0,9.64-3.96,18.42-10.32,24.79 l-0.02,0.02c-6.38,6.37-15.16,10.32-24.79,10.32H35.14c-9.66,0-18.45-3.96-24.82-10.32l-0.24-0.27C3.86,105.95,0,97.27,0,87.74 V35.14c0-9.67,3.95-18.45,10.32-24.82S25.47,0,35.14,0L35.14,0z M91.51,31.02l0.07,0.11h21.6c-0.87-5.68-3.58-10.78-7.48-14.69 C100.9,11.64,94.28,8.66,87,8.66h-8.87L91.51,31.02L91.51,31.02z M81.52,31.13L68.07,8.66H38.57l13.61,22.47H81.52L81.52,31.13z M42.11,31.13L28.95,9.39c-4.81,1.16-9.12,3.65-12.51,7.05c-3.9,3.9-6.6,9.01-7.48,14.69H42.11L42.11,31.13z M113.48,39.79H8.66 v47.96c0,7.17,2.89,13.7,7.56,18.48l0.22,0.21c4.8,4.8,11.43,7.79,18.7,7.79H87c7.28,0,13.9-2.98,18.69-7.77l0.02-0.02 c4.79-4.79,7.77-11.41,7.77-18.69V39.79L113.48,39.79z M50.95,54.95l26.83,17.45c0.43,0.28,0.82,0.64,1.13,1.08 c1.22,1.77,0.77,4.2-1,5.42L51.19,94.67c-0.67,0.55-1.53,0.88-2.48,0.88c-2.16,0-3.91-1.75-3.91-3.91V58.15h0.02 c0-0.77,0.23-1.55,0.7-2.23C46.76,54.15,49.19,53.72,50.95,54.95L50.95,54.95L50.95,54.95z" }) })
}), rt = (e) => /* @__PURE__ */ v("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ _("path", {
		d: "M0.003125 15.4988C0.04375 15.1957 0.075 14.8895 0.128125 14.5895C0.5375 12.3863 1.6875 10.6645 3.5125 9.36758C4.775 10.5645 6.2625 11.1957 8 11.1926C9.73125 11.1926 11.2156 10.5676 12.4906 9.36133C12.7438 9.56133 13.0094 9.75195 13.2531 9.96758C14.7906 11.3332 15.6969 13.0363 15.9438 15.0832C15.9594 15.2207 15.9812 15.3613 16 15.4988C16 15.6645 16 15.8332 16 15.9988C10.6656 15.9988 5.33437 15.9988 0 15.9988C0.003125 15.8332 0.003125 15.6645 0.003125 15.4988Z",
		fill: "white"
	}), /* @__PURE__ */ _("path", {
		d: "M8.37828 -0.000976562C8.69391 0.0615234 9.01578 0.102148 9.32203 0.189648C11.197 0.711523 12.5845 2.3709 12.7783 4.31152C13.047 7.00215 11.072 9.36465 8.36891 9.58652C5.93453 9.78965 3.69391 8.05527 3.28141 5.6459C2.83766 3.0709 4.44703 0.670898 7.00015 0.105273C7.2064 0.0583984 7.41891 0.0333984 7.62828 -0.000976562C7.87828 -0.000976563 8.12828 -0.000976562 8.37828 -0.000976562Z",
		fill: "white"
	})]
});
//#endregion
//#region ../../node_modules/.pnpm/interweave@13.1.1_react@18.3.1/node_modules/interweave/esm/bundle-7aab7250.js
function it(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
var at = {
	a: {
		content: 9,
		self: !1,
		type: 105
	},
	address: {
		invalid: [
			"h1",
			"h2",
			"h3",
			"h4",
			"h5",
			"h6",
			"address",
			"article",
			"aside",
			"section",
			"div",
			"header",
			"footer"
		],
		self: !1
	},
	audio: { children: ["track", "source"] },
	br: {
		type: 9,
		void: !0
	},
	body: { content: 127 },
	button: {
		content: 8,
		type: 105
	},
	caption: {
		content: 1,
		parent: ["table"]
	},
	col: {
		parent: ["colgroup"],
		void: !0
	},
	colgroup: {
		children: ["col"],
		parent: ["table"]
	},
	details: {
		children: ["summary"],
		type: 97
	},
	dd: {
		content: 1,
		parent: ["dl"]
	},
	dl: {
		children: ["dt", "dd"],
		type: 1
	},
	dt: {
		content: 1,
		invalid: ["footer", "header"],
		parent: ["dl"]
	},
	figcaption: {
		content: 1,
		parent: ["figure"]
	},
	footer: { invalid: ["footer", "header"] },
	header: { invalid: ["footer", "header"] },
	hr: {
		type: 1,
		void: !0
	},
	img: { void: !0 },
	li: {
		content: 1,
		parent: [
			"ul",
			"ol",
			"menu"
		]
	},
	main: { self: !1 },
	ol: {
		children: ["li"],
		type: 1
	},
	picture: {
		children: ["source", "img"],
		type: 25
	},
	rb: { parent: ["ruby", "rtc"] },
	rp: { parent: ["ruby", "rtc"] },
	rt: {
		content: 8,
		parent: ["ruby", "rtc"]
	},
	rtc: {
		content: 8,
		parent: ["ruby"]
	},
	ruby: { children: [
		"rb",
		"rp",
		"rt",
		"rtc"
	] },
	source: {
		parent: [
			"audio",
			"video",
			"picture"
		],
		void: !0
	},
	summary: {
		content: 8,
		parent: ["details"]
	},
	table: {
		children: [
			"caption",
			"colgroup",
			"thead",
			"tbody",
			"tfoot",
			"tr"
		],
		type: 1
	},
	tbody: {
		parent: ["table"],
		children: ["tr"]
	},
	td: {
		content: 1,
		parent: ["tr"]
	},
	tfoot: {
		parent: ["table"],
		children: ["tr"]
	},
	th: {
		content: 1,
		parent: ["tr"]
	},
	thead: {
		parent: ["table"],
		children: ["tr"]
	},
	tr: {
		parent: [
			"table",
			"tbody",
			"thead",
			"tfoot"
		],
		children: ["th", "td"]
	},
	track: {
		parent: ["audio", "video"],
		void: !0
	},
	ul: {
		children: ["li"],
		type: 1
	},
	video: { children: ["track", "source"] },
	wbr: {
		type: 9,
		void: !0
	}
};
function ot(e) {
	return (t) => {
		at[t] = {
			...e,
			...at[t]
		};
	};
}
[
	"address",
	"main",
	"div",
	"figure",
	"p",
	"pre"
].forEach(ot({
	content: 1,
	type: 65
})), [
	"abbr",
	"b",
	"bdi",
	"bdo",
	"cite",
	"code",
	"data",
	"dfn",
	"em",
	"i",
	"kbd",
	"mark",
	"q",
	"ruby",
	"samp",
	"strong",
	"sub",
	"sup",
	"time",
	"u",
	"var"
].forEach(ot({
	content: 8,
	type: 73
})), ["p", "pre"].forEach(ot({
	content: 8,
	type: 65
})), [
	"s",
	"small",
	"span",
	"del",
	"ins"
].forEach(ot({
	content: 8,
	type: 9
})), [
	"article",
	"aside",
	"footer",
	"header",
	"nav",
	"section",
	"blockquote"
].forEach(ot({
	content: 1,
	type: 67
})), [
	"h1",
	"h2",
	"h3",
	"h4",
	"h5",
	"h6"
].forEach(ot({
	content: 8,
	type: 69
})), [
	"audio",
	"canvas",
	"iframe",
	"img",
	"video"
].forEach(ot({ type: 89 }));
var st = Object.freeze(at), ct = [
	"applet",
	"base",
	"body",
	"command",
	"embed",
	"frame",
	"frameset",
	"head",
	"html",
	"link",
	"meta",
	"noscript",
	"object",
	"script",
	"style",
	"title"
], lt = Object.keys(st).filter((e) => e !== "canvas" && e !== "iframe"), ut = Object.freeze({
	alt: 1,
	cite: 1,
	class: 1,
	colspan: 3,
	controls: 4,
	datetime: 1,
	default: 4,
	disabled: 4,
	dir: 1,
	height: 1,
	href: 1,
	id: 1,
	kind: 1,
	label: 1,
	lang: 1,
	loading: 1,
	loop: 4,
	media: 1,
	muted: 4,
	poster: 1,
	rel: 1,
	role: 1,
	rowspan: 3,
	scope: 1,
	sizes: 1,
	span: 3,
	start: 3,
	style: 5,
	src: 1,
	srclang: 1,
	srcset: 1,
	tabindex: 1,
	target: 1,
	title: 1,
	type: 1,
	width: 1
}), dt = Object.freeze({
	class: "className",
	colspan: "colSpan",
	datetime: "dateTime",
	rowspan: "rowSpan",
	srclang: "srcLang",
	srcset: "srcSet",
	tabindex: "tabIndex"
});
function ft() {
	return ft = Object.assign || function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, ft.apply(this, arguments);
}
function pt({ attributes: e = {}, className: t, children: n = null, selfClose: r = !1, tagName: a }) {
	let o = a;
	return r ? /*#__PURE__*/ i.createElement(o, ft({ className: t }, e)) : /*#__PURE__*/ i.createElement(o, ft({ className: t }, e), n);
}
var mt = class {
	attribute(e, t) {
		return t;
	}
	node(e, t) {
		return t;
	}
};
function ht(e, t, n, r = !1) {
	let i = e.match(t instanceof RegExp ? t : new RegExp(t, "i"));
	return i ? {
		match: i[0],
		void: r,
		...n(i),
		index: i.index,
		length: i[0].length,
		valid: !0
	} : null;
}
var gt = class {
	constructor(e, t, n) {
		if (it(this, "greedy", !1), it(this, "options", void 0), it(this, "propName", void 0), it(this, "inverseName", void 0), it(this, "factory", void 0), process.env.NODE_ENV !== "production" && (!e || e.toLowerCase() === "html")) throw Error(`The matcher name "${e}" is not allowed.`);
		this.options = { ...t }, this.propName = e, this.inverseName = `no${e.charAt(0).toUpperCase() + e.slice(1)}`, this.factory = n ?? null;
	}
	createElement(e, t) {
		let n = this.factory ? /*#__PURE__*/ i.createElement(this.factory, t, e) : this.replaceWith(e, t);
		if (process.env.NODE_ENV !== "production" && typeof n != "string" && !/*#__PURE__*/ i.isValidElement(n)) throw Error(`Invalid React element created from ${this.constructor.name}.`);
		return n;
	}
	doMatch(e, t, n, r = !1) {
		return ht(e, t, n, r);
	}
	onBeforeParse(e, t) {
		return e;
	}
	onAfterParse(e, t) {
		return e;
	}
}, _t = /* @__PURE__ */ A((/* @__PURE__ */ O(((e, t) => {
	var n = /["'&<>]/;
	t.exports = r;
	function r(e) {
		var t = "" + e, r = n.exec(t);
		if (!r) return t;
		var i, a = "", o = 0, s = 0;
		for (o = r.index; o < t.length; o++) {
			switch (t.charCodeAt(o)) {
				case 34:
					i = "&quot;";
					break;
				case 38:
					i = "&amp;";
					break;
				case 39:
					i = "&#39;";
					break;
				case 60:
					i = "&lt;";
					break;
				case 62:
					i = "&gt;";
					break;
				default: continue;
			}
			s !== o && (a += t.substring(s, o)), s = o + 1, a += i;
		}
		return s === o ? a : a + t.substring(s, o);
	}
})))());
function vt(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
var yt = /(url|image|image-set)\(/i, bt = class extends mt {
	attribute(e, t) {
		return e === "style" && Object.keys(t).forEach((e) => {
			String(t[e]).match(yt) && delete t[e];
		}), t;
	}
}, xt = 1, St = 3, Ct = /^<(!doctype|(html|head|body)(\s|>))/i, wt = /^(aria-|data-|\w+:)/iu, Tt = /{{{(\w+)\/?}}}/;
function Et() {
	if (!(typeof window > "u" || typeof document > "u")) return document.implementation.createHTMLDocument("Interweave");
}
var Dt = class {
	constructor(e, t = {}, n = [], r = []) {
		if (vt(this, "allowed", void 0), vt(this, "banned", void 0), vt(this, "blocked", void 0), vt(this, "container", void 0), vt(this, "content", []), vt(this, "props", void 0), vt(this, "matchers", void 0), vt(this, "filters", void 0), vt(this, "keyIndex", void 0), process.env.NODE_ENV !== "production" && e && typeof e != "string") throw TypeError("Interweave parser requires a valid string.");
		this.props = t, this.matchers = n, this.filters = [...r, new bt()], this.keyIndex = -1, this.container = this.createContainer(e || ""), this.allowed = new Set(t.allowList ?? lt), this.banned = new Set(ct), this.blocked = new Set(t.blockList);
	}
	applyAttributeFilters(e, t) {
		return this.filters.reduce((t, n) => t !== null && typeof n.attribute == "function" ? n.attribute(e, t) : t, t);
	}
	applyNodeFilters(e, t) {
		return this.filters.reduce((t, n) => t !== null && typeof n.node == "function" ? n.node(e, t) : t, t);
	}
	applyMatchers(e, t) {
		let n = {}, { props: r } = this, i = e, a = 0, o = null;
		return this.matchers.forEach((e) => {
			let s = e.asTag().toLowerCase(), c = this.getTagConfig(s);
			if (r[e.inverseName] || !this.isTagAllowed(s) || !this.canRenderChild(t, c)) return;
			let l = "";
			for (; i && (o = e.match(i));) {
				let { index: t, length: s, match: c, valid: u, void: d, ...f } = o, p = e.propName + String(a);
				t > 0 && (l += i.slice(0, t)), u ? (l += d ? `{{{${p}/}}}` : `{{{${p}}}}${c}{{{/${p}}}}`, this.keyIndex += 1, a += 1, n[p] = {
					children: c,
					matcher: e,
					props: {
						...r,
						...f,
						key: this.keyIndex
					}
				}) : l += c, e.greedy ? (i = l + i.slice(t + s), l = "") : i = i.slice(t + (s || c.length));
			}
			e.greedy || (i = l + i);
		}), a === 0 ? e : this.replaceTokens(i, n);
	}
	canRenderChild(e, t) {
		return !e.tagName || !t.tagName || e.void ? !1 : e.children.length > 0 ? e.children.includes(t.tagName) : e.invalid.length > 0 && e.invalid.includes(t.tagName) ? !1 : t.parent.length > 0 ? t.parent.includes(e.tagName) : !e.self && e.tagName === t.tagName ? !1 : !!(e && e.content & t.type);
	}
	convertLineBreaks(e) {
		let { noHtml: t, disableLineBreaks: n } = this.props;
		if (t || n || e.match(/<((?:\/[ a-z]+)|(?:[ a-z]+\/))>/gi)) return e;
		let r = e.replace(/\r\n/g, "\n");
		return r = r.replace(/\n{3,}/g, "\n\n\n"), r = r.replace(/\n/g, "<br/>"), r;
	}
	createContainer(e) {
		let t = (typeof global < "u" && global.INTERWEAVE_SSR_POLYFILL || Et)();
		if (!t) return;
		let n = this.props.containerTagName ?? "body", r = n === "body" || n === "fragment" ? t.body : t.createElement(n);
		if (e.match(Ct)) {
			if (process.env.NODE_ENV !== "production") throw Error("HTML documents as Interweave content are not supported.");
		} else r.innerHTML = this.convertLineBreaks(this.props.escapeHtml ? (0, _t.default)(e) : e);
		return r;
	}
	extractAttributes(e) {
		let { allowAttributes: t } = this.props, n = {}, r = 0;
		return e.nodeType !== xt || !e.attributes || ([...e.attributes].forEach((i) => {
			let { name: a, value: o } = i, s = a.toLowerCase(), c = ut[s] || ut[a];
			if (!this.isSafe(e) || !s.match(wt) && (!t && (!c || c === 2) || s.startsWith("on") || o.replace(/(\s|\0|&#x0([9AD]);)/, "").match(/(javascript|vbscript|livescript|xss):/i))) return;
			let l = s === "style" ? this.extractStyleAttribute(e) : o;
			c === 4 ? l = !0 : c === 3 ? l = Number.parseFloat(String(l)) : c !== 5 && (l = String(l)), n[dt[s] || s] = this.applyAttributeFilters(s, l), r += 1;
		}), r === 0) ? null : n;
	}
	extractStyleAttribute(e) {
		let t = {};
		return Array.from(e.style).forEach((n) => {
			let r = e.style[n];
			(typeof r == "string" || typeof r == "number") && (t[n.replace(/-([a-z])/g, (e, t) => String(t).toUpperCase())] = r);
		}), t;
	}
	getTagConfig(e) {
		let t = {
			children: [],
			content: 0,
			invalid: [],
			parent: [],
			self: !0,
			tagName: "",
			type: 0,
			void: !1
		};
		return st[e] ? {
			...t,
			...st[e],
			tagName: e
		} : t;
	}
	isSafe(e) {
		if (typeof HTMLAnchorElement < "u" && e instanceof HTMLAnchorElement) {
			let t = e.getAttribute("href");
			if (t != null && t.startsWith("#")) return !0;
			let n = e.protocol.toLowerCase();
			return n === ":" || n === "http:" || n === "https:" || n === "mailto:" || n === "tel:";
		}
		return !0;
	}
	isTagAllowed(e) {
		return this.banned.has(e) || this.blocked.has(e) ? !1 : this.props.allowElements || this.allowed.has(e);
	}
	parse() {
		return this.container ? this.parseNode(this.container, this.getTagConfig(this.container.nodeName.toLowerCase())) : [];
	}
	parseNode(e, t) {
		let { noHtml: n, noHtmlExceptMatchers: r, allowElements: a, transform: o, transformOnlyAllowList: s } = this.props, c = [], l = "";
		return [...e.childNodes].forEach((e) => {
			if (e.nodeType === xt) {
				let u = e.nodeName.toLowerCase(), d = this.getTagConfig(u);
				l && (c.push(l), l = "");
				let f = this.applyNodeFilters(u, e);
				if (!f) return;
				let p;
				if (o && !(s && !this.isTagAllowed(u))) {
					this.keyIndex += 1;
					let e = this.keyIndex;
					p = this.parseNode(f, d);
					let t = o(f, p, d);
					if (t === null) return;
					if (t !== void 0) {
						c.push(/*#__PURE__*/ i.cloneElement(t, { key: e }));
						return;
					}
					this.keyIndex = e - 1;
				}
				if (this.banned.has(u)) return;
				if (!(n || r && u !== "br") && this.isTagAllowed(u) && (a || this.canRenderChild(t, d))) {
					this.keyIndex += 1;
					let e = this.extractAttributes(f), t = { tagName: u };
					e && (t.attributes = e), d.void && (t.selfClose = d.void), c.push(/*#__PURE__*/ i.createElement(pt, {
						...t,
						key: this.keyIndex
					}, p ?? this.parseNode(f, d)));
				} else c = [...c, ...this.parseNode(f, d.tagName ? d : t)];
			} else if (e.nodeType === St) {
				let i = n && !r ? e.textContent : this.applyMatchers(e.textContent || "", t);
				Array.isArray(i) ? c = [...c, ...i] : l += i;
			}
		}), l && c.push(l), c;
	}
	replaceTokens(e, t) {
		if (!e.includes("{{{")) return e;
		let n = [], r = e, i = null;
		for (; i = r.match(Tt);) {
			let [e, a] = i, o = i.index, s = e.includes("/");
			if (process.env.NODE_ENV !== "production" && !t[a]) throw Error(`Token "${a}" found but no matching element to replace with.`);
			o > 0 && (n.push(r.slice(0, o)), r = r.slice(o));
			let { children: c, matcher: l, props: u } = t[a], d;
			if (s) d = e.length, n.push(l.createElement(c, u));
			else {
				let i = r.match(RegExp(`{{{/${a}}}}`));
				if (process.env.NODE_ENV !== "production" && !i) throw Error(`Closing token missing for interpolated element "${a}".`);
				d = i.index + i[0].length, n.push(l.createElement(this.replaceTokens(r.slice(e.length, i.index), t), u));
			}
			r = r.slice(d);
		}
		return r.length > 0 && n.push(r), n.length === 0 ? "" : n.length === 1 && typeof n[0] == "string" ? n[0] : n;
	}
};
function Ot(e) {
	let { attributes: t, className: n, containerTagName: r, content: a, emptyContent: o, parsedContent: s, tagName: c, noWrap: l } = e, u = r ?? c ?? "span", d = u === "fragment" || l, f;
	if (s) f = s;
	else {
		let t = new Dt(a ?? "", e).parse();
		t.length > 0 && (f = t);
	}
	return f || (f = o), d ? /*#__PURE__*/ i.createElement(i.Fragment, null, f) : /*#__PURE__*/ i.createElement(pt, {
		attributes: t,
		className: n,
		tagName: u
	}, f);
}
function kt(e) {
	let { attributes: t, className: n, content: r = "", disableFilters: a = !1, disableMatchers: o = !1, emptyContent: s = null, filters: c = [], matchers: l = [], onAfterParse: u = null, onBeforeParse: d = null, tagName: f = "span", noWrap: p = !1, ...m } = e, h = o ? [] : l, g = a ? [] : c, _ = d ? [d] : [], v = u ? [u] : [];
	h.forEach((e) => {
		e.onBeforeParse && _.push(e.onBeforeParse.bind(e)), e.onAfterParse && v.push(e.onAfterParse.bind(e));
	});
	let y = new Dt(_.reduce((t, n) => {
		let r = n(t, e);
		if (process.env.NODE_ENV !== "production" && typeof r != "string") throw TypeError("Interweave `onBeforeParse` must return a valid HTML string.");
		return r;
	}, r ?? ""), m, h, g), b = v.reduce((t, n) => {
		let r = n(t, e);
		if (process.env.NODE_ENV !== "production" && !Array.isArray(r)) throw TypeError("Interweave `onAfterParse` must return an array of strings and React elements.");
		return r;
	}, y.parse());
	return /*#__PURE__*/ i.createElement(Ot, {
		attributes: t,
		className: n,
		containerTagName: e.containerTagName,
		emptyContent: s,
		noWrap: p,
		parsedContent: b.length === 0 ? void 0 : b,
		tagName: f
	});
}
//#endregion
//#region ../../node_modules/.pnpm/interweave-autolink@5.1.2_interweave@13.1.1_react@18.3.1__react@18.3.1/node_modules/interweave-autolink/esm/index.js
function V(e, t = {}) {
	let n = e.map((e) => e.source).join(t.join ?? "");
	return t.capture ? n = `(${n})` : t.nonCapture && (n = `(?:${n})`), t.match && (n += t.match), new RegExp(n, t.flags ?? "");
}
var At = /[a-z0-9]/, jt = /(?:[a-zA-Z\u0400-\u04FF0-9\-_~!$&'()[\]\\/*+,;=.%]*)/, Mt = /(https?:\/\/)?/, Nt = V([/[a-z\u0400-\u04FF0-9\-_~!$&'()*+,;=.:]+/, /@/], {
	capture: !0,
	match: "?"
}), Pt = V([
	/(?:(?:[a-z0-9](?:[-a-z0-9_]*[a-z0-9])?)\.)*/,
	/(?:(?:[a-z0-9](?:[-a-z0-9]*[a-z0-9])?)\.)/,
	/(?:[a-z](?:[-a-z0-9]*[a-z0-9])?)/
], { capture: !0 }), Ft = /(?::(\d{1,5}))?/, It = V([/\//, V([/[-+a-z0-9!*';:=,.$/%[\]_~@|&]*/, /[-+a-z0-9/]/], {
	match: "*",
	nonCapture: !0
})], {
	capture: !0,
	match: "?"
}), Lt = V([/\?/, V([jt, /[a-z0-9_&=]/], {
	match: "?",
	nonCapture: !0
})], {
	capture: !0,
	match: "?"
}), Rt = V([/#/, V([jt, /[a-z0-9]/], {
	match: "?",
	nonCapture: !0
})], {
	capture: !0,
	match: "?"
}), zt = V([
	Mt,
	Nt,
	Pt,
	Ft,
	It,
	Lt,
	Rt
], { flags: "i" }), Bt = /(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)/;
V([
	Mt,
	Nt,
	V([
		Bt,
		Bt,
		Bt,
		Bt
	], {
		capture: !0,
		join: "\\."
	}),
	Ft,
	It,
	Lt,
	Rt
], { flags: "i" }), V([/#/, V([
	/[\d_\u4E00-\u9FFF-]+/,
	/[\d_\u3000-\u30FF-]+/,
	/[\d_\u1100-\u11FF\u3130-\u318F\uA960-\uA97F\uAC00-\uD7FF-]+/,
	/[\d_\u0E00-\u0E7F-]+/,
	/[\d_a-z\u0400-\u052F\u1C80-\u1C8F\u2DE0-\u2DFF\uA640-\uA69F-]+/,
	/[\d_a-z\u0080-\u00FF\u0100-\u017F\u0180-\u024F-]+/
], {
	capture: !0,
	join: "|"
})], { flags: "i" });
var Vt = V([V([
	At,
	/[.a-z0-9!#$%&?*+=_{|}~-]*/,
	At
], { capture: !0 }), Pt], {
	flags: "i",
	join: "@"
}), Ht = RegExp(`^${Vt.source}$`, Vt.flags), Ut = /* @__PURE__ */ "com.org.net.int.edu.gov.mil.aero.asia.biz.cat.coop.jobs.mobi.museum.post.tel.travel.xxx.app.arpa.test.ac.ad.ae.af.ag.ai.al.am.an.ao.aq.ar.as.at.au.aw.ax.az.ba.bb.bd.be.bf.bg.bh.bi.bj.bl.bm.bn.bo.bq.br.bs.bt.bv.bw.by.bz.ca.cc.cd.cf.cg.ch.ci.ck.cl.cm.cn.co.cr.cu.cv.cw.cx.cy.cz.de.dj.dk.dm.do.dz.ec.ee.eg.eh.er.es.et.eu.fi.fj.fk.fm.fo.fr.ga.gb.gd.ge.gf.gg.gh.gi.gl.gm.gn.gp.gq.gr.gs.gt.gu.gw.gy.hk.hm.hn.hr.ht.hu.id.ie.il.im.in.io.iq.ir.is.it.je.jm.jo.jp.ke.kg.kh.ki.km.kn.kp.kr.kw.ky.kz.la.lb.lc.li.lk.lr.ls.lt.lu.lv.ly.ma.mc.md.me.mf.mg.mh.mk.ml.mm.mn.mo.mp.mq.mr.ms.mt.mu.mv.mw.mx.my.mz.na.nc.ne.nf.ng.ni.nl.no.np.nr.nu.nz.om.pa.pe.pf.pg.ph.pk.pl.pm.pn.pr.ps.pt.pw.py.qa.re.ro.rs.ru.rw.sa.sb.sc.sd.se.sg.sh.si.sj.sk.sl.sm.sn.so.sr.st.su.sv.sx.sy.sz.tc.td.tf.tg.th.tj.tk.tl.tm.tn.to.tp.tr.tt.tv.tw.tz.ua.ug.uk.um.us.uy.uz.va.vc.ve.vg.vi.vn.vu.wf.ws.ye.yt.za.zm.zw".split(".");
function Wt() {
	return Wt = Object.assign || function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, Wt.apply(this, arguments);
}
function Gt({ children: e, href: t, onClick: n, newWindow: r }) {
	return /*#__PURE__*/ i.createElement("a", {
		href: t,
		rel: "noopener noreferrer",
		target: r ? "_blank" : void 0,
		onClick: n
	}, e);
}
function Kt({ children: e, url: t, urlParts: n, ...r }) {
	let a = t;
	return a.match(/^https?:\/\//) || (a = `http://${a}`), /*#__PURE__*/ i.createElement(Gt, Wt({}, r, { href: a }), e);
}
var qt = class extends gt {
	constructor(e, t, n) {
		super(e, {
			customTLDs: [],
			validateTLD: !0,
			...t
		}, n);
	}
	replaceWith(e, t) {
		return /*#__PURE__*/ i.createElement(Kt, t, e);
	}
	asTag() {
		return "a";
	}
	match(e) {
		let t = this.doMatch(e, zt, this.handleMatches);
		if (t != null && t.match.match(Ht) && (t.valid = !1), t != null && t.valid && this.options.validateTLD) {
			let { host: e } = t.urlParts, n = [...Ut, ...this.options.customTLDs ?? []], r = e.slice(e.lastIndexOf(".") + 1).toLowerCase();
			if (!n.includes(r)) return null;
		}
		return t;
	}
	handleMatches(e) {
		return {
			url: e[0],
			urlParts: {
				auth: e[2] ? e[2].slice(0, -1) : "",
				fragment: e[7] || "",
				host: e[3],
				path: e[5] || "",
				port: e[4] ? e[4] : "",
				query: e[6] || "",
				scheme: e[1] ? e[1].replace("://", "") : "http"
			}
		};
	}
}, H = /* @__PURE__ */ O(((e, t) => {
	var n = function(e) {
		return e && e.Math === Math && e;
	};
	t.exports = n(typeof globalThis == "object" && globalThis) || n(typeof window == "object" && window) || n(typeof self == "object" && self) || n(typeof global == "object" && global) || n(typeof e == "object" && e) || (function() {
		return this;
	})() || Function("return this")();
})), U = /* @__PURE__ */ O(((e, t) => {
	t.exports = function(e) {
		try {
			return !!e();
		} catch {
			return !0;
		}
	};
})), Jt = /* @__PURE__ */ O(((e, t) => {
	t.exports = !U()(function() {
		var e = function() {}.bind();
		return typeof e != "function" || e.hasOwnProperty("prototype");
	});
})), Yt = /* @__PURE__ */ O(((e, t) => {
	var n = Jt(), r = Function.prototype, i = r.apply, a = r.call;
	t.exports = typeof Reflect == "object" && Reflect.apply || (n ? a.bind(i) : function() {
		return a.apply(i, arguments);
	});
})), W = /* @__PURE__ */ O(((e, t) => {
	var n = Jt(), r = Function.prototype, i = r.call, a = n && r.bind.bind(i, i);
	t.exports = n ? a : function(e) {
		return function() {
			return i.apply(e, arguments);
		};
	};
})), Xt = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = n({}.toString), i = n("".slice);
	t.exports = function(e) {
		return i(r(e), 8, -1);
	};
})), Zt = /* @__PURE__ */ O(((e, t) => {
	var n = Xt(), r = W();
	t.exports = function(e) {
		if (n(e) === "Function") return r(e);
	};
})), G = /* @__PURE__ */ O(((e, t) => {
	var n = typeof document == "object" && document.all;
	t.exports = n === void 0 && n !== void 0 ? function(e) {
		return typeof e == "function" || e === n;
	} : function(e) {
		return typeof e == "function";
	};
})), Qt = /* @__PURE__ */ O(((e, t) => {
	t.exports = !U()(function() {
		return Object.defineProperty({}, 1, { get: function() {
			return 7;
		} })[1] !== 7;
	});
})), $t = /* @__PURE__ */ O(((e, t) => {
	var n = Jt(), r = Function.prototype.call;
	t.exports = n ? r.bind(r) : function() {
		return r.apply(r, arguments);
	};
})), en = /* @__PURE__ */ O(((e) => {
	var t = {}.propertyIsEnumerable, n = Object.getOwnPropertyDescriptor;
	e.f = n && !t.call({ 1: 2 }, 1) ? function(e) {
		var t = n(this, e);
		return !!t && t.enumerable;
	} : t;
})), tn = /* @__PURE__ */ O(((e, t) => {
	t.exports = function(e, t) {
		return {
			enumerable: !(e & 1),
			configurable: !(e & 2),
			writable: !(e & 4),
			value: t
		};
	};
})), nn = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = U(), i = Xt(), a = Object, o = n("".split);
	t.exports = r(function() {
		return !a("z").propertyIsEnumerable(0);
	}) ? function(e) {
		return i(e) === "String" ? o(e, "") : a(e);
	} : a;
})), rn = /* @__PURE__ */ O(((e, t) => {
	t.exports = function(e) {
		return e == null;
	};
})), an = /* @__PURE__ */ O(((e, t) => {
	var n = rn(), r = TypeError;
	t.exports = function(e) {
		if (n(e)) throw new r("Can't call method on " + e);
		return e;
	};
})), on = /* @__PURE__ */ O(((e, t) => {
	var n = nn(), r = an();
	t.exports = function(e) {
		return n(r(e));
	};
})), sn = /* @__PURE__ */ O(((e, t) => {
	var n = G();
	t.exports = function(e) {
		return typeof e == "object" ? e !== null : n(e);
	};
})), cn = /* @__PURE__ */ O(((e, t) => {
	t.exports = {};
})), ln = /* @__PURE__ */ O(((e, t) => {
	var n = cn(), r = H(), i = G(), a = function(e) {
		return i(e) ? e : void 0;
	};
	t.exports = function(e, t) {
		return arguments.length < 2 ? a(n[e]) || a(r[e]) : n[e] && n[e][t] || r[e] && r[e][t];
	};
})), un = /* @__PURE__ */ O(((e, t) => {
	t.exports = W()({}.isPrototypeOf);
})), dn = /* @__PURE__ */ O(((e, t) => {
	var n = H().navigator, r = n && n.userAgent;
	t.exports = r ? String(r) : "";
})), fn = /* @__PURE__ */ O(((e, t) => {
	var n = H(), r = dn(), i = n.process, a = n.Deno, o = i && i.versions || a && a.version, s = o && o.v8, c, l;
	s && (c = s.split("."), l = c[0] > 0 && c[0] < 4 ? 1 : +(c[0] + c[1])), !l && r && (c = r.match(/Edge\/(\d+)/), (!c || c[1] >= 74) && (c = r.match(/Chrome\/(\d+)/), c && (l = +c[1]))), t.exports = l;
})), pn = /* @__PURE__ */ O(((e, t) => {
	var n = fn(), r = U(), i = H().String;
	t.exports = !!Object.getOwnPropertySymbols && !r(function() {
		var e = Symbol("symbol detection");
		return !i(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && n && n < 41;
	});
})), mn = /* @__PURE__ */ O(((e, t) => {
	t.exports = pn() && !Symbol.sham && typeof Symbol.iterator == "symbol";
})), hn = /* @__PURE__ */ O(((e, t) => {
	var n = ln(), r = G(), i = un(), a = mn(), o = Object;
	t.exports = a ? function(e) {
		return typeof e == "symbol";
	} : function(e) {
		var t = n("Symbol");
		return r(t) && i(t.prototype, o(e));
	};
})), gn = /* @__PURE__ */ O(((e, t) => {
	var n = String;
	t.exports = function(e) {
		try {
			return n(e);
		} catch {
			return "Object";
		}
	};
})), _n = /* @__PURE__ */ O(((e, t) => {
	var n = G(), r = gn(), i = TypeError;
	t.exports = function(e) {
		if (n(e)) return e;
		throw new i(r(e) + " is not a function");
	};
})), vn = /* @__PURE__ */ O(((e, t) => {
	var n = _n(), r = rn();
	t.exports = function(e, t) {
		var i = e[t];
		return r(i) ? void 0 : n(i);
	};
})), yn = /* @__PURE__ */ O(((e, t) => {
	var n = $t(), r = G(), i = sn(), a = TypeError;
	t.exports = function(e, t) {
		var o, s;
		if (t === "string" && r(o = e.toString) && !i(s = n(o, e)) || r(o = e.valueOf) && !i(s = n(o, e)) || t !== "string" && r(o = e.toString) && !i(s = n(o, e))) return s;
		throw new a("Can't convert object to primitive value");
	};
})), bn = /* @__PURE__ */ O(((e, t) => {
	t.exports = !0;
})), xn = /* @__PURE__ */ O(((e, t) => {
	var n = H(), r = Object.defineProperty;
	t.exports = function(e, t) {
		try {
			r(n, e, {
				value: t,
				configurable: !0,
				writable: !0
			});
		} catch {
			n[e] = t;
		}
		return t;
	};
})), Sn = /* @__PURE__ */ O(((e, t) => {
	var n = bn(), r = H(), i = xn(), a = "__core-js_shared__", o = t.exports = r[a] || i(a, {});
	(o.versions || (o.versions = [])).push({
		version: "3.49.0",
		mode: n ? "pure" : "global",
		copyright: "© 2013–2025 Denis Pushkarev (zloirock.ru), 2025–2026 CoreJS Company (core-js.io). All rights reserved.",
		license: "https://github.com/zloirock/core-js/blob/v3.49.0/LICENSE",
		source: "https://github.com/zloirock/core-js"
	});
})), Cn = /* @__PURE__ */ O(((e, t) => {
	var n = Sn();
	t.exports = function(e, t) {
		return n[e] || (n[e] = t || {});
	};
})), wn = /* @__PURE__ */ O(((e, t) => {
	var n = an(), r = Object;
	t.exports = function(e) {
		return r(n(e));
	};
})), Tn = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = wn(), i = n({}.hasOwnProperty);
	t.exports = Object.hasOwn || function(e, t) {
		return i(r(e), t);
	};
})), En = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = 0, i = Math.random(), a = n(1.1.toString);
	t.exports = function(e) {
		return "Symbol(" + (e === void 0 ? "" : e) + ")_" + a(++r + i, 36);
	};
})), K = /* @__PURE__ */ O(((e, t) => {
	var n = H(), r = Cn(), i = Tn(), a = En(), o = pn(), s = mn(), c = n.Symbol, l = r("wks"), u = s ? c.for || c : c && c.withoutSetter || a;
	t.exports = function(e) {
		return i(l, e) || (l[e] = o && i(c, e) ? c[e] : u("Symbol." + e)), l[e];
	};
})), Dn = /* @__PURE__ */ O(((e, t) => {
	var n = $t(), r = sn(), i = hn(), a = vn(), o = yn(), s = K(), c = TypeError, l = s("toPrimitive");
	t.exports = function(e, t) {
		if (!r(e) || i(e)) return e;
		var s = a(e, l), u;
		if (s) {
			if (t === void 0 && (t = "default"), u = n(s, e, t), !r(u) || i(u)) return u;
			throw new c("Can't convert object to primitive value");
		}
		return t === void 0 && (t = "number"), o(e, t);
	};
})), On = /* @__PURE__ */ O(((e, t) => {
	var n = Dn(), r = hn();
	t.exports = function(e) {
		var t = n(e, "string");
		return r(t) ? t : t + "";
	};
})), kn = /* @__PURE__ */ O(((e, t) => {
	var n = H(), r = sn(), i = n.document, a = r(i) && r(i.createElement);
	t.exports = function(e) {
		return a ? i.createElement(e) : {};
	};
})), An = /* @__PURE__ */ O(((e, t) => {
	var n = Qt(), r = U(), i = kn();
	t.exports = !n && !r(function() {
		return Object.defineProperty(i("div"), "a", { get: function() {
			return 7;
		} }).a !== 7;
	});
})), jn = /* @__PURE__ */ O(((e) => {
	var t = Qt(), n = $t(), r = en(), i = tn(), a = on(), o = On(), s = Tn(), c = An(), l = Object.getOwnPropertyDescriptor;
	e.f = t ? l : function(e, t) {
		if (e = a(e), t = o(t), c) try {
			return l(e, t);
		} catch {}
		if (s(e, t)) return i(!n(r.f, e, t), e[t]);
	};
})), Mn = /* @__PURE__ */ O(((e, t) => {
	var n = U(), r = G(), i = /#|\.prototype\./, a = function(e, t) {
		var i = s[o(e)];
		return i === l ? !0 : i === c ? !1 : r(t) ? n(t) : !!t;
	}, o = a.normalize = function(e) {
		return String(e).replace(i, ".").toLowerCase();
	}, s = a.data = {}, c = a.NATIVE = "N", l = a.POLYFILL = "P";
	t.exports = a;
})), Nn = /* @__PURE__ */ O(((e, t) => {
	var n = Zt(), r = _n(), i = Jt(), a = n(n.bind);
	t.exports = function(e, t) {
		return r(e), t === void 0 ? e : i ? a(e, t) : function() {
			return e.apply(t, arguments);
		};
	};
})), Pn = /* @__PURE__ */ O(((e, t) => {
	var n = Qt(), r = U();
	t.exports = n && r(function() {
		return Object.defineProperty(function() {}, "prototype", {
			value: 42,
			writable: !1
		}).prototype !== 42;
	});
})), Fn = /* @__PURE__ */ O(((e, t) => {
	var n = sn(), r = String, i = TypeError;
	t.exports = function(e) {
		if (n(e)) return e;
		throw new i(r(e) + " is not an object");
	};
})), In = /* @__PURE__ */ O(((e) => {
	var t = Qt(), n = An(), r = Pn(), i = Fn(), a = On(), o = TypeError, s = Object.defineProperty, c = Object.getOwnPropertyDescriptor, l = "enumerable", u = "configurable", d = "writable";
	e.f = t ? r ? function(e, t, n) {
		if (i(e), t = a(t), i(n), typeof e == "function" && t === "prototype" && "value" in n && d in n && !n[d]) {
			var r = c(e, t);
			r && r[d] && (e[t] = n.value, n = {
				configurable: u in n ? n[u] : r[u],
				enumerable: l in n ? n[l] : r[l],
				writable: !1
			});
		}
		return s(e, t, n);
	} : s : function(e, t, r) {
		if (i(e), t = a(t), i(r), n) try {
			return s(e, t, r);
		} catch {}
		if ("get" in r || "set" in r) throw new o("Accessors not supported");
		return "value" in r && (e[t] = r.value), e;
	};
})), Ln = /* @__PURE__ */ O(((e, t) => {
	var n = Qt(), r = In(), i = tn();
	t.exports = n ? function(e, t, n) {
		return r.f(e, t, i(1, n));
	} : function(e, t, n) {
		return e[t] = n, e;
	};
})), q = /* @__PURE__ */ O(((e, t) => {
	var n = H(), r = Yt(), i = Zt(), a = G(), o = jn().f, s = Mn(), c = cn(), l = Nn(), u = Ln(), d = Tn();
	Sn();
	var f = function(e) {
		var t = function(n, i, a) {
			if (this instanceof t) {
				switch (arguments.length) {
					case 0: return new e();
					case 1: return new e(n);
					case 2: return new e(n, i);
				}
				return new e(n, i, a);
			}
			return r(e, this, arguments);
		};
		return t.prototype = e.prototype, t;
	};
	t.exports = function(e, t) {
		var r = e.target, p = e.global, m = e.stat, h = e.proto, g = p ? n : m ? n[r] : n[r] && n[r].prototype, _ = p ? c : c[r] || u(c, r, {})[r], v = _.prototype, y, b, x, S, C, w, T, E, D;
		for (S in t) y = s(p ? S : r + (m ? "." : "#") + S, e.forced), b = !y && g && d(g, S), w = _[S], b && (e.dontCallGetSet ? (D = o(g, S), T = D && D.value) : T = g[S]), C = b && T ? T : t[S], !(!y && !h && typeof w == typeof C) && (E = e.bind && b ? l(C, n) : e.wrap && b ? f(C) : h && a(C) ? i(C) : C, (e.sham || C && C.sham || w && w.sham) && u(E, "sham", !0), u(_, S, E), h && (x = r + "Prototype", d(c, x) || u(c, x, {}), u(c[x], S, C), e.real && v && (y || !v[S]) && u(v, S, C)));
	};
})), Rn = /* @__PURE__ */ O((() => {
	var e = q(), t = Qt(), n = In().f;
	e({
		target: "Object",
		stat: !0,
		forced: Object.defineProperty !== n,
		sham: !t
	}, { defineProperty: n });
})), zn = /* @__PURE__ */ O(((e, t) => {
	Rn();
	var n = cn().Object, r = t.exports = function(e, t, r) {
		return n.defineProperty(e, t, r);
	};
	n.defineProperty.sham && (r.sham = !0);
})), Bn = /* @__PURE__ */ O(((e, t) => {
	t.exports = zn();
})), Vn = /* @__PURE__ */ O(((e, t) => {
	t.exports = Bn();
})), Hn = /* @__PURE__ */ O(((e, t) => {
	function n(e) {
		return e && e.__esModule ? e : { default: e };
	}
	t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
})), Un = /* @__PURE__ */ O(((e, t) => {
	var n = Xt();
	t.exports = Array.isArray || function(e) {
		return n(e) === "Array";
	};
})), Wn = /* @__PURE__ */ O(((e, t) => {
	var n = K()("toStringTag"), r = {};
	r[n] = "z", t.exports = String(r) === "[object z]";
})), Gn = /* @__PURE__ */ O(((e, t) => {
	var n = Wn(), r = G(), i = Xt(), a = K()("toStringTag"), o = Object, s = i(function() {
		return arguments;
	}()) === "Arguments", c = function(e, t) {
		try {
			return e[t];
		} catch {}
	};
	t.exports = n ? i : function(e) {
		var t, n, l;
		return e === void 0 ? "Undefined" : e === null ? "Null" : typeof (n = c(t = o(e), a)) == "string" ? n : s ? i(t) : (l = i(t)) === "Object" && r(t.callee) ? "Arguments" : l;
	};
})), Kn = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = G(), i = Sn(), a = n(Function.toString);
	r(i.inspectSource) || (i.inspectSource = function(e) {
		return a(e);
	}), t.exports = i.inspectSource;
})), qn = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = U(), i = G(), a = Gn(), o = ln(), s = Kn(), c = function() {}, l = o("Reflect", "construct"), u = /^\s*(?:class|function)\b/, d = n(u.exec), f = !u.test(c), p = function(e) {
		if (!i(e)) return !1;
		try {
			return l(c, [], e), !0;
		} catch {
			return !1;
		}
	}, m = function(e) {
		if (!i(e)) return !1;
		switch (a(e)) {
			case "AsyncFunction":
			case "GeneratorFunction":
			case "AsyncGeneratorFunction": return !1;
		}
		try {
			return f || !!d(u, s(e));
		} catch {
			return !0;
		}
	};
	m.sham = !0, t.exports = !l || r(function() {
		var e;
		return p(p.call) || !p(Object) || !p(function() {
			e = !0;
		}) || e;
	}) ? m : p;
})), Jn = /* @__PURE__ */ O(((e, t) => {
	var n = Math.ceil, r = Math.floor;
	t.exports = Math.trunc || function(e) {
		var t = +e;
		return (t > 0 ? r : n)(t);
	};
})), Yn = /* @__PURE__ */ O(((e, t) => {
	var n = Jn();
	t.exports = function(e) {
		var t = +e;
		return t !== t || t === 0 ? 0 : n(t);
	};
})), Xn = /* @__PURE__ */ O(((e, t) => {
	var n = Yn(), r = Math.max, i = Math.min;
	t.exports = function(e, t) {
		var a = n(e);
		return a < 0 ? r(a + t, 0) : i(a, t);
	};
})), Zn = /* @__PURE__ */ O(((e, t) => {
	var n = Yn(), r = Math.min;
	t.exports = function(e) {
		var t = n(e);
		return t > 0 ? r(t, 9007199254740991) : 0;
	};
})), Qn = /* @__PURE__ */ O(((e, t) => {
	var n = Zn();
	t.exports = function(e) {
		return n(e.length);
	};
})), $n = /* @__PURE__ */ O(((e, t) => {
	var n = Qt(), r = In(), i = tn();
	t.exports = function(e, t, a) {
		n ? r.f(e, t, i(0, a)) : e[t] = a;
	};
})), er = /* @__PURE__ */ O(((e, t) => {
	var n = Qt(), r = Un(), i = TypeError, a = Object.getOwnPropertyDescriptor;
	t.exports = n && !function() {
		if (this !== void 0) return !0;
		try {
			Object.defineProperty([], "length", { writable: !1 }).length = 1;
		} catch (e) {
			return e instanceof TypeError;
		}
	}() ? function(e, t) {
		if (r(e) && !a(e, "length").writable) throw new i("Cannot set read only .length");
		return e.length = t;
	} : function(e, t) {
		return e.length = t;
	};
})), tr = /* @__PURE__ */ O(((e, t) => {
	var n = U(), r = K(), i = fn(), a = r("species");
	t.exports = function(e) {
		return i >= 51 || !n(function() {
			var t = [], n = t.constructor = {};
			return n[a] = function() {
				return { foo: 1 };
			}, t[e](Boolean).foo !== 1;
		});
	};
})), nr = /* @__PURE__ */ O(((e, t) => {
	t.exports = W()([].slice);
})), rr = /* @__PURE__ */ O((() => {
	var e = q(), t = Un(), n = qn(), r = sn(), i = Xn(), a = Qn(), o = on(), s = $n(), c = er(), l = K(), u = tr(), d = nr(), f = u("slice"), p = l("species"), m = Array, h = Math.max;
	e({
		target: "Array",
		proto: !0,
		forced: !f
	}, { slice: function(e, l) {
		var u = o(this), f = a(u), g = i(e, f), _ = i(l === void 0 ? f : l, f), v, y, b;
		if (t(u) && (v = u.constructor, n(v) && (v === m || t(v.prototype)) ? v = void 0 : r(v) && (v = v[p], v === null && (v = void 0)), v === m || v === void 0)) return d(u, g, _);
		for (y = new (v === void 0 ? m : v)(h(_ - g, 0)), b = 0; g < _; g++, b++) g in u && s(y, b, u[g]);
		return c(y, b), y;
	} });
})), ir = /* @__PURE__ */ O(((e, t) => {
	var n = H(), r = cn();
	t.exports = function(e, t) {
		var i = r[e + "Prototype"], a = i && i[t];
		if (a) return a;
		var o = n[e], s = o && o.prototype;
		return s && s[t];
	};
})), ar = /* @__PURE__ */ O(((e, t) => {
	rr(), t.exports = ir()("Array", "slice");
})), or = /* @__PURE__ */ O(((e, t) => {
	var n = un(), r = ar(), i = Array.prototype;
	t.exports = function(e) {
		var t = e.slice;
		return e === i || n(i, e) && t === i.slice ? r : t;
	};
})), sr = /* @__PURE__ */ O(((e, t) => {
	t.exports = or();
})), cr = /* @__PURE__ */ O(((e, t) => {
	t.exports = sr();
})), lr = /* @__PURE__ */ O(((e, t) => {
	var n = Gn(), r = String;
	t.exports = function(e) {
		if (n(e) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
		return r(e);
	};
})), ur = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = Yn(), i = lr(), a = an(), o = n("".charAt), s = n("".charCodeAt), c = n("".slice), l = function(e) {
		return function(t, n) {
			var l = i(a(t)), u = r(n), d = l.length, f, p;
			return u < 0 || u >= d ? e ? "" : void 0 : (f = s(l, u), f < 55296 || f > 56319 || u + 1 === d || (p = s(l, u + 1)) < 56320 || p > 57343 ? e ? o(l, u) : f : e ? c(l, u, u + 2) : (f - 55296 << 10) + (p - 56320) + 65536);
		};
	};
	t.exports = {
		codeAt: l(!1),
		charAt: l(!0)
	};
})), dr = /* @__PURE__ */ O(((e, t) => {
	var n = H(), r = G(), i = n.WeakMap;
	t.exports = r(i) && /native code/.test(String(i));
})), fr = /* @__PURE__ */ O(((e, t) => {
	var n = Cn(), r = En(), i = n("keys");
	t.exports = function(e) {
		return i[e] || (i[e] = r(e));
	};
})), pr = /* @__PURE__ */ O(((e, t) => {
	t.exports = {};
})), mr = /* @__PURE__ */ O(((e, t) => {
	var n = dr(), r = H(), i = sn(), a = Ln(), o = Tn(), s = Sn(), c = fr(), l = pr(), u = "Object already initialized", d = r.TypeError, f = r.WeakMap, p, m, h, g = function(e) {
		return h(e) ? m(e) : p(e, {});
	}, _ = function(e) {
		return function(t) {
			var n;
			if (!i(t) || (n = m(t)).type !== e) throw new d("Incompatible receiver, " + e + " required");
			return n;
		};
	};
	if (n || s.state) {
		var v = s.state || (s.state = new f());
		v.get = v.get, v.has = v.has, v.set = v.set, p = function(e, t) {
			if (v.has(e)) throw new d(u);
			return t.facade = e, v.set(e, t), t;
		}, m = function(e) {
			return v.get(e) || {};
		}, h = function(e) {
			return v.has(e);
		};
	} else {
		var y = c("state");
		l[y] = !0, p = function(e, t) {
			if (o(e, y)) throw new d(u);
			return t.facade = e, a(e, y, t), t;
		}, m = function(e) {
			return o(e, y) ? e[y] : {};
		}, h = function(e) {
			return o(e, y);
		};
	}
	t.exports = {
		set: p,
		get: m,
		has: h,
		enforce: g,
		getterFor: _
	};
})), hr = /* @__PURE__ */ O(((e, t) => {
	var n = Qt(), r = Tn(), i = Function.prototype, a = n && Object.getOwnPropertyDescriptor, o = r(i, "name");
	t.exports = {
		EXISTS: o,
		PROPER: o && function() {}.name === "something",
		CONFIGURABLE: o && (!n || n && a(i, "name").configurable)
	};
})), gr = /* @__PURE__ */ O(((e, t) => {
	var n = on(), r = Xn(), i = Qn(), a = function(e) {
		return function(t, a, o) {
			var s = n(t), c = i(s);
			if (c === 0) return !e && -1;
			var l = r(o, c), u;
			if (e && a !== a) {
				for (; c > l;) if (u = s[l++], u !== u) return !0;
			} else for (; c > l; l++) if ((e || l in s) && s[l] === a) return e || l || 0;
			return !e && -1;
		};
	};
	t.exports = {
		includes: a(!0),
		indexOf: a(!1)
	};
})), _r = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = Tn(), i = on(), a = gr().indexOf, o = pr(), s = n([].push);
	t.exports = function(e, t) {
		var n = i(e), c = 0, l = [], u;
		for (u in n) !r(o, u) && r(n, u) && s(l, u);
		for (; t.length > c;) r(n, u = t[c++]) && (~a(l, u) || s(l, u));
		return l;
	};
})), vr = /* @__PURE__ */ O(((e, t) => {
	t.exports = [
		"constructor",
		"hasOwnProperty",
		"isPrototypeOf",
		"propertyIsEnumerable",
		"toLocaleString",
		"toString",
		"valueOf"
	];
})), yr = /* @__PURE__ */ O(((e, t) => {
	var n = _r(), r = vr();
	t.exports = Object.keys || function(e) {
		return n(e, r);
	};
})), br = /* @__PURE__ */ O(((e) => {
	var t = Qt(), n = Pn(), r = In(), i = Fn(), a = on(), o = yr();
	e.f = t && !n ? Object.defineProperties : function(e, t) {
		i(e);
		for (var n = a(t), s = o(t), c = s.length, l = 0, u; c > l;) r.f(e, u = s[l++], n[u]);
		return e;
	};
})), xr = /* @__PURE__ */ O(((e, t) => {
	t.exports = ln()("document", "documentElement");
})), Sr = /* @__PURE__ */ O(((e, t) => {
	var n = Fn(), r = br(), i = vr(), a = pr(), o = xr(), s = kn(), c = fr(), l = ">", u = "<", d = "prototype", f = "script", p = c("IE_PROTO"), m = function() {}, h = function(e) {
		return u + f + l + e + u + "/" + f + l;
	}, g = function(e) {
		e.write(h("")), e.close();
		var t = e.parentWindow.Object;
		return e = null, t;
	}, _ = function() {
		var e = s("iframe"), t = "java" + f + ":", n;
		return e.style.display = "none", o.appendChild(e), e.src = String(t), n = e.contentWindow.document, n.open(), n.write(h("document.F=Object")), n.close(), n.F;
	}, v, y = function() {
		try {
			v = new ActiveXObject("htmlfile");
		} catch {}
		y = typeof document < "u" ? document.domain && v ? g(v) : _() : g(v);
		for (var e = i.length; e--;) delete y[d][i[e]];
		return y();
	};
	a[p] = !0, t.exports = Object.create || function(e, t) {
		var i;
		return e === null ? i = y() : (m[d] = n(e), i = new m(), m[d] = null, i[p] = e), t === void 0 ? i : r.f(i, t);
	};
})), Cr = /* @__PURE__ */ O(((e, t) => {
	t.exports = !U()(function() {
		function e() {}
		return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
	});
})), wr = /* @__PURE__ */ O(((e, t) => {
	var n = Tn(), r = G(), i = wn(), a = fr(), o = Cr(), s = a("IE_PROTO"), c = Object, l = c.prototype;
	t.exports = o ? c.getPrototypeOf : function(e) {
		var t = i(e);
		if (n(t, s)) return t[s];
		var a = t.constructor;
		return r(a) && t instanceof a ? a.prototype : t instanceof c ? l : null;
	};
})), Tr = /* @__PURE__ */ O(((e, t) => {
	var n = Ln();
	t.exports = function(e, t, r, i) {
		return i && i.enumerable ? e[t] = r : n(e, t, r), e;
	};
})), Er = /* @__PURE__ */ O(((e, t) => {
	var n = U(), r = G(), i = sn(), a = Sr(), o = wr(), s = Tr(), c = K(), l = bn(), u = c("iterator"), d = !1, f, p, m;
	[].keys && (m = [].keys(), "next" in m ? (p = o(o(m)), p !== Object.prototype && (f = p)) : d = !0), !i(f) || n(function() {
		var e = {};
		return f[u].call(e) !== e;
	}) ? f = {} : l && (f = a(f)), r(f[u]) || s(f, u, function() {
		return this;
	}), t.exports = {
		IteratorPrototype: f,
		BUGGY_SAFARI_ITERATORS: d
	};
})), Dr = /* @__PURE__ */ O(((e, t) => {
	var n = Wn(), r = Gn();
	t.exports = n ? {}.toString : function() {
		return "[object " + r(this) + "]";
	};
})), Or = /* @__PURE__ */ O(((e, t) => {
	var n = Wn(), r = In().f, i = Ln(), a = Tn(), o = Dr(), s = K()("toStringTag");
	t.exports = function(e, t, c, l) {
		var u = c ? e : e && e.prototype;
		u && (a(u, s) || r(u, s, {
			configurable: !0,
			value: t
		}), l && !n && i(u, "toString", o));
	};
})), kr = /* @__PURE__ */ O(((e, t) => {
	t.exports = {};
})), Ar = /* @__PURE__ */ O(((e, t) => {
	var n = Er().IteratorPrototype, r = Sr(), i = tn(), a = Or(), o = kr(), s = function() {
		return this;
	};
	t.exports = function(e, t, c, l) {
		var u = t + " Iterator";
		return e.prototype = r(n, { next: i(+!l, c) }), a(e, u, !1, !0), o[u] = s, e;
	};
})), jr = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = _n();
	t.exports = function(e, t, i) {
		try {
			return n(r(Object.getOwnPropertyDescriptor(e, t)[i]));
		} catch {}
	};
})), Mr = /* @__PURE__ */ O(((e, t) => {
	var n = sn();
	t.exports = function(e) {
		return n(e) || e === null;
	};
})), Nr = /* @__PURE__ */ O(((e, t) => {
	var n = Mr(), r = String, i = TypeError;
	t.exports = function(e) {
		if (n(e)) return e;
		throw new i("Can't set " + r(e) + " as a prototype");
	};
})), Pr = /* @__PURE__ */ O(((e, t) => {
	var n = jr(), r = sn(), i = an(), a = Nr();
	t.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
		var e = !1, t = {}, o;
		try {
			o = n(Object.prototype, "__proto__", "set"), o(t, []), e = t instanceof Array;
		} catch {}
		return function(t, n) {
			return i(t), a(n), r(t) && (e ? o(t, n) : t.__proto__ = n), t;
		};
	}() : void 0);
})), Fr = /* @__PURE__ */ O(((e, t) => {
	var n = q(), r = $t(), i = bn(), a = hr(), o = G(), s = Ar(), c = wr(), l = Pr(), u = Or(), d = Ln(), f = Tr(), p = K(), m = kr(), h = Er(), g = a.PROPER, _ = a.CONFIGURABLE, v = h.IteratorPrototype, y = h.BUGGY_SAFARI_ITERATORS, b = p("iterator"), x = "keys", S = "values", C = "entries", w = function() {
		return this;
	};
	t.exports = function(e, t, a, p, h, T, E) {
		s(a, t, p);
		var D = function(e) {
			if (e === h && M) return M;
			if (!y && e && e in A) return A[e];
			switch (e) {
				case x: return function() {
					return new a(this, e);
				};
				case S: return function() {
					return new a(this, e);
				};
				case C: return function() {
					return new a(this, e);
				};
			}
			return function() {
				return new a(this);
			};
		}, O = t + " Iterator", k = !1, A = e.prototype, j = A[b] || A["@@iterator"] || h && A[h], M = !y && j || D(h), N = t === "Array" && A.entries || j, P, F, I;
		if (N && (P = c(N.call(new e())), P !== Object.prototype && P.next && (!i && c(P) !== v && (l ? l(P, v) : o(P[b]) || f(P, b, w)), u(P, O, !0, !0), i && (m[O] = w))), g && h === S && j && j.name !== S && (!i && _ ? d(A, "name", S) : (k = !0, M = function() {
			return r(j, this);
		})), h) if (F = {
			values: D(S),
			keys: T ? M : D(x),
			entries: D(C)
		}, E) for (I in F) (y || k || !(I in A)) && f(A, I, F[I]);
		else n({
			target: t,
			proto: !0,
			forced: y || k
		}, F);
		return (!i || E) && A[b] !== M && f(A, b, M, { name: h }), m[t] = M, F;
	};
})), Ir = /* @__PURE__ */ O(((e, t) => {
	t.exports = function(e, t) {
		return {
			value: e,
			done: t
		};
	};
})), Lr = /* @__PURE__ */ O((() => {
	var e = ur().charAt, t = lr(), n = mr(), r = Fr(), i = Ir(), a = "String Iterator", o = n.set, s = n.getterFor(a);
	r(String, "String", function(e) {
		o(this, {
			type: a,
			string: t(e),
			index: 0
		});
	}, function() {
		var t = s(this), n = t.string, r = t.index, a;
		return r >= n.length ? i(void 0, !0) : (a = e(n, r), t.index += a.length, i(a, !1));
	});
})), Rr = /* @__PURE__ */ O(((e, t) => {
	var n = $t(), r = Fn(), i = vn();
	t.exports = function(e, t, a) {
		var o, s;
		r(e);
		try {
			if (o = i(e, "return"), !o) {
				if (t === "throw") throw a;
				return a;
			}
			o = n(o, e);
		} catch (e) {
			s = !0, o = e;
		}
		if (t === "throw") throw a;
		if (s) throw o;
		return r(o), a;
	};
})), zr = /* @__PURE__ */ O(((e, t) => {
	var n = Fn(), r = Rr();
	t.exports = function(e, t, i, a) {
		try {
			return a ? t(n(i)[0], i[1]) : t(i);
		} catch (t) {
			r(e, "throw", t);
		}
	};
})), Br = /* @__PURE__ */ O(((e, t) => {
	var n = K(), r = kr(), i = n("iterator"), a = Array.prototype;
	t.exports = function(e) {
		return e !== void 0 && (r.Array === e || a[i] === e);
	};
})), Vr = /* @__PURE__ */ O(((e, t) => {
	var n = Gn(), r = vn(), i = rn(), a = kr(), o = K()("iterator");
	t.exports = function(e) {
		if (!i(e)) return r(e, o) || r(e, "@@iterator") || a[n(e)];
	};
})), Hr = /* @__PURE__ */ O(((e, t) => {
	var n = $t(), r = _n(), i = Fn(), a = gn(), o = Vr(), s = TypeError;
	t.exports = function(e, t) {
		var c = arguments.length < 2 ? o(e) : t;
		if (r(c)) return i(n(c, e));
		throw new s(a(e) + " is not iterable");
	};
})), Ur = /* @__PURE__ */ O(((e, t) => {
	var n = Nn(), r = $t(), i = wn(), a = zr(), o = Br(), s = qn(), c = Qn(), l = $n(), u = er(), d = Hr(), f = Vr(), p = Rr(), m = Array;
	t.exports = function(e) {
		var t = s(this), h = arguments.length, g = h > 1 ? arguments[1] : void 0, _ = g !== void 0;
		_ && (g = n(g, h > 2 ? arguments[2] : void 0));
		var v = i(e), y = f(v), b = 0, x, S, C, w, T, E;
		if (y && !(this === m && o(y))) for (S = t ? new this() : [], w = d(v, y), T = w.next; !(C = r(T, w)).done; b++) {
			E = _ ? a(w, g, [C.value, b], !0) : C.value;
			try {
				l(S, b, E);
			} catch (e) {
				p(w, "throw", e);
			}
		}
		else for (x = c(v), S = t ? new this(x) : m(x); x > b; b++) E = _ ? g(v[b], b) : v[b], l(S, b, E);
		return u(S, b), S;
	};
})), Wr = /* @__PURE__ */ O(((e, t) => {
	var n = K()("iterator"), r = !1;
	try {
		var i = 0, a = {
			next: function() {
				return { done: !!i++ };
			},
			return: function() {
				r = !0;
			}
		};
		a[n] = function() {
			return this;
		}, Array.from(a, function() {
			throw 2;
		});
	} catch {}
	t.exports = function(e, t) {
		try {
			if (!t && !r) return !1;
		} catch {
			return !1;
		}
		var i = !1;
		try {
			var a = {};
			a[n] = function() {
				return { next: function() {
					return { done: i = !0 };
				} };
			}, e(a);
		} catch {}
		return i;
	};
})), Gr = /* @__PURE__ */ O((() => {
	var e = q(), t = Ur();
	e({
		target: "Array",
		stat: !0,
		forced: !Wr()(function(e) {
			Array.from(e);
		})
	}, { from: t });
})), Kr = /* @__PURE__ */ O(((e, t) => {
	Lr(), Gr(), t.exports = cn().Array.from;
})), qr = /* @__PURE__ */ O(((e, t) => {
	t.exports = Kr();
})), Jr = /* @__PURE__ */ O(((e, t) => {
	t.exports = qr();
})), Yr = /* @__PURE__ */ O(((e, t) => {
	var n = TypeError, r = 9007199254740991;
	t.exports = function(e) {
		if (e > r) throw new n("Maximum allowed index exceeded");
		return e;
	};
})), Xr = /* @__PURE__ */ O(((e, t) => {
	var n = Un(), r = qn(), i = sn(), a = K()("species"), o = Array;
	t.exports = function(e) {
		var t;
		return n(e) && (t = e.constructor, r(t) && (t === o || n(t.prototype)) ? t = void 0 : i(t) && (t = t[a], t === null && (t = void 0))), t === void 0 ? o : t;
	};
})), Zr = /* @__PURE__ */ O(((e, t) => {
	var n = Xr();
	t.exports = function(e, t) {
		return new (n(e))(t === 0 ? 0 : t);
	};
})), Qr = /* @__PURE__ */ O((() => {
	var e = q(), t = U(), n = Un(), r = sn(), i = wn(), a = Qn(), o = Yr(), s = $n(), c = er(), l = Zr(), u = tr(), d = K(), f = fn(), p = d("isConcatSpreadable"), m = f >= 51 || !t(function() {
		var e = [];
		return e[p] = !1, e.concat()[0] !== e;
	}), h = function(e) {
		if (!r(e)) return !1;
		var t = e[p];
		return t === void 0 ? n(e) : !!t;
	};
	e({
		target: "Array",
		proto: !0,
		arity: 1,
		forced: !m || !u("concat")
	}, { concat: function(e) {
		var t = i(this), n = l(t, 0), r = 0, u, d, f, p, m;
		for (u = -1, f = arguments.length; u < f; u++) if (m = u === -1 ? t : arguments[u], h(m)) for (p = a(m), o(r + p), d = 0; d < p; d++, r++) d in m && s(n, r, m[d]);
		else o(r + 1), s(n, r++, m);
		return c(n, r), n;
	} });
})), $r = /* @__PURE__ */ O((() => {})), ei = /* @__PURE__ */ O(((e) => {
	var t = _r(), n = vr().concat("length", "prototype");
	e.f = Object.getOwnPropertyNames || function(e) {
		return t(e, n);
	};
})), ti = /* @__PURE__ */ O(((e, t) => {
	var n = Xt(), r = on(), i = ei().f, a = nr(), o = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], s = function(e) {
		try {
			return i(e);
		} catch {
			return a(o);
		}
	};
	t.exports.f = function(e) {
		return o && n(e) === "Window" ? s(e) : i(r(e));
	};
})), ni = /* @__PURE__ */ O(((e) => {
	e.f = Object.getOwnPropertySymbols;
})), ri = /* @__PURE__ */ O(((e, t) => {
	var n = In();
	t.exports = function(e, t, r) {
		return n.f(e, t, r);
	};
})), ii = /* @__PURE__ */ O(((e) => {
	e.f = K();
})), J = /* @__PURE__ */ O(((e, t) => {
	var n = cn(), r = Tn(), i = ii(), a = In().f;
	t.exports = function(e) {
		var t = n.Symbol || (n.Symbol = {});
		r(t, e) || a(t, e, { value: i.f(e) });
	};
})), ai = /* @__PURE__ */ O(((e, t) => {
	var n = $t(), r = ln(), i = K(), a = Tr();
	t.exports = function() {
		var e = r("Symbol"), t = e && e.prototype, o = t && t.valueOf, s = i("toPrimitive");
		t && !t[s] && a(t, s, function(e) {
			return n(o, this);
		}, { arity: 1 });
	};
})), oi = /* @__PURE__ */ O(((e, t) => {
	var n = Nn(), r = nn(), i = wn(), a = Qn(), o = Zr(), s = $n(), c = function(e) {
		var t = e === 1, c = e === 2, l = e === 3, u = e === 4, d = e === 6, f = e === 7, p = e === 5 || d;
		return function(m, h, g) {
			for (var _ = i(m), v = r(_), y = a(v), b = n(h, g), x = 0, S = 0, C = t ? o(m, y) : c || f ? o(m, 0) : void 0, w, T; y > x; x++) if ((p || x in v) && (w = v[x], T = b(w, x, _), e)) if (t) s(C, x, T);
			else if (T) switch (e) {
				case 3: return !0;
				case 5: return w;
				case 6: return x;
				case 2: s(C, S++, w);
			}
			else switch (e) {
				case 4: return !1;
				case 7: s(C, S++, w);
			}
			return d ? -1 : l || u ? u : C;
		};
	};
	t.exports = {
		forEach: c(0),
		map: c(1),
		filter: c(2),
		some: c(3),
		every: c(4),
		find: c(5),
		findIndex: c(6),
		filterReject: c(7)
	};
})), si = /* @__PURE__ */ O((() => {
	var e = q(), t = H(), n = $t(), r = W(), i = bn(), a = Qt(), o = pn(), s = U(), c = Tn(), l = un(), u = Fn(), d = on(), f = On(), p = lr(), m = tn(), h = Sr(), g = yr(), _ = ei(), v = ti(), y = ni(), b = jn(), x = In(), S = br(), C = en(), w = Tr(), T = ri(), E = Cn(), D = fr(), O = pr(), k = En(), A = K(), j = ii(), M = J(), N = ai(), P = Or(), F = mr(), I = oi().forEach, L = D("hidden"), ee = "Symbol", te = "prototype", ne = F.set, re = F.getterFor(ee), R = Object[te], ie = t.Symbol, ae = ie && ie[te], oe = t.RangeError, se = t.TypeError, ce = t.QObject, le = b.f, ue = x.f, z = v.f, de = C.f, fe = r([].push), pe = E("symbols"), me = E("op-symbols"), he = E("wks"), ge = !ce || !ce[te] || !ce[te].findChild, _e = function(e, t, n) {
		var r = le(R, t);
		return r && delete R[t], ue(e, t, n), r && e !== R && ue(R, t, r), e;
	}, B = a && s(function() {
		return h(ue({}, "a", { get: function() {
			return ue(this, "a", { value: 7 }).a;
		} })).a !== 7;
	}) ? _e : ue, ve = function(e, t) {
		var n = pe[e] = h(ae);
		return ne(n, {
			type: ee,
			tag: e,
			description: t
		}), a || (n.description = t), n;
	}, ye = function(e, t, n) {
		e === R && ye(me, t, n), u(e);
		var r = f(t);
		return u(n), c(pe, r) ? (("enumerable" in n ? !n.enumerable : !c(e, r) || c(e, L) && e[L][r]) ? (c(e, L) || ue(e, L, m(1, h(null))), e[L][r] = !0) : (c(e, L) && e[L][r] && (e[L][r] = !1), n = h(n, { enumerable: m(0, !1) })), B(e, r, n)) : ue(e, r, n);
	}, be = function(e, t) {
		u(e);
		var r = d(t);
		return I(g(r).concat(Te(r)), function(t) {
			(!a || n(Se, r, t)) && ye(e, t, r[t]);
		}), e;
	}, xe = function(e, t) {
		return t === void 0 ? h(e) : be(h(e), t);
	}, Se = function(e) {
		var t = f(e), r = n(de, this, t);
		return this === R && c(pe, t) && !c(me, t) ? !1 : r || !c(this, t) || !c(pe, t) || c(this, L) && this[L][t] ? r : !0;
	}, Ce = function(e, t) {
		var n = d(e), r = f(t);
		if (!(n === R && c(pe, r) && !c(me, r))) {
			var i = le(n, r);
			return i && c(pe, r) && !(c(n, L) && n[L][r]) && (i.enumerable = !0), i;
		}
	}, we = function(e) {
		var t = z(d(e)), n = [];
		return I(t, function(e) {
			!c(pe, e) && !c(O, e) && fe(n, e);
		}), n;
	}, Te = function(e) {
		var t = e === R, n = z(t ? me : d(e)), r = [];
		return I(n, function(e) {
			c(pe, e) && (!t || c(R, e)) && fe(r, pe[e]);
		}), r;
	};
	o || (ie = function() {
		if (l(ae, this)) throw new se("Symbol is not a constructor");
		var e = !arguments.length || arguments[0] === void 0 ? void 0 : p(arguments[0]), r = k(e), i = function(e) {
			var a = this === void 0 ? t : this;
			a === R && n(i, me, e), c(a, L) && c(a[L], r) && (a[L][r] = !1);
			var o = m(1, e);
			try {
				B(a, r, o);
			} catch (e) {
				if (!(e instanceof oe)) throw e;
				_e(a, r, o);
			}
		};
		return a && ge && B(R, r, {
			configurable: !0,
			set: i
		}), ve(r, e);
	}, ae = ie[te], w(ae, "toString", function() {
		return re(this).tag;
	}), w(ie, "withoutSetter", function(e) {
		return ve(k(e), e);
	}), C.f = Se, x.f = ye, S.f = be, b.f = Ce, _.f = v.f = we, y.f = Te, j.f = function(e) {
		return ve(A(e), e);
	}, a && (T(ae, "description", {
		configurable: !0,
		get: function() {
			return re(this).description;
		}
	}), i || w(R, "propertyIsEnumerable", Se, { unsafe: !0 }))), e({
		global: !0,
		constructor: !0,
		wrap: !0,
		forced: !o,
		sham: !o
	}, { Symbol: ie }), I(g(he), function(e) {
		M(e);
	}), e({
		target: ee,
		stat: !0,
		forced: !o
	}, {
		useSetter: function() {
			ge = !0;
		},
		useSimple: function() {
			ge = !1;
		}
	}), e({
		target: "Object",
		stat: !0,
		forced: !o,
		sham: !a
	}, {
		create: xe,
		defineProperty: ye,
		defineProperties: be,
		getOwnPropertyDescriptor: Ce
	}), e({
		target: "Object",
		stat: !0,
		forced: !o
	}, { getOwnPropertyNames: we }), N(), P(ie, ee), O[L] = !0;
})), ci = /* @__PURE__ */ O(((e, t) => {
	t.exports = pn() && !!Symbol.for && !!Symbol.keyFor;
})), li = /* @__PURE__ */ O((() => {
	var e = q(), t = ln(), n = Tn(), r = lr(), i = Cn(), a = ci(), o = i("string-to-symbol-registry"), s = i("symbol-to-string-registry");
	e({
		target: "Symbol",
		stat: !0,
		forced: !a
	}, { for: function(e) {
		var i = r(e);
		if (n(o, i)) return o[i];
		var a = t("Symbol")(i);
		return o[i] = a, s[a] = i, a;
	} });
})), ui = /* @__PURE__ */ O((() => {
	var e = q(), t = Tn(), n = hn(), r = gn(), i = Cn(), a = ci(), o = i("symbol-to-string-registry");
	e({
		target: "Symbol",
		stat: !0,
		forced: !a
	}, { keyFor: function(e) {
		if (!n(e)) throw TypeError(r(e) + " is not a symbol");
		if (t(o, e)) return o[e];
	} });
})), di = /* @__PURE__ */ O(((e, t) => {
	var n = sn(), r = mr().get;
	t.exports = function(e) {
		if (!n(e)) return !1;
		var t = r(e);
		return !!t && t.type === "RawJSON";
	};
})), fi = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = Tn(), i = SyntaxError, a = parseInt, o = String.fromCharCode, s = n("".charAt), c = n("".slice), l = n(/./.exec), u = {
		"\\\"": "\"",
		"\\\\": "\\",
		"\\/": "/",
		"\\b": "\b",
		"\\f": "\f",
		"\\n": "\n",
		"\\r": "\r",
		"\\t": "	"
	}, d = /^[\da-f]{4}$/i, f = /^[\u0000-\u001F]$/;
	t.exports = function(e, t) {
		for (var n = !0, p = ""; t < e.length;) {
			var m = s(e, t);
			if (m === "\\") {
				var h = c(e, t, t + 2);
				if (r(u, h)) p += u[h], t += 2;
				else if (h === "\\u") {
					t += 2;
					var g = c(e, t, t + 4);
					if (!l(d, g)) throw new i("Bad Unicode escape at: " + t);
					p += o(a(g, 16)), t += 4;
				} else throw new i("Unknown escape sequence: \"" + h + "\"");
			} else if (m === "\"") {
				n = !1, t++;
				break;
			} else {
				if (l(f, m)) throw new i("Bad control character in string literal at: " + t);
				p += m, t++;
			}
		}
		if (n) throw new i("Unterminated string at: " + t);
		return {
			value: p,
			end: t
		};
	};
})), pi = /* @__PURE__ */ O(((e, t) => {
	t.exports = !U()(function() {
		var e = "9007199254740993", t = JSON.rawJSON(e);
		return !JSON.isRawJSON(t) || JSON.stringify(t) !== e;
	});
})), mi = /* @__PURE__ */ O((() => {
	var e = q(), t = ln(), n = Yt(), r = $t(), i = W(), a = U(), o = Un(), s = G(), c = di(), l = hn(), u = Xt(), d = lr(), f = nr(), p = fi(), m = En(), h = pn(), g = pi(), _ = String, v = t("JSON", "stringify"), y = i(/./.exec), b = i("".charAt), x = i("".charCodeAt), S = i("".replace), C = i("".slice), w = i([].push), T = i(1.1.toString), E = /[\uD800-\uDFFF]/g, D = /^[\uD800-\uDBFF]$/, O = /^[\uDC00-\uDFFF]$/, k = m(), A = k.length, j = !h || a(function() {
		var e = t("Symbol")("stringify detection");
		return v([e]) !== "[null]" || v({ a: e }) !== "{}" || v(Object(e)) !== "{}";
	}), M = a(function() {
		return v("\udf06\ud834") !== "\"\\udf06\\ud834\"" || v("\udead") !== "\"\\udead\"";
	}), N = j ? function(e, t) {
		var i = f(arguments), a = F(t);
		if (!(!s(a) && (e === void 0 || l(e)))) return i[1] = function(e, t) {
			if (s(a) && (t = r(a, this, _(e), t)), !l(t)) return t;
		}, n(v, null, i);
	} : v, P = function(e, t, n) {
		var r = b(n, t - 1), i = b(n, t + 1);
		return y(D, e) && !y(O, i) || y(O, e) && !y(D, r) ? "\\u" + T(x(e, 0), 16) : e;
	}, F = function(e) {
		if (s(e)) return e;
		if (o(e)) {
			for (var t = e.length, n = [], r = 0; r < t; r++) {
				var i = e[r];
				typeof i == "string" ? w(n, i) : (typeof i == "number" || u(i) === "Number" || u(i) === "String") && w(n, d(i));
			}
			var a = n.length, c = !0;
			return function(e, t) {
				if (c) return c = !1, t;
				if (o(this)) return t;
				for (var r = 0; r < a; r++) if (n[r] === e) return t;
			};
		}
	};
	v && e({
		target: "JSON",
		stat: !0,
		arity: 3,
		forced: j || M || !g
	}, { stringify: function(e, t, n) {
		var i = F(t), a = [], o = N(e, function(e, t) {
			var n = s(i) ? r(i, this, _(e), t) : t;
			return !g && c(n) ? k + (w(a, n.rawJSON) - 1) : n;
		}, n);
		if (typeof o != "string" || (M && (o = S(o, E, P)), g)) return o;
		for (var l = "", u = o.length, d = 0; d < u; d++) {
			var f = b(o, d);
			if (f === "\"") {
				var m = p(o, ++d).end - 1, h = C(o, d, m);
				l += C(h, 0, A) === k ? a[C(h, A)] : "\"" + h + "\"", d = m;
			} else l += f;
		}
		return l;
	} });
})), hi = /* @__PURE__ */ O((() => {
	var e = q(), t = pn(), n = U(), r = ni(), i = wn();
	e({
		target: "Object",
		stat: !0,
		forced: !t || n(function() {
			r.f(1);
		})
	}, { getOwnPropertySymbols: function(e) {
		var t = r.f;
		return t ? t(i(e)) : [];
	} });
})), gi = /* @__PURE__ */ O((() => {
	si(), li(), ui(), mi(), hi();
})), _i = /* @__PURE__ */ O((() => {
	J()("asyncDispose");
})), vi = /* @__PURE__ */ O((() => {
	J()("asyncIterator");
})), yi = /* @__PURE__ */ O((() => {})), bi = /* @__PURE__ */ O((() => {
	J()("dispose");
})), xi = /* @__PURE__ */ O((() => {
	J()("hasInstance");
})), Si = /* @__PURE__ */ O((() => {
	J()("isConcatSpreadable");
})), Ci = /* @__PURE__ */ O((() => {
	J()("iterator");
})), wi = /* @__PURE__ */ O((() => {
	J()("match");
})), Ti = /* @__PURE__ */ O((() => {
	J()("matchAll");
})), Ei = /* @__PURE__ */ O((() => {
	J()("replace");
})), Di = /* @__PURE__ */ O((() => {
	J()("search");
})), Oi = /* @__PURE__ */ O((() => {
	J()("species");
})), ki = /* @__PURE__ */ O((() => {
	J()("split");
})), Ai = /* @__PURE__ */ O((() => {
	var e = J(), t = ai();
	e("toPrimitive"), t();
})), ji = /* @__PURE__ */ O((() => {
	var e = ln(), t = J(), n = Or();
	t("toStringTag"), n(e("Symbol"), "Symbol");
})), Mi = /* @__PURE__ */ O((() => {
	J()("unscopables");
})), Ni = /* @__PURE__ */ O((() => {
	var e = H();
	Or()(e.JSON, "JSON", !0);
})), Pi = /* @__PURE__ */ O((() => {})), Fi = /* @__PURE__ */ O((() => {})), Ii = /* @__PURE__ */ O(((e, t) => {
	Qr(), $r(), gi(), _i(), vi(), yi(), bi(), xi(), Si(), Ci(), wi(), Ti(), Ei(), Di(), Oi(), ki(), Ai(), ji(), Mi(), Ni(), Pi(), Fi(), t.exports = cn().Symbol;
})), Li = /* @__PURE__ */ O(((e, t) => {
	t.exports = function() {};
})), Ri = /* @__PURE__ */ O(((e, t) => {
	var n = on(), r = Li(), i = kr(), a = mr(), o = In().f, s = Fr(), c = Ir(), l = bn(), u = Qt(), d = "Array Iterator", f = a.set, p = a.getterFor(d);
	t.exports = s(Array, "Array", function(e, t) {
		f(this, {
			type: d,
			target: n(e),
			index: 0,
			kind: t
		});
	}, function() {
		var e = p(this), t = e.target, n = e.index++;
		if (!t || n >= t.length) return e.target = null, c(void 0, !0);
		switch (e.kind) {
			case "keys": return c(n, !1);
			case "values": return c(t[n], !1);
		}
		return c([n, t[n]], !1);
	}, "values");
	var m = i.Arguments = i.Array;
	if (r("keys"), r("values"), r("entries"), !l && u && m.name !== "values") try {
		o(m, "name", { value: "values" });
	} catch {}
})), zi = /* @__PURE__ */ O(((e, t) => {
	t.exports = {
		CSSRuleList: 0,
		CSSStyleDeclaration: 0,
		CSSValueList: 0,
		ClientRectList: 0,
		DOMRectList: 0,
		DOMStringList: 0,
		DOMTokenList: 1,
		DataTransferItemList: 0,
		FileList: 0,
		HTMLAllCollection: 0,
		HTMLCollection: 0,
		HTMLFormElement: 0,
		HTMLSelectElement: 0,
		MediaList: 0,
		MimeTypeArray: 0,
		NamedNodeMap: 0,
		NodeList: 1,
		PaintRequestList: 0,
		Plugin: 0,
		PluginArray: 0,
		SVGLengthList: 0,
		SVGNumberList: 0,
		SVGPathSegList: 0,
		SVGPointList: 0,
		SVGStringList: 0,
		SVGTransformList: 0,
		SourceBufferList: 0,
		StyleSheetList: 0,
		TextTrackCueList: 0,
		TextTrackList: 0,
		TouchList: 0
	};
})), Bi = /* @__PURE__ */ O((() => {
	Ri();
	var e = zi(), t = H(), n = Or(), r = kr();
	for (var i in e) n(t[i], i), r[i] = r.Array;
})), Vi = /* @__PURE__ */ O(((e, t) => {
	var n = Ii();
	Bi(), t.exports = n;
})), Hi = /* @__PURE__ */ O(((e, t) => {
	t.exports = Vi();
})), Ui = /* @__PURE__ */ O(((e, t) => {
	Ri(), Lr(), t.exports = Vr();
})), Wi = /* @__PURE__ */ O(((e, t) => {
	var n = Ui();
	Bi(), t.exports = n;
})), Gi = /* @__PURE__ */ O(((e, t) => {
	t.exports = Wi();
})), Ki = /* @__PURE__ */ O(((e, t) => {
	t.exports = Gi();
})), qi = /* @__PURE__ */ O(((e, t) => {
	t.exports = Ki();
})), Ji = /* @__PURE__ */ O(((e, t) => {
	t.exports = qi();
})), Yi = /* @__PURE__ */ O((() => {
	q()({
		target: "Array",
		stat: !0
	}, { isArray: Un() });
})), Xi = /* @__PURE__ */ O(((e, t) => {
	Yi(), t.exports = cn().Array.isArray;
})), Zi = /* @__PURE__ */ O(((e, t) => {
	t.exports = Xi();
})), Qi = /* @__PURE__ */ O(((e, t) => {
	t.exports = Zi();
})), $i = /* @__PURE__ */ O(((e, t) => {
	t.exports = Zi();
})), ea = /* @__PURE__ */ O(((e, t) => {
	t.exports = $i();
})), ta = /* @__PURE__ */ O(((e, t) => {
	t.exports = ea();
})), na = /* @__PURE__ */ O(((e, t) => {
	var n = ta();
	function r(e) {
		if (n(e)) return e;
	}
	t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
})), ra = /* @__PURE__ */ O((() => {
	var e = K(), t = In().f, n = e("metadata"), r = Function.prototype;
	r[n] === void 0 && t(r, n, { value: null });
})), ia = /* @__PURE__ */ O((() => {
	_i();
})), aa = /* @__PURE__ */ O((() => {
	bi();
})), oa = /* @__PURE__ */ O((() => {
	J()("metadata");
})), sa = /* @__PURE__ */ O(((e, t) => {
	var n = Vi();
	ra(), ia(), aa(), oa(), t.exports = n;
})), ca = /* @__PURE__ */ O(((e, t) => {
	var n = ln(), r = W(), i = n("Symbol"), a = i.keyFor, o = r(i.prototype.valueOf);
	t.exports = i.isRegisteredSymbol || function(e) {
		try {
			return a(o(e)) !== void 0;
		} catch {
			return !1;
		}
	};
})), la = /* @__PURE__ */ O((() => {
	q()({
		target: "Symbol",
		stat: !0
	}, { isRegisteredSymbol: ca() });
})), ua = /* @__PURE__ */ O(((e, t) => {
	for (var n = Cn(), r = ln(), i = W(), a = hn(), o = K(), s = r("Symbol"), c = s.isWellKnownSymbol, l = r("Object", "getOwnPropertyNames"), u = i(s.prototype.valueOf), d = n("wks"), f = 0, p = l(s), m = p.length; f < m; f++) try {
		var h = p[f];
		a(s[h]) && o(h);
	} catch {}
	t.exports = function(e) {
		if (c && c(e)) return !0;
		try {
			for (var t = u(e), n = 0, r = l(d), i = r.length; n < i; n++) if (d[r[n]] == t) return !0;
		} catch {}
		return !1;
	};
})), da = /* @__PURE__ */ O((() => {
	q()({
		target: "Symbol",
		stat: !0,
		forced: !0
	}, { isWellKnownSymbol: ua() });
})), fa = /* @__PURE__ */ O((() => {
	J()("customMatcher");
})), pa = /* @__PURE__ */ O((() => {
	J()("observable");
})), ma = /* @__PURE__ */ O((() => {
	q()({
		target: "Symbol",
		stat: !0,
		name: "isRegisteredSymbol"
	}, { isRegistered: ca() });
})), ha = /* @__PURE__ */ O((() => {
	q()({
		target: "Symbol",
		stat: !0,
		name: "isWellKnownSymbol",
		forced: !0
	}, { isWellKnown: ua() });
})), ga = /* @__PURE__ */ O((() => {
	J()("matcher");
})), _a = /* @__PURE__ */ O((() => {
	J()("metadataKey");
})), va = /* @__PURE__ */ O((() => {
	J()("patternMatch");
})), ya = /* @__PURE__ */ O((() => {
	J()("replaceAll");
})), ba = /* @__PURE__ */ O(((e, t) => {
	var n = sa();
	la(), da(), fa(), pa(), ma(), ha(), ga(), _a(), va(), ya(), t.exports = n;
})), xa = /* @__PURE__ */ O(((e, t) => {
	t.exports = ba();
})), Sa = /* @__PURE__ */ O((() => {
	var e = q(), t = wn(), n = Qn(), r = er(), i = Yr();
	e({
		target: "Array",
		proto: !0,
		arity: 1,
		forced: U()(function() {
			return [].push.call({ length: 4294967296 }, 1) !== 4294967297;
		}) || !function() {
			try {
				Object.defineProperty([], "length", { writable: !1 }).push();
			} catch (e) {
				return e instanceof TypeError;
			}
		}()
	}, { push: function(e) {
		var a = t(this), o = n(a), s = arguments.length;
		i(o + s);
		for (var c = 0; c < s; c++) a[o] = arguments[c], o++;
		return r(a, o), o;
	} });
})), Ca = /* @__PURE__ */ O(((e, t) => {
	Sa(), t.exports = ir()("Array", "push");
})), wa = /* @__PURE__ */ O(((e, t) => {
	var n = un(), r = Ca(), i = Array.prototype;
	t.exports = function(e) {
		var t = e.push;
		return e === i || n(i, e) && t === i.push ? r : t;
	};
})), Ta = /* @__PURE__ */ O(((e, t) => {
	t.exports = wa();
})), Ea = /* @__PURE__ */ O(((e, t) => {
	t.exports = Ta();
})), Da = /* @__PURE__ */ O(((e, t) => {
	t.exports = Ea();
})), Oa = /* @__PURE__ */ O(((e, t) => {
	t.exports = Da();
})), ka = /* @__PURE__ */ O(((e, t) => {
	var n = xa(), r = qi(), i = Oa();
	function a(e, t) {
		var a = e == null ? null : n !== void 0 && r(e) || e["@@iterator"];
		if (a != null) {
			var o, s, c, l, u = [], d = !0, f = !1;
			try {
				if (c = (a = a.call(e)).next, t === 0) {
					if (Object(a) !== a) return;
					d = !1;
				} else for (; !(d = (o = c.call(a)).done) && (i(u).call(u, o.value), u.length !== t); d = !0);
			} catch (e) {
				f = !0, s = e;
			} finally {
				try {
					if (!d && a.return != null && (l = a.return(), Object(l) !== l)) return;
				} finally {
					if (f) throw s;
				}
			}
			return u;
		}
	}
	t.exports = a, t.exports.__esModule = !0, t.exports.default = t.exports;
})), Aa = /* @__PURE__ */ O(((e, t) => {
	t.exports = sr();
})), ja = /* @__PURE__ */ O(((e, t) => {
	t.exports = Aa();
})), Ma = /* @__PURE__ */ O(((e, t) => {
	t.exports = ja();
})), Na = /* @__PURE__ */ O(((e, t) => {
	t.exports = qr();
})), Pa = /* @__PURE__ */ O(((e, t) => {
	t.exports = Na();
})), Fa = /* @__PURE__ */ O(((e, t) => {
	t.exports = Pa();
})), Ia = /* @__PURE__ */ O(((e, t) => {
	function n(e, t) {
		(t == null || t > e.length) && (t = e.length);
		for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
		return r;
	}
	t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
})), La = /* @__PURE__ */ O(((e, t) => {
	var n = Ma(), r = Fa(), i = Ia();
	function a(e, t) {
		if (e) {
			var a;
			if (typeof e == "string") return i(e, t);
			var o = n(a = {}.toString.call(e)).call(a, 8, -1);
			return o === "Object" && e.constructor && (o = e.constructor.name), o === "Map" || o === "Set" ? r(e) : o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o) ? i(e, t) : void 0;
		}
	}
	t.exports = a, t.exports.__esModule = !0, t.exports.default = t.exports;
})), Ra = /* @__PURE__ */ O(((e, t) => {
	function n() {
		throw TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
	}
	t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
})), za = /* @__PURE__ */ O(((e, t) => {
	var n = na(), r = ka(), i = La(), a = Ra();
	function o(e, t) {
		return n(e) || r(e, t) || i(e, t) || a();
	}
	t.exports = o, t.exports.__esModule = !0, t.exports.default = t.exports;
})), Ba = /* @__PURE__ */ O((() => {
	var e = q(), t = Qt(), n = Sr();
	e({
		target: "Object",
		stat: !0,
		sham: !t
	}, { create: n });
})), Va = /* @__PURE__ */ O(((e, t) => {
	Ba();
	var n = cn().Object;
	t.exports = function(e, t) {
		return n.create(e, t);
	};
})), Ha = /* @__PURE__ */ O(((e, t) => {
	t.exports = Va();
})), Ua = /* @__PURE__ */ O(((e, t) => {
	t.exports = Ha();
})), Wa = /* @__PURE__ */ O((() => {})), Ga = /* @__PURE__ */ O(((e, t) => {
	var n = H(), r = U(), i = n.RegExp;
	t.exports = { correct: !r(function() {
		var e = !0;
		try {
			i(".", "d");
		} catch {
			e = !1;
		}
		var t = {}, n = "", r = e ? "dgimsy" : "gimsy", a = function(e, r) {
			Object.defineProperty(t, e, { get: function() {
				return n += r, !0;
			} });
		}, o = {
			dotAll: "s",
			global: "g",
			ignoreCase: "i",
			multiline: "m",
			sticky: "y"
		};
		for (var s in e && (o.hasIndices = "d"), o) a(s, o[s]);
		return Object.getOwnPropertyDescriptor(i.prototype, "flags").get.call(t) !== r || n !== r;
	}) };
})), Ka = /* @__PURE__ */ O(((e, t) => {
	var n = Fn();
	t.exports = function() {
		var e = n(this), t = "";
		return e.hasIndices && (t += "d"), e.global && (t += "g"), e.ignoreCase && (t += "i"), e.multiline && (t += "m"), e.dotAll && (t += "s"), e.unicode && (t += "u"), e.unicodeSets && (t += "v"), e.sticky && (t += "y"), t;
	};
})), qa = /* @__PURE__ */ O(((e, t) => {
	var n = $t(), r = Tn(), i = un(), a = Ga(), o = Ka(), s = RegExp.prototype;
	t.exports = a.correct ? function(e) {
		return e.flags;
	} : function(e) {
		return !a.correct && i(s, e) && !r(e, "flags") ? n(o, e) : e.flags;
	};
})), Ja = /* @__PURE__ */ O(((e, t) => {
	Wa(), t.exports = qa();
})), Ya = /* @__PURE__ */ O(((e, t) => {
	var n = un(), r = Ja(), i = RegExp.prototype;
	t.exports = function(e) {
		return e === i || n(i, e) ? r(e) : e.flags;
	};
})), Xa = /* @__PURE__ */ O(((e, t) => {
	t.exports = Ya();
})), Za = /* @__PURE__ */ O(((e, t) => {
	t.exports = Xa();
})), Qa = /* @__PURE__ */ O(((e, t) => {
	var n = gn(), r = TypeError;
	t.exports = function(e, t) {
		if (!delete e[t]) throw new r("Cannot delete property " + n(t) + " of " + n(e));
	};
})), $a = /* @__PURE__ */ O(((e, t) => {
	var n = nr(), r = Math.floor, i = function(e, t) {
		var a = e.length;
		if (a < 8) for (var o = 1, s, c; o < a;) {
			for (c = o, s = e[o]; c && t(e[c - 1], s) > 0;) e[c] = e[--c];
			c !== o++ && (e[c] = s);
		}
		else for (var l = r(a / 2), u = i(n(e, 0, l), t), d = i(n(e, l), t), f = u.length, p = d.length, m = 0, h = 0; m < f || h < p;) e[m + h] = m < f && h < p ? t(u[m], d[h]) <= 0 ? u[m++] : d[h++] : m < f ? u[m++] : d[h++];
		return e;
	};
	t.exports = i;
})), eo = /* @__PURE__ */ O(((e, t) => {
	var n = U();
	t.exports = function(e, t) {
		var r = [][e];
		return !!r && n(function() {
			r.call(null, t || function() {
				return 1;
			}, 1);
		});
	};
})), to = /* @__PURE__ */ O(((e, t) => {
	var n = dn().match(/firefox\/(\d+)/i);
	t.exports = !!n && +n[1];
})), no = /* @__PURE__ */ O(((e, t) => {
	var n = dn();
	t.exports = /MSIE|Trident/.test(n);
})), ro = /* @__PURE__ */ O(((e, t) => {
	var n = dn().match(/AppleWebKit\/(\d+)\./);
	t.exports = !!n && +n[1];
})), io = /* @__PURE__ */ O((() => {
	var e = q(), t = W(), n = _n(), r = wn(), i = Qn(), a = Qa(), o = lr(), s = U(), c = $a(), l = eo(), u = to(), d = no(), f = fn(), p = ro(), m = [], h = t(m.sort), g = t(m.push), _ = s(function() {
		m.sort(void 0);
	}), v = s(function() {
		m.sort(null);
	}), y = l("sort"), b = !s(function() {
		if (f) return f < 70;
		if (!(u && u > 3)) {
			if (d) return !0;
			if (p) return p < 603;
			var e = "", t, n, r, i;
			for (t = 65; t < 76; t++) {
				switch (n = String.fromCharCode(t), t) {
					case 66:
					case 69:
					case 70:
					case 72:
						r = 3;
						break;
					case 68:
					case 71:
						r = 4;
						break;
					default: r = 2;
				}
				for (i = 0; i < 47; i++) m.push({
					k: n + i,
					v: r
				});
			}
			for (m.sort(function(e, t) {
				return t.v - e.v;
			}), i = 0; i < m.length; i++) n = m[i].k.charAt(0), e.charAt(e.length - 1) !== n && (e += n);
			return e !== "DGBEFHACIJK";
		}
	}), x = _ || !v || !y || !b, S = function(e) {
		return function(t, n) {
			if (n === void 0) return -1;
			if (t === void 0) return 1;
			if (e !== void 0) return +e(t, n) || 0;
			var r = o(t), i = o(n);
			return r === i ? 0 : r > i ? 1 : -1;
		};
	};
	e({
		target: "Array",
		proto: !0,
		forced: x
	}, { sort: function(e) {
		e !== void 0 && n(e);
		var t = r(this);
		if (b) return e === void 0 ? h(t) : h(t, e);
		var o = [], s = i(t), l, u;
		for (u = 0; u < s; u++) u in t && g(o, t[u]);
		for (c(o, S(e)), l = i(o), u = 0; u < l;) t[u] = o[u++];
		for (; u < s;) a(t, u++);
		return t;
	} });
})), ao = /* @__PURE__ */ O(((e, t) => {
	io(), t.exports = ir()("Array", "sort");
})), oo = /* @__PURE__ */ O(((e, t) => {
	var n = un(), r = ao(), i = Array.prototype;
	t.exports = function(e) {
		var t = e.sort;
		return e === i || n(i, e) && t === i.sort ? r : t;
	};
})), so = /* @__PURE__ */ O(((e, t) => {
	t.exports = oo();
})), co = /* @__PURE__ */ O(((e, t) => {
	t.exports = so();
})), lo = /* @__PURE__ */ O(((e, t) => {
	t.exports = "	\n\v\f\r \xA0              　\u2028\u2029﻿";
})), uo = /* @__PURE__ */ O(((e, t) => {
	var n = W(), r = an(), i = lr(), a = lo(), o = n("".replace), s = RegExp("^[" + a + "]+"), c = RegExp("(^|[^" + a + "])[" + a + "]+$"), l = function(e) {
		return function(t) {
			var n = i(r(t));
			return e & 1 && (n = o(n, s, "")), e & 2 && (n = o(n, c, "$1")), n;
		};
	};
	t.exports = {
		start: l(1),
		end: l(2),
		trim: l(3)
	};
})), fo = /* @__PURE__ */ O(((e, t) => {
	var n = H(), r = U(), i = W(), a = lr(), o = uo().trim, s = lo(), c = n.parseInt, l = n.Symbol, u = l && l.iterator, d = /^[+-]?0x/i, f = i(d.exec);
	t.exports = c(s + "08") !== 8 || c(s + "0x16") !== 22 || u && !r(function() {
		c(Object(u));
	}) ? function(e, t) {
		var n = o(a(e));
		return c(n, t >>> 0 || (f(d, n) ? 16 : 10));
	} : c;
})), po = /* @__PURE__ */ O((() => {
	var e = q(), t = fo();
	e({
		global: !0,
		forced: parseInt !== t
	}, { parseInt: t });
})), mo = /* @__PURE__ */ O(((e, t) => {
	po(), t.exports = cn().parseInt;
})), ho = /* @__PURE__ */ O(((e, t) => {
	t.exports = mo();
})), go = /* @__PURE__ */ O(((e, t) => {
	t.exports = ho();
})), _o = /* @__PURE__ */ O((() => {
	var e = q(), t = Zt(), n = gr().indexOf, r = eo(), i = t([].indexOf), a = !!i && 1 / i([1], 1, -0) < 0;
	e({
		target: "Array",
		proto: !0,
		forced: a || !r("indexOf")
	}, { indexOf: function(e) {
		var t = arguments.length > 1 ? arguments[1] : void 0;
		return a ? i(this, e, t) || 0 : n(this, e, t);
	} });
})), vo = /* @__PURE__ */ O(((e, t) => {
	_o(), t.exports = ir()("Array", "indexOf");
})), yo = /* @__PURE__ */ O(((e, t) => {
	var n = un(), r = vo(), i = Array.prototype;
	t.exports = function(e) {
		var t = e.indexOf;
		return e === i || n(i, e) && t === i.indexOf ? r : t;
	};
})), bo = /* @__PURE__ */ O(((e, t) => {
	t.exports = yo();
})), xo = /* @__PURE__ */ O(((e, t) => {
	t.exports = bo();
})), So = /* @__PURE__ */ O(((e, t) => {
	var n = oi().forEach;
	t.exports = eo()("forEach") ? [].forEach : function(e) {
		return n(this, e, arguments.length > 1 ? arguments[1] : void 0);
	};
})), Co = /* @__PURE__ */ O((() => {
	var e = q(), t = So();
	e({
		target: "Array",
		proto: !0,
		forced: [].forEach !== t
	}, { forEach: t });
})), wo = /* @__PURE__ */ O(((e, t) => {
	Co(), t.exports = ir()("Array", "forEach");
})), To = /* @__PURE__ */ O(((e, t) => {
	t.exports = wo();
})), Eo = /* @__PURE__ */ O((() => {})), Do = /* @__PURE__ */ O(((e, t) => {
	var n = Gn(), r = Tn(), i = un(), a = To();
	Eo();
	var o = Array.prototype, s = {
		DOMTokenList: !0,
		NodeList: !0
	};
	t.exports = function(e) {
		var t = e.forEach;
		return e === o || i(o, e) && t === o.forEach || r(s, n(e)) ? a : t;
	};
})), Oo = /* @__PURE__ */ O(((e, t) => {
	t.exports = Do();
})), ko = /* @__PURE__ */ O(((e, t) => {
	Qr(), t.exports = ir()("Array", "concat");
})), Ao = /* @__PURE__ */ O(((e, t) => {
	var n = un(), r = ko(), i = Array.prototype;
	t.exports = function(e) {
		var t = e.concat;
		return e === i || n(i, e) && t === i.concat ? r : t;
	};
})), jo = /* @__PURE__ */ O(((e, t) => {
	t.exports = Ao();
})), Mo = /* @__PURE__ */ O(((e, t) => {
	t.exports = jo();
})), No = /* @__PURE__ */ O(((e, t) => {
	var n = cr(), r = Jr(), i = Hi(), a = Ji(), o = Qi(), s = Vn(), c = Hn();
	s(e, "__esModule", { value: !0 }), e.default = void 0;
	var l = c(za()), u = c(Ua()), d = c(Za()), f = c(co()), p = c(cr()), m = c(go()), h = c(xo()), g = c(Oo()), _ = c(Mo());
	function v(e, t) {
		var n = i !== void 0 && a(e) || e["@@iterator"];
		if (!n) {
			if (o(e) || (n = y(e)) || t && e && typeof e.length == "number") {
				n && (e = n);
				var r = 0, s = function() {};
				return {
					s,
					n: function() {
						return r >= e.length ? { done: !0 } : {
							done: !1,
							value: e[r++]
						};
					},
					e: function(e) {
						throw e;
					},
					f: s
				};
			}
			throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		var c, l = !0, u = !1;
		return {
			s: function() {
				n = n.call(e);
			},
			n: function() {
				var e = n.next();
				return l = e.done, e;
			},
			e: function(e) {
				u = !0, c = e;
			},
			f: function() {
				try {
					l || n.return == null || n.return();
				} finally {
					if (u) throw c;
				}
			}
		};
	}
	function y(e, t) {
		if (e) {
			var i;
			if (typeof e == "string") return b(e, t);
			var a = n(i = {}.toString.call(e)).call(i, 8, -1);
			return a === "Object" && e.constructor && (a = e.constructor.name), a === "Map" || a === "Set" ? r(e) : a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? b(e, t) : void 0;
		}
	}
	function b(e, t) {
		(t == null || t > e.length) && (t = e.length);
		for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
		return r;
	}
	var x = "xregexp", S = {
		astral: !1,
		namespacing: !0
	}, C = {}, w = (0, u.default)(null), T = (0, u.default)(null), E = [], D = "default", O = "class", k = {
		default: /\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9]\d*|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|\(\?(?:[:=!]|<[=!])|[?*+]\?|{\d+(?:,\d*)?}\??|[\s\S]/,
		class: /\\(?:[0-3][0-7]{0,2}|[4-7][0-7]?|x[\dA-Fa-f]{2}|u(?:[\dA-Fa-f]{4}|{[\dA-Fa-f]+})|c[A-Za-z]|[\s\S])|[\s\S]/
	}, A = /\$(?:\{([^\}]+)\}|<([^>]+)>|(\d\d?|[\s\S]?))/g, j = /()??/.exec("")[1] === void 0, M = (0, d.default)(/x/) !== void 0;
	function N(e) {
		var t = !0;
		try {
			if (RegExp("", e), e === "y") {
				var n = function() {
					return "gy";
				}();
				".a".replace(RegExp("a", n), ".") === ".." && (t = !1);
			}
		} catch {
			t = !1;
		}
		return t;
	}
	var P = N("d"), F = N("s"), I = N("u"), L = N("y"), ee = {
		d: P,
		g: !0,
		i: !0,
		m: !0,
		s: F,
		u: I,
		y: L
	}, te = F ? /[^dgimsuy]+/g : /[^dgimuy]+/g;
	function ne(e, t, n, r, i) {
		var a;
		if (e[x] = { captureNames: t }, i) return e;
		if (e.__proto__) e.__proto__ = B.prototype;
		else for (var o in B.prototype) e[o] = B.prototype[o];
		return e[x].source = n, e[x].flags = r && (0, f.default)(a = r.split("")).call(a).join(""), e;
	}
	function re(e) {
		return e.replace(/([\s\S])(?=[\s\S]*\1)/g, "");
	}
	function R(e, t) {
		var n;
		if (!B.isRegExp(e)) throw TypeError("Type RegExp expected");
		var r = e[x] || {}, i = oe(e), a = "", o = "", s = null, c = null;
		return t = t || {}, t.removeG && (o += "g"), t.removeY && (o += "y"), o && (i = i.replace(RegExp(`[${o}]+`, "g"), "")), t.addG && (a += "g"), t.addY && (a += "y"), a && (i = re(i + a)), t.isInternalOnly || (r.source !== void 0 && (s = r.source), (0, d.default)(r) != null && (c = a ? re((0, d.default)(r) + a) : (0, d.default)(r))), e = ne(new RegExp(t.source || e.source, i), se(e) ? (0, p.default)(n = r.captureNames).call(n, 0) : null, s, c, t.isInternalOnly), e;
	}
	function ie(e) {
		return (0, m.default)(e, 16);
	}
	function ae(e, t, n) {
		var r = e.index + e[0].length, i = e.input[e.index - 1], a = e.input[r];
		return /^[()|]$/.test(i) || /^[()|]$/.test(a) || e.index === 0 || r === e.input.length || /\(\?(?:[:=!]|<[=!])$/.test(e.input.substring(e.index - 4, e.index)) || le(e.input, r, n) ? "" : "(?:)";
	}
	function oe(e) {
		return M ? (0, d.default)(e) : /\/([a-z]*)$/i.exec(RegExp.prototype.toString.call(e))[1];
	}
	function se(e) {
		return !!(e[x] && e[x].captureNames);
	}
	function ce(e) {
		return (0, m.default)(e, 10).toString(16);
	}
	function le(e, t, n) {
		return ((0, h.default)(n).call(n, "x") === -1 ? /^(?:\(\?#[^)]*\))*(?:[?*+]|{\d+(?:,\d*)?})/ : /^(?:\s|#[^#\n]*|\(\?#[^)]*\))*(?:[?*+]|{\d+(?:,\d*)?})/).test((0, p.default)(e).call(e, t));
	}
	function ue(e, t) {
		return Object.prototype.toString.call(e) === `[object ${t}]`;
	}
	function z(e) {
		if (e == null) throw TypeError("Cannot convert null or undefined to object");
		return e;
	}
	function de(e) {
		for (; e.length < 4;) e = `0${e}`;
		return e;
	}
	function fe(e, t) {
		if (re(t) !== t) throw SyntaxError(`Invalid duplicate regex flag ${t}`);
		e = e.replace(/^\(\?([\w$]+)\)/, function(e, n) {
			if (/[dgy]/.test(n)) throw SyntaxError(`Cannot use flags dgy in mode modifier ${e}`);
			return t = re(t + n), "";
		});
		var n = v(t), r;
		try {
			for (n.s(); !(r = n.n()).done;) {
				var i = r.value;
				if (!ee[i]) throw SyntaxError(`Unknown regex flag ${i}`);
			}
		} catch (e) {
			n.e(e);
		} finally {
			n.f();
		}
		return {
			pattern: e,
			flags: t
		};
	}
	function pe(e) {
		var t = {};
		return ue(e, "String") ? ((0, g.default)(B).call(B, e, /[^\s,]+/, function(e) {
			t[e] = !0;
		}), t) : e;
	}
	function me(e) {
		if (!/^[\w$]$/.test(e)) throw Error("Flag must be a single character A-Za-z0-9_$");
		ee[e] = !0;
	}
	function he(e, t, n, r, i) {
		for (var a = E.length, o = e[n], s = null, c, l; a--;) if (l = E[a], !(l.leadChar && l.leadChar !== o || l.scope !== r && l.scope !== "all" || l.flag && (0, h.default)(t).call(t, l.flag) === -1) && (c = B.exec(e, l.regex, n, "sticky"), c)) {
			s = {
				matchLength: c[0].length,
				output: l.handler.call(i, c, r, t),
				reparse: l.reparse
			};
			break;
		}
		return s;
	}
	function ge(e) {
		S.astral = e;
	}
	function _e(e) {
		S.namespacing = e;
	}
	function B(e, t) {
		if (B.isRegExp(e)) {
			if (t !== void 0) throw TypeError("Cannot supply flags when copying a RegExp");
			return R(e);
		}
		if (e = e === void 0 ? "" : String(e), t = t === void 0 ? "" : String(t), B.isInstalled("astral") && (0, h.default)(t).call(t, "A") === -1 && (t += "A"), T[e] || (T[e] = {}), !T[e][t]) {
			for (var n = {
				hasNamedCapture: !1,
				captureNames: []
			}, r = D, i = "", a = 0, o, s = fe(e, t), c = s.pattern, u = (0, d.default)(s); a < c.length;) {
				do
					o = he(c, u, a, r, n), o && o.reparse && (c = (0, p.default)(c).call(c, 0, a) + o.output + (0, p.default)(c).call(c, a + o.matchLength));
				while (o && o.reparse);
				if (o) i += o.output, a += o.matchLength || 1;
				else {
					var f = B.exec(c, k[r], a, "sticky"), m = (0, l.default)(f, 1)[0];
					i += m, a += m.length, m === "[" && r === D ? r = O : m === "]" && r === O && (r = D);
				}
			}
			T[e][t] = {
				pattern: i.replace(/(?:\(\?:\))+/g, "(?:)"),
				flags: u.replace(te, ""),
				captures: n.hasNamedCapture ? n.captureNames : null
			};
		}
		var g = T[e][t];
		return ne(new RegExp(g.pattern, (0, d.default)(g)), g.captures, e, t);
	}
	B.prototype = /(?:)/, B.version = "5.1.2", B._clipDuplicates = re, B._hasNativeFlag = N, B._dec = ie, B._hex = ce, B._pad4 = de, B.addToken = function(e, t, n) {
		n = n || {};
		var r = n.optionalFlags;
		if (n.flag && me(n.flag), r) {
			r = r.split("");
			var i = v(r), a;
			try {
				for (i.s(); !(a = i.n()).done;) {
					var o = a.value;
					me(o);
				}
			} catch (e) {
				i.e(e);
			} finally {
				i.f();
			}
		}
		E.push({
			regex: R(e, {
				addG: !0,
				addY: L,
				isInternalOnly: !0
			}),
			handler: t,
			scope: n.scope || D,
			flag: n.flag,
			reparse: n.reparse,
			leadChar: n.leadChar
		}), B.cache.flush("patterns");
	}, B.cache = function(e, t) {
		return w[e] || (w[e] = {}), w[e][t] || (w[e][t] = B(e, t));
	}, B.cache.flush = function(e) {
		e === "patterns" ? T = (0, u.default)(null) : w = (0, u.default)(null);
	}, B.escape = function(e) {
		return String(z(e)).replace(/[\\\[\]{}()*+?.^$|]/g, "\\$&").replace(/[\s#\-,]/g, function(e) {
			return `\\u${de(ce(e.charCodeAt(0)))}`;
		});
	}, B.exec = function(e, t, n, r) {
		var i = "g", a = !1, o = !1, s;
		a = L && !!(r || t.sticky && r !== !1), a ? i += "y" : r && (o = !0, i += "FakeY"), t[x] = t[x] || {};
		var c = t[x][i] || (t[x][i] = R(t, {
			addG: !0,
			addY: a,
			source: o ? `${t.source}|()` : void 0,
			removeY: r === !1,
			isInternalOnly: !0
		}));
		return n = n || 0, c.lastIndex = n, s = C.exec.call(c, e), o && s && s.pop() === "" && (s = null), t.global && (t.lastIndex = s ? c.lastIndex : 0), s;
	}, B.forEach = function(e, t, n) {
		for (var r = 0, i = -1, a; a = B.exec(e, t, r);) n(a, ++i, e, t), r = a.index + (a[0].length || 1);
	}, B.globalize = function(e) {
		return R(e, { addG: !0 });
	}, B.install = function(e) {
		e = pe(e), !S.astral && e.astral && ge(!0), !S.namespacing && e.namespacing && _e(!0);
	}, B.isInstalled = function(e) {
		return !!S[e];
	}, B.isRegExp = function(e) {
		return Object.prototype.toString.call(e) === "[object RegExp]";
	}, B.match = function(e, t, n) {
		var r = t.global && n !== "one" || n === "all", i = (r ? "g" : "") + (t.sticky ? "y" : "") || "noGY";
		t[x] = t[x] || {};
		var a = t[x][i] || (t[x][i] = R(t, {
			addG: !!r,
			removeG: n === "one",
			isInternalOnly: !0
		})), o = String(z(e)).match(a);
		return t.global && (t.lastIndex = n === "one" && o ? o.index + o[0].length : 0), r ? o || [] : o && o[0];
	}, B.matchChain = function(e, t) {
		return function e(n, r) {
			var i = t[r].regex ? t[r] : { regex: t[r] }, a = [];
			function o(e) {
				if (i.backref) {
					var t = `Backreference to undefined group: ${i.backref}`, n = isNaN(i.backref);
					if (n && B.isInstalled("namespacing")) {
						if (!(e.groups && i.backref in e.groups)) throw ReferenceError(t);
					} else if (!e.hasOwnProperty(i.backref)) throw ReferenceError(t);
					var r = n && B.isInstalled("namespacing") ? e.groups[i.backref] : e[i.backref];
					a.push(r || "");
				} else a.push(e[0]);
			}
			var s = v(n), c;
			try {
				for (s.s(); !(c = s.n()).done;) {
					var l = c.value;
					(0, g.default)(B).call(B, l, i.regex, o);
				}
			} catch (e) {
				s.e(e);
			} finally {
				s.f();
			}
			return r === t.length - 1 || !a.length ? a : e(a, r + 1);
		}([e], 0);
	}, B.replace = function(e, t, n, r) {
		var i = B.isRegExp(t), a = t.global && r !== "one" || r === "all", o = (a ? "g" : "") + (t.sticky ? "y" : "") || "noGY", s = t;
		i ? (t[x] = t[x] || {}, s = t[x][o] || (t[x][o] = R(t, {
			addG: !!a,
			removeG: r === "one",
			isInternalOnly: !0
		}))) : a && (s = new RegExp(B.escape(String(t)), "g"));
		var c = C.replace.call(z(e), s, n);
		return i && t.global && (t.lastIndex = 0), c;
	}, B.replaceEach = function(e, t) {
		var n = v(t), r;
		try {
			for (n.s(); !(r = n.n()).done;) {
				var i = r.value;
				e = B.replace(e, i[0], i[1], i[2]);
			}
		} catch (e) {
			n.e(e);
		} finally {
			n.f();
		}
		return e;
	}, B.split = function(e, t, n) {
		return C.split.call(z(e), t, n);
	}, B.test = function(e, t, n, r) {
		return !!B.exec(e, t, n, r);
	}, B.uninstall = function(e) {
		e = pe(e), S.astral && e.astral && ge(!1), S.namespacing && e.namespacing && _e(!1);
	}, B.union = function(e, t, n) {
		n = n || {};
		var r = n.conjunction || "or", i = 0, a, o;
		function s(e, t, n) {
			var r = o[i - a];
			if (t) {
				if (++i, r) return `(?<${r}>`;
			} else if (n) return `\\${+n + a}`;
			return e;
		}
		if (!(ue(e, "Array") && e.length)) throw TypeError("Must provide a nonempty array of patterns to merge");
		var c = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g, l = [], u = v(e), d;
		try {
			for (u.s(); !(d = u.n()).done;) {
				var f = d.value;
				B.isRegExp(f) ? (a = i, o = f[x] && f[x].captureNames || [], l.push(B(f.source).source.replace(c, s))) : l.push(B.escape(f));
			}
		} catch (e) {
			u.e(e);
		} finally {
			u.f();
		}
		var p = r === "none" ? "" : "|";
		return B(l.join(p), t);
	}, C.exec = function(e) {
		var t = this.lastIndex, n = RegExp.prototype.exec.apply(this, arguments);
		if (n) {
			if (!j && n.length > 1 && (0, h.default)(n).call(n, "") !== -1) {
				var r, i = R(this, {
					removeG: !0,
					isInternalOnly: !0
				});
				(0, p.default)(r = String(e)).call(r, n.index).replace(i, function() {
					for (var e = arguments.length, t = 1; t < e - 2; ++t) (t < 0 || arguments.length <= t ? void 0 : arguments[t]) === void 0 && (n[t] = void 0);
				});
			}
			if (this[x] && this[x].captureNames) {
				var a = n;
				B.isInstalled("namespacing") && (n.groups = (0, u.default)(null), a = n.groups);
				for (var o = 1; o < n.length; ++o) {
					var s = this[x].captureNames[o - 1];
					s && (a[s] = n[o]);
				}
			} else !n.groups && B.isInstalled("namespacing") && (n.groups = void 0);
			this.global && !n[0].length && this.lastIndex > n.index && (this.lastIndex = n.index);
		}
		return this.global || (this.lastIndex = t), n;
	}, C.test = function(e) {
		return !!C.exec.call(this, e);
	}, C.match = function(e) {
		if (!B.isRegExp(e)) e = new RegExp(e);
		else if (e.global) {
			var t = String.prototype.match.apply(this, arguments);
			return e.lastIndex = 0, t;
		}
		return C.exec.call(e, z(this));
	}, C.replace = function(e, t) {
		var n = B.isRegExp(e), r, i, a;
		return n ? (e[x] && (i = e[x].captureNames), r = e.lastIndex) : e += "", a = ue(t, "Function") ? String(this).replace(e, function() {
			var e = [...arguments];
			if (i) {
				var n;
				B.isInstalled("namespacing") ? (n = (0, u.default)(null), e.push(n)) : (e[0] = new String(e[0]), n = e[0]);
				for (var r = 0; r < i.length; ++r) i[r] && (n[i[r]] = e[r + 1]);
			}
			return t.apply(void 0, e);
		}) : String(z(this)).replace(e, function() {
			var e = [...arguments];
			return String(t).replace(A, n);
			function n(t, n, r, a) {
				n = n || r;
				var o = ue(e[e.length - 1], "Object") ? 4 : 3, s = e.length - o;
				if (n) {
					if (/^\d+$/.test(n)) {
						var c = +n;
						if (c <= s) return e[c] || "";
					}
					var l = i ? (0, h.default)(i).call(i, n) : -1;
					if (l < 0) throw SyntaxError(`Backreference to undefined group ${t}`);
					return e[l + 1] || "";
				}
				if (a === "" || a === " ") throw SyntaxError(`Invalid token ${t}`);
				if (a === "&" || +a == 0) return e[0];
				if (a === "$") return "$";
				if (a === "`") {
					var u;
					return (0, p.default)(u = e[e.length - 1]).call(u, 0, e[e.length - 2]);
				}
				if (a === "'") {
					var d;
					return (0, p.default)(d = e[e.length - 1]).call(d, e[e.length - 2] + e[0].length);
				}
				if (a = +a, !isNaN(a)) {
					if (a > s) throw SyntaxError(`Backreference to undefined group ${t}`);
					return e[a] || "";
				}
				throw SyntaxError(`Invalid token ${t}`);
			}
		}), n && (e.global ? e.lastIndex = 0 : e.lastIndex = r), a;
	}, C.split = function(e, t) {
		if (!B.isRegExp(e)) return String.prototype.split.apply(this, arguments);
		var n = String(this), r = [], i = e.lastIndex, a = 0, o;
		return t = (t === void 0 ? -1 : t) >>> 0, (0, g.default)(B).call(B, n, e, function(e) {
			e.index + e[0].length > a && (r.push((0, p.default)(n).call(n, a, e.index)), e.length > 1 && e.index < n.length && Array.prototype.push.apply(r, (0, p.default)(e).call(e, 1)), o = e[0].length, a = e.index + o);
		}), a === n.length ? (!e.test("") || o) && r.push("") : r.push((0, p.default)(n).call(n, a)), e.lastIndex = i, r.length > t ? (0, p.default)(r).call(r, 0, t) : r;
	}, B.addToken(/\\([ABCE-RTUVXYZaeg-mopqyz]|c(?![A-Za-z])|u(?![\dA-Fa-f]{4}|{[\dA-Fa-f]+})|x(?![\dA-Fa-f]{2}))/, function(e, t) {
		if (e[1] === "B" && t === D) return e[0];
		throw SyntaxError(`Invalid escape ${e[0]}`);
	}, {
		scope: "all",
		leadChar: "\\"
	}), B.addToken(/\\u{([\dA-Fa-f]+)}/, function(e, t, n) {
		var r = ie(e[1]);
		if (r > 1114111) throw SyntaxError(`Invalid Unicode code point ${e[0]}`);
		if (r <= 65535) return `\\u${de(ce(r))}`;
		if (I && (0, h.default)(n).call(n, "u") !== -1) return e[0];
		throw SyntaxError("Cannot use Unicode code point above \\u{FFFF} without flag u");
	}, {
		scope: "all",
		leadChar: "\\"
	}), B.addToken(/\(\?#[^)]*\)/, ae, { leadChar: "(" }), B.addToken(/\s+|#[^\n]*\n?/, ae, { flag: "x" }), F || B.addToken(/\./, function() {
		return "[\\s\\S]";
	}, {
		flag: "s",
		leadChar: "."
	}), B.addToken(/\\k<([^>]+)>/, function(e) {
		var t, n, r = isNaN(e[1]) ? (0, h.default)(t = this.captureNames).call(t, e[1]) + 1 : +e[1], i = e.index + e[0].length;
		if (!r || r > this.captureNames.length) throw SyntaxError(`Backreference to undefined group ${e[0]}`);
		return (0, _.default)(n = `\\${r}`).call(n, i === e.input.length || isNaN(e.input[i]) ? "" : "(?:)");
	}, { leadChar: "\\" }), B.addToken(/\\(\d+)/, function(e, t) {
		if (!(t === D && /^[1-9]/.test(e[1]) && +e[1] <= this.captureNames.length) && e[1] !== "0") throw SyntaxError(`Cannot use octal escape or backreference to undefined group ${e[0]}`);
		return e[0];
	}, {
		scope: "all",
		leadChar: "\\"
	}), B.addToken(/\(\?P?<((?:[\$A-Z_a-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC4\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])(?:[\$0-9A-Z_a-z\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05EF-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u07FD\u0800-\u082D\u0840-\u085B\u0860-\u086A\u0870-\u0887\u0889-\u088E\u0897-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u09FC\u09FE\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9-\u0AFF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B55-\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3C-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C5D\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDD\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1-\u0CF3\u0D00-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D81-\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECE\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1715\u171F-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u180F-\u1819\u1820-\u1878\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1ABF-\u1ACE\u1B00-\u1B4C\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CD0-\u1CD2\u1CD4-\u1CFA\u1D00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA827\uA82C\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF65-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD27\uDD30-\uDD39\uDD40-\uDD65\uDD69-\uDD6D\uDD6F-\uDD85\uDE80-\uDEA9\uDEAB\uDEAC\uDEB0\uDEB1\uDEC2-\uDEC4\uDEFC-\uDF1C\uDF27\uDF30-\uDF50\uDF70-\uDF85\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC00-\uDC46\uDC66-\uDC75\uDC7F-\uDCBA\uDCC2\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD44-\uDD47\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDC9-\uDDCC\uDDCE-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E-\uDE41\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3B-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7-\uDFC0\uDFC2\uDFC5\uDFC7-\uDFCA\uDFCC-\uDFD3\uDFE1\uDFE2]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC5E-\uDC61\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB8\uDEC0-\uDEC9\uDED0-\uDEE3\uDF00-\uDF1A\uDF1D-\uDF2B\uDF30-\uDF39\uDF40-\uDF46]|\uD806[\uDC00-\uDC3A\uDCA0-\uDCE9\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD35\uDD37\uDD38\uDD3B-\uDD43\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD7\uDDDA-\uDDE1\uDDE3\uDDE4\uDE00-\uDE3E\uDE47\uDE50-\uDE99\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0\uDFF0-\uDFF9]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD8E\uDD90\uDD91\uDD93-\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF6\uDF00-\uDF10\uDF12-\uDF3A\uDF3E-\uDF42\uDF50-\uDF5A\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC40-\uDC55\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD39]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDD70-\uDD79\uDE40-\uDE7F\uDF00-\uDF4A\uDF4F-\uDF87\uDF8F-\uDF9F\uDFE0\uDFE1\uDFE3\uDFE4\uDFF0\uDFF1]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD833[\uDCF0-\uDCF9\uDF00-\uDF2D\uDF30-\uDF46]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDC30-\uDC6D\uDC8F\uDD00-\uDD2C\uDD30-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAE\uDEC0-\uDEF9]|\uD839[\uDCD0-\uDCF9\uDDD0-\uDDFA\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4B\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF]|\uDB40[\uDD00-\uDDEF])*)>/, function(e) {
		var t;
		if (!B.isInstalled("namespacing") && (e[1] === "length" || e[1] === "__proto__")) throw SyntaxError(`Cannot use reserved word as capture name ${e[0]}`);
		if ((0, h.default)(t = this.captureNames).call(t, e[1]) !== -1) throw SyntaxError(`Cannot use same name for multiple groups ${e[0]}`);
		return this.captureNames.push(e[1]), this.hasNamedCapture = !0, "(";
	}, { leadChar: "(" }), B.addToken(/\((?!\?)/, function(e, t, n) {
		return (0, h.default)(n).call(n, "n") === -1 ? (this.captureNames.push(null), "(") : "(?:";
	}, {
		optionalFlags: "n",
		leadChar: "("
	}), e.default = B, t.exports = e.default;
})), Po = /* @__PURE__ */ O(((e, t) => {
	var n = _n(), r = wn(), i = nn(), a = Qn(), o = TypeError, s = "Reduce of empty array with no initial value", c = function(e) {
		return function(t, c, l, u) {
			var d = r(t), f = i(d), p = a(d);
			if (n(c), p === 0 && l < 2) throw new o(s);
			var m = e ? p - 1 : 0, h = e ? -1 : 1;
			if (l < 2) for (;;) {
				if (m in f) {
					u = f[m], m += h;
					break;
				}
				if (m += h, e ? m < 0 : p <= m) throw new o(s);
			}
			for (; e ? m >= 0 : p > m; m += h) m in f && (u = c(u, f[m], m, d));
			return u;
		};
	};
	t.exports = {
		left: c(!1),
		right: c(!0)
	};
})), Fo = /* @__PURE__ */ O(((e, t) => {
	var n = H(), r = dn(), i = Xt(), a = function(e) {
		return r.slice(0, e.length) === e;
	};
	t.exports = (function() {
		return a("Bun/") ? "BUN" : a("Cloudflare-Workers") ? "CLOUDFLARE" : a("Deno/") ? "DENO" : a("Node.js/") ? "NODE" : n.Bun && typeof Bun.version == "string" ? "BUN" : n.Deno && typeof Deno.version == "object" ? "DENO" : i(n.process) === "process" ? "NODE" : n.window && n.document ? "BROWSER" : "REST";
	})();
})), Io = /* @__PURE__ */ O(((e, t) => {
	t.exports = Fo() === "NODE";
})), Lo = /* @__PURE__ */ O((() => {
	var e = q(), t = Po().left, n = eo(), r = fn();
	e({
		target: "Array",
		proto: !0,
		forced: !Io() && r > 79 && r < 83 || !n("reduce")
	}, { reduce: function(e) {
		var n = arguments.length;
		return t(this, e, n, n > 1 ? arguments[1] : void 0);
	} });
})), Ro = /* @__PURE__ */ O(((e, t) => {
	Lo(), t.exports = ir()("Array", "reduce");
})), zo = /* @__PURE__ */ O(((e, t) => {
	var n = un(), r = Ro(), i = Array.prototype;
	t.exports = function(e) {
		var t = e.reduce;
		return e === i || n(i, e) && t === i.reduce ? r : t;
	};
})), Bo = /* @__PURE__ */ O(((e, t) => {
	t.exports = zo();
})), Vo = /* @__PURE__ */ O(((e, t) => {
	t.exports = Bo();
})), Ho = /* @__PURE__ */ O((() => {
	var e = q(), t = oi().map;
	e({
		target: "Array",
		proto: !0,
		forced: !tr()("map")
	}, { map: function(e) {
		return t(this, e, arguments.length > 1 ? arguments[1] : void 0);
	} });
})), Uo = /* @__PURE__ */ O(((e, t) => {
	Ho(), t.exports = ir()("Array", "map");
})), Wo = /* @__PURE__ */ O(((e, t) => {
	var n = un(), r = Uo(), i = Array.prototype;
	t.exports = function(e) {
		var t = e.map;
		return e === i || n(i, e) && t === i.map ? r : t;
	};
})), Go = /* @__PURE__ */ O(((e, t) => {
	t.exports = Wo();
})), Ko = /* @__PURE__ */ O(((e, t) => {
	t.exports = Go();
})), qo = /* @__PURE__ */ O(((e, t) => {
	var n = Vn(), r = Hn();
	n(e, "__esModule", { value: !0 }), e.default = void 0;
	var i = r(Vo()), a = r(Ko()), o = r(xo()), s = r(Mo());
	e.default = function(e) {
		var t = "xregexp", n = /(\()(?!\?)|\\([1-9]\d*)|\\[\s\S]|\[(?:[^\\\]]|\\[\s\S])*\]/g, r = e.union([/\({{([\w$]+)}}\)|{{([\w$]+)}}/, n], "g", { conjunction: "or" });
		function c(e) {
			var t = /^(?:\(\?:\))*\^/, n = /\$(?:\(\?:\))*$/;
			return t.test(e) && n.test(e) && n.test(e.replace(/\\[\s\S]/g, "")) ? e.replace(t, "").replace(n, "") : e;
		}
		function l(n, r) {
			var i = r ? "x" : "";
			return e.isRegExp(n) ? n[t] && n[t].captureNames ? n : e(n.source, i) : e(n, i);
		}
		function u(t) {
			return t instanceof RegExp ? t : e.escape(t);
		}
		function d(e, t, n) {
			return e[`subpattern${n}`] = t, e;
		}
		function f(e, t, n) {
			return e + (t < n.length - 1 ? `{{subpattern${t}}}` : "");
		}
		e.tag = function(t) {
			return function(n) {
				var r, o, s = [...arguments].slice(1), c = (0, i.default)(r = (0, a.default)(s).call(s, u)).call(r, d, {}), l = (0, a.default)(o = n.raw).call(o, f).join("");
				return e.build(l, c, t);
			};
		}, e.build = function(i, a, u) {
			u = u || "";
			var d = (0, o.default)(u).call(u, "x") !== -1, f = /^\(\?([\w$]+)\)/.exec(i);
			f && (u = e._clipDuplicates(u + f[1]));
			var p = {};
			for (var m in a) if (a.hasOwnProperty(m)) {
				var h = l(a[m], d);
				p[m] = {
					pattern: c(h.source),
					names: h[t].captureNames || []
				};
			}
			var g = l(i, d), _ = 0, v, y = 0, b = [0], x = g[t].captureNames || [];
			return e(g.source.replace(r, function(e, t, r, i, a) {
				var o = t || r, c, l, u;
				if (o) {
					var d;
					if (!p.hasOwnProperty(o)) throw ReferenceError(`Undefined property ${e}`);
					t ? (c = x[y], b[++y] = ++_, l = `(?<${c || o}>`) : l = "(?:", v = _;
					var f = p[o].pattern.replace(n, function(e, t, n) {
						if (t) {
							if (c = p[o].names[_ - v], ++_, c) return `(?<${c}>`;
						} else if (n) return u = n - 1, p[o].names[u] ? `\\k<${p[o].names[u]}>` : `\\${+n + v}`;
						return e;
					});
					return (0, s.default)(d = `${l}`).call(d, f, ")");
				}
				if (i) {
					if (c = x[y], b[++y] = ++_, c) return `(?<${c}>`;
				} else if (a) return u = a - 1, x[u] ? `\\k<${x[u]}>` : `\\${b[+a]}`;
				return e;
			}), u);
		};
	}, t.exports = e.default;
})), Jo = /* @__PURE__ */ O(((e, t) => {
	var n = Vn(), r = Hn();
	n(e, "__esModule", { value: !0 }), e.default = void 0;
	var i = r(xo()), a = r(Mo()), o = r(cr());
	e.default = function(e) {
		function t(e, t, n, r) {
			return {
				name: e,
				value: t,
				start: n,
				end: r
			};
		}
		e.matchRecursive = function(n, r, s, c, l) {
			c = c || "", l = l || {};
			var u = (0, i.default)(c).call(c, "g") !== -1, d = (0, i.default)(c).call(c, "y") !== -1, f = c.replace(/y/g, "");
			r = e(r, f), s = e(s, f);
			var p, m = l.escapeChar;
			if (m) {
				var h, g;
				if (m.length > 1) throw Error("Cannot use more than one escape character");
				m = e.escape(m), p = new RegExp((0, a.default)(h = (0, a.default)(g = `(?:${m}[\\S\\s]|(?:(?!`).call(g, e.union([r, s], "", { conjunction: "or" }).source, ")[^")).call(h, m, "])+)+"), c.replace(e._hasNativeFlag("s") ? /[^imsu]/g : /[^imu]/g, ""));
			}
			for (var _ = 0, v = 0, y = 0, b = 0, x, S, C, w, T = l.valueNames, E = [];;) {
				if (m && (y += (e.exec(n, p, y, "sticky") || [""])[0].length), C = e.exec(n, r, y), w = e.exec(n, s, y), C && w && (C.index <= w.index ? w = null : C = null), C || w) v = (C || w).index, y = v + (C || w)[0].length;
				else if (!_) break;
				if (d && !_ && v > b) break;
				if (C) _ || (x = v, S = y), _ += 1;
				else if (w && _) {
					if (--_, !_ && (T ? (T[0] && x > b && E.push(t(T[0], (0, o.default)(n).call(n, b, x), b, x)), T[1] && E.push(t(T[1], (0, o.default)(n).call(n, x, S), x, S)), T[2] && E.push(t(T[2], (0, o.default)(n).call(n, S, v), S, v)), T[3] && E.push(t(T[3], (0, o.default)(n).call(n, v, y), v, y))) : E.push((0, o.default)(n).call(n, S, v)), b = y, !u)) break;
				} else {
					var D = l.unbalanced || "error";
					if (D === "skip" || D === "skip-lazy") if (w) w = null;
					else {
						if (D === "skip") {
							var O = e.exec(n, r, x, "sticky")[0].length;
							y = x + (O || 1);
						} else y = x + 1;
						_ = 0;
					}
					else if (D === "error") {
						var k, A = w ? "right" : "left", j = w ? v : x;
						throw Error((0, a.default)(k = `Unbalanced ${A} delimiter found in string at position `).call(k, j));
					} else throw Error(`Unsupported value for unbalanced: ${D}`);
				}
				v === y && (y += 1);
			}
			return u && E.length > 0 && !d && T && T[0] && n.length > b && E.push(t(T[0], (0, o.default)(n).call(n, b), b, n.length)), E;
		};
	}, t.exports = e.default;
})), Yo = /* @__PURE__ */ O(((e, t) => {
	var n = cr(), r = Jr(), i = Hi(), a = Ji(), o = Qi(), s = Vn(), c = Hn();
	s(e, "__esModule", { value: !0 }), e.default = void 0;
	var l = c(za()), u = c(Oo()), d = c(Mo()), f = c(xo());
	function p(e, t) {
		var n = i !== void 0 && a(e) || e["@@iterator"];
		if (!n) {
			if (o(e) || (n = m(e)) || t && e && typeof e.length == "number") {
				n && (e = n);
				var r = 0, s = function() {};
				return {
					s,
					n: function() {
						return r >= e.length ? { done: !0 } : {
							done: !1,
							value: e[r++]
						};
					},
					e: function(e) {
						throw e;
					},
					f: s
				};
			}
			throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
		}
		var c, l = !0, u = !1;
		return {
			s: function() {
				n = n.call(e);
			},
			n: function() {
				var e = n.next();
				return l = e.done, e;
			},
			e: function(e) {
				u = !0, c = e;
			},
			f: function() {
				try {
					l || n.return == null || n.return();
				} finally {
					if (u) throw c;
				}
			}
		};
	}
	function m(e, t) {
		if (e) {
			var i;
			if (typeof e == "string") return h(e, t);
			var a = n(i = {}.toString.call(e)).call(i, 8, -1);
			return a === "Object" && e.constructor && (a = e.constructor.name), a === "Map" || a === "Set" ? r(e) : a === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a) ? h(e, t) : void 0;
		}
	}
	function h(e, t) {
		(t == null || t > e.length) && (t = e.length);
		for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
		return r;
	}
	e.default = function(e) {
		var t = {}, n = {}, r = e._dec, i = e._hex, a = e._pad4;
		function o(e) {
			return e.replace(/[- _]+/g, "").toLowerCase();
		}
		function s(e) {
			var t = /^\\[xu](.+)/.exec(e);
			return t ? r(t[1]) : e.charCodeAt(+(e[0] === "\\"));
		}
		function c(t) {
			var n = "", r = -1;
			return (0, u.default)(e).call(e, t, /(\\x..|\\u....|\\?[\s\S])(?:-(\\x..|\\u....|\\?[\s\S]))?/, function(e) {
				var t = s(e[1]);
				t > r + 1 && (n += `\\u${a(i(r + 1))}`, t > r + 2 && (n += `-\\u${a(i(t - 1))}`)), r = s(e[2] || e[1]);
			}), r < 65535 && (n += `\\u${a(i(r + 1))}`, r < 65534 && (n += "-\\uFFFF")), n;
		}
		function m(e) {
			var n = "b!";
			return t[e][n] || (t[e][n] = c(t[e].bmp));
		}
		function h(e, n) {
			var r = t[e], i = "";
			if (r.bmp && !r.isBmpLast) {
				var a;
				i = (0, d.default)(a = `[${r.bmp}]`).call(a, r.astral ? "|" : "");
			}
			if (r.astral && (i += r.astral), r.isBmpLast && r.bmp) {
				var o;
				i += (0, d.default)(o = `${r.astral ? "|" : ""}[`).call(o, r.bmp, "]");
			}
			return n ? `(?:(?!${i})(?:[�d800-�dbff][�dc00-�dfff]|[ -￿]))` : `(?:${i})`;
		}
		function g(e, n) {
			var r = n ? "a!" : "a=";
			return t[e][r] || (t[e][r] = h(e, n));
		}
		e.addToken(/\\([pP])(?:{(\^?)(?:(\w+)=)?([^}]*)}|([A-Za-z]))/, function(e, r, i) {
			var a = "Invalid double negation ", s = "Unknown Unicode token ", c = "Unicode token missing data ", u = "Astral mode required for Unicode token ", p = "Astral mode does not support Unicode tokens within character classes", h = (0, l.default)(e, 6), _ = h[0], v = h[1], y = h[2], b = h[3], x = h[4], S = h[5], C = v === "P" || !!y, w = (0, f.default)(i).call(i, "A") !== -1, T = o(S || x), E = t[T];
			if (v === "P" && y) throw SyntaxError(a + _);
			if (!t.hasOwnProperty(T) || b && !(n[b] && n[b][T])) throw SyntaxError(s + _);
			if (E.inverseOf) {
				if (T = o(E.inverseOf), !t.hasOwnProperty(T)) {
					var D;
					throw ReferenceError((0, d.default)(D = `${c + _} -> `).call(D, E.inverseOf));
				}
				E = t[T], C = !C;
			}
			if (!(E.bmp || w)) throw SyntaxError(u + _);
			if (w) {
				if (r === "class") throw SyntaxError(p);
				return g(T, C);
			}
			return r === "class" ? C ? m(T) : E.bmp : `${(C ? "[^" : "[") + E.bmp}]`;
		}, {
			scope: "all",
			optionalFlags: "A",
			leadChar: "\\"
		}), e.addUnicodeData = function(r, i) {
			var a = "Unicode token requires name", s = "Unicode token has no character data ";
			i && (n[i] = {});
			var c = p(r), l;
			try {
				for (c.s(); !(l = c.n()).done;) {
					var u = l.value;
					if (!u.name) throw Error(a);
					if (!(u.inverseOf || u.bmp || u.astral)) throw Error(s + u.name);
					var d = o(u.name);
					if (t[d] = u, i && (n[i][d] = !0), u.alias) {
						var f = o(u.alias);
						t[f] = u, i && (n[i][f] = !0);
					}
				}
			} catch (e) {
				c.e(e);
			} finally {
				c.f();
			}
			e.cache.flush("patterns");
		}, e._getUnicodeProperty = function(e) {
			return t[o(e)];
		};
	}, t.exports = e.default;
})), Xo = /* @__PURE__ */ O(((e, t) => {
	t.exports = [
		{
			name: "C",
			alias: "Other",
			isBmpLast: !0,
			bmp: "\0--­͸͹΀-΃΋΍΢԰՗՘֋֌֐׈-׏׫-׮׵-؅؜۝܎܏݋݌޲-޿߻߼࠮࠯࠿࡜࡝࡟࡫-࡯࢏-ࢗ࣢঄঍঎঑঒঩঱঳-঵঺঻৅৆৉৊৏-৖৘-৛৞৤৥৿਀਄਋-਎਑਒਩਱਴਷਺਻਽੃-੆੉੊੎-੐੒-੘੝੟-੥੷-઀઄઎઒઩઱઴઺઻૆૊૎૏૑-૟૤૥૲-૸଀଄଍଎଑଒଩଱଴଺଻୅୆୉୊୎-୔୘-୛୞୤୥୸-஁஄஋-஍஑஖-஘஛஝஠-஢஥-஧஫-஭஺-஽௃-௅௉௎௏௑-௖௘-௥௻-௿఍఑఩఺఻౅౉౎-౔౗౛౜౞౟౤౥౰-౶಍಑಩಴಺಻೅೉೎-೔೗-೜೟೤೥೰ೳ-೿഍഑൅൉൐-൓൤൥඀඄඗-඙඲඼඾඿෇-෉෋-෎෕෗෠-෥෰෱෵-฀฻-฾๜-຀຃຅຋຤຦຾຿໅໇໎໏໚໛໠-໿཈཭-཰྘྽࿍࿛-࿿჆჈-჌჎჏቉቎቏቗቙቞቟኉኎኏኱኶኷኿዁዆዇዗጑጖጗፛፜፽-፿᎚-᎟᏶᏷᏾᏿᚝-᚟᛹-᛿᜖-᜞᜷-᜿᝔-᝟᝭᝱᝴-᝿៞៟៪-៯៺-៿᠎᠚-᠟᡹-᡿᢫-᢯᣶-᣿᤟᤬-᤯᤼-᤿᥁-᥃᥮᥯᥵-᥿᦬-᦯᧊-᧏᧛-᧝᨜᨝᩟᩽᩾᪊-᪏᪚-᪟᪮᪯᫏-᫿᭍-᭏᭿᯴-᯻᰸-᰺᱊-᱌Ᲊ-᲏᲻᲼᳈-᳏᳻-᳿἖἗἞἟὆὇὎὏὘὚὜὞὾὿᾵῅῔῕῜῰῱῵῿​-‏‪-‮⁠-⁯⁲⁳₏₝-₟⃁-⃏⃱-⃿↌-↏␧-␿⑋-⑟⭴⭵⮖⳴-⳸⴦⴨-⴬⴮⴯⵨-⵮⵱-⵾⶗-⶟⶧⶯⶷⶿⷇⷏⷗⷟⹞-⹿⺚⻴-⻿⿖-⿯⿼-⿿぀゗゘㄀-㄄㄰㆏㇤-㇯㈟꒍-꒏꓇-꓏꘬-꘿꛸-꛿Ɤ-꟏꟒꟔Ꟛ-꟱꠭-꠯꠺-꠿꡸-꡿꣆-꣍꣚-꣟꥔-꥞꥽-꥿꧎꧚-꧝꧿꨷-꨿꩎꩏꩚꩛꫃-꫚꫷-꬀꬇꬈꬏꬐꬗-꬟꬧꬯꭬-꭯꯮꯯꯺-꯿힤-힯퟇-퟊퟼-﩮﩯﫚-﫿﬇-﬒﬘-﬜﬷﬽﬿﭂﭅﯃-﯒﶐﶑﷈-﷎﷐-﷯︚-︟﹓﹧﹬-﹯﹵﻽-＀﾿-￁￈￉￐￑￘￙￝-￟￧￯-￻￾￿",
			astral: "\ud800[\udc0c\udc27\udc3b\udc3e\udc4e\udc4f\udc5e-\udc7f\udcfb-\udcff\udd03-\udd06\udd34-\udd36\udd8f\udd9d-\udd9f\udda1-\uddcf\uddfe-\ude7f\ude9d-\ude9f\uded1-\udedf\udefc-\udeff\udf24-\udf2c\udf4b-\udf4f\udf7b-\udf7f\udf9e\udfc4-\udfc7\udfd6-\udfff]|\ud801[\udc9e\udc9f\udcaa-\udcaf\udcd4-\udcd7\udcfc-\udcff\udd28-\udd2f\udd64-\udd6e\udd7b\udd8b\udd93\udd96\udda2\uddb2\uddba\uddbd-\uddff\udf37-\udf3f\udf56-\udf5f\udf68-\udf7f\udf86\udfb1\udfbb-\udfff]|\ud802[\udc06\udc07\udc09\udc36\udc39-\udc3b\udc3d\udc3e\udc56\udc9f-\udca6\udcb0-\udcdf\udcf3\udcf6-\udcfa\udd1c-\udd1e\udd3a-\udd3e\udd40-\udd7f\uddb8-\uddbb\uddd0\uddd1\ude04\ude07-\ude0b\ude14\ude18\ude36\ude37\ude3b-\ude3e\ude49-\ude4f\ude59-\ude5f\udea0-\udebf\udee7-\udeea\udef7-\udeff\udf36-\udf38\udf56\udf57\udf73-\udf77\udf92-\udf98\udf9d-\udfa8\udfb0-\udfff]|\ud803[\udc49-\udc7f\udcb3-\udcbf\udcf3-\udcf9\udd28-\udd2f\udd3a-\ude5f\ude7f\udeaa\udeae\udeaf\udeb2-\udeff\udf28-\udf2f\udf5a-\udf6f\udf8a-\udfaf\udfcc-\udfdf\udff7-\udfff]|\ud804[\udc4e-\udc51\udc76-\udc7e\udcbd\udcc3-\udccf\udce9-\udcef\udcfa-\udcff\udd35\udd48-\udd4f\udd77-\udd7f\udde0\uddf5-\uddff\ude12\ude3f-\ude7f\ude87\ude89\ude8e\ude9e\udeaa-\udeaf\udeeb-\udeef\udefa-\udeff\udf04\udf0d\udf0e\udf11\udf12\udf29\udf31\udf34\udf3a\udf45\udf46\udf49\udf4a\udf4e\udf4f\udf51-\udf56\udf58-\udf5c\udf64\udf65\udf6d-\udf6f\udf75-\udfff]|\ud805[\udc5c\udc62-\udc7f\udcc8-\udccf\udcda-\udd7f\uddb6\uddb7\uddde-\uddff\ude45-\ude4f\ude5a-\ude5f\ude6d-\ude7f\udeba-\udebf\udeca-\udeff\udf1b\udf1c\udf2c-\udf2f\udf47-\udfff]|\ud806[\udc3c-\udc9f\udcf3-\udcfe\udd07\udd08\udd0a\udd0b\udd14\udd17\udd36\udd39\udd3a\udd47-\udd4f\udd5a-\udd9f\udda8\udda9\uddd8\uddd9\udde5-\uddff\ude48-\ude4f\udea3-\udeaf\udef9-\udfff]|\ud807[\udc09\udc37\udc46-\udc4f\udc6d-\udc6f\udc90\udc91\udca8\udcb7-\udcff\udd07\udd0a\udd37-\udd39\udd3b\udd3e\udd48-\udd4f\udd5a-\udd5f\udd66\udd69\udd8f\udd92\udd99-\udd9f\uddaa-\udedf\udef9-\udfaf\udfb1-\udfbf\udff2-\udffe]|\ud808[\udf9a-\udfff]|\ud809[\udc6f\udc75-\udc7f\udd44-\udfff]|[\ud80a\ud80e-\ud810\ud812-\ud819\ud824-\ud82a\ud82d\ud82e\ud830-\ud832\ud83f\ud87b-\ud87d\ud87f\ud885-\udb3f\udb41-\udbff][\udc00-\udfff]|\ud80b[\udc00-\udf8f\udff3-\udfff]|\ud80d[\udc2f-\udfff]|\ud811[\ude47-\udfff]|\ud81a[\ude39-\ude3f\ude5f\ude6a-\ude6d\udebf\udeca-\udecf\udeee\udeef\udef6-\udeff\udf46-\udf4f\udf5a\udf62\udf78-\udf7c\udf90-\udfff]|\ud81b[\udc00-\ude3f\ude9b-\udeff\udf4b-\udf4e\udf88-\udf8e\udfa0-\udfdf\udfe5-\udfef\udff2-\udfff]|\ud821[\udff8-\udfff]|\ud823[\udcd6-\udcff\udd09-\udfff]|\ud82b[\udc00-\udfef\udff4\udffc\udfff]|\ud82c[\udd23-\udd4f\udd53-\udd63\udd68-\udd6f\udefc-\udfff]|\ud82f[\udc6b-\udc6f\udc7d-\udc7f\udc89-\udc8f\udc9a\udc9b\udca0-\udfff]|\ud833[\udc00-\udeff\udf2e\udf2f\udf47-\udf4f\udfc4-\udfff]|\ud834[\udcf6-\udcff\udd27\udd28\udd73-\udd7a\uddeb-\uddff\ude46-\udedf\udef4-\udeff\udf57-\udf5f\udf79-\udfff]|\ud835[\udc55\udc9d\udca0\udca1\udca3\udca4\udca7\udca8\udcad\udcba\udcbc\udcc4\udd06\udd0b\udd0c\udd15\udd1d\udd3a\udd3f\udd45\udd47-\udd49\udd51\udea6\udea7\udfcc\udfcd]|\ud836[\ude8c-\ude9a\udea0\udeb0-\udfff]|\ud837[\udc00-\udeff\udf1f-\udfff]|\ud838[\udc07\udc19\udc1a\udc22\udc25\udc2b-\udcff\udd2d-\udd2f\udd3e\udd3f\udd4a-\udd4d\udd50-\ude8f\udeaf-\udebf\udefa-\udefe\udf00-\udfff]|\ud839[\udc00-\udfdf\udfe7\udfec\udfef\udfff]|\ud83a[\udcc5\udcc6\udcd7-\udcff\udd4c-\udd4f\udd5a-\udd5d\udd60-\udfff]|\ud83b[\udc00-\udc70\udcb5-\udd00\udd3e-\uddff\ude04\ude20\ude23\ude25\ude26\ude28\ude33\ude38\ude3a\ude3c-\ude41\ude43-\ude46\ude48\ude4a\ude4c\ude50\ude53\ude55\ude56\ude58\ude5a\ude5c\ude5e\ude60\ude63\ude65\ude66\ude6b\ude73\ude78\ude7d\ude7f\ude8a\ude9c-\udea0\udea4\udeaa\udebc-\udeef\udef2-\udfff]|\ud83c[\udc2c-\udc2f\udc94-\udc9f\udcaf\udcb0\udcc0\udcd0\udcf6-\udcff\uddae-\udde5\ude03-\ude0f\ude3c-\ude3f\ude49-\ude4f\ude52-\ude5f\ude66-\udeff]|\ud83d[\uded8-\udedc\udeed-\udeef\udefd-\udeff\udf74-\udf7f\udfd9-\udfdf\udfec-\udfef\udff1-\udfff]|\ud83e[\udc0c-\udc0f\udc48-\udc4f\udc5a-\udc5f\udc88-\udc8f\udcae\udcaf\udcb2-\udcff\ude54-\ude5f\ude6e\ude6f\ude75-\ude77\ude7d-\ude7f\ude87-\ude8f\udead-\udeaf\udebb-\udebf\udec6-\udecf\udeda-\udedf\udee8-\udeef\udef7-\udeff\udf93\udfcb-\udfef\udffa-\udfff]|\ud869[\udee0-\udeff]|\ud86d[\udf39-\udf3f]|\ud86e[\udc1e\udc1f]|\ud873[\udea2-\udeaf]|\ud87a[\udfe1-\udfff]|\ud87e[\ude1e-\udfff]|\ud884[\udf4b-\udfff]|\udb40[\udc00-\udcff\uddf0-\udfff]"
		},
		{
			name: "Cc",
			alias: "Control",
			bmp: "\0--"
		},
		{
			name: "Cf",
			alias: "Format",
			bmp: "­؀-؅؜۝܏࢐࢑࣢᠎​-‏‪-‮⁠-⁤⁦-⁯﻿￹-￻",
			astral: "\ud804[\udcbd\udccd]|\ud80d[\udc30-\udc38]|\ud82f[\udca0-\udca3]|\ud834[\udd73-\udd7a]|\udb40[\udc01\udc20-\udc7f]"
		},
		{
			name: "Cn",
			alias: "Unassigned",
			bmp: "͸͹΀-΃΋΍΢԰՗՘֋֌֐׈-׏׫-׮׵-׿܎݋݌޲-޿߻߼࠮࠯࠿࡜࡝࡟࡫-࡯࢏࢒-ࢗ঄঍঎঑঒঩঱঳-঵঺঻৅৆৉৊৏-৖৘-৛৞৤৥৿਀਄਋-਎਑਒਩਱਴਷਺਻਽੃-੆੉੊੎-੐੒-੘੝੟-੥੷-઀઄઎઒઩઱઴઺઻૆૊૎૏૑-૟૤૥૲-૸଀଄଍଎଑଒଩଱଴଺଻୅୆୉୊୎-୔୘-୛୞୤୥୸-஁஄஋-஍஑஖-஘஛஝஠-஢஥-஧஫-஭஺-஽௃-௅௉௎௏௑-௖௘-௥௻-௿఍఑఩఺఻౅౉౎-౔౗౛౜౞౟౤౥౰-౶಍಑಩಴಺಻೅೉೎-೔೗-೜೟೤೥೰ೳ-೿഍഑൅൉൐-൓൤൥඀඄඗-඙඲඼඾඿෇-෉෋-෎෕෗෠-෥෰෱෵-฀฻-฾๜-຀຃຅຋຤຦຾຿໅໇໎໏໚໛໠-໿཈཭-཰྘྽࿍࿛-࿿჆჈-჌჎჏቉቎቏቗቙቞቟኉኎኏኱኶኷኿዁዆዇዗጑጖጗፛፜፽-፿᎚-᎟᏶᏷᏾᏿᚝-᚟᛹-᛿᜖-᜞᜷-᜿᝔-᝟᝭᝱᝴-᝿៞៟៪-៯៺-៿᠚-᠟᡹-᡿᢫-᢯᣶-᣿᤟᤬-᤯᤼-᤿᥁-᥃᥮᥯᥵-᥿᦬-᦯᧊-᧏᧛-᧝᨜᨝᩟᩽᩾᪊-᪏᪚-᪟᪮᪯᫏-᫿᭍-᭏᭿᯴-᯻᰸-᰺᱊-᱌Ᲊ-᲏᲻᲼᳈-᳏᳻-᳿἖἗἞἟὆὇὎὏὘὚὜὞὾὿᾵῅῔῕῜῰῱῵῿⁥⁲⁳₏₝-₟⃁-⃏⃱-⃿↌-↏␧-␿⑋-⑟⭴⭵⮖⳴-⳸⴦⴨-⴬⴮⴯⵨-⵮⵱-⵾⶗-⶟⶧⶯⶷⶿⷇⷏⷗⷟⹞-⹿⺚⻴-⻿⿖-⿯⿼-⿿぀゗゘㄀-㄄㄰㆏㇤-㇯㈟꒍-꒏꓇-꓏꘬-꘿꛸-꛿Ɤ-꟏꟒꟔Ꟛ-꟱꠭-꠯꠺-꠿꡸-꡿꣆-꣍꣚-꣟꥔-꥞꥽-꥿꧎꧚-꧝꧿꨷-꨿꩎꩏꩚꩛꫃-꫚꫷-꬀꬇꬈꬏꬐꬗-꬟꬧꬯꭬-꭯꯮꯯꯺-꯿힤-힯퟇-퟊퟼-퟿﩮﩯﫚-﫿﬇-﬒﬘-﬜﬷﬽﬿﭂﭅﯃-﯒﶐﶑﷈-﷎﷐-﷯︚-︟﹓﹧﹬-﹯﹵﻽﻾＀﾿-￁￈￉￐￑￘￙￝-￟￧￯-￸￾￿",
			astral: "\ud800[\udc0c\udc27\udc3b\udc3e\udc4e\udc4f\udc5e-\udc7f\udcfb-\udcff\udd03-\udd06\udd34-\udd36\udd8f\udd9d-\udd9f\udda1-\uddcf\uddfe-\ude7f\ude9d-\ude9f\uded1-\udedf\udefc-\udeff\udf24-\udf2c\udf4b-\udf4f\udf7b-\udf7f\udf9e\udfc4-\udfc7\udfd6-\udfff]|\ud801[\udc9e\udc9f\udcaa-\udcaf\udcd4-\udcd7\udcfc-\udcff\udd28-\udd2f\udd64-\udd6e\udd7b\udd8b\udd93\udd96\udda2\uddb2\uddba\uddbd-\uddff\udf37-\udf3f\udf56-\udf5f\udf68-\udf7f\udf86\udfb1\udfbb-\udfff]|\ud802[\udc06\udc07\udc09\udc36\udc39-\udc3b\udc3d\udc3e\udc56\udc9f-\udca6\udcb0-\udcdf\udcf3\udcf6-\udcfa\udd1c-\udd1e\udd3a-\udd3e\udd40-\udd7f\uddb8-\uddbb\uddd0\uddd1\ude04\ude07-\ude0b\ude14\ude18\ude36\ude37\ude3b-\ude3e\ude49-\ude4f\ude59-\ude5f\udea0-\udebf\udee7-\udeea\udef7-\udeff\udf36-\udf38\udf56\udf57\udf73-\udf77\udf92-\udf98\udf9d-\udfa8\udfb0-\udfff]|\ud803[\udc49-\udc7f\udcb3-\udcbf\udcf3-\udcf9\udd28-\udd2f\udd3a-\ude5f\ude7f\udeaa\udeae\udeaf\udeb2-\udeff\udf28-\udf2f\udf5a-\udf6f\udf8a-\udfaf\udfcc-\udfdf\udff7-\udfff]|\ud804[\udc4e-\udc51\udc76-\udc7e\udcc3-\udccc\udcce\udccf\udce9-\udcef\udcfa-\udcff\udd35\udd48-\udd4f\udd77-\udd7f\udde0\uddf5-\uddff\ude12\ude3f-\ude7f\ude87\ude89\ude8e\ude9e\udeaa-\udeaf\udeeb-\udeef\udefa-\udeff\udf04\udf0d\udf0e\udf11\udf12\udf29\udf31\udf34\udf3a\udf45\udf46\udf49\udf4a\udf4e\udf4f\udf51-\udf56\udf58-\udf5c\udf64\udf65\udf6d-\udf6f\udf75-\udfff]|\ud805[\udc5c\udc62-\udc7f\udcc8-\udccf\udcda-\udd7f\uddb6\uddb7\uddde-\uddff\ude45-\ude4f\ude5a-\ude5f\ude6d-\ude7f\udeba-\udebf\udeca-\udeff\udf1b\udf1c\udf2c-\udf2f\udf47-\udfff]|\ud806[\udc3c-\udc9f\udcf3-\udcfe\udd07\udd08\udd0a\udd0b\udd14\udd17\udd36\udd39\udd3a\udd47-\udd4f\udd5a-\udd9f\udda8\udda9\uddd8\uddd9\udde5-\uddff\ude48-\ude4f\udea3-\udeaf\udef9-\udfff]|\ud807[\udc09\udc37\udc46-\udc4f\udc6d-\udc6f\udc90\udc91\udca8\udcb7-\udcff\udd07\udd0a\udd37-\udd39\udd3b\udd3e\udd48-\udd4f\udd5a-\udd5f\udd66\udd69\udd8f\udd92\udd99-\udd9f\uddaa-\udedf\udef9-\udfaf\udfb1-\udfbf\udff2-\udffe]|\ud808[\udf9a-\udfff]|\ud809[\udc6f\udc75-\udc7f\udd44-\udfff]|[\ud80a\ud80e-\ud810\ud812-\ud819\ud824-\ud82a\ud82d\ud82e\ud830-\ud832\ud83f\ud87b-\ud87d\ud87f\ud885-\udb3f\udb41-\udb7f][\udc00-\udfff]|\ud80b[\udc00-\udf8f\udff3-\udfff]|\ud80d[\udc2f\udc39-\udfff]|\ud811[\ude47-\udfff]|\ud81a[\ude39-\ude3f\ude5f\ude6a-\ude6d\udebf\udeca-\udecf\udeee\udeef\udef6-\udeff\udf46-\udf4f\udf5a\udf62\udf78-\udf7c\udf90-\udfff]|\ud81b[\udc00-\ude3f\ude9b-\udeff\udf4b-\udf4e\udf88-\udf8e\udfa0-\udfdf\udfe5-\udfef\udff2-\udfff]|\ud821[\udff8-\udfff]|\ud823[\udcd6-\udcff\udd09-\udfff]|\ud82b[\udc00-\udfef\udff4\udffc\udfff]|\ud82c[\udd23-\udd4f\udd53-\udd63\udd68-\udd6f\udefc-\udfff]|\ud82f[\udc6b-\udc6f\udc7d-\udc7f\udc89-\udc8f\udc9a\udc9b\udca4-\udfff]|\ud833[\udc00-\udeff\udf2e\udf2f\udf47-\udf4f\udfc4-\udfff]|\ud834[\udcf6-\udcff\udd27\udd28\uddeb-\uddff\ude46-\udedf\udef4-\udeff\udf57-\udf5f\udf79-\udfff]|\ud835[\udc55\udc9d\udca0\udca1\udca3\udca4\udca7\udca8\udcad\udcba\udcbc\udcc4\udd06\udd0b\udd0c\udd15\udd1d\udd3a\udd3f\udd45\udd47-\udd49\udd51\udea6\udea7\udfcc\udfcd]|\ud836[\ude8c-\ude9a\udea0\udeb0-\udfff]|\ud837[\udc00-\udeff\udf1f-\udfff]|\ud838[\udc07\udc19\udc1a\udc22\udc25\udc2b-\udcff\udd2d-\udd2f\udd3e\udd3f\udd4a-\udd4d\udd50-\ude8f\udeaf-\udebf\udefa-\udefe\udf00-\udfff]|\ud839[\udc00-\udfdf\udfe7\udfec\udfef\udfff]|\ud83a[\udcc5\udcc6\udcd7-\udcff\udd4c-\udd4f\udd5a-\udd5d\udd60-\udfff]|\ud83b[\udc00-\udc70\udcb5-\udd00\udd3e-\uddff\ude04\ude20\ude23\ude25\ude26\ude28\ude33\ude38\ude3a\ude3c-\ude41\ude43-\ude46\ude48\ude4a\ude4c\ude50\ude53\ude55\ude56\ude58\ude5a\ude5c\ude5e\ude60\ude63\ude65\ude66\ude6b\ude73\ude78\ude7d\ude7f\ude8a\ude9c-\udea0\udea4\udeaa\udebc-\udeef\udef2-\udfff]|\ud83c[\udc2c-\udc2f\udc94-\udc9f\udcaf\udcb0\udcc0\udcd0\udcf6-\udcff\uddae-\udde5\ude03-\ude0f\ude3c-\ude3f\ude49-\ude4f\ude52-\ude5f\ude66-\udeff]|\ud83d[\uded8-\udedc\udeed-\udeef\udefd-\udeff\udf74-\udf7f\udfd9-\udfdf\udfec-\udfef\udff1-\udfff]|\ud83e[\udc0c-\udc0f\udc48-\udc4f\udc5a-\udc5f\udc88-\udc8f\udcae\udcaf\udcb2-\udcff\ude54-\ude5f\ude6e\ude6f\ude75-\ude77\ude7d-\ude7f\ude87-\ude8f\udead-\udeaf\udebb-\udebf\udec6-\udecf\udeda-\udedf\udee8-\udeef\udef7-\udeff\udf93\udfcb-\udfef\udffa-\udfff]|\ud869[\udee0-\udeff]|\ud86d[\udf39-\udf3f]|\ud86e[\udc1e\udc1f]|\ud873[\udea2-\udeaf]|\ud87a[\udfe1-\udfff]|\ud87e[\ude1e-\udfff]|\ud884[\udf4b-\udfff]|\udb40[\udc00\udc02-\udc1f\udc80-\udcff\uddf0-\udfff]|[\udbbf\udbff][\udffe\udfff]"
		},
		{
			name: "Co",
			alias: "Private_Use",
			bmp: "-",
			astral: "[\udb80-\udbbe\udbc0-\udbfe][\udc00-\udfff]|[\udbbf\udbff][\udc00-\udffd]"
		},
		{
			name: "Cs",
			alias: "Surrogate",
			bmp: "\ud800-\udfff"
		},
		{
			name: "L",
			alias: "Letter",
			bmp: "A-Za-zªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛱ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢄᢇ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎↃↄⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々〆〱-〵〻〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛥꜗ-ꜟꜢ-ꞈꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
			astral: "\ud800[\udc00-\udc0b\udc0d-\udc26\udc28-\udc3a\udc3c\udc3d\udc3f-\udc4d\udc50-\udc5d\udc80-\udcfa\ude80-\ude9c\udea0-\uded0\udf00-\udf1f\udf2d-\udf40\udf42-\udf49\udf50-\udf75\udf80-\udf9d\udfa0-\udfc3\udfc8-\udfcf]|\ud801[\udc00-\udc9d\udcb0-\udcd3\udcd8-\udcfb\udd00-\udd27\udd30-\udd63\udd70-\udd7a\udd7c-\udd8a\udd8c-\udd92\udd94\udd95\udd97-\udda1\udda3-\uddb1\uddb3-\uddb9\uddbb\uddbc\ude00-\udf36\udf40-\udf55\udf60-\udf67\udf80-\udf85\udf87-\udfb0\udfb2-\udfba]|\ud802[\udc00-\udc05\udc08\udc0a-\udc35\udc37\udc38\udc3c\udc3f-\udc55\udc60-\udc76\udc80-\udc9e\udce0-\udcf2\udcf4\udcf5\udd00-\udd15\udd20-\udd39\udd80-\uddb7\uddbe\uddbf\ude00\ude10-\ude13\ude15-\ude17\ude19-\ude35\ude60-\ude7c\ude80-\ude9c\udec0-\udec7\udec9-\udee4\udf00-\udf35\udf40-\udf55\udf60-\udf72\udf80-\udf91]|\ud803[\udc00-\udc48\udc80-\udcb2\udcc0-\udcf2\udd00-\udd23\ude80-\udea9\udeb0\udeb1\udf00-\udf1c\udf27\udf30-\udf45\udf70-\udf81\udfb0-\udfc4\udfe0-\udff6]|\ud804[\udc03-\udc37\udc71\udc72\udc75\udc83-\udcaf\udcd0-\udce8\udd03-\udd26\udd44\udd47\udd50-\udd72\udd76\udd83-\uddb2\uddc1-\uddc4\uddda\udddc\ude00-\ude11\ude13-\ude2b\ude80-\ude86\ude88\ude8a-\ude8d\ude8f-\ude9d\ude9f-\udea8\udeb0-\udede\udf05-\udf0c\udf0f\udf10\udf13-\udf28\udf2a-\udf30\udf32\udf33\udf35-\udf39\udf3d\udf50\udf5d-\udf61]|\ud805[\udc00-\udc34\udc47-\udc4a\udc5f-\udc61\udc80-\udcaf\udcc4\udcc5\udcc7\udd80-\uddae\uddd8-\udddb\ude00-\ude2f\ude44\ude80-\udeaa\udeb8\udf00-\udf1a\udf40-\udf46]|\ud806[\udc00-\udc2b\udca0-\udcdf\udcff-\udd06\udd09\udd0c-\udd13\udd15\udd16\udd18-\udd2f\udd3f\udd41\udda0-\udda7\uddaa-\uddd0\udde1\udde3\ude00\ude0b-\ude32\ude3a\ude50\ude5c-\ude89\ude9d\udeb0-\udef8]|\ud807[\udc00-\udc08\udc0a-\udc2e\udc40\udc72-\udc8f\udd00-\udd06\udd08\udd09\udd0b-\udd30\udd46\udd60-\udd65\udd67\udd68\udd6a-\udd89\udd98\udee0-\udef2\udfb0]|\ud808[\udc00-\udf99]|\ud809[\udc80-\udd43]|\ud80b[\udf90-\udff0]|[\ud80c\ud81c-\ud820\ud822\ud840-\ud868\ud86a-\ud86c\ud86f-\ud872\ud874-\ud879\ud880-\ud883][\udc00-\udfff]|\ud80d[\udc00-\udc2e]|\ud811[\udc00-\ude46]|\ud81a[\udc00-\ude38\ude40-\ude5e\ude70-\udebe\uded0-\udeed\udf00-\udf2f\udf40-\udf43\udf63-\udf77\udf7d-\udf8f]|\ud81b[\ude40-\ude7f\udf00-\udf4a\udf50\udf93-\udf9f\udfe0\udfe1\udfe3]|\ud821[\udc00-\udff7]|\ud823[\udc00-\udcd5\udd00-\udd08]|\ud82b[\udff0-\udff3\udff5-\udffb\udffd\udffe]|\ud82c[\udc00-\udd22\udd50-\udd52\udd64-\udd67\udd70-\udefb]|\ud82f[\udc00-\udc6a\udc70-\udc7c\udc80-\udc88\udc90-\udc99]|\ud835[\udc00-\udc54\udc56-\udc9c\udc9e\udc9f\udca2\udca5\udca6\udca9-\udcac\udcae-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd1e-\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd52-\udea5\udea8-\udec0\udec2-\udeda\udedc-\udefa\udefc-\udf14\udf16-\udf34\udf36-\udf4e\udf50-\udf6e\udf70-\udf88\udf8a-\udfa8\udfaa-\udfc2\udfc4-\udfcb]|\ud837[\udf00-\udf1e]|\ud838[\udd00-\udd2c\udd37-\udd3d\udd4e\ude90-\udead\udec0-\udeeb]|\ud839[\udfe0-\udfe6\udfe8-\udfeb\udfed\udfee\udff0-\udffe]|\ud83a[\udc00-\udcc4\udd00-\udd43\udd4b]|\ud83b[\ude00-\ude03\ude05-\ude1f\ude21\ude22\ude24\ude27\ude29-\ude32\ude34-\ude37\ude39\ude3b\ude42\ude47\ude49\ude4b\ude4d-\ude4f\ude51\ude52\ude54\ude57\ude59\ude5b\ude5d\ude5f\ude61\ude62\ude64\ude67-\ude6a\ude6c-\ude72\ude74-\ude77\ude79-\ude7c\ude7e\ude80-\ude89\ude8b-\ude9b\udea1-\udea3\udea5-\udea9\udeab-\udebb]|\ud869[\udc00-\udedf\udf00-\udfff]|\ud86d[\udc00-\udf38\udf40-\udfff]|\ud86e[\udc00-\udc1d\udc20-\udfff]|\ud873[\udc00-\udea1\udeb0-\udfff]|\ud87a[\udc00-\udfe0]|\ud87e[\udc00-\ude1d]|\ud884[\udc00-\udf4a]"
		},
		{
			name: "LC",
			alias: "Cased_Letter",
			bmp: "A-Za-zµÀ-ÖØ-öø-ƺƼ-ƿǄ-ʓʕ-ʯͰ-ͳͶͷͻ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՠ-ֈႠ-ჅჇჍა-ჺჽ-ჿᎠ-Ᏽᏸ-ᏽᲀ-ᲈᲐ-ᲺᲽ-Ჿᴀ-ᴫᵫ-ᵷᵹ-ᶚḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℴℹℼ-ℿⅅ-ⅉⅎↃↄⰀ-ⱻⱾ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭꙀ-ꙭꚀ-ꚛꜢ-ꝯꝱ-ꞇꞋ-ꞎꞐ-ꟊꟐꟑꟓꟕ-ꟙꟵꟶꟺꬰ-ꭚꭠ-ꭨꭰ-ꮿﬀ-ﬆﬓ-ﬗＡ-Ｚａ-ｚ",
			astral: "\ud801[\udc00-\udc4f\udcb0-\udcd3\udcd8-\udcfb\udd70-\udd7a\udd7c-\udd8a\udd8c-\udd92\udd94\udd95\udd97-\udda1\udda3-\uddb1\uddb3-\uddb9\uddbb\uddbc]|\ud803[\udc80-\udcb2\udcc0-\udcf2]|\ud806[\udca0-\udcdf]|\ud81b[\ude40-\ude7f]|\ud835[\udc00-\udc54\udc56-\udc9c\udc9e\udc9f\udca2\udca5\udca6\udca9-\udcac\udcae-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd1e-\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd52-\udea5\udea8-\udec0\udec2-\udeda\udedc-\udefa\udefc-\udf14\udf16-\udf34\udf36-\udf4e\udf50-\udf6e\udf70-\udf88\udf8a-\udfa8\udfaa-\udfc2\udfc4-\udfcb]|\ud837[\udf00-\udf09\udf0b-\udf1e]|\ud83a[\udd00-\udd43]"
		},
		{
			name: "Ll",
			alias: "Lowercase_Letter",
			bmp: "a-zµß-öø-ÿāăąćĉċčďđēĕėęěĝğġģĥħĩīĭįıĳĵķĸĺļľŀłńņňŉŋōŏőœŕŗřśŝşšţťŧũūŭůűųŵŷźżž-ƀƃƅƈƌƍƒƕƙ-ƛƞơƣƥƨƪƫƭưƴƶƹƺƽ-ƿǆǉǌǎǐǒǔǖǘǚǜǝǟǡǣǥǧǩǫǭǯǰǳǵǹǻǽǿȁȃȅȇȉȋȍȏȑȓȕȗșțȝȟȡȣȥȧȩȫȭȯȱȳ-ȹȼȿɀɂɇɉɋɍɏ-ʓʕ-ʯͱͳͷͻ-ͽΐά-ώϐϑϕ-ϗϙϛϝϟϡϣϥϧϩϫϭϯ-ϳϵϸϻϼа-џѡѣѥѧѩѫѭѯѱѳѵѷѹѻѽѿҁҋҍҏґғҕҗҙқҝҟҡңҥҧҩҫҭүұҳҵҷҹһҽҿӂӄӆӈӊӌӎӏӑӓӕӗәӛӝӟӡӣӥӧөӫӭӯӱӳӵӷӹӻӽӿԁԃԅԇԉԋԍԏԑԓԕԗԙԛԝԟԡԣԥԧԩԫԭԯՠ-ֈა-ჺჽ-ჿᏸ-ᏽᲀ-ᲈᴀ-ᴫᵫ-ᵷᵹ-ᶚḁḃḅḇḉḋḍḏḑḓḕḗḙḛḝḟḡḣḥḧḩḫḭḯḱḳḵḷḹḻḽḿṁṃṅṇṉṋṍṏṑṓṕṗṙṛṝṟṡṣṥṧṩṫṭṯṱṳṵṷṹṻṽṿẁẃẅẇẉẋẍẏẑẓẕ-ẝẟạảấầẩẫậắằẳẵặẹẻẽếềểễệỉịọỏốồổỗộớờởỡợụủứừửữựỳỵỷỹỻỽỿ-ἇἐ-ἕἠ-ἧἰ-ἷὀ-ὅὐ-ὗὠ-ὧὰ-ώᾀ-ᾇᾐ-ᾗᾠ-ᾧᾰ-ᾴᾶᾷιῂ-ῄῆῇῐ-ΐῖῗῠ-ῧῲ-ῴῶῷℊℎℏℓℯℴℹℼℽⅆ-ⅉⅎↄⰰ-ⱟⱡⱥⱦⱨⱪⱬⱱⱳⱴⱶ-ⱻⲁⲃⲅⲇⲉⲋⲍⲏⲑⲓⲕⲗⲙⲛⲝⲟⲡⲣⲥⲧⲩⲫⲭⲯⲱⲳⲵⲷⲹⲻⲽⲿⳁⳃⳅⳇⳉⳋⳍⳏⳑⳓⳕⳗⳙⳛⳝⳟⳡⳣⳤⳬⳮⳳⴀ-ⴥⴧⴭꙁꙃꙅꙇꙉꙋꙍꙏꙑꙓꙕꙗꙙꙛꙝꙟꙡꙣꙥꙧꙩꙫꙭꚁꚃꚅꚇꚉꚋꚍꚏꚑꚓꚕꚗꚙꚛꜣꜥꜧꜩꜫꜭꜯ-ꜱꜳꜵꜷꜹꜻꜽꜿꝁꝃꝅꝇꝉꝋꝍꝏꝑꝓꝕꝗꝙꝛꝝꝟꝡꝣꝥꝧꝩꝫꝭꝯꝱ-ꝸꝺꝼꝿꞁꞃꞅꞇꞌꞎꞑꞓ-ꞕꞗꞙꞛꞝꞟꞡꞣꞥꞧꞩꞯꞵꞷꞹꞻꞽꞿꟁꟃꟈꟊꟑꟓꟕꟗꟙꟶꟺꬰ-ꭚꭠ-ꭨꭰ-ꮿﬀ-ﬆﬓ-ﬗａ-ｚ",
			astral: "\ud801[\udc28-\udc4f\udcd8-\udcfb\udd97-\udda1\udda3-\uddb1\uddb3-\uddb9\uddbb\uddbc]|\ud803[\udcc0-\udcf2]|\ud806[\udcc0-\udcdf]|\ud81b[\ude60-\ude7f]|\ud835[\udc1a-\udc33\udc4e-\udc54\udc56-\udc67\udc82-\udc9b\udcb6-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udccf\udcea-\udd03\udd1e-\udd37\udd52-\udd6b\udd86-\udd9f\uddba-\uddd3\uddee-\ude07\ude22-\ude3b\ude56-\ude6f\ude8a-\udea5\udec2-\udeda\udedc-\udee1\udefc-\udf14\udf16-\udf1b\udf36-\udf4e\udf50-\udf55\udf70-\udf88\udf8a-\udf8f\udfaa-\udfc2\udfc4-\udfc9\udfcb]|\ud837[\udf00-\udf09\udf0b-\udf1e]|\ud83a[\udd22-\udd43]"
		},
		{
			name: "Lm",
			alias: "Modifier_Letter",
			bmp: "ʰ-ˁˆ-ˑˠ-ˤˬˮʹͺՙـۥۦߴߵߺࠚࠤࠨࣉॱๆໆჼៗᡃᪧᱸ-ᱽᴬ-ᵪᵸᶛ-ᶿⁱⁿₐ-ₜⱼⱽⵯⸯ々〱-〵〻ゝゞー-ヾꀕꓸ-ꓽꘌꙿꚜꚝꜗ-ꜟꝰꞈꟲ-ꟴꟸꟹꧏꧦꩰꫝꫳꫴꭜ-ꭟꭩｰﾞﾟ",
			astral: "\ud801[\udf80-\udf85\udf87-\udfb0\udfb2-\udfba]|\ud81a[\udf40-\udf43]|\ud81b[\udf93-\udf9f\udfe0\udfe1\udfe3]|\ud82b[\udff0-\udff3\udff5-\udffb\udffd\udffe]|\ud838[\udd37-\udd3d]|𞥋"
		},
		{
			name: "Lo",
			alias: "Other_Letter",
			bmp: "ªºƻǀ-ǃʔא-תׯ-ײؠ-ؿف-يٮٯٱ-ۓەۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪࠀ-ࠕࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣈऄ-हऽॐक़-ॡॲ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๅກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎᄀ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛱ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៜᠠ-ᡂᡄ-ᡸᢀ-ᢄᢇ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱷᳩ-ᳬᳮ-ᳳᳵᳶᳺℵ-ℸⴰ-ⵧⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ〆〼ぁ-ゖゟァ-ヺヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꀔꀖ-ꒌꓐ-ꓷꔀ-ꘋꘐ-ꘟꘪꘫꙮꚠ-ꛥꞏꟷꟻ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧠ-ꧤꧧ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩯꩱ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛꫜꫠ-ꫪꫲꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꯀ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎יִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼｦ-ｯｱ-ﾝﾠ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
			astral: "\ud800[\udc00-\udc0b\udc0d-\udc26\udc28-\udc3a\udc3c\udc3d\udc3f-\udc4d\udc50-\udc5d\udc80-\udcfa\ude80-\ude9c\udea0-\uded0\udf00-\udf1f\udf2d-\udf40\udf42-\udf49\udf50-\udf75\udf80-\udf9d\udfa0-\udfc3\udfc8-\udfcf]|\ud801[\udc50-\udc9d\udd00-\udd27\udd30-\udd63\ude00-\udf36\udf40-\udf55\udf60-\udf67]|\ud802[\udc00-\udc05\udc08\udc0a-\udc35\udc37\udc38\udc3c\udc3f-\udc55\udc60-\udc76\udc80-\udc9e\udce0-\udcf2\udcf4\udcf5\udd00-\udd15\udd20-\udd39\udd80-\uddb7\uddbe\uddbf\ude00\ude10-\ude13\ude15-\ude17\ude19-\ude35\ude60-\ude7c\ude80-\ude9c\udec0-\udec7\udec9-\udee4\udf00-\udf35\udf40-\udf55\udf60-\udf72\udf80-\udf91]|\ud803[\udc00-\udc48\udd00-\udd23\ude80-\udea9\udeb0\udeb1\udf00-\udf1c\udf27\udf30-\udf45\udf70-\udf81\udfb0-\udfc4\udfe0-\udff6]|\ud804[\udc03-\udc37\udc71\udc72\udc75\udc83-\udcaf\udcd0-\udce8\udd03-\udd26\udd44\udd47\udd50-\udd72\udd76\udd83-\uddb2\uddc1-\uddc4\uddda\udddc\ude00-\ude11\ude13-\ude2b\ude80-\ude86\ude88\ude8a-\ude8d\ude8f-\ude9d\ude9f-\udea8\udeb0-\udede\udf05-\udf0c\udf0f\udf10\udf13-\udf28\udf2a-\udf30\udf32\udf33\udf35-\udf39\udf3d\udf50\udf5d-\udf61]|\ud805[\udc00-\udc34\udc47-\udc4a\udc5f-\udc61\udc80-\udcaf\udcc4\udcc5\udcc7\udd80-\uddae\uddd8-\udddb\ude00-\ude2f\ude44\ude80-\udeaa\udeb8\udf00-\udf1a\udf40-\udf46]|\ud806[\udc00-\udc2b\udcff-\udd06\udd09\udd0c-\udd13\udd15\udd16\udd18-\udd2f\udd3f\udd41\udda0-\udda7\uddaa-\uddd0\udde1\udde3\ude00\ude0b-\ude32\ude3a\ude50\ude5c-\ude89\ude9d\udeb0-\udef8]|\ud807[\udc00-\udc08\udc0a-\udc2e\udc40\udc72-\udc8f\udd00-\udd06\udd08\udd09\udd0b-\udd30\udd46\udd60-\udd65\udd67\udd68\udd6a-\udd89\udd98\udee0-\udef2\udfb0]|\ud808[\udc00-\udf99]|\ud809[\udc80-\udd43]|\ud80b[\udf90-\udff0]|[\ud80c\ud81c-\ud820\ud822\ud840-\ud868\ud86a-\ud86c\ud86f-\ud872\ud874-\ud879\ud880-\ud883][\udc00-\udfff]|\ud80d[\udc00-\udc2e]|\ud811[\udc00-\ude46]|\ud81a[\udc00-\ude38\ude40-\ude5e\ude70-\udebe\uded0-\udeed\udf00-\udf2f\udf63-\udf77\udf7d-\udf8f]|\ud81b[\udf00-\udf4a\udf50]|\ud821[\udc00-\udff7]|\ud823[\udc00-\udcd5\udd00-\udd08]|\ud82c[\udc00-\udd22\udd50-\udd52\udd64-\udd67\udd70-\udefb]|\ud82f[\udc00-\udc6a\udc70-\udc7c\udc80-\udc88\udc90-\udc99]|𝼊|\ud838[\udd00-\udd2c\udd4e\ude90-\udead\udec0-\udeeb]|\ud839[\udfe0-\udfe6\udfe8-\udfeb\udfed\udfee\udff0-\udffe]|\ud83a[\udc00-\udcc4]|\ud83b[\ude00-\ude03\ude05-\ude1f\ude21\ude22\ude24\ude27\ude29-\ude32\ude34-\ude37\ude39\ude3b\ude42\ude47\ude49\ude4b\ude4d-\ude4f\ude51\ude52\ude54\ude57\ude59\ude5b\ude5d\ude5f\ude61\ude62\ude64\ude67-\ude6a\ude6c-\ude72\ude74-\ude77\ude79-\ude7c\ude7e\ude80-\ude89\ude8b-\ude9b\udea1-\udea3\udea5-\udea9\udeab-\udebb]|\ud869[\udc00-\udedf\udf00-\udfff]|\ud86d[\udc00-\udf38\udf40-\udfff]|\ud86e[\udc00-\udc1d\udc20-\udfff]|\ud873[\udc00-\udea1\udeb0-\udfff]|\ud87a[\udc00-\udfe0]|\ud87e[\udc00-\ude1d]|\ud884[\udc00-\udf4a]"
		},
		{
			name: "Lt",
			alias: "Titlecase_Letter",
			bmp: "ǅǈǋǲᾈ-ᾏᾘ-ᾟᾨ-ᾯᾼῌῼ"
		},
		{
			name: "Lu",
			alias: "Uppercase_Letter",
			bmp: "A-ZÀ-ÖØ-ÞĀĂĄĆĈĊČĎĐĒĔĖĘĚĜĞĠĢĤĦĨĪĬĮİĲĴĶĹĻĽĿŁŃŅŇŊŌŎŐŒŔŖŘŚŜŞŠŢŤŦŨŪŬŮŰŲŴŶŸŹŻŽƁƂƄƆƇƉ-ƋƎ-ƑƓƔƖ-ƘƜƝƟƠƢƤƦƧƩƬƮƯƱ-ƳƵƷƸƼǄǇǊǍǏǑǓǕǗǙǛǞǠǢǤǦǨǪǬǮǱǴǶ-ǸǺǼǾȀȂȄȆȈȊȌȎȐȒȔȖȘȚȜȞȠȢȤȦȨȪȬȮȰȲȺȻȽȾɁɃ-ɆɈɊɌɎͰͲͶͿΆΈ-ΊΌΎΏΑ-ΡΣ-ΫϏϒ-ϔϘϚϜϞϠϢϤϦϨϪϬϮϴϷϹϺϽ-ЯѠѢѤѦѨѪѬѮѰѲѴѶѸѺѼѾҀҊҌҎҐҒҔҖҘҚҜҞҠҢҤҦҨҪҬҮҰҲҴҶҸҺҼҾӀӁӃӅӇӉӋӍӐӒӔӖӘӚӜӞӠӢӤӦӨӪӬӮӰӲӴӶӸӺӼӾԀԂԄԆԈԊԌԎԐԒԔԖԘԚԜԞԠԢԤԦԨԪԬԮԱ-ՖႠ-ჅჇჍᎠ-ᏵᲐ-ᲺᲽ-ᲿḀḂḄḆḈḊḌḎḐḒḔḖḘḚḜḞḠḢḤḦḨḪḬḮḰḲḴḶḸḺḼḾṀṂṄṆṈṊṌṎṐṒṔṖṘṚṜṞṠṢṤṦṨṪṬṮṰṲṴṶṸṺṼṾẀẂẄẆẈẊẌẎẐẒẔẞẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼẾỀỂỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪỬỮỰỲỴỶỸỺỼỾἈ-ἏἘ-ἝἨ-ἯἸ-ἿὈ-ὍὙὛὝὟὨ-ὯᾸ-ΆῈ-ΉῘ-ΊῨ-ῬῸ-Ώℂℇℋ-ℍℐ-ℒℕℙ-ℝℤΩℨK-ℭℰ-ℳℾℿⅅↃⰀ-ⰯⱠⱢ-ⱤⱧⱩⱫⱭ-ⱰⱲⱵⱾ-ⲀⲂⲄⲆⲈⲊⲌⲎⲐⲒⲔⲖⲘⲚⲜⲞⲠⲢⲤⲦⲨⲪⲬⲮⲰⲲⲴⲶⲸⲺⲼⲾⳀⳂⳄⳆⳈⳊⳌⳎⳐⳒⳔⳖⳘⳚⳜⳞⳠⳢⳫⳭⳲꙀꙂꙄꙆꙈꙊꙌꙎꙐꙒꙔꙖꙘꙚꙜꙞꙠꙢꙤꙦꙨꙪꙬꚀꚂꚄꚆꚈꚊꚌꚎꚐꚒꚔꚖꚘꚚꜢꜤꜦꜨꜪꜬꜮꜲꜴꜶꜸꜺꜼꜾꝀꝂꝄꝆꝈꝊꝌꝎꝐꝒꝔꝖꝘꝚꝜꝞꝠꝢꝤꝦꝨꝪꝬꝮꝹꝻꝽꝾꞀꞂꞄꞆꞋꞍꞐꞒꞖꞘꞚꞜꞞꞠꞢꞤꞦꞨꞪ-ꞮꞰ-ꞴꞶꞸꞺꞼꞾꟀꟂꟄ-ꟇꟉꟐꟖꟘꟵＡ-Ｚ",
			astral: "\ud801[\udc00-\udc27\udcb0-\udcd3\udd70-\udd7a\udd7c-\udd8a\udd8c-\udd92\udd94\udd95]|\ud803[\udc80-\udcb2]|\ud806[\udca0-\udcbf]|\ud81b[\ude40-\ude5f]|\ud835[\udc00-\udc19\udc34-\udc4d\udc68-\udc81\udc9c\udc9e\udc9f\udca2\udca5\udca6\udca9-\udcac\udcae-\udcb5\udcd0-\udce9\udd04\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd38\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd6c-\udd85\udda0-\uddb9\uddd4-\udded\ude08-\ude21\ude3c-\ude55\ude70-\ude89\udea8-\udec0\udee2-\udefa\udf1c-\udf34\udf56-\udf6e\udf90-\udfa8\udfca]|\ud83a[\udd00-\udd21]"
		},
		{
			name: "M",
			alias: "Mark",
			bmp: "̀-ͯ҃-҉֑-ׇֽֿׁׂׅׄؐ-ًؚ-ٰٟۖ-ۜ۟-۪ۤۧۨ-ܑۭܰ-݊ަ-ް߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࢘-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣঁ-ঃ়া-ৄেৈো-্ৗৢৣ৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑੰੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣஂா-ூெ-ைொ-்ௗఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣඁ-ඃ්ා-ුූෘ-ෟෲෳัิ-ฺ็-๎ັິ-ຼ່-ໍ༹༘༙༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏႚ-ႝ፝-፟ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝᠋-᠍᠏ᢅᢆᢩᤠ-ᤫᤰ-᤻ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼᪰-ᫎᬀ-ᬄ᬴-᭄᭫-᭳ᮀ-ᮂᮡ-ᮭ᯦-᯳ᰤ-᰷᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿⃐-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯꙯-꙲ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣠-꣱ꣿꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀ꧥꨩ-ꨶꩃꩌꩍꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭ﬞ︀-️︠-︯",
			astral: "\ud800[\uddfd\udee0\udf76-\udf7a]|\ud802[\ude01-\ude03\ude05\ude06\ude0c-\ude0f\ude38-\ude3a\ude3f\udee5\udee6]|\ud803[\udd24-\udd27\udeab\udeac\udf46-\udf50\udf82-\udf85]|\ud804[\udc00-\udc02\udc38-\udc46\udc70\udc73\udc74\udc7f-\udc82\udcb0-\udcba\udcc2\udd00-\udd02\udd27-\udd34\udd45\udd46\udd73\udd80-\udd82\uddb3-\uddc0\uddc9-\uddcc\uddce\uddcf\ude2c-\ude37\ude3e\udedf-\udeea\udf00-\udf03\udf3b\udf3c\udf3e-\udf44\udf47\udf48\udf4b-\udf4d\udf57\udf62\udf63\udf66-\udf6c\udf70-\udf74]|\ud805[\udc35-\udc46\udc5e\udcb0-\udcc3\uddaf-\uddb5\uddb8-\uddc0\udddc\udddd\ude30-\ude40\udeab-\udeb7\udf1d-\udf2b]|\ud806[\udc2c-\udc3a\udd30-\udd35\udd37\udd38\udd3b-\udd3e\udd40\udd42\udd43\uddd1-\uddd7\uddda-\udde0\udde4\ude01-\ude0a\ude33-\ude39\ude3b-\ude3e\ude47\ude51-\ude5b\ude8a-\ude99]|\ud807[\udc2f-\udc36\udc38-\udc3f\udc92-\udca7\udca9-\udcb6\udd31-\udd36\udd3a\udd3c\udd3d\udd3f-\udd45\udd47\udd8a-\udd8e\udd90\udd91\udd93-\udd97\udef3-\udef6]|\ud81a[\udef0-\udef4\udf30-\udf36]|\ud81b[\udf4f\udf51-\udf87\udf8f-\udf92\udfe4\udff0\udff1]|\ud82f[\udc9d\udc9e]|\ud833[\udf00-\udf2d\udf30-\udf46]|\ud834[\udd65-\udd69\udd6d-\udd72\udd7b-\udd82\udd85-\udd8b\uddaa-\uddad\ude42-\ude44]|\ud836[\ude00-\ude36\ude3b-\ude6c\ude75\ude84\ude9b-\ude9f\udea1-\udeaf]|\ud838[\udc00-\udc06\udc08-\udc18\udc1b-\udc21\udc23\udc24\udc26-\udc2a\udd30-\udd36\udeae\udeec-\udeef]|\ud83a[\udcd0-\udcd6\udd44-\udd4a]|\udb40[\udd00-\uddef]"
		},
		{
			name: "Mc",
			alias: "Spacing_Mark",
			bmp: "ःऻा-ीॉ-ौॎॏংঃা-ীেৈোৌৗਃਾ-ੀઃા-ીૉોૌଂଃାୀେୈୋୌୗாிுூெ-ைொ-ௌௗఁ-ఃు-ౄಂಃಾೀ-ೄೇೈೊೋೕೖംഃാ-ീെ-ൈൊ-ൌൗංඃා-ෑෘ-ෟෲෳ༾༿ཿါာေးျြၖၗၢ-ၤၧ-ၭႃႄႇ-ႌႏႚ-ႜ᜕᜴ាើ-ៅះៈᤣ-ᤦᤩ-ᤫᤰᤱᤳ-ᤸᨙᨚᩕᩗᩡᩣᩤᩭ-ᩲᬄᬵᬻᬽ-ᭁᭃ᭄ᮂᮡᮦᮧ᮪ᯧᯪ-ᯬᯮ᯲᯳ᰤ-ᰫᰴᰵ᳡᳷〮〯ꠣꠤꠧꢀꢁꢴ-ꣃꥒ꥓ꦃꦴꦵꦺꦻꦾ-꧀ꨯꨰꨳꨴꩍꩻꩽꫫꫮꫯꫵꯣꯤꯦꯧꯩꯪ꯬",
			astral: "\ud804[\udc00\udc02\udc82\udcb0-\udcb2\udcb7\udcb8\udd2c\udd45\udd46\udd82\uddb3-\uddb5\uddbf\uddc0\uddce\ude2c-\ude2e\ude32\ude33\ude35\udee0-\udee2\udf02\udf03\udf3e\udf3f\udf41-\udf44\udf47\udf48\udf4b-\udf4d\udf57\udf62\udf63]|\ud805[\udc35-\udc37\udc40\udc41\udc45\udcb0-\udcb2\udcb9\udcbb-\udcbe\udcc1\uddaf-\uddb1\uddb8-\uddbb\uddbe\ude30-\ude32\ude3b\ude3c\ude3e\udeac\udeae\udeaf\udeb6\udf20\udf21\udf26]|\ud806[\udc2c-\udc2e\udc38\udd30-\udd35\udd37\udd38\udd3d\udd40\udd42\uddd1-\uddd3\udddc-\udddf\udde4\ude39\ude57\ude58\ude97]|\ud807[\udc2f\udc3e\udca9\udcb1\udcb4\udd8a-\udd8e\udd93\udd94\udd96\udef5\udef6]|\ud81b[\udf51-\udf87\udff0\udff1]|\ud834[\udd65\udd66\udd6d-\udd72]"
		},
		{
			name: "Me",
			alias: "Enclosing_Mark",
			bmp: "҈҉᪾⃝-⃠⃢-⃤꙰-꙲"
		},
		{
			name: "Mn",
			alias: "Nonspacing_Mark",
			bmp: "̀-ͯ҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-ٰٟۖ-ۜ۟-۪ۤۧۨ-ܑۭܰ-݊ަ-ް߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࢘-࢟࣊-ࣣ࣡-ंऺ़ु-ै्॑-ॗॢॣঁ়ু-ৄ্ৢৣ৾ਁਂ਼ੁੂੇੈੋ-੍ੑੰੱੵઁં઼ુ-ૅેૈ્ૢૣૺ-૿ଁ଼ିୁ-ୄ୍୕ୖୢୣஂீ்ఀఄ఼ా-ీె-ైొ-్ౕౖౢౣಁ಼ಿೆೌ್ೢೣഀഁ഻഼ു-ൄ്ൢൣඁ්ි-ුූัิ-ฺ็-๎ັິ-ຼ່-ໍཱ༹༘༙༵༷-ཾྀ-྄྆྇ྍ-ྗྙ-ྼ࿆ိ-ူဲ-့္်ွှၘၙၞ-ၠၱ-ၴႂႅႆႍႝ፝-፟ᜒ-᜔ᜲᜳᝒᝓᝲᝳ឴឵ិ-ួំ៉-៓៝᠋-᠍᠏ᢅᢆᢩᤠ-ᤢᤧᤨᤲ᤹-᤻ᨘᨗᨛᩖᩘ-ᩞ᩠ᩢᩥ-ᩬᩳ-᩿᩼᪰-᪽ᪿ-ᫎᬀ-ᬃ᬴ᬶ-ᬺᬼᭂ᭫-᭳ᮀᮁᮢ-ᮥᮨᮩ᮫-ᮭ᯦ᯨᯩᯭᯯ-ᯱᰬ-ᰳᰶ᰷᳐-᳔᳒-᳢᳠-᳨᳭᳴᳸᳹᷀-᷿⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〭꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠥꠦ꠬꣄ꣅ꣠-꣱ꣿꤦ-꤭ꥇ-ꥑꦀ-ꦂ꦳ꦶ-ꦹꦼꦽꧥꨩ-ꨮꨱꨲꨵꨶꩃꩌꩼꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫬꫭ꫶ꯥꯨ꯭ﬞ︀-️︠-︯",
			astral: "\ud800[\uddfd\udee0\udf76-\udf7a]|\ud802[\ude01-\ude03\ude05\ude06\ude0c-\ude0f\ude38-\ude3a\ude3f\udee5\udee6]|\ud803[\udd24-\udd27\udeab\udeac\udf46-\udf50\udf82-\udf85]|\ud804[\udc01\udc38-\udc46\udc70\udc73\udc74\udc7f-\udc81\udcb3-\udcb6\udcb9\udcba\udcc2\udd00-\udd02\udd27-\udd2b\udd2d-\udd34\udd73\udd80\udd81\uddb6-\uddbe\uddc9-\uddcc\uddcf\ude2f-\ude31\ude34\ude36\ude37\ude3e\udedf\udee3-\udeea\udf00\udf01\udf3b\udf3c\udf40\udf66-\udf6c\udf70-\udf74]|\ud805[\udc38-\udc3f\udc42-\udc44\udc46\udc5e\udcb3-\udcb8\udcba\udcbf\udcc0\udcc2\udcc3\uddb2-\uddb5\uddbc\uddbd\uddbf\uddc0\udddc\udddd\ude33-\ude3a\ude3d\ude3f\ude40\udeab\udead\udeb0-\udeb5\udeb7\udf1d-\udf1f\udf22-\udf25\udf27-\udf2b]|\ud806[\udc2f-\udc37\udc39\udc3a\udd3b\udd3c\udd3e\udd43\uddd4-\uddd7\uddda\udddb\udde0\ude01-\ude0a\ude33-\ude38\ude3b-\ude3e\ude47\ude51-\ude56\ude59-\ude5b\ude8a-\ude96\ude98\ude99]|\ud807[\udc30-\udc36\udc38-\udc3d\udc3f\udc92-\udca7\udcaa-\udcb0\udcb2\udcb3\udcb5\udcb6\udd31-\udd36\udd3a\udd3c\udd3d\udd3f-\udd45\udd47\udd90\udd91\udd95\udd97\udef3\udef4]|\ud81a[\udef0-\udef4\udf30-\udf36]|\ud81b[\udf4f\udf8f-\udf92\udfe4]|\ud82f[\udc9d\udc9e]|\ud833[\udf00-\udf2d\udf30-\udf46]|\ud834[\udd67-\udd69\udd7b-\udd82\udd85-\udd8b\uddaa-\uddad\ude42-\ude44]|\ud836[\ude00-\ude36\ude3b-\ude6c\ude75\ude84\ude9b-\ude9f\udea1-\udeaf]|\ud838[\udc00-\udc06\udc08-\udc18\udc1b-\udc21\udc23\udc24\udc26-\udc2a\udd30-\udd36\udeae\udeec-\udeef]|\ud83a[\udcd0-\udcd6\udd44-\udd4a]|\udb40[\udd00-\uddef]"
		},
		{
			name: "N",
			alias: "Number",
			bmp: "0-9²³¹¼-¾٠-٩۰-۹߀-߉०-९০-৯৴-৹੦-੯૦-૯୦-୯୲-୷௦-௲౦-౯౸-౾೦-೯൘-൞൦-൸෦-෯๐-๙໐-໙༠-༳၀-၉႐-႙፩-፼ᛮ-ᛰ០-៩៰-៹᠐-᠙᥆-᥏᧐-᧚᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙⁰⁴-⁹₀-₉⅐-ↂↅ-↉①-⒛⓪-⓿❶-➓⳽〇〡-〩〸-〺㆒-㆕㈠-㈩㉈-㉏㉑-㉟㊀-㊉㊱-㊿꘠-꘩ꛦ-ꛯ꠰-꠵꣐-꣙꤀-꤉꧐-꧙꧰-꧹꩐-꩙꯰-꯹０-９",
			astral: "\ud800[\udd07-\udd33\udd40-\udd78\udd8a\udd8b\udee1-\udefb\udf20-\udf23\udf41\udf4a\udfd1-\udfd5]|\ud801[\udca0-\udca9]|\ud802[\udc58-\udc5f\udc79-\udc7f\udca7-\udcaf\udcfb-\udcff\udd16-\udd1b\uddbc\uddbd\uddc0-\uddcf\uddd2-\uddff\ude40-\ude48\ude7d\ude7e\ude9d-\ude9f\udeeb-\udeef\udf58-\udf5f\udf78-\udf7f\udfa9-\udfaf]|\ud803[\udcfa-\udcff\udd30-\udd39\ude60-\ude7e\udf1d-\udf26\udf51-\udf54\udfc5-\udfcb]|\ud804[\udc52-\udc6f\udcf0-\udcf9\udd36-\udd3f\uddd0-\uddd9\udde1-\uddf4\udef0-\udef9]|\ud805[\udc50-\udc59\udcd0-\udcd9\ude50-\ude59\udec0-\udec9\udf30-\udf3b]|\ud806[\udce0-\udcf2\udd50-\udd59]|\ud807[\udc50-\udc6c\udd50-\udd59\udda0-\udda9\udfc0-\udfd4]|\ud809[\udc00-\udc6e]|\ud81a[\ude60-\ude69\udec0-\udec9\udf50-\udf59\udf5b-\udf61]|\ud81b[\ude80-\ude96]|\ud834[\udee0-\udef3\udf60-\udf78]|\ud835[\udfce-\udfff]|\ud838[\udd40-\udd49\udef0-\udef9]|\ud83a[\udcc7-\udccf\udd50-\udd59]|\ud83b[\udc71-\udcab\udcad-\udcaf\udcb1-\udcb4\udd01-\udd2d\udd2f-\udd3d]|\ud83c[\udd00-\udd0c]|\ud83e[\udff0-\udff9]"
		},
		{
			name: "Nd",
			alias: "Decimal_Number",
			bmp: "0-9٠-٩۰-۹߀-߉०-९০-৯੦-੯૦-૯୦-୯௦-௯౦-౯೦-೯൦-൯෦-෯๐-๙໐-໙༠-༩၀-၉႐-႙០-៩᠐-᠙᥆-᥏᧐-᧙᪀-᪉᪐-᪙᭐-᭙᮰-᮹᱀-᱉᱐-᱙꘠-꘩꣐-꣙꤀-꤉꧐-꧙꧰-꧹꩐-꩙꯰-꯹０-９",
			astral: "\ud801[\udca0-\udca9]|\ud803[\udd30-\udd39]|\ud804[\udc66-\udc6f\udcf0-\udcf9\udd36-\udd3f\uddd0-\uddd9\udef0-\udef9]|\ud805[\udc50-\udc59\udcd0-\udcd9\ude50-\ude59\udec0-\udec9\udf30-\udf39]|\ud806[\udce0-\udce9\udd50-\udd59]|\ud807[\udc50-\udc59\udd50-\udd59\udda0-\udda9]|\ud81a[\ude60-\ude69\udec0-\udec9\udf50-\udf59]|\ud835[\udfce-\udfff]|\ud838[\udd40-\udd49\udef0-\udef9]|\ud83a[\udd50-\udd59]|\ud83e[\udff0-\udff9]"
		},
		{
			name: "Nl",
			alias: "Letter_Number",
			bmp: "ᛮ-ᛰⅠ-ↂↅ-ↈ〇〡-〩〸-〺ꛦ-ꛯ",
			astral: "\ud800[\udd40-\udd74\udf41\udf4a\udfd1-\udfd5]|\ud809[\udc00-\udc6e]"
		},
		{
			name: "No",
			alias: "Other_Number",
			bmp: "²³¹¼-¾৴-৹୲-୷௰-௲౸-౾൘-൞൰-൸༪-༳፩-፼៰-៹᧚⁰⁴-⁹₀-₉⅐-⅟↉①-⒛⓪-⓿❶-➓⳽㆒-㆕㈠-㈩㉈-㉏㉑-㉟㊀-㊉㊱-㊿꠰-꠵",
			astral: "\ud800[\udd07-\udd33\udd75-\udd78\udd8a\udd8b\udee1-\udefb\udf20-\udf23]|\ud802[\udc58-\udc5f\udc79-\udc7f\udca7-\udcaf\udcfb-\udcff\udd16-\udd1b\uddbc\uddbd\uddc0-\uddcf\uddd2-\uddff\ude40-\ude48\ude7d\ude7e\ude9d-\ude9f\udeeb-\udeef\udf58-\udf5f\udf78-\udf7f\udfa9-\udfaf]|\ud803[\udcfa-\udcff\ude60-\ude7e\udf1d-\udf26\udf51-\udf54\udfc5-\udfcb]|\ud804[\udc52-\udc65\udde1-\uddf4]|\ud805[\udf3a\udf3b]|\ud806[\udcea-\udcf2]|\ud807[\udc5a-\udc6c\udfc0-\udfd4]|\ud81a[\udf5b-\udf61]|\ud81b[\ude80-\ude96]|\ud834[\udee0-\udef3\udf60-\udf78]|\ud83a[\udcc7-\udccf]|\ud83b[\udc71-\udcab\udcad-\udcaf\udcb1-\udcb4\udd01-\udd2d\udd2f-\udd3d]|\ud83c[\udd00-\udd0c]"
		},
		{
			name: "P",
			alias: "Punctuation",
			bmp: "!-#%-\\*,-\\/:;\\?@\\[-\\]_\\{\\}¡§«¶·»¿;·՚-՟։֊־׀׃׆׳״؉؊،؍؛؝-؟٪-٭۔܀-܍߷-߹࠰-࠾࡞।॥॰৽੶૰౷಄෴๏๚๛༄-༒༔༺-༽྅࿐-࿔࿙࿚၊-၏჻፠-፨᐀᙮᚛᚜᛫-᛭᜵᜶។-៖៘-៚᠀-᠊᥄᥅᨞᨟᪠-᪦᪨-᪭᭚-᭠᭽᭾᯼-᯿᰻-᰿᱾᱿᳀-᳇᳓‐-‧‰-⁃⁅-⁑⁓-⁞⁽⁾₍₎⌈-⌋〈〉❨-❵⟅⟆⟦-⟯⦃-⦘⧘-⧛⧼⧽⳹-⳼⳾⳿⵰⸀-⸮⸰-⹏⹒-⹝、-〃〈-】〔-〟〰〽゠・꓾꓿꘍-꘏꙳꙾꛲-꛷꡴-꡷꣎꣏꣸-꣺꣼꤮꤯꥟꧁-꧍꧞꧟꩜-꩟꫞꫟꫰꫱꯫﴾﴿︐-︙︰-﹒﹔-﹡﹣﹨﹪﹫！-＃％-＊，-／：；？＠［-］＿｛｝｟-･",
			astral: "\ud800[\udd00-\udd02\udf9f\udfd0]|𐕯|\ud802[\udc57\udd1f\udd3f\ude50-\ude58\ude7f\udef0-\udef6\udf39-\udf3f\udf99-\udf9c]|\ud803[\udead\udf55-\udf59\udf86-\udf89]|\ud804[\udc47-\udc4d\udcbb\udcbc\udcbe-\udcc1\udd40-\udd43\udd74\udd75\uddc5-\uddc8\uddcd\udddb\udddd-\udddf\ude38-\ude3d\udea9]|\ud805[\udc4b-\udc4f\udc5a\udc5b\udc5d\udcc6\uddc1-\uddd7\ude41-\ude43\ude60-\ude6c\udeb9\udf3c-\udf3e]|\ud806[\udc3b\udd44-\udd46\udde2\ude3f-\ude46\ude9a-\ude9c\ude9e-\udea2]|\ud807[\udc41-\udc45\udc70\udc71\udef7\udef8\udfff]|\ud809[\udc70-\udc74]|\ud80b[\udff1\udff2]|\ud81a[\ude6e\ude6f\udef5\udf37-\udf3b\udf44]|\ud81b[\ude97-\ude9a\udfe2]|𛲟|\ud836[\ude87-\ude8b]|\ud83a[\udd5e\udd5f]"
		},
		{
			name: "Pc",
			alias: "Connector_Punctuation",
			bmp: "_‿⁀⁔︳︴﹍-﹏＿"
		},
		{
			name: "Pd",
			alias: "Dash_Punctuation",
			bmp: "\\-֊־᐀᠆‐-―⸗⸚⸺⸻⹀⹝〜〰゠︱︲﹘﹣－",
			astral: "𐺭"
		},
		{
			name: "Pe",
			alias: "Close_Punctuation",
			bmp: "\\)\\]\\}༻༽᚜⁆⁾₎⌉⌋〉❩❫❭❯❱❳❵⟆⟧⟩⟫⟭⟯⦄⦆⦈⦊⦌⦎⦐⦒⦔⦖⦘⧙⧛⧽⸣⸥⸧⸩⹖⹘⹚⹜〉》」』】〕〗〙〛〞〟﴾︘︶︸︺︼︾﹀﹂﹄﹈﹚﹜﹞）］｝｠｣"
		},
		{
			name: "Pf",
			alias: "Final_Punctuation",
			bmp: "»’”›⸃⸅⸊⸍⸝⸡"
		},
		{
			name: "Pi",
			alias: "Initial_Punctuation",
			bmp: "«‘‛“‟‹⸂⸄⸉⸌⸜⸠"
		},
		{
			name: "Po",
			alias: "Other_Punctuation",
			bmp: "!-#%-'\\*,\\.\\/:;\\?@\\¡§¶·¿;·՚-՟։׀׃׆׳״؉؊،؍؛؝-؟٪-٭۔܀-܍߷-߹࠰-࠾࡞।॥॰৽੶૰౷಄෴๏๚๛༄-༒༔྅࿐-࿔࿙࿚၊-၏჻፠-፨᙮᛫-᛭᜵᜶។-៖៘-៚᠀-᠅᠇-᠊᥄᥅᨞᨟᪠-᪦᪨-᪭᭚-᭠᭽᭾᯼-᯿᰻-᰿᱾᱿᳀-᳇᳓‖‗†-‧‰-‸※-‾⁁-⁃⁇-⁑⁓⁕-⁞⳹-⳼⳾⳿⵰⸀⸁⸆-⸈⸋⸎-⸖⸘⸙⸛⸞⸟⸪-⸮⸰-⸹⸼-⸿⹁⹃-⹏⹒-⹔、-〃〽・꓾꓿꘍-꘏꙳꙾꛲-꛷꡴-꡷꣎꣏꣸-꣺꣼꤮꤯꥟꧁-꧍꧞꧟꩜-꩟꫞꫟꫰꫱꯫︐-︖︙︰﹅﹆﹉-﹌﹐-﹒﹔-﹗﹟-﹡﹨﹪﹫！-＃％-＇＊，．／：；？＠＼｡､･",
			astral: "\ud800[\udd00-\udd02\udf9f\udfd0]|𐕯|\ud802[\udc57\udd1f\udd3f\ude50-\ude58\ude7f\udef0-\udef6\udf39-\udf3f\udf99-\udf9c]|\ud803[\udf55-\udf59\udf86-\udf89]|\ud804[\udc47-\udc4d\udcbb\udcbc\udcbe-\udcc1\udd40-\udd43\udd74\udd75\uddc5-\uddc8\uddcd\udddb\udddd-\udddf\ude38-\ude3d\udea9]|\ud805[\udc4b-\udc4f\udc5a\udc5b\udc5d\udcc6\uddc1-\uddd7\ude41-\ude43\ude60-\ude6c\udeb9\udf3c-\udf3e]|\ud806[\udc3b\udd44-\udd46\udde2\ude3f-\ude46\ude9a-\ude9c\ude9e-\udea2]|\ud807[\udc41-\udc45\udc70\udc71\udef7\udef8\udfff]|\ud809[\udc70-\udc74]|\ud80b[\udff1\udff2]|\ud81a[\ude6e\ude6f\udef5\udf37-\udf3b\udf44]|\ud81b[\ude97-\ude9a\udfe2]|𛲟|\ud836[\ude87-\ude8b]|\ud83a[\udd5e\udd5f]"
		},
		{
			name: "Ps",
			alias: "Open_Punctuation",
			bmp: "\\(\\[\\{༺༼᚛‚„⁅⁽₍⌈⌊〈❨❪❬❮❰❲❴⟅⟦⟨⟪⟬⟮⦃⦅⦇⦉⦋⦍⦏⦑⦓⦕⦗⧘⧚⧼⸢⸤⸦⸨⹂⹕⹗⹙⹛〈《「『【〔〖〘〚〝﴿︗︵︷︹︻︽︿﹁﹃﹇﹙﹛﹝（［｛｟｢"
		},
		{
			name: "S",
			alias: "Symbol",
			bmp: "\\$\\+<->\\^`\\|~¢-¦¨©¬®-±´¸×÷˂-˅˒-˟˥-˫˭˯-˿͵΄΅϶҂֍-֏؆-؈؋؎؏۞۩۽۾߶߾߿࢈৲৳৺৻૱୰௳-௺౿൏൹฿༁-༃༓༕-༗༚-༟༴༶༸྾-࿅࿇-࿌࿎࿏࿕-࿘႞႟᎐-᎙᙭៛᥀᧞-᧿᭡-᭪᭴-᭼᾽᾿-῁῍-῏῝-῟῭-`´῾⁄⁒⁺-⁼₊-₌₠-⃀℀℁℃-℆℈℉℔№-℘℞-℣℥℧℩℮℺℻⅀-⅄⅊-⅍⅏↊↋←-⌇⌌-⌨⌫-␦⑀-⑊⒜-ⓩ─-❧➔-⟄⟇-⟥⟰-⦂⦙-⧗⧜-⧻⧾-⭳⭶-⮕⮗-⯿⳥-⳪⹐⹑⺀-⺙⺛-⻳⼀-⿕⿰-⿻〄〒〓〠〶〷〾〿゛゜㆐㆑㆖-㆟㇀-㇣㈀-㈞㈪-㉇㉐㉠-㉿㊊-㊰㋀-㏿䷀-䷿꒐-꓆꜀-꜖꜠꜡꞉꞊꠨-꠫꠶-꠹꩷-꩹꭛꭪꭫﬩﮲-﯂﵀-﵏﷏﷼-﷿﹢﹤-﹦﹩＄＋＜-＞＾｀｜～￠-￦￨-￮￼�",
			astral: "\ud800[\udd37-\udd3f\udd79-\udd89\udd8c-\udd8e\udd90-\udd9c\udda0\uddd0-\uddfc]|\ud802[\udc77\udc78\udec8]|𑜿|\ud807[\udfd5-\udff1]|\ud81a[\udf3c-\udf3f\udf45]|𛲜|\ud833[\udf50-\udfc3]|\ud834[\udc00-\udcf5\udd00-\udd26\udd29-\udd64\udd6a-\udd6c\udd83\udd84\udd8c-\udda9\uddae-\uddea\ude00-\ude41\ude45\udf00-\udf56]|\ud835[\udec1\udedb\udefb\udf15\udf35\udf4f\udf6f\udf89\udfa9\udfc3]|\ud836[\udc00-\uddff\ude37-\ude3a\ude6d-\ude74\ude76-\ude83\ude85\ude86]|\ud838[\udd4f\udeff]|\ud83b[\udcac\udcb0\udd2e\udef0\udef1]|\ud83c[\udc00-\udc2b\udc30-\udc93\udca0-\udcae\udcb1-\udcbf\udcc1-\udccf\udcd1-\udcf5\udd0d-\uddad\udde6-\ude02\ude10-\ude3b\ude40-\ude48\ude50\ude51\ude60-\ude65\udf00-\udfff]|\ud83d[\udc00-\uded7\udedd-\udeec\udef0-\udefc\udf00-\udf73\udf80-\udfd8\udfe0-\udfeb\udff0]|\ud83e[\udc00-\udc0b\udc10-\udc47\udc50-\udc59\udc60-\udc87\udc90-\udcad\udcb0\udcb1\udd00-\ude53\ude60-\ude6d\ude70-\ude74\ude78-\ude7c\ude80-\ude86\ude90-\udeac\udeb0-\udeba\udec0-\udec5\uded0-\uded9\udee0-\udee7\udef0-\udef6\udf00-\udf92\udf94-\udfca]"
		},
		{
			name: "Sc",
			alias: "Currency_Symbol",
			bmp: "\\$¢-¥֏؋߾߿৲৳৻૱௹฿៛₠-⃀꠸﷼﹩＄￠￡￥￦",
			astral: "\ud807[\udfdd-\udfe0]|𞋿|𞲰"
		},
		{
			name: "Sk",
			alias: "Modifier_Symbol",
			bmp: "\\^`¨¯´¸˂-˅˒-˟˥-˫˭˯-˿͵΄΅࢈᾽᾿-῁῍-῏῝-῟῭-`´῾゛゜꜀-꜖꜠꜡꞉꞊꭛꭪꭫﮲-﯂＾｀￣",
			astral: "\ud83c[\udffb-\udfff]"
		},
		{
			name: "Sm",
			alias: "Math_Symbol",
			bmp: "\\+<->\\|~¬±×÷϶؆-؈⁄⁒⁺-⁼₊-₌℘⅀-⅄⅋←-↔↚↛↠↣↦↮⇎⇏⇒⇔⇴-⋿⌠⌡⍼⎛-⎳⏜-⏡▷◁◸-◿♯⟀-⟄⟇-⟥⟰-⟿⤀-⦂⦙-⧗⧜-⧻⧾-⫿⬰-⭄⭇-⭌﬩﹢﹤-﹦＋＜-＞｜～￢￩-￬",
			astral: "\ud835[\udec1\udedb\udefb\udf15\udf35\udf4f\udf6f\udf89\udfa9\udfc3]|\ud83b[\udef0\udef1]"
		},
		{
			name: "So",
			alias: "Other_Symbol",
			bmp: "¦©®°҂֍֎؎؏۞۩۽۾߶৺୰௳-௸௺౿൏൹༁-༃༓༕-༗༚-༟༴༶༸྾-࿅࿇-࿌࿎࿏࿕-࿘႞႟᎐-᎙᙭᥀᧞-᧿᭡-᭪᭴-᭼℀℁℃-℆℈℉℔№℗℞-℣℥℧℩℮℺℻⅊⅌⅍⅏↊↋↕-↙↜-↟↡↢↤↥↧-↭↯-⇍⇐⇑⇓⇕-⇳⌀-⌇⌌-⌟⌢-⌨⌫-⍻⍽-⎚⎴-⏛⏢-␦⑀-⑊⒜-ⓩ─-▶▸-◀◂-◷☀-♮♰-❧➔-➿⠀-⣿⬀-⬯⭅⭆⭍-⭳⭶-⮕⮗-⯿⳥-⳪⹐⹑⺀-⺙⺛-⻳⼀-⿕⿰-⿻〄〒〓〠〶〷〾〿㆐㆑㆖-㆟㇀-㇣㈀-㈞㈪-㉇㉐㉠-㉿㊊-㊰㋀-㏿䷀-䷿꒐-꓆꠨-꠫꠶꠷꠹꩷-꩹﵀-﵏﷏﷽-﷿￤￨￭￮￼�",
			astral: "\ud800[\udd37-\udd3f\udd79-\udd89\udd8c-\udd8e\udd90-\udd9c\udda0\uddd0-\uddfc]|\ud802[\udc77\udc78\udec8]|𑜿|\ud807[\udfd5-\udfdc\udfe1-\udff1]|\ud81a[\udf3c-\udf3f\udf45]|𛲜|\ud833[\udf50-\udfc3]|\ud834[\udc00-\udcf5\udd00-\udd26\udd29-\udd64\udd6a-\udd6c\udd83\udd84\udd8c-\udda9\uddae-\uddea\ude00-\ude41\ude45\udf00-\udf56]|\ud836[\udc00-\uddff\ude37-\ude3a\ude6d-\ude74\ude76-\ude83\ude85\ude86]|𞅏|\ud83b[\udcac\udd2e]|\ud83c[\udc00-\udc2b\udc30-\udc93\udca0-\udcae\udcb1-\udcbf\udcc1-\udccf\udcd1-\udcf5\udd0d-\uddad\udde6-\ude02\ude10-\ude3b\ude40-\ude48\ude50\ude51\ude60-\ude65\udf00-\udffa]|\ud83d[\udc00-\uded7\udedd-\udeec\udef0-\udefc\udf00-\udf73\udf80-\udfd8\udfe0-\udfeb\udff0]|\ud83e[\udc00-\udc0b\udc10-\udc47\udc50-\udc59\udc60-\udc87\udc90-\udcad\udcb0\udcb1\udd00-\ude53\ude60-\ude6d\ude70-\ude74\ude78-\ude7c\ude80-\ude86\ude90-\udeac\udeb0-\udeba\udec0-\udec5\uded0-\uded9\udee0-\udee7\udef0-\udef6\udf00-\udf92\udf94-\udfca]"
		},
		{
			name: "Z",
			alias: "Separator",
			bmp: " \xA0  - \u2028\u2029  　"
		},
		{
			name: "Zl",
			alias: "Line_Separator",
			bmp: "\u2028"
		},
		{
			name: "Zp",
			alias: "Paragraph_Separator",
			bmp: "\u2029"
		},
		{
			name: "Zs",
			alias: "Space_Separator",
			bmp: " \xA0  -   　"
		}
	];
})), Zo = /* @__PURE__ */ O(((e, t) => {
	var n = Vn(), r = Hn();
	n(e, "__esModule", { value: !0 }), e.default = void 0;
	var i = r(Xo());
	e.default = function(e) {
		if (!e.addUnicodeData) throw ReferenceError("Unicode Base must be loaded before Unicode Categories");
		e.addUnicodeData(i.default);
	}, t.exports = e.default;
})), Qo = /* @__PURE__ */ O(((e, t) => {
	t.exports = [
		{
			name: "ASCII",
			bmp: "\0-"
		},
		{
			name: "Alphabetic",
			bmp: "A-Za-zªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͅͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈְ-ׇֽֿׁׂׅׄא-תׯ-ײؐ-ؚؠ-ٗٙ-ٟٮ-ۓە-ۜۡ-ۭۨ-ۯۺ-ۼۿܐ-ܿݍ-ޱߊ-ߪߴߵߺࠀ-ࠗࠚ-ࠬࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉࣔ-ࣣࣟ-ࣰࣩ-ऻऽ-ौॎ-ॐॕ-ॣॱ-ঃঅ-ঌএঐও-নপ-রলশ-হঽ-ৄেৈোৌৎৗড়ঢ়য়-ৣৰৱৼਁ-ਃਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਾ-ੂੇੈੋੌੑਖ਼-ੜਫ਼ੰ-ੵઁ-ઃઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽ-ૅે-ૉોૌૐૠ-ૣૹ-ૼଁ-ଃଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽ-ୄେୈୋୌୖୗଡ଼ଢ଼ୟ-ୣୱஂஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹா-ூெ-ைொ-ௌௐௗఀ-ఃఅ-ఌఎ-ఐఒ-నప-హఽ-ౄె-ైొ-ౌౕౖౘ-ౚౝౠ-ౣಀ-ಃಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽ-ೄೆ-ೈೊ-ೌೕೖೝೞೠ-ೣೱೲഀ-ഌഎ-ഐഒ-ഺഽ-ൄെ-ൈൊ-ൌൎൔ-ൗൟ-ൣൺ-ൿඁ-ඃඅ-ඖක-නඳ-රලව-ෆා-ුූෘ-ෟෲෳก-ฺเ-ๆํກຂຄຆ-ຊຌ-ຣລວ-ູົ-ຽເ-ໄໆໍໜ-ໟༀཀ-ཇཉ-ཬཱ-ཱྀྈ-ྗྙ-ྼက-ံးျ-ဿၐ-ႏႚ-ႝႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜓᜟ-ᜳᝀ-ᝓᝠ-ᝬᝮ-ᝰᝲᝳក-ឳា-ៈៗៜᠠ-ᡸᢀ-ᢪᢰ-ᣵᤀ-ᤞᤠ-ᤫᤰ-ᤸᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨛᨠ-ᩞᩡ-ᩴᪧᪿᫀᫌ-ᫎᬀ-ᬳᬵ-ᭃᭅ-ᭌᮀ-ᮩᮬ-ᮯᮺ-ᯥᯧ-ᯱᰀ-ᰶᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿᷧ-ᷴḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⒶ-ⓩⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⷠ-ⷿⸯ々-〇〡-〩〱-〵〸-〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙴ-ꙻꙿ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꠅꠇ-ꠧꡀ-ꡳꢀ-ꣃꣅꣲ-ꣷꣻꣽ-ꣿꤊ-ꤪꤰ-ꥒꥠ-ꥼꦀ-ꦲꦴ-ꦿꧏꧠ-ꧯꧺ-ꧾꨀ-ꨶꩀ-ꩍꩠ-ꩶꩺ-ꪾꫀꫂꫛ-ꫝꫠ-ꫯꫲ-ꫵꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯪ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ",
			astral: "\ud800[\udc00-\udc0b\udc0d-\udc26\udc28-\udc3a\udc3c\udc3d\udc3f-\udc4d\udc50-\udc5d\udc80-\udcfa\udd40-\udd74\ude80-\ude9c\udea0-\uded0\udf00-\udf1f\udf2d-\udf4a\udf50-\udf7a\udf80-\udf9d\udfa0-\udfc3\udfc8-\udfcf\udfd1-\udfd5]|\ud801[\udc00-\udc9d\udcb0-\udcd3\udcd8-\udcfb\udd00-\udd27\udd30-\udd63\udd70-\udd7a\udd7c-\udd8a\udd8c-\udd92\udd94\udd95\udd97-\udda1\udda3-\uddb1\uddb3-\uddb9\uddbb\uddbc\ude00-\udf36\udf40-\udf55\udf60-\udf67\udf80-\udf85\udf87-\udfb0\udfb2-\udfba]|\ud802[\udc00-\udc05\udc08\udc0a-\udc35\udc37\udc38\udc3c\udc3f-\udc55\udc60-\udc76\udc80-\udc9e\udce0-\udcf2\udcf4\udcf5\udd00-\udd15\udd20-\udd39\udd80-\uddb7\uddbe\uddbf\ude00-\ude03\ude05\ude06\ude0c-\ude13\ude15-\ude17\ude19-\ude35\ude60-\ude7c\ude80-\ude9c\udec0-\udec7\udec9-\udee4\udf00-\udf35\udf40-\udf55\udf60-\udf72\udf80-\udf91]|\ud803[\udc00-\udc48\udc80-\udcb2\udcc0-\udcf2\udd00-\udd27\ude80-\udea9\udeab\udeac\udeb0\udeb1\udf00-\udf1c\udf27\udf30-\udf45\udf70-\udf81\udfb0-\udfc4\udfe0-\udff6]|\ud804[\udc00-\udc45\udc71-\udc75\udc82-\udcb8\udcc2\udcd0-\udce8\udd00-\udd32\udd44-\udd47\udd50-\udd72\udd76\udd80-\uddbf\uddc1-\uddc4\uddce\uddcf\uddda\udddc\ude00-\ude11\ude13-\ude34\ude37\ude3e\ude80-\ude86\ude88\ude8a-\ude8d\ude8f-\ude9d\ude9f-\udea8\udeb0-\udee8\udf00-\udf03\udf05-\udf0c\udf0f\udf10\udf13-\udf28\udf2a-\udf30\udf32\udf33\udf35-\udf39\udf3d-\udf44\udf47\udf48\udf4b\udf4c\udf50\udf57\udf5d-\udf63]|\ud805[\udc00-\udc41\udc43-\udc45\udc47-\udc4a\udc5f-\udc61\udc80-\udcc1\udcc4\udcc5\udcc7\udd80-\uddb5\uddb8-\uddbe\uddd8-\udddd\ude00-\ude3e\ude40\ude44\ude80-\udeb5\udeb8\udf00-\udf1a\udf1d-\udf2a\udf40-\udf46]|\ud806[\udc00-\udc38\udca0-\udcdf\udcff-\udd06\udd09\udd0c-\udd13\udd15\udd16\udd18-\udd35\udd37\udd38\udd3b\udd3c\udd3f-\udd42\udda0-\udda7\uddaa-\uddd7\uddda-\udddf\udde1\udde3\udde4\ude00-\ude32\ude35-\ude3e\ude50-\ude97\ude9d\udeb0-\udef8]|\ud807[\udc00-\udc08\udc0a-\udc36\udc38-\udc3e\udc40\udc72-\udc8f\udc92-\udca7\udca9-\udcb6\udd00-\udd06\udd08\udd09\udd0b-\udd36\udd3a\udd3c\udd3d\udd3f-\udd41\udd43\udd46\udd47\udd60-\udd65\udd67\udd68\udd6a-\udd8e\udd90\udd91\udd93-\udd96\udd98\udee0-\udef6\udfb0]|\ud808[\udc00-\udf99]|\ud809[\udc00-\udc6e\udc80-\udd43]|\ud80b[\udf90-\udff0]|[\ud80c\ud81c-\ud820\ud822\ud840-\ud868\ud86a-\ud86c\ud86f-\ud872\ud874-\ud879\ud880-\ud883][\udc00-\udfff]|\ud80d[\udc00-\udc2e]|\ud811[\udc00-\ude46]|\ud81a[\udc00-\ude38\ude40-\ude5e\ude70-\udebe\uded0-\udeed\udf00-\udf2f\udf40-\udf43\udf63-\udf77\udf7d-\udf8f]|\ud81b[\ude40-\ude7f\udf00-\udf4a\udf4f-\udf87\udf8f-\udf9f\udfe0\udfe1\udfe3\udff0\udff1]|\ud821[\udc00-\udff7]|\ud823[\udc00-\udcd5\udd00-\udd08]|\ud82b[\udff0-\udff3\udff5-\udffb\udffd\udffe]|\ud82c[\udc00-\udd22\udd50-\udd52\udd64-\udd67\udd70-\udefb]|\ud82f[\udc00-\udc6a\udc70-\udc7c\udc80-\udc88\udc90-\udc99\udc9e]|\ud835[\udc00-\udc54\udc56-\udc9c\udc9e\udc9f\udca2\udca5\udca6\udca9-\udcac\udcae-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd1e-\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd52-\udea5\udea8-\udec0\udec2-\udeda\udedc-\udefa\udefc-\udf14\udf16-\udf34\udf36-\udf4e\udf50-\udf6e\udf70-\udf88\udf8a-\udfa8\udfaa-\udfc2\udfc4-\udfcb]|\ud837[\udf00-\udf1e]|\ud838[\udc00-\udc06\udc08-\udc18\udc1b-\udc21\udc23\udc24\udc26-\udc2a\udd00-\udd2c\udd37-\udd3d\udd4e\ude90-\udead\udec0-\udeeb]|\ud839[\udfe0-\udfe6\udfe8-\udfeb\udfed\udfee\udff0-\udffe]|\ud83a[\udc00-\udcc4\udd00-\udd43\udd47\udd4b]|\ud83b[\ude00-\ude03\ude05-\ude1f\ude21\ude22\ude24\ude27\ude29-\ude32\ude34-\ude37\ude39\ude3b\ude42\ude47\ude49\ude4b\ude4d-\ude4f\ude51\ude52\ude54\ude57\ude59\ude5b\ude5d\ude5f\ude61\ude62\ude64\ude67-\ude6a\ude6c-\ude72\ude74-\ude77\ude79-\ude7c\ude7e\ude80-\ude89\ude8b-\ude9b\udea1-\udea3\udea5-\udea9\udeab-\udebb]|\ud83c[\udd30-\udd49\udd50-\udd69\udd70-\udd89]|\ud869[\udc00-\udedf\udf00-\udfff]|\ud86d[\udc00-\udf38\udf40-\udfff]|\ud86e[\udc00-\udc1d\udc20-\udfff]|\ud873[\udc00-\udea1\udeb0-\udfff]|\ud87a[\udc00-\udfe0]|\ud87e[\udc00-\ude1d]|\ud884[\udc00-\udf4a]"
		},
		{
			name: "Any",
			isBmpLast: !0,
			bmp: "\0-￿",
			astral: "[\ud800-\udbff][\udc00-\udfff]"
		},
		{
			name: "Default_Ignorable_Code_Point",
			bmp: "­͏؜ᅟᅠ឴឵᠋-᠏​-‏‪-‮⁠-⁯ㅤ︀-️﻿ﾠ￰-￸",
			astral: "\ud82f[\udca0-\udca3]|\ud834[\udd73-\udd7a]|[\udb40-\udb43][\udc00-\udfff]"
		},
		{
			name: "Lowercase",
			bmp: "a-zªµºß-öø-ÿāăąćĉċčďđēĕėęěĝğġģĥħĩīĭįıĳĵķĸĺļľŀłńņňŉŋōŏőœŕŗřśŝşšţťŧũūŭůűųŵŷźżž-ƀƃƅƈƌƍƒƕƙ-ƛƞơƣƥƨƪƫƭưƴƶƹƺƽ-ƿǆǉǌǎǐǒǔǖǘǚǜǝǟǡǣǥǧǩǫǭǯǰǳǵǹǻǽǿȁȃȅȇȉȋȍȏȑȓȕȗșțȝȟȡȣȥȧȩȫȭȯȱȳ-ȹȼȿɀɂɇɉɋɍɏ-ʓʕ-ʸˀˁˠ-ˤͅͱͳͷͺ-ͽΐά-ώϐϑϕ-ϗϙϛϝϟϡϣϥϧϩϫϭϯ-ϳϵϸϻϼа-џѡѣѥѧѩѫѭѯѱѳѵѷѹѻѽѿҁҋҍҏґғҕҗҙқҝҟҡңҥҧҩҫҭүұҳҵҷҹһҽҿӂӄӆӈӊӌӎӏӑӓӕӗәӛӝӟӡӣӥӧөӫӭӯӱӳӵӷӹӻӽӿԁԃԅԇԉԋԍԏԑԓԕԗԙԛԝԟԡԣԥԧԩԫԭԯՠ-ֈა-ჺჽ-ჿᏸ-ᏽᲀ-ᲈᴀ-ᶿḁḃḅḇḉḋḍḏḑḓḕḗḙḛḝḟḡḣḥḧḩḫḭḯḱḳḵḷḹḻḽḿṁṃṅṇṉṋṍṏṑṓṕṗṙṛṝṟṡṣṥṧṩṫṭṯṱṳṵṷṹṻṽṿẁẃẅẇẉẋẍẏẑẓẕ-ẝẟạảấầẩẫậắằẳẵặẹẻẽếềểễệỉịọỏốồổỗộớờởỡợụủứừửữựỳỵỷỹỻỽỿ-ἇἐ-ἕἠ-ἧἰ-ἷὀ-ὅὐ-ὗὠ-ὧὰ-ώᾀ-ᾇᾐ-ᾗᾠ-ᾧᾰ-ᾴᾶᾷιῂ-ῄῆῇῐ-ΐῖῗῠ-ῧῲ-ῴῶῷⁱⁿₐ-ₜℊℎℏℓℯℴℹℼℽⅆ-ⅉⅎⅰ-ⅿↄⓐ-ⓩⰰ-ⱟⱡⱥⱦⱨⱪⱬⱱⱳⱴⱶ-ⱽⲁⲃⲅⲇⲉⲋⲍⲏⲑⲓⲕⲗⲙⲛⲝⲟⲡⲣⲥⲧⲩⲫⲭⲯⲱⲳⲵⲷⲹⲻⲽⲿⳁⳃⳅⳇⳉⳋⳍⳏⳑⳓⳕⳗⳙⳛⳝⳟⳡⳣⳤⳬⳮⳳⴀ-ⴥⴧⴭꙁꙃꙅꙇꙉꙋꙍꙏꙑꙓꙕꙗꙙꙛꙝꙟꙡꙣꙥꙧꙩꙫꙭꚁꚃꚅꚇꚉꚋꚍꚏꚑꚓꚕꚗꚙꚛ-ꚝꜣꜥꜧꜩꜫꜭꜯ-ꜱꜳꜵꜷꜹꜻꜽꜿꝁꝃꝅꝇꝉꝋꝍꝏꝑꝓꝕꝗꝙꝛꝝꝟꝡꝣꝥꝧꝩꝫꝭꝯ-ꝸꝺꝼꝿꞁꞃꞅꞇꞌꞎꞑꞓ-ꞕꞗꞙꞛꞝꞟꞡꞣꞥꞧꞩꞯꞵꞷꞹꞻꞽꞿꟁꟃꟈꟊꟑꟓꟕꟗꟙꟶꟸ-ꟺꬰ-ꭚꭜ-ꭨꭰ-ꮿﬀ-ﬆﬓ-ﬗａ-ｚ",
			astral: "\ud801[\udc28-\udc4f\udcd8-\udcfb\udd97-\udda1\udda3-\uddb1\uddb3-\uddb9\uddbb\uddbc\udf80\udf83-\udf85\udf87-\udfb0\udfb2-\udfba]|\ud803[\udcc0-\udcf2]|\ud806[\udcc0-\udcdf]|\ud81b[\ude60-\ude7f]|\ud835[\udc1a-\udc33\udc4e-\udc54\udc56-\udc67\udc82-\udc9b\udcb6-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udccf\udcea-\udd03\udd1e-\udd37\udd52-\udd6b\udd86-\udd9f\uddba-\uddd3\uddee-\ude07\ude22-\ude3b\ude56-\ude6f\ude8a-\udea5\udec2-\udeda\udedc-\udee1\udefc-\udf14\udf16-\udf1b\udf36-\udf4e\udf50-\udf55\udf70-\udf88\udf8a-\udf8f\udfaa-\udfc2\udfc4-\udfc9\udfcb]|\ud837[\udf00-\udf09\udf0b-\udf1e]|\ud83a[\udd22-\udd43]"
		},
		{
			name: "Noncharacter_Code_Point",
			bmp: "﷐-﷯￾￿",
			astral: "[\ud83f\ud87f\ud8bf\ud8ff\ud93f\ud97f\ud9bf\ud9ff\uda3f\uda7f\udabf\udaff\udb3f\udb7f\udbbf\udbff][\udffe\udfff]"
		},
		{
			name: "Uppercase",
			bmp: "A-ZÀ-ÖØ-ÞĀĂĄĆĈĊČĎĐĒĔĖĘĚĜĞĠĢĤĦĨĪĬĮİĲĴĶĹĻĽĿŁŃŅŇŊŌŎŐŒŔŖŘŚŜŞŠŢŤŦŨŪŬŮŰŲŴŶŸŹŻŽƁƂƄƆƇƉ-ƋƎ-ƑƓƔƖ-ƘƜƝƟƠƢƤƦƧƩƬƮƯƱ-ƳƵƷƸƼǄǇǊǍǏǑǓǕǗǙǛǞǠǢǤǦǨǪǬǮǱǴǶ-ǸǺǼǾȀȂȄȆȈȊȌȎȐȒȔȖȘȚȜȞȠȢȤȦȨȪȬȮȰȲȺȻȽȾɁɃ-ɆɈɊɌɎͰͲͶͿΆΈ-ΊΌΎΏΑ-ΡΣ-ΫϏϒ-ϔϘϚϜϞϠϢϤϦϨϪϬϮϴϷϹϺϽ-ЯѠѢѤѦѨѪѬѮѰѲѴѶѸѺѼѾҀҊҌҎҐҒҔҖҘҚҜҞҠҢҤҦҨҪҬҮҰҲҴҶҸҺҼҾӀӁӃӅӇӉӋӍӐӒӔӖӘӚӜӞӠӢӤӦӨӪӬӮӰӲӴӶӸӺӼӾԀԂԄԆԈԊԌԎԐԒԔԖԘԚԜԞԠԢԤԦԨԪԬԮԱ-ՖႠ-ჅჇჍᎠ-ᏵᲐ-ᲺᲽ-ᲿḀḂḄḆḈḊḌḎḐḒḔḖḘḚḜḞḠḢḤḦḨḪḬḮḰḲḴḶḸḺḼḾṀṂṄṆṈṊṌṎṐṒṔṖṘṚṜṞṠṢṤṦṨṪṬṮṰṲṴṶṸṺṼṾẀẂẄẆẈẊẌẎẐẒẔẞẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼẾỀỂỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪỬỮỰỲỴỶỸỺỼỾἈ-ἏἘ-ἝἨ-ἯἸ-ἿὈ-ὍὙὛὝὟὨ-ὯᾸ-ΆῈ-ΉῘ-ΊῨ-ῬῸ-Ώℂℇℋ-ℍℐ-ℒℕℙ-ℝℤΩℨK-ℭℰ-ℳℾℿⅅⅠ-ⅯↃⒶ-ⓏⰀ-ⰯⱠⱢ-ⱤⱧⱩⱫⱭ-ⱰⱲⱵⱾ-ⲀⲂⲄⲆⲈⲊⲌⲎⲐⲒⲔⲖⲘⲚⲜⲞⲠⲢⲤⲦⲨⲪⲬⲮⲰⲲⲴⲶⲸⲺⲼⲾⳀⳂⳄⳆⳈⳊⳌⳎⳐⳒⳔⳖⳘⳚⳜⳞⳠⳢⳫⳭⳲꙀꙂꙄꙆꙈꙊꙌꙎꙐꙒꙔꙖꙘꙚꙜꙞꙠꙢꙤꙦꙨꙪꙬꚀꚂꚄꚆꚈꚊꚌꚎꚐꚒꚔꚖꚘꚚꜢꜤꜦꜨꜪꜬꜮꜲꜴꜶꜸꜺꜼꜾꝀꝂꝄꝆꝈꝊꝌꝎꝐꝒꝔꝖꝘꝚꝜꝞꝠꝢꝤꝦꝨꝪꝬꝮꝹꝻꝽꝾꞀꞂꞄꞆꞋꞍꞐꞒꞖꞘꞚꞜꞞꞠꞢꞤꞦꞨꞪ-ꞮꞰ-ꞴꞶꞸꞺꞼꞾꟀꟂꟄ-ꟇꟉꟐꟖꟘꟵＡ-Ｚ",
			astral: "\ud801[\udc00-\udc27\udcb0-\udcd3\udd70-\udd7a\udd7c-\udd8a\udd8c-\udd92\udd94\udd95]|\ud803[\udc80-\udcb2]|\ud806[\udca0-\udcbf]|\ud81b[\ude40-\ude5f]|\ud835[\udc00-\udc19\udc34-\udc4d\udc68-\udc81\udc9c\udc9e\udc9f\udca2\udca5\udca6\udca9-\udcac\udcae-\udcb5\udcd0-\udce9\udd04\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd38\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd6c-\udd85\udda0-\uddb9\uddd4-\udded\ude08-\ude21\ude3c-\ude55\ude70-\ude89\udea8-\udec0\udee2-\udefa\udf1c-\udf34\udf56-\udf6e\udf90-\udfa8\udfca]|\ud83a[\udd00-\udd21]|\ud83c[\udd30-\udd49\udd50-\udd69\udd70-\udd89]"
		},
		{
			name: "White_Space",
			bmp: "	-\r \xA0  - \u2028\u2029  　"
		}
	];
})), $o = /* @__PURE__ */ O(((e, t) => {
	var n = Vn(), r = Hn();
	n(e, "__esModule", { value: !0 }), e.default = void 0;
	var i = r(Qo());
	e.default = function(e) {
		if (!e.addUnicodeData) throw ReferenceError("Unicode Base must be loaded before Unicode Properties");
		var t = i.default;
		t.push({
			name: "Assigned",
			inverseOf: "Cn"
		}), e.addUnicodeData(t);
	}, t.exports = e.default;
})), es = /* @__PURE__ */ O(((e, t) => {
	t.exports = [
		{
			name: "Adlam",
			astral: "\ud83a[\udd00-\udd4b\udd50-\udd59\udd5e\udd5f]"
		},
		{
			name: "Ahom",
			astral: "\ud805[\udf00-\udf1a\udf1d-\udf2b\udf30-\udf46]"
		},
		{
			name: "Anatolian_Hieroglyphs",
			astral: "\ud811[\udc00-\ude46]"
		},
		{
			name: "Arabic",
			bmp: "؀-؄؆-؋؍-ؚ؜-؞ؠ-ؿف-يٖ-ٯٱ-ۜ۞-ۿݐ-ݿࡰ-ࢎ࢐࢑࢘-ࣣ࣡-ࣿﭐ-﯂ﯓ-ﴽ﵀-ﶏﶒ-ﷇ﷏ﷰ-﷿ﹰ-ﹴﹶ-ﻼ",
			astral: "\ud803[\ude60-\ude7e]|\ud83b[\ude00-\ude03\ude05-\ude1f\ude21\ude22\ude24\ude27\ude29-\ude32\ude34-\ude37\ude39\ude3b\ude42\ude47\ude49\ude4b\ude4d-\ude4f\ude51\ude52\ude54\ude57\ude59\ude5b\ude5d\ude5f\ude61\ude62\ude64\ude67-\ude6a\ude6c-\ude72\ude74-\ude77\ude79-\ude7c\ude7e\ude80-\ude89\ude8b-\ude9b\udea1-\udea3\udea5-\udea9\udeab-\udebb\udef0\udef1]"
		},
		{
			name: "Armenian",
			bmp: "Ա-Ֆՙ-֊֍-֏ﬓ-ﬗ"
		},
		{
			name: "Avestan",
			astral: "\ud802[\udf00-\udf35\udf39-\udf3f]"
		},
		{
			name: "Balinese",
			bmp: "ᬀ-ᭌ᭐-᭾"
		},
		{
			name: "Bamum",
			bmp: "ꚠ-꛷",
			astral: "\ud81a[\udc00-\ude38]"
		},
		{
			name: "Bassa_Vah",
			astral: "\ud81a[\uded0-\udeed\udef0-\udef5]"
		},
		{
			name: "Batak",
			bmp: "ᯀ-᯳᯼-᯿"
		},
		{
			name: "Bengali",
			bmp: "ঀ-ঃঅ-ঌএঐও-নপ-রলশ-হ়-ৄেৈো-ৎৗড়ঢ়য়-ৣ০-৾"
		},
		{
			name: "Bhaiksuki",
			astral: "\ud807[\udc00-\udc08\udc0a-\udc36\udc38-\udc45\udc50-\udc6c]"
		},
		{
			name: "Bopomofo",
			bmp: "˪˫ㄅ-ㄯㆠ-ㆿ"
		},
		{
			name: "Brahmi",
			astral: "\ud804[\udc00-\udc4d\udc52-\udc75\udc7f]"
		},
		{
			name: "Braille",
			bmp: "⠀-⣿"
		},
		{
			name: "Buginese",
			bmp: "ᨀ-ᨛ᨞᨟"
		},
		{
			name: "Buhid",
			bmp: "ᝀ-ᝓ"
		},
		{
			name: "Canadian_Aboriginal",
			bmp: "᐀-ᙿᢰ-ᣵ",
			astral: "\ud806[\udeb0-\udebf]"
		},
		{
			name: "Carian",
			astral: "\ud800[\udea0-\uded0]"
		},
		{
			name: "Caucasian_Albanian",
			astral: "\ud801[\udd30-\udd63\udd6f]"
		},
		{
			name: "Chakma",
			astral: "\ud804[\udd00-\udd34\udd36-\udd47]"
		},
		{
			name: "Cham",
			bmp: "ꨀ-ꨶꩀ-ꩍ꩐-꩙꩜-꩟"
		},
		{
			name: "Cherokee",
			bmp: "Ꭰ-Ᏽᏸ-ᏽꭰ-ꮿ"
		},
		{
			name: "Chorasmian",
			astral: "\ud803[\udfb0-\udfcb]"
		},
		{
			name: "Common",
			bmp: "\0-@\\[-`\\{-©«-¹»-¿×÷ʹ-˟˥-˩ˬ-˿ʹ;΅·؅،؛؟ـ۝࣢।॥฿࿕-࿘჻᛫-᛭᜵᜶᠂᠃᠅᳓᳡ᳩ-ᳬᳮ-ᳳᳵ-᳷ᳺ -​‎-⁤⁦-⁰⁴-⁾₀-₎₠-⃀℀-℥℧-℩ℬ-ℱℳ-⅍⅏-⅟↉-↋←-␦⑀-⑊①-⟿⤀-⭳⭶-⮕⮗-⯿⸀-⹝⿰-⿻　-〄〆〈-〠〰-〷〼-〿゛゜゠・ー㆐-㆟㇀-㇣㈠-㉟㉿-㋏㋿㍘-㏿䷀-䷿꜀-꜡ꞈ-꞊꠰-꠹꤮ꧏ꭛꭪꭫﴾﴿︐-︙︰-﹒﹔-﹦﹨-﹫﻿！-＠［-｀｛-･ｰﾞﾟ￠-￦￨-￮￹-�",
			astral: "\ud800[\udd00-\udd02\udd07-\udd33\udd37-\udd3f\udd90-\udd9c\uddd0-\uddfc\udee1-\udefb]|\ud82f[\udca0-\udca3]|\ud833[\udf50-\udfc3]|\ud834[\udc00-\udcf5\udd00-\udd26\udd29-\udd66\udd6a-\udd7a\udd83\udd84\udd8c-\udda9\uddae-\uddea\udee0-\udef3\udf00-\udf56\udf60-\udf78]|\ud835[\udc00-\udc54\udc56-\udc9c\udc9e\udc9f\udca2\udca5\udca6\udca9-\udcac\udcae-\udcb9\udcbb\udcbd-\udcc3\udcc5-\udd05\udd07-\udd0a\udd0d-\udd14\udd16-\udd1c\udd1e-\udd39\udd3b-\udd3e\udd40-\udd44\udd46\udd4a-\udd50\udd52-\udea5\udea8-\udfcb\udfce-\udfff]|\ud83b[\udc71-\udcb4\udd01-\udd3d]|\ud83c[\udc00-\udc2b\udc30-\udc93\udca0-\udcae\udcb1-\udcbf\udcc1-\udccf\udcd1-\udcf5\udd00-\uddad\udde6-\uddff\ude01\ude02\ude10-\ude3b\ude40-\ude48\ude50\ude51\ude60-\ude65\udf00-\udfff]|\ud83d[\udc00-\uded7\udedd-\udeec\udef0-\udefc\udf00-\udf73\udf80-\udfd8\udfe0-\udfeb\udff0]|\ud83e[\udc00-\udc0b\udc10-\udc47\udc50-\udc59\udc60-\udc87\udc90-\udcad\udcb0\udcb1\udd00-\ude53\ude60-\ude6d\ude70-\ude74\ude78-\ude7c\ude80-\ude86\ude90-\udeac\udeb0-\udeba\udec0-\udec5\uded0-\uded9\udee0-\udee7\udef0-\udef6\udf00-\udf92\udf94-\udfca\udff0-\udff9]|\udb40[\udc01\udc20-\udc7f]"
		},
		{
			name: "Coptic",
			bmp: "Ϣ-ϯⲀ-ⳳ⳹-⳿"
		},
		{
			name: "Cuneiform",
			astral: "\ud808[\udc00-\udf99]|\ud809[\udc00-\udc6e\udc70-\udc74\udc80-\udd43]"
		},
		{
			name: "Cypriot",
			astral: "\ud802[\udc00-\udc05\udc08\udc0a-\udc35\udc37\udc38\udc3c\udc3f]"
		},
		{
			name: "Cypro_Minoan",
			astral: "\ud80b[\udf90-\udff2]"
		},
		{
			name: "Cyrillic",
			bmp: "Ѐ-҄҇-ԯᲀ-ᲈᴫᵸⷠ-ⷿꙀ-ꚟ︮︯"
		},
		{
			name: "Deseret",
			astral: "\ud801[\udc00-\udc4f]"
		},
		{
			name: "Devanagari",
			bmp: "ऀ-ॐॕ-ॣ०-ॿ꣠-ꣿ"
		},
		{
			name: "Dives_Akuru",
			astral: "\ud806[\udd00-\udd06\udd09\udd0c-\udd13\udd15\udd16\udd18-\udd35\udd37\udd38\udd3b-\udd46\udd50-\udd59]"
		},
		{
			name: "Dogra",
			astral: "\ud806[\udc00-\udc3b]"
		},
		{
			name: "Duployan",
			astral: "\ud82f[\udc00-\udc6a\udc70-\udc7c\udc80-\udc88\udc90-\udc99\udc9c-\udc9f]"
		},
		{
			name: "Egyptian_Hieroglyphs",
			astral: "\ud80c[\udc00-\udfff]|\ud80d[\udc00-\udc2e\udc30-\udc38]"
		},
		{
			name: "Elbasan",
			astral: "\ud801[\udd00-\udd27]"
		},
		{
			name: "Elymaic",
			astral: "\ud803[\udfe0-\udff6]"
		},
		{
			name: "Ethiopic",
			bmp: "ሀ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚ፝-፼ᎀ-᎙ⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮ",
			astral: "\ud839[\udfe0-\udfe6\udfe8-\udfeb\udfed\udfee\udff0-\udffe]"
		},
		{
			name: "Georgian",
			bmp: "Ⴀ-ჅჇჍა-ჺჼ-ჿᲐ-ᲺᲽ-Ჿⴀ-ⴥⴧⴭ"
		},
		{
			name: "Glagolitic",
			bmp: "Ⰰ-ⱟ",
			astral: "\ud838[\udc00-\udc06\udc08-\udc18\udc1b-\udc21\udc23\udc24\udc26-\udc2a]"
		},
		{
			name: "Gothic",
			astral: "\ud800[\udf30-\udf4a]"
		},
		{
			name: "Grantha",
			astral: "\ud804[\udf00-\udf03\udf05-\udf0c\udf0f\udf10\udf13-\udf28\udf2a-\udf30\udf32\udf33\udf35-\udf39\udf3c-\udf44\udf47\udf48\udf4b-\udf4d\udf50\udf57\udf5d-\udf63\udf66-\udf6c\udf70-\udf74]"
		},
		{
			name: "Greek",
			bmp: "Ͱ-ͳ͵-ͷͺ-ͽͿ΄ΆΈ-ΊΌΎ-ΡΣ-ϡϰ-Ͽᴦ-ᴪᵝ-ᵡᵦ-ᵪᶿἀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ῄῆ-ΐῖ-Ί῝-`ῲ-ῴῶ-῾Ωꭥ",
			astral: "\ud800[\udd40-\udd8e\udda0]|\ud834[\ude00-\ude45]"
		},
		{
			name: "Gujarati",
			bmp: "ઁ-ઃઅ-ઍએ-ઑઓ-નપ-રલળવ-હ઼-ૅે-ૉો-્ૐૠ-ૣ૦-૱ૹ-૿"
		},
		{
			name: "Gunjala_Gondi",
			astral: "\ud807[\udd60-\udd65\udd67\udd68\udd6a-\udd8e\udd90\udd91\udd93-\udd98\udda0-\udda9]"
		},
		{
			name: "Gurmukhi",
			bmp: "ਁ-ਃਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹ਼ਾ-ੂੇੈੋ-੍ੑਖ਼-ੜਫ਼੦-੶"
		},
		{
			name: "Han",
			bmp: "⺀-⺙⺛-⻳⼀-⿕々〇〡-〩〸-〻㐀-䶿一-鿿豈-舘並-龎",
			astral: "\ud81b[\udfe2\udfe3\udff0\udff1]|[\ud840-\ud868\ud86a-\ud86c\ud86f-\ud872\ud874-\ud879\ud880-\ud883][\udc00-\udfff]|\ud869[\udc00-\udedf\udf00-\udfff]|\ud86d[\udc00-\udf38\udf40-\udfff]|\ud86e[\udc00-\udc1d\udc20-\udfff]|\ud873[\udc00-\udea1\udeb0-\udfff]|\ud87a[\udc00-\udfe0]|\ud87e[\udc00-\ude1d]|\ud884[\udc00-\udf4a]"
		},
		{
			name: "Hangul",
			bmp: "ᄀ-ᇿ〮〯ㄱ-ㆎ㈀-㈞㉠-㉾ꥠ-ꥼ가-힣ힰ-ퟆퟋ-ퟻﾠ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ"
		},
		{
			name: "Hanifi_Rohingya",
			astral: "\ud803[\udd00-\udd27\udd30-\udd39]"
		},
		{
			name: "Hanunoo",
			bmp: "ᜠ-᜴"
		},
		{
			name: "Hatran",
			astral: "\ud802[\udce0-\udcf2\udcf4\udcf5\udcfb-\udcff]"
		},
		{
			name: "Hebrew",
			bmp: "֑-ׇא-תׯ-״יִ-זּטּ-לּמּנּסּףּפּצּ-ﭏ"
		},
		{
			name: "Hiragana",
			bmp: "ぁ-ゖゝ-ゟ",
			astral: "\ud82c[\udc01-\udd1f\udd50-\udd52]|🈀"
		},
		{
			name: "Imperial_Aramaic",
			astral: "\ud802[\udc40-\udc55\udc57-\udc5f]"
		},
		{
			name: "Inherited",
			bmp: "̀-ًͯ҅҆-ٰٕ॑-॔᪰-ᫎ᳐-᳔᳒-᳢᳠-᳨᳭᳴᳸᳹᷀-᷿‌‍⃐-〪⃰-゙゚〭︀-️︠-︭",
			astral: "\ud800[\uddfd\udee0]|𑌻|\ud833[\udf00-\udf2d\udf30-\udf46]|\ud834[\udd67-\udd69\udd7b-\udd82\udd85-\udd8b\uddaa-\uddad]|\udb40[\udd00-\uddef]"
		},
		{
			name: "Inscriptional_Pahlavi",
			astral: "\ud802[\udf60-\udf72\udf78-\udf7f]"
		},
		{
			name: "Inscriptional_Parthian",
			astral: "\ud802[\udf40-\udf55\udf58-\udf5f]"
		},
		{
			name: "Javanese",
			bmp: "ꦀ-꧍꧐-꧙꧞꧟"
		},
		{
			name: "Kaithi",
			astral: "\ud804[\udc80-\udcc2\udccd]"
		},
		{
			name: "Kannada",
			bmp: "ಀ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹ಼-ೄೆ-ೈೊ-್ೕೖೝೞೠ-ೣ೦-೯ೱೲ"
		},
		{
			name: "Katakana",
			bmp: "ァ-ヺヽ-ヿㇰ-ㇿ㋐-㋾㌀-㍗ｦ-ｯｱ-ﾝ",
			astral: "\ud82b[\udff0-\udff3\udff5-\udffb\udffd\udffe]|\ud82c[\udc00\udd20-\udd22\udd64-\udd67]"
		},
		{
			name: "Kayah_Li",
			bmp: "꤀-꤭꤯"
		},
		{
			name: "Kharoshthi",
			astral: "\ud802[\ude00-\ude03\ude05\ude06\ude0c-\ude13\ude15-\ude17\ude19-\ude35\ude38-\ude3a\ude3f-\ude48\ude50-\ude58]"
		},
		{
			name: "Khitan_Small_Script",
			astral: "𖿤|\ud822[\udf00-\udfff]|\ud823[\udc00-\udcd5]"
		},
		{
			name: "Khmer",
			bmp: "ក-៝០-៩៰-៹᧠-᧿"
		},
		{
			name: "Khojki",
			astral: "\ud804[\ude00-\ude11\ude13-\ude3e]"
		},
		{
			name: "Khudawadi",
			astral: "\ud804[\udeb0-\udeea\udef0-\udef9]"
		},
		{
			name: "Lao",
			bmp: "ກຂຄຆ-ຊຌ-ຣລວ-ຽເ-ໄໆ່-ໍ໐-໙ໜ-ໟ"
		},
		{
			name: "Latin",
			bmp: "A-Za-zªºÀ-ÖØ-öø-ʸˠ-ˤᴀ-ᴥᴬ-ᵜᵢ-ᵥᵫ-ᵷᵹ-ᶾḀ-ỿⁱⁿₐ-ₜKÅℲⅎⅠ-ↈⱠ-ⱿꜢ-ꞇꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꟿꬰ-ꭚꭜ-ꭤꭦ-ꭩﬀ-ﬆＡ-Ｚａ-ｚ",
			astral: "\ud801[\udf80-\udf85\udf87-\udfb0\udfb2-\udfba]|\ud837[\udf00-\udf1e]"
		},
		{
			name: "Lepcha",
			bmp: "ᰀ-᰷᰻-᱉ᱍ-ᱏ"
		},
		{
			name: "Limbu",
			bmp: "ᤀ-ᤞᤠ-ᤫᤰ-᤻᥀᥄-᥏"
		},
		{
			name: "Linear_A",
			astral: "\ud801[\ude00-\udf36\udf40-\udf55\udf60-\udf67]"
		},
		{
			name: "Linear_B",
			astral: "\ud800[\udc00-\udc0b\udc0d-\udc26\udc28-\udc3a\udc3c\udc3d\udc3f-\udc4d\udc50-\udc5d\udc80-\udcfa]"
		},
		{
			name: "Lisu",
			bmp: "ꓐ-꓿",
			astral: "𑾰"
		},
		{
			name: "Lycian",
			astral: "\ud800[\ude80-\ude9c]"
		},
		{
			name: "Lydian",
			astral: "\ud802[\udd20-\udd39\udd3f]"
		},
		{
			name: "Mahajani",
			astral: "\ud804[\udd50-\udd76]"
		},
		{
			name: "Makasar",
			astral: "\ud807[\udee0-\udef8]"
		},
		{
			name: "Malayalam",
			bmp: "ഀ-ഌഎ-ഐഒ-ൄെ-ൈൊ-൏ൔ-ൣ൦-ൿ"
		},
		{
			name: "Mandaic",
			bmp: "ࡀ-࡛࡞"
		},
		{
			name: "Manichaean",
			astral: "\ud802[\udec0-\udee6\udeeb-\udef6]"
		},
		{
			name: "Marchen",
			astral: "\ud807[\udc70-\udc8f\udc92-\udca7\udca9-\udcb6]"
		},
		{
			name: "Masaram_Gondi",
			astral: "\ud807[\udd00-\udd06\udd08\udd09\udd0b-\udd36\udd3a\udd3c\udd3d\udd3f-\udd47\udd50-\udd59]"
		},
		{
			name: "Medefaidrin",
			astral: "\ud81b[\ude40-\ude9a]"
		},
		{
			name: "Meetei_Mayek",
			bmp: "ꫠ-꫶ꯀ-꯭꯰-꯹"
		},
		{
			name: "Mende_Kikakui",
			astral: "\ud83a[\udc00-\udcc4\udcc7-\udcd6]"
		},
		{
			name: "Meroitic_Cursive",
			astral: "\ud802[\udda0-\uddb7\uddbc-\uddcf\uddd2-\uddff]"
		},
		{
			name: "Meroitic_Hieroglyphs",
			astral: "\ud802[\udd80-\udd9f]"
		},
		{
			name: "Miao",
			astral: "\ud81b[\udf00-\udf4a\udf4f-\udf87\udf8f-\udf9f]"
		},
		{
			name: "Modi",
			astral: "\ud805[\ude00-\ude44\ude50-\ude59]"
		},
		{
			name: "Mongolian",
			bmp: "᠀᠁᠄᠆-᠙ᠠ-ᡸᢀ-ᢪ",
			astral: "\ud805[\ude60-\ude6c]"
		},
		{
			name: "Mro",
			astral: "\ud81a[\ude40-\ude5e\ude60-\ude69\ude6e\ude6f]"
		},
		{
			name: "Multani",
			astral: "\ud804[\ude80-\ude86\ude88\ude8a-\ude8d\ude8f-\ude9d\ude9f-\udea9]"
		},
		{
			name: "Myanmar",
			bmp: "က-႟ꧠ-ꧾꩠ-ꩿ"
		},
		{
			name: "Nabataean",
			astral: "\ud802[\udc80-\udc9e\udca7-\udcaf]"
		},
		{
			name: "Nandinagari",
			astral: "\ud806[\udda0-\udda7\uddaa-\uddd7\uddda-\udde4]"
		},
		{
			name: "New_Tai_Lue",
			bmp: "ᦀ-ᦫᦰ-ᧉ᧐-᧚᧞᧟"
		},
		{
			name: "Newa",
			astral: "\ud805[\udc00-\udc5b\udc5d-\udc61]"
		},
		{
			name: "Nko",
			bmp: "߀-ߺ߽-߿"
		},
		{
			name: "Nushu",
			astral: "𖿡|\ud82c[\udd70-\udefb]"
		},
		{
			name: "Nyiakeng_Puachue_Hmong",
			astral: "\ud838[\udd00-\udd2c\udd30-\udd3d\udd40-\udd49\udd4e\udd4f]"
		},
		{
			name: "Ogham",
			bmp: " -᚜"
		},
		{
			name: "Ol_Chiki",
			bmp: "᱐-᱿"
		},
		{
			name: "Old_Hungarian",
			astral: "\ud803[\udc80-\udcb2\udcc0-\udcf2\udcfa-\udcff]"
		},
		{
			name: "Old_Italic",
			astral: "\ud800[\udf00-\udf23\udf2d-\udf2f]"
		},
		{
			name: "Old_North_Arabian",
			astral: "\ud802[\ude80-\ude9f]"
		},
		{
			name: "Old_Permic",
			astral: "\ud800[\udf50-\udf7a]"
		},
		{
			name: "Old_Persian",
			astral: "\ud800[\udfa0-\udfc3\udfc8-\udfd5]"
		},
		{
			name: "Old_Sogdian",
			astral: "\ud803[\udf00-\udf27]"
		},
		{
			name: "Old_South_Arabian",
			astral: "\ud802[\ude60-\ude7f]"
		},
		{
			name: "Old_Turkic",
			astral: "\ud803[\udc00-\udc48]"
		},
		{
			name: "Old_Uyghur",
			astral: "\ud803[\udf70-\udf89]"
		},
		{
			name: "Oriya",
			bmp: "ଁ-ଃଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହ଼-ୄେୈୋ-୍୕-ୗଡ଼ଢ଼ୟ-ୣ୦-୷"
		},
		{
			name: "Osage",
			astral: "\ud801[\udcb0-\udcd3\udcd8-\udcfb]"
		},
		{
			name: "Osmanya",
			astral: "\ud801[\udc80-\udc9d\udca0-\udca9]"
		},
		{
			name: "Pahawh_Hmong",
			astral: "\ud81a[\udf00-\udf45\udf50-\udf59\udf5b-\udf61\udf63-\udf77\udf7d-\udf8f]"
		},
		{
			name: "Palmyrene",
			astral: "\ud802[\udc60-\udc7f]"
		},
		{
			name: "Pau_Cin_Hau",
			astral: "\ud806[\udec0-\udef8]"
		},
		{
			name: "Phags_Pa",
			bmp: "ꡀ-꡷"
		},
		{
			name: "Phoenician",
			astral: "\ud802[\udd00-\udd1b\udd1f]"
		},
		{
			name: "Psalter_Pahlavi",
			astral: "\ud802[\udf80-\udf91\udf99-\udf9c\udfa9-\udfaf]"
		},
		{
			name: "Rejang",
			bmp: "ꤰ-꥓꥟"
		},
		{
			name: "Runic",
			bmp: "ᚠ-ᛪᛮ-ᛸ"
		},
		{
			name: "Samaritan",
			bmp: "ࠀ-࠭࠰-࠾"
		},
		{
			name: "Saurashtra",
			bmp: "ꢀ-ꣅ꣎-꣙"
		},
		{
			name: "Sharada",
			astral: "\ud804[\udd80-\udddf]"
		},
		{
			name: "Shavian",
			astral: "\ud801[\udc50-\udc7f]"
		},
		{
			name: "Siddham",
			astral: "\ud805[\udd80-\uddb5\uddb8-\udddd]"
		},
		{
			name: "SignWriting",
			astral: "\ud836[\udc00-\ude8b\ude9b-\ude9f\udea1-\udeaf]"
		},
		{
			name: "Sinhala",
			bmp: "ඁ-ඃඅ-ඖක-නඳ-රලව-ෆ්ා-ුූෘ-ෟ෦-෯ෲ-෴",
			astral: "\ud804[\udde1-\uddf4]"
		},
		{
			name: "Sogdian",
			astral: "\ud803[\udf30-\udf59]"
		},
		{
			name: "Sora_Sompeng",
			astral: "\ud804[\udcd0-\udce8\udcf0-\udcf9]"
		},
		{
			name: "Soyombo",
			astral: "\ud806[\ude50-\udea2]"
		},
		{
			name: "Sundanese",
			bmp: "ᮀ-ᮿ᳀-᳇"
		},
		{
			name: "Syloti_Nagri",
			bmp: "ꠀ-꠬"
		},
		{
			name: "Syriac",
			bmp: "܀-܍܏-݊ݍ-ݏࡠ-ࡪ"
		},
		{
			name: "Tagalog",
			bmp: "ᜀ-᜕ᜟ"
		},
		{
			name: "Tagbanwa",
			bmp: "ᝠ-ᝬᝮ-ᝰᝲᝳ"
		},
		{
			name: "Tai_Le",
			bmp: "ᥐ-ᥭᥰ-ᥴ"
		},
		{
			name: "Tai_Tham",
			bmp: "ᨠ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪠-᪭"
		},
		{
			name: "Tai_Viet",
			bmp: "ꪀ-ꫂꫛ-꫟"
		},
		{
			name: "Takri",
			astral: "\ud805[\ude80-\udeb9\udec0-\udec9]"
		},
		{
			name: "Tamil",
			bmp: "ஂஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹா-ூெ-ைொ-்ௐௗ௦-௺",
			astral: "\ud807[\udfc0-\udff1\udfff]"
		},
		{
			name: "Tangsa",
			astral: "\ud81a[\ude70-\udebe\udec0-\udec9]"
		},
		{
			name: "Tangut",
			astral: "𖿠|[\ud81c-\ud820][\udc00-\udfff]|\ud821[\udc00-\udff7]|\ud822[\udc00-\udeff]|\ud823[\udd00-\udd08]"
		},
		{
			name: "Telugu",
			bmp: "ఀ-ఌఎ-ఐఒ-నప-హ఼-ౄె-ైొ-్ౕౖౘ-ౚౝౠ-ౣ౦-౯౷-౿"
		},
		{
			name: "Thaana",
			bmp: "ހ-ޱ"
		},
		{
			name: "Thai",
			bmp: "ก-ฺเ-๛"
		},
		{
			name: "Tibetan",
			bmp: "ༀ-ཇཉ-ཬཱ-ྗྙ-ྼ྾-࿌࿎-࿔࿙࿚"
		},
		{
			name: "Tifinagh",
			bmp: "ⴰ-ⵧⵯ⵰⵿"
		},
		{
			name: "Tirhuta",
			astral: "\ud805[\udc80-\udcc7\udcd0-\udcd9]"
		},
		{
			name: "Toto",
			astral: "\ud838[\ude90-\udeae]"
		},
		{
			name: "Ugaritic",
			astral: "\ud800[\udf80-\udf9d\udf9f]"
		},
		{
			name: "Vai",
			bmp: "ꔀ-ꘫ"
		},
		{
			name: "Vithkuqi",
			astral: "\ud801[\udd70-\udd7a\udd7c-\udd8a\udd8c-\udd92\udd94\udd95\udd97-\udda1\udda3-\uddb1\uddb3-\uddb9\uddbb\uddbc]"
		},
		{
			name: "Wancho",
			astral: "\ud838[\udec0-\udef9\udeff]"
		},
		{
			name: "Warang_Citi",
			astral: "\ud806[\udca0-\udcf2\udcff]"
		},
		{
			name: "Yezidi",
			astral: "\ud803[\ude80-\udea9\udeab-\udead\udeb0\udeb1]"
		},
		{
			name: "Yi",
			bmp: "ꀀ-ꒌ꒐-꓆"
		},
		{
			name: "Zanabazar_Square",
			astral: "\ud806[\ude00-\ude47]"
		}
	];
})), ts = /* @__PURE__ */ O(((e, t) => {
	var n = Vn(), r = Hn();
	n(e, "__esModule", { value: !0 }), e.default = void 0;
	var i = r(es());
	e.default = function(e) {
		if (!e.addUnicodeData) throw ReferenceError("Unicode Base must be loaded before Unicode Scripts");
		e.addUnicodeData(i.default, "Script");
	}, t.exports = e.default;
})), ns = /* @__PURE__ */ A((/* @__PURE__ */ O(((e, t) => {
	var n = Vn(), r = Hn();
	n(e, "__esModule", { value: !0 }), e.default = void 0;
	var i = r(No()), a = r(qo()), o = r(Jo()), s = r(Yo()), c = r(Zo()), l = r($o()), u = r(ts());
	(0, a.default)(i.default), (0, o.default)(i.default), (0, s.default)(i.default), (0, c.default)(i.default), (0, l.default)(i.default), (0, u.default)(i.default), e.default = i.default, t.exports = e.default;
})))(), 1), rs = (0, ns.default)(/@\[(\d+)\]\(([^)]+)\)+/i), is = (0, ns.default)(/@\[(urn:li:(organization|person):[A-Za-z0-9\_\-]+)\]\(([^)]+)\)+/i), as = (0, ns.default)(/(?:@)([A-Za-z0-9_](?:(?:[A-Za-z0-9_]|(?:\.(?!\.))){0,28}(?:[A-Za-z0-9_]))?)/i), os = (0, ns.default)(/(?:@)([A-Za-z0-9_](?:[A-Za-z0-9_.]{0,28}(?:[A-Za-z0-9_]))?)/i), ss = (0, ns.default)(/(#+[a-zA-Z0-9(_)]{1,})/i);
//#endregion
//#region lib/components/SkedCaptionPreview/hashtag-matcher/HashtagTag.tsx
function cs({ host: e, tag: t, label: n }) {
	return /* @__PURE__ */ _("a", {
		className: "sked-mention sked-mention-link",
		target: "_blank",
		rel: "noreferrer",
		href: `${e}${t}`,
		children: n
	});
}
//#endregion
//#region lib/components/SkedCaptionPreview/hashtag-matcher/HashtagTagWrongPlatform.tsx
function ls({ label: e }) {
	return /* @__PURE__ */ _("span", { children: e }, `unknown-${e}`);
}
//#endregion
//#region lib/components/SkedCaptionPreview/hashtag-matcher/HashtagMatcher.ts
var us = class extends gt {
	constructor(t, n) {
		super(t), e(this, "targetPlatform", void 0), this.targetPlatform = n;
	}
	match(e) {
		let t = e.match(ss);
		return !t || t.index === void 0 ? null : {
			index: t.index,
			length: t[0].length,
			match: t[0],
			urn: t[0],
			label: t[0],
			valid: !0
		};
	}
	replaceWith(e, t) {
		let { label: n } = t, r = n.replace("#", ""), a;
		switch (this.targetPlatform) {
			case "IG":
				a = "https://www.instagram.com/explore/tags/";
				break;
			case "TW":
				a = "https://twitter.com/hashtag/";
				break;
			case "TH":
				a = "https://threads.net/search?q=", n = n.replace("#", "");
				break;
			case "LI":
				a = "https://www.linkedin.com/feed/hashtag/";
				break;
			case "TT":
				a = "https://www.tiktok.com/tag/";
				break;
			case "FB":
				a = "https://www.facebook.com/hashtag/";
				break;
			default: a = null;
		}
		return a ? i.createElement(cs, {
			key: t.key,
			tag: r,
			host: a,
			label: n
		}, e) : i.createElement(ls, {
			key: t.key,
			label: n
		}, e);
	}
	asTag() {
		return "a";
	}
};
//#endregion
//#region lib/components/SkedCaptionPreview/insta-tw-tt-matcher/InstaTwitterTag.tsx
function ds({ host: e, username: t, label: n }) {
	return /* @__PURE__ */ _("a", {
		className: "sked-mention sked-mention-link",
		target: "_blank",
		rel: "noreferrer",
		href: `${e}/${t}`,
		children: n
	}, n);
}
//#endregion
//#region lib/components/SkedCaptionPreview/insta-tw-tt-matcher/InstagramTwitterTikTokMatcher.ts
var fs = class extends gt {
	constructor(t, n) {
		if (super(t), e(this, "targetPlatform", void 0), e(this, "platformHosts", void 0), this.targetPlatform = n, this.platformHosts = {
			IG: "https://instagram.com",
			TW: "https://twitter.com",
			TH: "https://threads.net",
			TT: "https://tiktok.com",
			PI: "https://pinterest.com"
		}, !this.platformHosts[n]) throw Error(`Unsupported "targetPlatform": ${n}`);
	}
	match(e) {
		let t = this.targetPlatform === "TT" ? os : as, n = e.match(t);
		if (!n || n.index === void 0) return null;
		let r = this.targetPlatform === "IG" ? n[0].replace("@", "") : n[0];
		return {
			index: n.index,
			length: n[0].length,
			match: n[0],
			urn: r,
			label: n[0],
			valid: !0
		};
	}
	replaceWith(e, t) {
		let { label: n } = t;
		if (!n) throw Error("Username is required.");
		let r = this.platformHosts[this.targetPlatform], a = this.targetPlatform === "IG" ? n.replace(/^@/, "") : n;
		return i.createElement(ds, {
			...t,
			key: t.key,
			host: r,
			username: a
		}, e);
	}
	asTag() {
		return "a";
	}
};
//#endregion
//#region lib/components/SkedCaptionPreview/linkedin-matcher/LinkedInTag.tsx
function ps({ urn: e, label: t, orgId: n, trackEvent: r }) {
	return /* @__PURE__ */ _("span", {
		className: "sked-mention sked-mention-linkedin",
		title: `LinkedIn organization: ${e}`,
		onClick: () => {
			r && r("link-preview-clicked"), window.open(`https://www.linkedin.com/company/${n}`, "_blank");
		},
		children: t
	}, e);
}
//#endregion
//#region lib/components/SkedCaptionPreview/linkedin-matcher/LinkedInUnknownPlatformTag.tsx
function ms({ label: e, urn: t }) {
	return /* @__PURE__ */ _("span", {
		className: "sked-mention sked-mention-linkedin",
		title: `Person mention for ${e}. Sked currently can't link you directly to the person's profile.`,
		children: e
	}, `unknown-${t}${e}`);
}
//#endregion
//#region lib/components/SkedCaptionPreview/linkedin-matcher/LinkedInMentionMatcher.ts
var hs = class extends gt {
	constructor(t, n, r) {
		super(t), e(this, "targetPlatform", void 0), e(this, "trackEvent", void 0), this.targetPlatform = n, this.trackEvent = r;
	}
	match(e) {
		let t = e.match(is);
		return !t || t.index === void 0 ? null : {
			index: t.index,
			length: t[0].length,
			match: t[0],
			urn: t[1],
			label: t[3],
			valid: !0
		};
	}
	replaceWith(e, t) {
		let { urn: n, label: r } = t;
		if (this.targetPlatform === "LI" && n.includes("organization")) {
			let a = n.split(":").pop();
			return i.createElement(ps, {
				key: t.key,
				urn: n,
				label: r,
				orgId: a,
				trackEvent: this.trackEvent
			}, e);
		}
		return i.createElement(ms, {
			key: t.key,
			urn: n,
			label: r,
			trackEvent: this.trackEvent
		}, e);
	}
	asTag() {
		return "span";
	}
};
//#endregion
//#region lib/components/SkedCaptionPreview/facebook-matcher/FacebookTag.tsx
function gs({ id: e, label: t }) {
	return /* @__PURE__ */ _("a", {
		className: "sked-mention sked-mention-link sked-mention-facebook",
		target: "_blank",
		rel: "noreferrer",
		href: `https://www.facebook.com/${e}`,
		children: t
	}, t);
}
//#endregion
//#region lib/components/SkedCaptionPreview/facebook-matcher/FacebookMentionMatcher.ts
var _s = class extends gt {
	constructor(t, n) {
		super(t), e(this, "targetPlatform", void 0), this.targetPlatform = n;
	}
	match(e) {
		let t = e.match(rs);
		return !t || t.index === void 0 ? null : {
			index: t.index,
			length: t[0].length,
			match: t[0],
			id: t[1],
			label: t[2],
			valid: !0
		};
	}
	replaceWith(e, t) {
		return this.targetPlatform, i.createElement(gs, {
			...t,
			key: t.key
		}, e);
	}
	asTag() {
		return "a";
	}
};
//#endregion
//#region lib/components/SkedCaptionPreview/getMatchers.ts
function vs(e, t) {
	e === void 0 && (e = "");
	let n = [new qt("url"), new us("hashtag", e)];
	switch (e) {
		case "IG":
		case "TW":
		case "TT":
		case "TH":
		case "PI": return [new fs("socialLink", e), ...n];
		default: return [
			new _s("fb", e),
			new hs("li", e, t),
			...n
		];
	}
}
//#endregion
//#region lib/components/SkedCaptionPreview/RenderSkedCaption.tsx
function Y({ caption: e, targetPlatform: t, trackEvent: n }) {
	let r = e, i = vs(t, n);
	return /* @__PURE__ */ _(kt, {
		content: r,
		matchers: i,
		newWindow: !0
	});
}
//#endregion
//#region lib/components/SkedCaptionPreview/SkedCaptionPreview.tsx
function ys({ caption: e, targetPlatform: t }) {
	return /* @__PURE__ */ _(bs, { children: /* @__PURE__ */ _(Y, {
		caption: e,
		targetPlatform: t
	}) });
}
var bs = N.div`
  .sked-mention {
    color: hsl(214, 89%, 52%);

    &:hover {
      text-decoration: underline;
    }
  }
`, xs = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i, Ss = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i, Cs = /\.(m3u8)($|\?)/i, ws = /\.(mpd)($|\?)/i, Ts = /stream\.mux\.com\/(?!\w+\.m3u8)(\w+)/, Es = /(?:youtu\.be\/|youtube(?:-nocookie|education)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//, Ds = /vimeo\.com\/(?!progressive_redirect).+/, Os = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?([^?]+)/, ks = /open\.spotify\.com\/(\w+)\/(\w+)/i, As = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+|(videos?\/|\?video=)\d+)($|\?)/, js = /tiktok\.com\/(?:player\/v1\/|share\/video\/|@[^/]+\/video\/)([0-9]+)/, Ms = (e, t) => {
	if (Array.isArray(e)) {
		for (let n of e) if (typeof n == "string" && Ms(n, t) || Ms(n.src, t)) return !0;
		return !1;
	}
	return t(e);
}, Ns = {
	html: (e) => Ms(e, (e) => xs.test(e) || Ss.test(e)),
	hls: (e) => Ms(e, (e) => Cs.test(e)),
	dash: (e) => Ms(e, (e) => ws.test(e)),
	mux: (e) => Ts.test(e),
	youtube: (e) => Es.test(e),
	vimeo: (e) => Ds.test(e) && !Ss.test(e) && !Cs.test(e),
	wistia: (e) => Os.test(e),
	spotify: (e) => ks.test(e),
	twitch: (e) => As.test(e),
	tiktok: (e) => js.test(e)
}, Ps = i.forwardRef((e, t) => {
	let n = xs.test(`${e.src}`) ? "audio" : "video";
	return /* @__PURE__ */ i.createElement(n, {
		...e,
		ref: t
	}, e.children);
}), Fs = [
	{
		key: "hls",
		name: "hls.js",
		canPlay: Ns.hls,
		canEnablePIP: () => !0,
		player: c(() => import(
			/* webpackChunkName: 'reactPlayerHls' */
			"./react-jA3ER_dz.js"
))
	},
	{
		key: "dash",
		name: "dash.js",
		canPlay: Ns.dash,
		canEnablePIP: () => !0,
		player: c(() => import(
			/* webpackChunkName: 'reactPlayerDash' */
			"./react-DSOtAdMk.js"
))
	},
	{
		key: "mux",
		name: "Mux",
		canPlay: Ns.mux,
		canEnablePIP: () => !0,
		player: c(() => import(
			/* webpackChunkName: 'reactPlayerMux' */
			"./dist-Brxb-Ufj.js"
))
	},
	{
		key: "youtube",
		name: "YouTube",
		canPlay: Ns.youtube,
		player: c(() => import(
			/* webpackChunkName: 'reactPlayerYouTube' */
			"./react-bmwCPrlA.js"
))
	},
	{
		key: "vimeo",
		name: "Vimeo",
		canPlay: Ns.vimeo,
		player: c(() => import(
			/* webpackChunkName: 'reactPlayerVimeo' */
			"./react-Xw2Pa0ke.js"
))
	},
	{
		key: "wistia",
		name: "Wistia",
		canPlay: Ns.wistia,
		canEnablePIP: () => !0,
		player: c(() => import(
			/* webpackChunkName: 'reactPlayerWistia' */
			"./react-DfVEkBFx.js"
))
	},
	{
		key: "spotify",
		name: "Spotify",
		canPlay: Ns.spotify,
		canEnablePIP: () => !1,
		player: c(() => import(
			/* webpackChunkName: 'reactPlayerSpotify' */
			"./react-jrZDXH8y.js"
))
	},
	{
		key: "twitch",
		name: "Twitch",
		canPlay: Ns.twitch,
		canEnablePIP: () => !1,
		player: c(() => import(
			/* webpackChunkName: 'reactPlayerTwitch' */
			"./react-CGUi8g7b.js"
))
	},
	{
		key: "tiktok",
		name: "TikTok",
		canPlay: Ns.tiktok,
		canEnablePIP: () => !1,
		player: c(() => import(
			/* webpackChunkName: 'reactPlayerTiktok' */
			"./react-DiCNVhRZ.js"
))
	},
	{
		key: "html",
		name: "html",
		canPlay: Ns.html,
		canEnablePIP: () => !0,
		player: Ps
	}
], Is = {
	width: "320px",
	height: "180px",
	volume: 1,
	playbackRate: 1,
	previewTabIndex: 0,
	previewAriaLabel: "",
	oEmbedUrl: "https://noembed.com/embed?url={url}"
}, Ls = i.forwardRef((e, t) => {
	let { playing: n, pip: r } = e, a = e.activePlayer, o = m(null), s = m(!0);
	d(() => {
		o.current && (o.current.paused && n === !0 && o.current.play(), !o.current.paused && n === !1 && o.current.pause(), o.current.playbackRate = e.playbackRate ?? 1, o.current.volume = e.volume ?? 1);
	}), d(() => {
		var e, t, n, i, a;
		if (!(!o.current || !globalThis.document)) {
			if (r && !document.pictureInPictureElement) try {
				(t = (e = o.current).requestPictureInPicture) == null || t.call(e);
			} catch {}
			if (!r && document.pictureInPictureElement) try {
				(i = (n = o.current).exitPictureInPicture) == null || i.call(n), (a = document.exitPictureInPicture) == null || a.call(document);
			} catch {}
		}
	}, [r]);
	let c = (t) => {
		var n, r;
		s.current = !0, (n = e.onReady) == null || n.call(e), (r = e.onLoadStart) == null || r.call(e, t);
	}, u = (t) => {
		var n, r;
		s.current && (s.current = !1, (n = e.onStart) == null || n.call(e, t)), (r = e.onPlay) == null || r.call(e, t);
	};
	if (!a) return null;
	let f = {}, p = ["onReady", "onStart"];
	for (let t in e) t.startsWith("on") && !p.includes(t) && (f[t] = e[t]);
	return /* @__PURE__ */ i.createElement(a, {
		...f,
		style: e.style,
		className: e.className,
		slot: e.slot,
		ref: l((e) => {
			o.current = e, typeof t == "function" ? t(e) : t !== null && (t.current = e);
		}, [t]),
		src: e.src,
		crossOrigin: e.crossOrigin,
		preload: e.preload,
		controls: e.controls,
		muted: e.muted,
		autoPlay: e.autoPlay,
		loop: e.loop,
		playsInline: e.playsInline,
		disableRemotePlayback: e.disableRemotePlayback,
		config: e.config,
		onLoadStart: c,
		onPlay: u
	}, e.children);
});
Ls.displayName = "Player";
var Rs = Ls, zs = c(() => import(
	/* webpackChunkName: 'reactPlayerPreview' */
	"./Preview-DKoZdlxG.js"
)), Bs = [], Vs = (e, t) => {
	let n = (n) => {
		for (let t of [...Bs, ...e]) if (n && t.canPlay(n)) return t;
		return t || null;
	}, r = i.forwardRef((e, t) => {
		let r = {
			...Is,
			...e
		}, { src: a, slot: s, className: c, style: l, width: u, height: f, fallback: p, wrapper: m } = r, [g, _] = h(!!r.light);
		d(() => {
			r.light ? _(!0) : _(!1);
		}, [r.light]);
		let v = (e) => {
			var t;
			_(!1), (t = r.onClickPreview) == null || t.call(r, e);
		}, y = (e) => {
			if (!e) return null;
			let { light: t, playIcon: n, previewTabIndex: a, oEmbedUrl: o, previewAriaLabel: s } = r;
			return /* @__PURE__ */ i.createElement(zs, {
				src: e,
				light: t,
				playIcon: n,
				previewTabIndex: a,
				previewAriaLabel: s,
				oEmbedUrl: o,
				onClickPreview: v
			});
		}, b = (e) => {
			let a = n(e);
			if (!a) return null;
			let { style: o, width: l, height: u, wrapper: d } = r, f = r.config?.[a.key];
			return /* @__PURE__ */ i.createElement(Rs, {
				...r,
				ref: t,
				activePlayer: a.player ?? a,
				slot: d ? void 0 : s,
				className: d ? void 0 : c,
				style: d ? {
					display: "block",
					width: "100%",
					height: "100%"
				} : {
					display: "block",
					width: l,
					height: u,
					...o
				},
				config: f
			});
		}, x = m ?? Hs, S = p === !1 ? Hs : o;
		return /* @__PURE__ */ i.createElement(x, {
			slot: s,
			className: c,
			style: {
				width: u,
				height: f,
				...l
			}
		}, /* @__PURE__ */ i.createElement(S, { fallback: p }, g ? y(a) : b(a)));
	});
	return r.displayName = "ReactPlayer", r.addCustomPlayer = (e) => {
		Bs.push(e);
	}, r.removeCustomPlayers = () => {
		Bs.length = 0;
	}, r.canPlay = (t) => {
		if (t) {
			for (let n of [...Bs, ...e]) if (n.canPlay(t)) return !0;
		}
		return !1;
	}, r.canEnablePIP = (t) => {
		if (t) {
			for (let n of [...Bs, ...e]) if (n.canPlay(t) && n.canEnablePIP?.call(n)) return !0;
		}
		return !1;
	}, r;
}, Hs = ({ children: e }) => e, Us = Fs[Fs.length - 1], Ws = Vs(Fs, Us), Gs = N.a`
  display: ${(e) => e.$isFlex ? "flex" : "inline-flex"};
  width: 100%;
  margin: auto;
`, Ks = s({ post: null }), qs = (e) => e || void 0, Js = ({ contextVideoCoverPreview: e, videoCoverPreviewOverride: t, fallbackToContext: n = !0 }) => {
	let r = qs(t), i = qs(e);
	return n ? r ?? i : r;
}, Ys = (e = {}) => {
	let [t, n] = h(!1), [r, i] = h(!1), [a, o] = h(0), { videoCoverPreview: s, post: c } = u(Ks), { usePostTypeCheck: l = !0, videoCoverPreviewOverride: f, fallbackToContext: p = !0 } = e, m = Js({
		contextVideoCoverPreview: s,
		videoCoverPreviewOverride: f,
		fallbackToContext: p
	});
	d(() => {
		m && (n(!1), i(!1), o((e) => e + 1));
	}, [m]);
	let g = l ? m !== void 0 && (c?.type === "reel" || c?.storyType === "reel") : m !== void 0;
	return {
		isPlaying: t,
		hasPlayed: r,
		vid: a,
		videoCoverPreview: m,
		showVideoCover: g,
		resetVideo: () => {
			n(!1), i(!1), o((e) => e + 1);
		},
		handlePlay: () => {
			n(!0), i(!0);
		},
		handlePause: () => {
			n(!1);
		},
		showResetButton: g && !t && r
	};
}, Xs = (e) => /* @__PURE__ */ _("svg", {
	width: 36,
	height: 34,
	viewBox: "0 0 36 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ _("path", {
		d: "M2.33301 13.6667C2.33301 13.6667 5.67464 9.1137 8.3894 6.39707C11.1042 3.68045 14.8557 2 18.9997 2C27.2839 2 33.9997 8.71573 33.9997 17C33.9997 25.2843 27.2839 32 18.9997 32C12.1612 32 6.39153 27.4238 4.58595 21.1667M2.33301 13.6667V3.66667M2.33301 13.6667H12.333",
		stroke: "white",
		strokeWidth: 3.33333,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
}), Zs = N.div`
  position: absolute;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  box-shadow:
    0px 4px 8px -2px rgba(16, 24, 40, 0.1),
    0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  left: 50%;
  margin-left: -28px;
  margin-top: -28px;
  cursor: pointer;
  z-index: 99;
`, Qs = N.div`
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100% !important;
  background-color: ${(e) => e.$backgroundColor || "transparent"};

  .react-player video {
    object-fit: ${(e) => e.$videoObjectFit || "contain"};
  }

  ${(e) => e.$showVideoCover && n`
      .react-player__preview {
        width: 100%;
        height: 100%;
        background-color: ${e.$backgroundColor || "transparent"} !important;
        background-size: ${e.$videoCoverObjectFit || "cover"} !important;
        background-position: center !important;
        background-repeat: no-repeat !important;
      }
    `}
`, $s = N.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background-color: ${(e) => e.$backgroundColor || "transparent"};
  object-fit: ${(e) => e.$objectFit || "cover"};
  z-index: 2;
  pointer-events: none;
`, ec = N.div`
  align-items: center;
  overflow: hidden;
  border-radius: 15px;
  max-height: 711px;
  width: 100%;
  height: 100%;
  background: ${(e) => e.$backgroundColor || "grey"};
  display: flex;
`, tc = ({ onClick: e }) => /* @__PURE__ */ _(Zs, {
	onClick: e,
	children: /* @__PURE__ */ _(Xs, {})
}), nc = N.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`, rc = N.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(e) => +!!e.$visible};
  transition: opacity 0.2s ease;
  pointer-events: none;
`, ic = () => /* @__PURE__ */ _("svg", {
	width: "24",
	height: "28",
	viewBox: "0 0 24 28",
	fill: "none",
	children: /* @__PURE__ */ _("path", {
		d: "M22 14L2 26V2L22 14Z",
		fill: "white"
	})
}), ac = () => /* @__PURE__ */ v("svg", {
	width: "20",
	height: "24",
	viewBox: "0 0 20 24",
	fill: "none",
	children: [/* @__PURE__ */ _("rect", {
		x: "1",
		y: "1",
		width: "6",
		height: "22",
		rx: "1",
		fill: "white"
	}), /* @__PURE__ */ _("rect", {
		x: "13",
		y: "1",
		width: "6",
		height: "22",
		rx: "1",
		fill: "white"
	})]
}), oc = ({ playing: e, onToggle: t }) => /* @__PURE__ */ _(nc, {
	onClick: t,
	children: /* @__PURE__ */ _(rc, {
		$visible: !e,
		children: _(e ? ac : ic, {})
	})
}), sc = ({ src: e, imageObjectFit: t, fillContainer: n = !1 }) => /* @__PURE__ */ _(uc, {
	$isFlex: !0,
	$fillContainer: n,
	href: e,
	children: /* @__PURE__ */ _(dc, {
		src: e,
		$imageObjectFit: t,
		$fillContainer: n
	})
}), cc = ({ url: e, thumbnailUrl: t, isActiveSlide: n = !0, videoRef: r, containerStyles: i, controls: a = !0, backgroundColor: o, videoCoverObjectFit: s, videoObjectFit: c }) => {
	let { vid: u, videoCoverPreview: d, showVideoCover: f, resetVideo: p, handlePlay: m, handlePause: g, showResetButton: y } = Ys({
		usePostTypeCheck: !0,
		videoCoverPreviewOverride: t,
		fallbackToContext: !t
	}), [b, x] = h(!1), S = !a, C = S && f && !b, w = l((e) => {
		e && (t ? e.setAttribute("poster", t) : e.removeAttribute("poster"));
	}, [t]), T = () => {
		x(!1), p();
	};
	if (!n) return null;
	let E = /* @__PURE__ */ v(Qs, {
		ref: r,
		style: i,
		$backgroundColor: o,
		$showVideoCover: f,
		$videoCoverObjectFit: s,
		$videoObjectFit: c,
		children: [
			y && /* @__PURE__ */ _(tc, { onClick: T }),
			C && d && /* @__PURE__ */ _($s, {
				$backgroundColor: o,
				$objectFit: s,
				src: d,
				alt: ""
			}),
			S && /* @__PURE__ */ _(oc, {
				playing: b,
				onToggle: () => x((e) => !e)
			}),
			/* @__PURE__ */ _(Ws, {
				ref: w,
				playing: S ? b : !!d,
				onPlay: m,
				onPause: g,
				light: !S && f ? d : void 0,
				controls: a,
				src: e,
				playsInline: !0,
				preload: "metadata",
				className: "sp-relative sp-w-full react-player",
				width: "100%",
				height: "100%",
				style: f ? {
					minHeight: "500px",
					background: o || "grey",
					position: "absolute",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0
				} : {
					display: "flex",
					position: "absolute",
					top: 0,
					left: 0
				}
			}, u)
		]
	});
	return f ? /* @__PURE__ */ _(ec, {
		$backgroundColor: o,
		children: E
	}) : E;
}, lc = ({ media: e, isActiveSlide: t = !0, videoRef: n, videoContainerStyles: r, controls: i, backgroundColor: a, videoCoverObjectFit: o, videoObjectFit: s, imageObjectFit: c, fillContainer: l = !1 }) => e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ _(cc, {
	videoRef: n,
	url: e.url,
	thumbnailUrl: e.thumbnailUrl,
	isActiveSlide: t,
	containerStyles: r,
	controls: i,
	backgroundColor: a,
	videoCoverObjectFit: o,
	videoObjectFit: s
}) : /* @__PURE__ */ _(sc, {
	src: e.url,
	imageObjectFit: c,
	fillContainer: l
}), uc = N(Gs)`
  height: ${(e) => e.$fillContainer ? "100%" : "auto"};
  align-items: center;
  justify-content: center;
`, dc = N.img`
  display: block;
  object-fit: ${(e) => e.$imageObjectFit || "cover"};
  position: relative;
  width: 100%;
  height: ${(e) => e.$fillContainer ? "100%" : "auto"};
`, fc = (e) => /* @__PURE__ */ _("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...e,
	children: /* @__PURE__ */ _("path", { d: "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z" })
}), pc = (e) => /* @__PURE__ */ _("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...e,
	children: /* @__PURE__ */ _("path", { d: "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z" })
}), mc = ({ direction: e, onClick: t }) => /* @__PURE__ */ _(hc, {
	direction: e,
	role: "button",
	"aria-label": e === "left" ? "Previous slide" : "Next slide",
	onClick: t,
	children: _(e === "left" ? fc : pc, { className: "sp-w-full sp-h-full sp-shadow-around sp-rounded-full sp-bg-grey sp-cursor-pointer" })
}), hc = N.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  ${(e) => e.direction === "left" ? "left: 10px;" : "right: 10px;"};
  fill: white;
  opacity: 0.8;
  width: 34px;
  height: 34px;
  z-index: 1000;
  border-radius: 9000px;
  background-color: rgba(84, 84, 84, 0.5);
  cursor: pointer;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0.2);

  &:hover,
  &:active {
    opacity: 1;
  }

  @media (min-width: 768px) {
    width: 30px;
    height: 30px;
  }
`, gc = ({ media: e, slideNo: t, isActiveSlide: n }) => {
	let r = {
		order: t,
		flex: "1 0 100%"
	}, i = e.isVideo || e.url?.includes(".mp4");
	return /* @__PURE__ */ _("div", {
		style: r,
		children: i ? /* @__PURE__ */ _("div", {
			className: "sp-relative sp-w-full sp-aspect-[2/3] sp-bg-[#f2f2f2] [@supports_not_(aspect-ratio:1/1)]:sp-h-0 [@supports_not_(aspect-ratio:1/1)]:sp-pb-[150%]",
			children: /* @__PURE__ */ _("div", {
				className: "sp-absolute sp-inset-0",
				children: /* @__PURE__ */ _(lc, {
					media: e,
					isActiveSlide: n,
					videoObjectFit: "cover"
				})
			})
		}) : /* @__PURE__ */ _(lc, {
			media: e,
			isActiveSlide: n,
			videoObjectFit: "cover"
		})
	});
}, _c = ({ medias: e, currentSlide: t }) => e.map((e, n) => /* @__PURE__ */ _(gc, {
	media: e,
	slideNo: n + 1,
	isActiveSlide: t === n + 1
}, n)), vc = ({ current: e }) => /* @__PURE__ */ _("div", { className: `${e ? "sp-bg-blue-600" : "sp-bg-gray-500"}
    sp-rounded-full
    sp-w-8px
    sp-h-8px
    sp-mx-1
    sp-transition-all
    sp-transition-duration-200
    ease-in-out` }), yc = ({ count: e, current: t }) => /* @__PURE__ */ _("div", {
	className: "sp-flex sp-items-center sp-justify-center sp-z-50 sp-py-4",
	style: {
		marginBottom: "-42px",
		height: "42px"
	},
	children: [...Array(e)].map((e, n) => /* @__PURE__ */ _(vc, { current: n + 1 === t }, n))
}), bc = ({ medias: e, count: t, getIsFirstSlide: n }) => {
	let [r, i] = h(1);
	d(() => {
		r > e.length && i(e.length);
	}, [e.length]);
	let a = {
		left: "100%",
		transform: `translateX(${r * -100}%)`
	};
	return d(() => {
		n && n(r === 1);
	}, [r]), /* @__PURE__ */ v("div", {
		className: "sp-relative",
		children: [/* @__PURE__ */ v("div", {
			className: "sp-flex sp-flex-col sp-relative sp-overflow-hidden",
			children: [
				r !== 1 && /* @__PURE__ */ _(mc, {
					direction: "left",
					onClick: () => i(r - 1)
				}),
				/* @__PURE__ */ _("div", {
					className: "sp-flex sp-relative sp-items-center",
					style: a,
					children: /* @__PURE__ */ _(_c, {
						medias: e,
						currentSlide: r
					})
				}),
				r !== e.length && /* @__PURE__ */ _(mc, {
					direction: "right",
					onClick: () => i(r + 1)
				})
			]
		}), /* @__PURE__ */ _(yc, {
			count: t,
			current: r
		})]
	});
}, xc = () => /* @__PURE__ */ v("div", {
	className: "sp-flex sp-w-full sp-justify-center sp-p-4 sp-text-gray-800",
	children: [/* @__PURE__ */ v("div", {
		className: "sp-flex sp-flex-grow sp-items-center",
		children: [
			/* @__PURE__ */ _(Sc, {
				icon: "icon-instagram-heart",
				className: "sp-mr-6"
			}),
			/* @__PURE__ */ _(Sc, {
				icon: "icon-instagram-comment",
				className: "sp-mr-6"
			}),
			/* @__PURE__ */ _(Sc, {
				icon: "icon-instagram-share",
				className: "sp-mr-6"
			})
		]
	}), /* @__PURE__ */ _(Sc, { icon: "icon-instagram-bookmark" })]
}), Sc = ({ icon: e, className: t }) => /* @__PURE__ */ _("div", {
	className: `sp-flex sp-items-center sp-justify-center ${t}`,
	children: /* @__PURE__ */ _("div", { className: `sp-text-2xl sp-font-normal ${e}` })
}), Cc = N.button`
  border: none;
  display: flex;
  align-items: center;
  background: #504e4c;
  border-radius: 4px;
  padding: 9px 7px;
  cursor: pointer;
  position: absolute;
  z-index: 2;
  top: 8px;
  left: 8px;
  min-width: 100px;
  justify-content: center;

  svg {
    margin-right: 6px;
    width: 16px;
    height: 16px;
  }

  p {
    margin: 0;
    font-weight: 500;
    color: white;
    font-size: 12px;
  }
`, wc = N.div`
  position: absolute;
  z-index: 2;
  top: ${(e) => e.top && e.top}%;
  left: ${(e) => e.left && e.left}%;
  font-family: Helvetica Neue;
  background: #504e4c;
  color: white;
  font-weight: 500;
  font-size: 14px;
  padding: 9px 13px;
  border-radius: 4px;

  &::before {
    content: "";
    display: block;
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    top: 0;
    left: 5px;
    margin-top: -5px;
    border-width: 0 5px 5px;
    border-bottom-color: #504e4c;
  }

  .sked-mention.sked-mention-link {
    color: white;
  }
`, Tc = ({ medias: e, storyType: t, productTags: n, userTags: r }) => {
	let i = e.collection, a = i.length, o = a > 1, [s, c] = h(!0), l = n && n.length > 0 ? "productTags" : void 0;
	r && r.length > 0 && (l = "userTags");
	let u = l === "productTags" ? n : r, [d, f] = h(!1);
	return /* @__PURE__ */ v("div", { children: [/* @__PURE__ */ v("div", {
		className: "sp-relative",
		children: [
			t && t === "reel" && /* @__PURE__ */ v("div", {
				className: "sp-absolute sp-bottom-0 sp-left-0 sp-bg-black sp-px-8 sp-py-6 sp-m-12 sp-z-50 sp-flex sp-flex-row sp-items-center sp-rounded-lg sp-bg-opacity-50",
				children: [/* @__PURE__ */ _("div", {
					className: "sp-h-10 sp-w-10 sp-pr-2",
					children: /* @__PURE__ */ _(nt, {})
				}), /* @__PURE__ */ v(P, {
					$variant: "caption",
					className: "sp-text-2xl sp-text-white",
					children: [" ", "\xA0Reel"]
				})]
			}),
			t && t === "igtv" && /* @__PURE__ */ v("div", {
				className: "sp-absolute sp-bottom-0 sp-left-0 sp-bg-black sp-px-8 sp-py-6 sp-m-12 sp-z-50 sp-flex sp-flex-row sp-items-center sp-rounded-lg sp-bg-opacity-50",
				children: [/* @__PURE__ */ _("div", {
					className: "sp-h-10 sp-w-10 sp-pr-2",
					children: /* @__PURE__ */ _(tt, {})
				}), /* @__PURE__ */ v(P, {
					$variant: "caption",
					className: "sp-text-2xl sp-text-white",
					children: [" ", "\xA0IGTV"]
				})]
			}),
			s && u.length > 0 && /* @__PURE__ */ v(Cc, {
				onClick: () => f((e) => !e),
				children: [l === "productTags" && /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _(et, {}), /* @__PURE__ */ v("p", { children: [d ? "Hide" : "Show", " product tags"] })] }), l === "userTags" && /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _(rt, {}), /* @__PURE__ */ v("p", { children: [d ? "Hide" : "Show", " user tags"] })] })]
			}),
			u.length > 0 && d && /* @__PURE__ */ _("div", { children: u.map(({ top: e, left: t, value: n }) => /* @__PURE__ */ _(wc, {
				top: e,
				left: t,
				children: l === "userTags" ? /* @__PURE__ */ _(Y, {
					caption: `@${n}`,
					targetPlatform: "IG"
				}) : n
			}, n)) }),
			/* @__PURE__ */ _("div", {
				onClick: () => f(!1),
				children: o ? /* @__PURE__ */ _(bc, {
					medias: i,
					count: a,
					getIsFirstSlide: (e) => {
						c(e);
					}
				}) : /* @__PURE__ */ _(lc, { media: i[0] })
			})
		]
	}), /* @__PURE__ */ _("div", {
		className: "sp-flex sp-items-center sp-justify-between",
		children: /* @__PURE__ */ _(xc, {})
	})] });
}, Ec = ({ post: e }) => {
	let t = e.comment?.trim();
	return /* @__PURE__ */ v("div", {
		className: "sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0 sp-flex sp-flex-col",
		children: [
			/* @__PURE__ */ _(Ke, {
				collabs: e.collaboratingIgUsers,
				username: e.username,
				profilePicture: e.profilePicture,
				locationName: e.locationName
			}),
			/* @__PURE__ */ _(Tc, {
				medias: e.medias,
				storyType: e.storyType || null,
				productTags: e.providedPost.productTags || [],
				userTags: e.providedPost.tags || []
			}),
			/* @__PURE__ */ v("div", {
				className: "sp-flex sp-flex-col sp-px-4 sp-pb-8",
				children: [/* @__PURE__ */ v(P, {
					$variant: "caption",
					className: "sp-whitespace-pre-line sp-mb-2 sp-break-words",
					children: [/* @__PURE__ */ _("span", {
						className: "sp-font-bold sp-mr-1",
						children: e.username
					}), /* @__PURE__ */ _(Y, {
						caption: e.caption,
						targetPlatform: "IG"
					})]
				}), t && /* @__PURE__ */ v(P, {
					$variant: "caption",
					className: "sp-whitespace-pre-line sp-break-words",
					children: [/* @__PURE__ */ _("span", {
						className: "sp-font-bold sp-mr-1",
						children: e.username
					}), /* @__PURE__ */ _(Y, {
						caption: t,
						targetPlatform: "IG"
					})]
				})]
			})
		]
	});
}, Dc = (e) => /* @__PURE__ */ _("svg", {
	viewBox: "0 0 33 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ _("path", {
		d: "M13 0.463379L9 4.36582H3.23171C1.71834 4.36582 0.5 5.58417 0.5 7.09753L0.500002 27C0.500002 28.5134 1.71834 29.7317 3.23171 29.7317H29.7683C31.2817 29.7317 32.5 28.5134 32.5 27L32.5 7.09753C32.5 5.58417 31.2817 4.36582 29.7683 4.36582H24L20 0.463379H13ZM16.5 8.30487C21.0122 8.30487 24.6951 11.9878 24.6951 16.5C24.6951 21.0122 21.0122 24.6951 16.5 24.6951C11.9878 24.6951 8.30488 21.0122 8.30488 16.5C8.30488 11.9878 11.9879 8.30487 16.5 8.30487ZM16.5 10.6463C13.2533 10.6463 10.6463 13.2533 10.6463 16.5C10.6463 19.7467 13.2533 22.3537 16.5 22.3537C19.7468 22.3537 22.3537 19.7467 22.3537 16.5C22.3537 13.2533 19.7468 10.6463 16.5 10.6463Z",
		fill: "white"
	})
}), Oc = (e) => /* @__PURE__ */ _("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26 26",
	fill: "#1a9bfb",
	...e,
	children: /* @__PURE__ */ _("path", {
		d: "M 19.625 0.15625 C 17.996094 0.234375 16.429688 0.945313 15.21875 2.15625 L 10.46875 6.90625 C 11.214844 6.15625 13.984375 6.671875 14.65625 7.34375 L 17.53125 4.46875 C 18.167969 3.832031 18.964844 3.441406 19.78125 3.40625 C 20.335938 3.378906 21.121094 3.496094 21.8125 4.1875 C 22.457031 4.832031 22.59375 5.582031 22.59375 6.09375 C 22.59375 6.949219 22.203125 7.800781 21.53125 8.46875 L 16.53125 13.5 C 15.273438 14.757813 13.359375 14.859375 12.25 13.75 C 11.617188 13.117188 10.574219 13.113281 9.9375 13.75 C 9.300781 14.386719 9.300781 15.425781 9.9375 16.0625 C 11.078125 17.203125 12.578125 17.78125 14.125 17.78125 C 15.796875 17.78125 17.503906 17.097656 18.8125 15.78125 L 23.84375 10.78125 C 25.121094 9.507813 25.84375 7.804688 25.84375 6.09375 C 25.84375 4.503906 25.242188 2.992188 24.125 1.875 C 22.929688 0.679688 21.324219 0.078125 19.625 0.15625 Z M 11.875 8.21875 C 10.203125 8.21875 8.46875 8.90625 7.15625 10.21875 L 2.15625 15.21875 C 0.878906 16.492188 0.15625 18.195313 0.15625 19.90625 C 0.15625 21.496094 0.757813 23.007813 1.875 24.125 C 3.070313 25.320313 4.675781 25.921875 6.375 25.84375 C 8.003906 25.765625 9.570313 25.054688 10.78125 23.84375 L 15.53125 19.09375 C 14.78125 19.84375 12.015625 19.328125 11.34375 18.65625 L 8.46875 21.53125 C 7.832031 22.167969 7.035156 22.554688 6.21875 22.59375 C 5.664063 22.621094 4.878906 22.503906 4.1875 21.8125 C 3.542969 21.167969 3.40625 20.414063 3.40625 19.90625 C 3.40625 19.050781 3.796875 18.199219 4.46875 17.53125 L 9.46875 12.5 C 10.726563 11.242188 12.640625 11.144531 13.75 12.25 C 14.386719 12.886719 15.429688 12.886719 16.0625 12.25 C 16.699219 11.613281 16.699219 10.574219 16.0625 9.9375 C 14.921875 8.796875 13.417969 8.21875 11.875 8.21875 Z",
		fill: "#1a9bfb"
	})
}), kc = 6.5, Ac = 60, jc = (e) => `calc(${(e ?? .8) * 100 + kc}% - ${Ac}px)`, Mc = (e) => {
	try {
		let { hostname: t } = new URL(e);
		return t;
	} catch {
		return "Error";
	}
}, Nc = () => /* @__PURE__ */ _("div", {
	className: "sp-w-full sp-h-2 sp-overflow-hidden",
	style: { backgroundColor: "rgba(181, 180, 176, 0.4)" },
	children: /* @__PURE__ */ _("span", {
		className: "sp-block sp-bg-gray-400 sp-h-full sp-opacity-75",
		style: { width: "33%" },
		children: "\xA0"
	})
}), Pc = ({ username: e, profilePicture: t, locationName: n }) => /* @__PURE__ */ v("section", {
	className: "sp-absolute sp-top-0 sp-left-0 sp-w-full sp-z-50",
	children: [/* @__PURE__ */ _("div", {
		className: "sp-my-3 sp-mx-2",
		children: /* @__PURE__ */ _(Nc, {})
	}), /* @__PURE__ */ _(Ke, {
		username: e,
		profilePicture: t,
		locationName: n,
		small: !0
	})]
}), Fc = () => /* @__PURE__ */ _(el, {
	className: "sp-text-white",
	children: /* @__PURE__ */ v("div", {
		className: "sp-flex sp-items-center sp-w-full",
		children: [/* @__PURE__ */ v("div", {
			className: "sp-flex sp-flex-grow sp-rounded-full sp-p-2 sp-border-2 sp-border-solid sp-border-gray-600 sp-flex sp-items-center sp-mr-3",
			children: [/* @__PURE__ */ _("div", {
				className: "sp-flex sp-justify-center sp-items-center sp-rounded-full sp-p-3 sp-mr-2",
				style: { backgroundColor: "rgba(74, 85, 104, 0.7)" },
				children: /* @__PURE__ */ _(Dc, { className: "sp-h-20px sp-w-20px" })
			}), /* @__PURE__ */ _(P, {
				$variant: "caption",
				className: "sp-font-bold sp-pl-4",
				children: "Send message"
			})]
		}), /* @__PURE__ */ v("div", {
			className: "sp-flex sp-items-center sp-mx-8",
			children: [/* @__PURE__ */ _("div", { className: "sp-flex sp-fill-current sp-mr-3 icon-instagram-share sp-flex sp-text-4xl sp-mr-8" }), /* @__PURE__ */ _("div", {
				className: "sp-flex sp-flex sp-mr-3 sp-mr-4",
				children: [...[
					,
					,
					,
				]].map((e, t) => /* @__PURE__ */ _(Yc, {}, t))
			})]
		})]
	})
}), Ic = ({ url: e, label: t, height: n }) => /* @__PURE__ */ _(Wc, {
	className: "sp-bg-white sp-rounded-lg sp-absolute sp-z-10",
	$storyStickerHeight: n,
	children: /* @__PURE__ */ _(Gc, {
		href: e,
		target: "_blank",
		rel: "noreferrer",
		children: /* @__PURE__ */ v(Kc, { children: [/* @__PURE__ */ _(Jc, { children: /* @__PURE__ */ _(Oc, {}) }), /* @__PURE__ */ _(qc, { children: t || Mc(e) })] })
	})
}), Lc = 6.5, Rc = N.div`
  top: calc(
    ${(e) => e.height ? `${e.height + Lc}% - ${e.height > 60 ? "140px" : "110px"}` : "0"}
  );
  position: absolute;
  z-index: 10;
  width: 100%;
  display: flex;
  flex-direction: ${(e) => e.height > 60 ? "column-reverse" : "column"};
`, zc = N.div`
  width: 100%;
  height: 145px;
  background: rgba(255, 255, 255, 0.2);
  align-items: center;
  display: flex;
  border-top: 1px dashed rgba(255, 255, 255, 0.2);
  border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
  div {
    width: 100%;
    height: 100px;
    background: rgba(255, 255, 255, 0.2);
    border-top: 1px dashed rgba(255, 255, 255, 0.2);
    border-bottom: 1px dashed rgba(255, 255, 255, 0.2);
  }
`, Bc = N.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 10px;
  margin: 10px 0;
`, Vc = N.p`
  color: white;
  font-size: 10px;
  font-family: Inter;
  font-weight: 600;
  text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.9);
  text-transform: uppercase;
  margin: 0;
`, Hc = N.div`
  width: 18px;
  height: 18px;
  background: #333;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 10px;
  font-family: Inter;
  font-weight: 600;
  margin-left: 8px;
  position: relative;
  :hover {
    cursor: pointer;
    div {
      visibility: visible;
    }
  }
`, Uc = N.div`
  visibility: hidden;
  width: 340px;
  background-color: rgba(51, 51, 51, 1);
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: ${(e) => e.height > 60 ? "-38px" : "28px"};
  right: -62px;
  &::after {
    content: "";
    position: absolute;
    bottom: ${(e) => e.height > 60 ? "-10px" : "29px"};
    right: 66px;
    rotate: ${(e) => e.height > 60 ? "180deg" : "0"};
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent rgba(51, 51, 51, 1) transparent;
  }
`, Wc = N.div`
  top: ${(e) => jc(e.$storyStickerHeight)};
  left: 50%;
  transform: translateX(-50%);
  width: fit-content;
  max-width: 95%;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 8px 16px;
`, Gc = N.a`
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  &:hover {
    text-decoration: none;
  }
`, Kc = N.div`
  max-width: 100%;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  gap: 6px;
`, qc = N.div`
  flex: 1 1 auto;
  min-width: 0;
  display: block;
  color: #1a9bfb;
  font-size: clamp(20px, 2.4vw, 28px);
  line-height: 1.1;
  font-family: Aveny, "Apple Color Emoji", "Segoe UI Emoji", Arial, sans-serif;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transform: translateY(4px);
`, Jc = N.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 25px;
  width: 25px;
`, Yc = N.div`
  width: 5px;
  height: 5px;
  border-radius: 9999px;
  background-color: white;
  margin-left: 2px;
`, Xc = ({ post: e, media: t, isActiveSlide: n, env: r, showNote: i = !0 }) => /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _("div", {
	className: "sp-flex sp-flex-column sp-justify-center",
	children: /* @__PURE__ */ v(Qc, { children: [
		/* @__PURE__ */ _(Pc, {
			username: e.username,
			profilePicture: e.profilePicture,
			locationName: e.locationName
		}),
		/* @__PURE__ */ v($c, { children: [e.storyUrl && /* @__PURE__ */ v(g, { children: [r === "schedugram-client" && /* @__PURE__ */ v(Rc, {
			height: (e.storyStickerHeight ?? .8) * 100,
			children: [/* @__PURE__ */ _(zc, { children: /* @__PURE__ */ _("div", {}) }), /* @__PURE__ */ v(Bc, { children: [/* @__PURE__ */ _(Vc, { children: "Approx. Sticker placement area" }), /* @__PURE__ */ v(Hc, { children: ["?", /* @__PURE__ */ _(Uc, {
				height: (e.storyStickerHeight ?? .8) * 100,
				children: "Sticker position is approximate, to be used as a guide only."
			})] })] })]
		}), /* @__PURE__ */ _(Ic, {
			url: e.storyUrl,
			label: e.storyLabel,
			height: e.storyStickerHeight
		})] }), /* @__PURE__ */ _("div", {
			className: "sp-flex sp-h-full sp-w-full sp-flex-col sp-justify-center sp-bg-black",
			children: /* @__PURE__ */ _(lc, {
				media: t,
				isActiveSlide: n,
				imageObjectFit: "contain",
				fillContainer: !0,
				videoObjectFit: "contain"
			})
		})] }),
		/* @__PURE__ */ _(Fc, {})
	] })
}), i && e.caption && /* @__PURE__ */ v(Zc, { children: [/* @__PURE__ */ _("strong", { children: "Notes for manual Publishing: " }), e.caption] })] }), Zc = N.p`
  max-width: 358px;
  margin: 14px auto 0;
  font-size: 14px;
`, Qc = N.div`
  position: relative;
  width: 400px;
  max-width: 100%;
  aspect-ratio: 9 / 16;
  background: #000;
  overflow: hidden;
`, $c = N.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  background: #000;
`, el = N.section`
  position: absolute;
  left: 16px;
  right: 16px;
  bottom: 24px;
  z-index: 50;
`, tl = ({ post: e, media: t, slideNo: n, isActiveSlide: r, env: i }) => /* @__PURE__ */ _("div", {
	"data-ig-story-carousel-slide": n,
	style: {
		order: n,
		flex: "0 0 100%",
		minWidth: 0,
		overflow: "hidden",
		width: "100%"
	},
	children: /* @__PURE__ */ _(Xc, {
		post: e,
		media: t,
		isActiveSlide: r,
		env: i,
		showNote: !1
	})
}), nl = ({ post: e, stories: t, currentSlide: n, env: r }) => t.map((t, i) => /* @__PURE__ */ _(tl, {
	post: e,
	media: t,
	slideNo: i + 1,
	isActiveSlide: n === i + 1,
	env: r
}, i)), rl = ({ post: e, stories: t, count: n, env: r }) => {
	let [i, a] = h(1), o = n;
	d(() => {
		a(1);
	}, [e]);
	let s = {
		transform: `translateX(-${(i - 1) * 100}%)`,
		width: "100%"
	};
	return /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ v("div", {
		className: "sp-flex sp-flex-col sp-relative sp-overflow-hidden",
		"data-ig-story-carousel": !0,
		children: [
			i === 1 || /* @__PURE__ */ _(mc, {
				direction: "left",
				onClick: () => a(i - 1)
			}),
			/* @__PURE__ */ _("div", {
				className: "sp-flex sp-relative",
				"data-ig-story-carousel-track": !0,
				style: s,
				children: /* @__PURE__ */ _(nl, {
					post: e,
					stories: t,
					currentSlide: i,
					env: r
				})
			}),
			o === i || /* @__PURE__ */ _(mc, {
				direction: "right",
				onClick: () => a(i + 1)
			})
		]
	}), e.caption && /* @__PURE__ */ v(Zc, { children: [/* @__PURE__ */ _("strong", { children: "Notes for manual Publishing: " }), e.caption] })] });
}, il = ({ post: e, env: t }) => {
	let n = e.medias.collection, r = n.length;
	return /* @__PURE__ */ _("div", {
		className: "sp-pb-8",
		children: r > 1 ? /* @__PURE__ */ _(rl, {
			post: e,
			stories: n,
			count: r,
			env: t
		}) : /* @__PURE__ */ _(Xc, {
			post: e,
			media: n[0],
			env: t
		})
	});
}, al = N.div`
  display: flex;
  flex-direction: ${({ $direction: e = "row" }) => e};
  justify-content: ${({ $justify: e = "flex-start" }) => e};
  align-items: ${({ $align: e = "flex-start" }) => e};
  gap: ${({ $gap: e = 7 }) => `${e}px`};
  margin-top: ${({ $marginTop: e = 0 }) => e === "auto" ? "auto" : `${e}px`};
  margin-bottom: ${({ $marginBottom: e = 0 }) => e === "auto" ? "auto" : `${e}px`};
  margin-left: ${({ $marginLeft: e = 0 }) => e === "auto" ? "auto" : `${e}px`};
  margin-right: ${({ $marginRight: e = 0 }) => e === "auto" ? "auto" : `${e}px`};
  width: ${({ $width: e = "auto" }) => e};
`, ol = ({ media: e, slideNo: t, isActiveSlide: n }) => /* @__PURE__ */ _("div", {
	style: {
		order: t,
		flex: "1 0 100%"
	},
	className: "sp-h-full",
	children: /* @__PURE__ */ _(lc, {
		backgroundColor: "black",
		media: e,
		isActiveSlide: n,
		videoContainerStyles: { position: "relative" },
		videoCoverObjectFit: "contain",
		videoObjectFit: "contain",
		imageObjectFit: "contain",
		fillContainer: !0
	})
}), sl = ({ medias: e, currentSlide: t }) => {
	let n = e.map((e, n) => /* @__PURE__ */ _(ol, {
		media: e,
		slideNo: n + 1,
		isActiveSlide: t === n + 1
	}, `slide-${n}`));
	return /* @__PURE__ */ _(g, { children: n });
}, cl = ({ current: e }) => /* @__PURE__ */ _("div", { className: `${e ? "sp-bg-blue-600" : "sp-bg-gray-500"}
    sp-rounded-full
    sp-w-8px
    sp-h-8px
    sp-mx-1
    sp-transition-all
    sp-transition-duration-200
    ease-in-out` }), ll = ({ count: e, current: t }) => /* @__PURE__ */ _(dl, {
	className: "sp-flex sp-items-center sp-justify-center",
	children: [...Array(e)].map((e, n) => /* @__PURE__ */ _(cl, { current: n + 1 === t }, `dot-${n}`))
}), ul = ({ medias: e, count: t }) => {
	let [n, r] = h(1);
	d(() => {
		n > e.length && r(e.length);
	}, [e.length, n]);
	let i = {
		left: "100%",
		transform: `translateX(${n * -100}%)`
	};
	return /* @__PURE__ */ v(al, {
		$width: "100%",
		$direction: "column",
		$justify: "center",
		$align: "stretch",
		$gap: "0",
		className: "sp-relative",
		children: [/* @__PURE__ */ v("div", {
			className: "sp-flex sp-flex-col sp-flex-1 sp-relative sp-overflow-hidden",
			children: [
				n !== 1 && /* @__PURE__ */ _(mc, {
					direction: "left",
					onClick: () => r(n - 1)
				}),
				/* @__PURE__ */ _("div", {
					className: "sp-flex sp-relative sp-items-stretch sp-h-full",
					style: i,
					children: /* @__PURE__ */ _(sl, {
						medias: e,
						currentSlide: n
					})
				}),
				n !== e.length && /* @__PURE__ */ _(mc, {
					direction: "right",
					onClick: () => r(n + 1)
				})
			]
		}), /* @__PURE__ */ _(ll, {
			count: t,
			current: n
		})]
	});
}, dl = N.div`
  position: absolute;
  bottom: -15px;
  left: 0;
  width: 100%;
`, fl = ({ medias: e }) => {
	let t = e.collection, n = t.length, r = n > 1;
	if (n === 0) return null;
	let i = t[0], a = !!i?.isVideo || i?.url?.includes(".mp4");
	return r ? /* @__PURE__ */ _(ul, {
		medias: t,
		count: n
	}) : /* @__PURE__ */ _(lc, {
		backgroundColor: "black",
		media: i,
		controls: a,
		videoCoverObjectFit: "contain",
		videoObjectFit: "contain",
		imageObjectFit: "contain",
		fillContainer: !0
	});
}, pl = N.p`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.015em;
  margin: 0;
  color: white;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
`, ml = (e) => /* @__PURE__ */ _("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 9 14",
	...e,
	children: /* @__PURE__ */ _("path", {
		d: "M0.285317 6.39974C0.194867 6.47853 0.123111 6.5721 0.0741546 6.6751C0.0251977 6.7781 6.52568e-07 6.8885 6.47695e-07 7C6.42821e-07 7.1115 0.0251977 7.2219 0.0741545 7.3249C0.123111 7.42789 0.194867 7.52146 0.285317 7.60026L7.33835 13.7514C7.52089 13.9106 7.76847 14 8.02663 14C8.28478 14 8.53236 13.9106 8.71491 13.7514C8.89745 13.5922 9 13.3762 9 13.1511C9 12.926 8.89745 12.71 8.71491 12.5508L2.35015 7L8.71491 1.44916C8.80529 1.37033 8.87699 1.27675 8.92591 1.17376C8.97482 1.07077 9 0.960378 9 0.848899C9 0.73742 8.97482 0.627033 8.92591 0.52404C8.87699 0.421046 8.80529 0.327465 8.71491 0.248637C8.62452 0.169809 8.51722 0.10728 8.39912 0.0646186C8.28103 0.0219574 8.15445 -3.86212e-08 8.02663 -4.25475e-08C7.8988 -4.64737e-08 7.77223 0.0219574 7.65413 0.0646186C7.53604 0.10728 7.42873 0.169809 7.33835 0.248637L0.285317 6.39974Z",
		fill: "white"
	})
}), hl = (e) => /* @__PURE__ */ v("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "10 6 21 17",
	...e,
	children: [/* @__PURE__ */ _("g", {
		filter: "url(#filter0_d_0_85)",
		children: /* @__PURE__ */ _("path", {
			d: "M13.2308 23C11.4549 23 10 21.6081 10 19.9091V11.6667C10 9.96768 11.4549 8.57576 13.2308 8.57576H15.9567L17.0841 6.42661C17.1514 6.2982 17.2547 6.19026 17.3825 6.11491C17.5103 6.03955 17.6576 5.99976 17.8077 6H23.1923C23.3424 5.99976 23.4897 6.03955 23.6175 6.11491C23.7453 6.19026 23.8486 6.2982 23.9159 6.42661L25.0433 8.57576H27.7692C29.5451 8.57576 31 9.96768 31 11.6667V19.9091C31 21.6081 29.5451 23 27.7692 23H13.2308ZM13.2308 21.4545H27.7692C28.6781 21.4545 29.3846 20.7786 29.3846 19.9091V11.6667C29.3846 10.7972 28.6781 10.1212 27.7692 10.1212H24.5385C24.3883 10.1215 24.2411 10.0817 24.1133 10.0063C23.9855 9.93097 23.8822 9.82303 23.8149 9.69462L22.6875 7.54545H18.3125L17.1851 9.69462C17.1178 9.82303 17.0145 9.93097 16.8867 10.0063C16.7589 10.0817 16.6117 10.1215 16.4615 10.1212H13.2308C12.3219 10.1212 11.6154 10.7972 11.6154 11.6667V19.9091C11.6154 20.7786 12.3219 21.4545 13.2308 21.4545ZM20.5 20.1667C17.9818 20.1667 15.9231 18.1971 15.9231 15.7879C15.9231 13.3787 17.9818 11.4091 20.5 11.4091C23.0182 11.4091 25.0769 13.3787 25.0769 15.7879C25.0769 18.1971 23.0182 20.1667 20.5 20.1667ZM20.5 18.6212C22.1452 18.6212 23.4615 17.3618 23.4615 15.7879C23.4615 14.2139 22.1452 12.9546 20.5 12.9546C18.8549 12.9546 17.5385 14.2139 17.5385 15.7879C17.5385 17.3618 18.8549 18.6212 20.5 18.6212Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _("defs", { children: /* @__PURE__ */ v("filter", {
		id: "filter0_d_0_85",
		x: 0,
		y: 0,
		width: 41,
		height: 37,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _("feOffset", { dy: 4 }),
			/* @__PURE__ */ _("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ _("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_85"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_85",
				result: "shape"
			})
		]
	}) })]
}), gl = (e) => /* @__PURE__ */ v("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "10 6 8 8",
	...e,
	children: [/* @__PURE__ */ v("g", {
		filter: "url(#filter0_d_0_80)",
		children: [
			/* @__PURE__ */ _("rect", {
				x: 10,
				y: 8,
				width: 2,
				height: 5,
				rx: 1,
				fill: "white"
			}),
			/* @__PURE__ */ _("rect", {
				x: 16,
				y: 8,
				width: 2,
				height: 5,
				rx: 1,
				fill: "white"
			}),
			/* @__PURE__ */ _("rect", {
				x: 13,
				y: 6,
				width: 2,
				height: 8,
				rx: 1,
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _("defs", { children: /* @__PURE__ */ v("filter", {
		id: "filter0_d_0_80",
		x: 0,
		y: 0,
		width: 28,
		height: 28,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _("feOffset", { dy: 4 }),
			/* @__PURE__ */ _("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ _("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_80"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_80",
				result: "shape"
			})
		]
	}) })]
}), _l = N.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`, vl = N.div`
  background: url(${(e) => e.$profilePicture}) no-repeat center center;
  background-size: cover;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin-right: 6px;
`, yl = ({ profilePicture: e, username: t }) => /* @__PURE__ */ v(_l, { children: [/* @__PURE__ */ _(vl, { $profilePicture: e }), /* @__PURE__ */ v(pl, {
	className: "sp-font-bold",
	children: [t, " • Follow"]
})] }), bl = (e) => /* @__PURE__ */ v("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "10 6 20 18",
	...e,
	children: [/* @__PURE__ */ _("g", {
		filter: "url(#filter0_d_0_66)",
		children: /* @__PURE__ */ _("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24.383 6C21.3618 6 20.0001 8.32683 20.0001 8.32683C20.0001 8.32683 18.6384 6 15.6171 6C12.5107 6 10.0001 8.80976 10.0001 12.278C10.0001 15.7463 12.5958 17.722 15.1916 20.0927C19.1064 23.6927 19.3618 24 20.0001 24C20.6384 24 20.8937 23.6927 24.8086 20.0927C27.4469 17.678 30.0001 15.7024 30.0001 12.278C30.0001 8.80976 27.4894 6 24.383 6ZM23.9575 19.0829C21.6596 21.1902 20.4256 22.3756 20.0001 22.639C19.5745 22.3317 18.0426 20.9268 16.0426 19.0829C13.7022 16.9317 11.2767 15.1317 11.2767 12.2341C11.2767 9.5122 13.2341 7.27317 15.6171 7.27317C17.3618 7.27317 18.2979 8.15122 18.9788 9.11707C20.5107 11.3561 19.4894 11.3561 21.0213 9.11707C21.7022 8.15122 22.6384 7.27317 24.383 7.27317C26.766 7.27317 28.7235 9.5122 28.7235 12.2341C28.7235 15.1756 26.2979 16.9756 23.9575 19.0829Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _("defs", { children: /* @__PURE__ */ v("filter", {
		id: "filter0_d_0_66",
		x: 610352e-10,
		y: 0,
		width: 40,
		height: 38,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _("feOffset", { dy: 4 }),
			/* @__PURE__ */ _("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ _("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_66"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_66",
				result: "shape"
			})
		]
	}) })]
}), xl = (e) => /* @__PURE__ */ v("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "10 6 20 20",
	...e,
	children: [/* @__PURE__ */ _("g", {
		filter: "url(#filter0_d_0_65)",
		children: /* @__PURE__ */ _("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M29.9868 25.3914L28.7961 20.7137C29.5615 19.3103 29.9868 17.6944 29.9868 15.9934C29.9868 10.4651 25.5216 6 19.9934 6C14.4651 6 10 10.4651 10 15.9934C10 21.5216 14.4651 25.9868 19.9934 25.9868C21.6944 25.9868 23.3103 25.5615 24.7137 24.7961L29.3914 25.9868C29.7316 26.0718 30.0718 25.7316 29.9868 25.3914ZM28.711 15.9934C28.711 17.6944 28.2858 18.9701 27.6054 20.2459C27.5203 20.416 27.4778 20.6286 27.5203 20.8412L28.4134 24.4134L24.8838 23.5203C24.6711 23.4778 24.4585 23.4778 24.2884 23.6054C23.523 24.0306 22.0771 24.711 20.0359 24.711C15.1881 24.711 11.2758 20.7987 11.2758 15.9934C11.2758 11.1881 15.1881 7.27575 19.9934 7.27575C24.7987 7.27575 28.711 11.1881 28.711 15.9934Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _("defs", { children: /* @__PURE__ */ v("filter", {
		id: "filter0_d_0_65",
		x: 0,
		y: 0,
		width: 40,
		height: 40,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _("feOffset", { dy: 4 }),
			/* @__PURE__ */ _("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ _("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_65"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_65",
				result: "shape"
			})
		]
	}) })]
}), Sl = (e) => /* @__PURE__ */ v("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "10 6 20 17",
	...e,
	children: [/* @__PURE__ */ _("g", {
		filter: "url(#filter0_d_0_64)",
		children: /* @__PURE__ */ _("path", {
			d: "M29.5574 6H10.419C10.0363 6 9.86616 6.45544 10.1213 6.70386L16.9261 13.2456L19.2652 22.6856C19.3503 23.0582 19.8606 23.0996 20.0307 22.8098L29.9401 6.62105C30.1102 6.33123 29.8976 6 29.5574 6ZM12.503 7.2421H26.7504L17.9043 12.0035C17.7341 12.0863 17.5215 12.0449 17.3939 11.9207L12.503 7.2421ZM20.0307 20.4084L18.3295 13.5354C18.287 13.3698 18.3721 13.1628 18.5422 13.08L27.4309 8.27719L20.0307 20.4084Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _("defs", { children: /* @__PURE__ */ v("filter", {
		id: "filter0_d_0_64",
		x: 0,
		y: 0,
		width: 40,
		height: 37,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _("feOffset", { dy: 4 }),
			/* @__PURE__ */ _("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ _("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_64"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_64",
				result: "shape"
			})
		]
	}) })]
}), Cl = (e) => /* @__PURE__ */ v("svg", {
	width: 16,
	height: 4,
	viewBox: "0 0 16 4",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ _("circle", {
			cx: 2,
			cy: 2,
			r: 2,
			fill: "white"
		}),
		/* @__PURE__ */ _("circle", {
			cx: 8,
			cy: 2,
			r: 2,
			fill: "white"
		}),
		/* @__PURE__ */ _("circle", {
			cx: 14,
			cy: 2,
			r: 2,
			fill: "white"
		})
	]
}), wl = N.div`
  position: absolute;
  display: flex;
  align-items: center;
  z-index: 4;

  svg {
    width: 20px;

    &.more {
      position: relative;
      ${({ $vertical: e }) => e && "top: -10px;"};
    }
  }

  ${({ $vertical: e }) => e ? "\n      flex-direction: column;\n      right: 14px;\n      bottom: 145px;\n      gap: 40px;\n      " : "\n      flex-direction: row;\n      gap: 14px;\n      left: 14px;\n      bottom: 80px;\n      "}
`, Tl = ({ vertical: e }) => /* @__PURE__ */ v(wl, {
	$vertical: e,
	children: [
		/* @__PURE__ */ _(bl, {}),
		/* @__PURE__ */ _(xl, {}),
		/* @__PURE__ */ _(Sl, {}),
		/* @__PURE__ */ _(Cl, { className: "more" })
	]
}), El = ({ post: e, className: t }) => {
	let n = e?.medias?.collection?.length > 1, r = e.comment?.trim(), [i, a] = h(!1);
	return /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ v(Dl, {
		className: t,
		children: [
			/* @__PURE__ */ v(Al, { children: [
				/* @__PURE__ */ _(ml, { className: "arrow-back" }),
				/* @__PURE__ */ _(pl, { children: "Reels" }),
				/* @__PURE__ */ _(hl, { className: "camera" })
			] }),
			/* @__PURE__ */ _(Tl, { vertical: !0 }),
			/* @__PURE__ */ _("div", { className: "sp-absolute sp-bottom-0 sp-left-0 sp-w-full sp-h-64 sp-bg-gradient-to-t sp-from-black/60 sp-via-black/20 sp-to-transparent sp-pointer-events-none sp-z-[1]" }),
			/* @__PURE__ */ v(Ol, {
				$isMultipleMedia: n,
				$expanded: i,
				children: [
					/* @__PURE__ */ _(yl, {
						profilePicture: e.profilePicture,
						username: e.username
					}),
					/* @__PURE__ */ _("div", {
						className: i ? "sp-max-h-[300px] sp-overflow-y-auto" : "sp-line-clamp-2 sp-overflow-hidden",
						style: i ? { scrollbarWidth: "none" } : void 0,
						children: /* @__PURE__ */ _(pl, { children: /* @__PURE__ */ _(Y, {
							caption: e.caption,
							targetPlatform: "IG"
						}) })
					}),
					e.caption && /* @__PURE__ */ _("button", {
						onClick: (e) => {
							e.stopPropagation(), a(!i);
						},
						className: "sp-text-white/70 sp-text-sm sp-cursor-pointer sp-bg-transparent sp-border-none sp-p-0",
						children: i ? "less" : "more"
					}),
					/* @__PURE__ */ v(jl, { children: [/* @__PURE__ */ _(gl, {}), /* @__PURE__ */ _("span", { children: "Audio will be auto-matched after publishing" })] })
				]
			}),
			/* @__PURE__ */ _(fl, { medias: e.medias })
		]
	}), r && /* @__PURE__ */ v(kl, {
		id: "post-preview-notes",
		children: [/* @__PURE__ */ v("strong", { children: [e.username, " "] }), /* @__PURE__ */ _(Y, {
			caption: r,
			targetPlatform: "IG"
		})]
	})] });
}, Dl = N.div`
  box-shadow: 0 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
  width: 400px;
  max-width: 100%;
  aspect-ratio: 9 / 16;
  background: #333;
  display: flex;
  overflow: hidden;
`, Ol = N.div`
  position: absolute;
  bottom: ${(e) => e.$isMultipleMedia ? "85px" : "55px"};
  z-index: 4;
  padding: ${(e) => e.$expanded ? "12px" : "0 0 0 12px"};
  right: 60px;
  overflow-wrap: break-word;
  word-break: break-word;
  border-radius: ${(e) => e.$expanded ? "12px" : "0"};
  background: ${(e) => e.$expanded ? "rgba(0, 0, 0, 0.5)" : "transparent"};
  transition:
    background 0.2s ease,
    padding 0.2s ease;

  a {
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
  }
`, kl = N.div`
  margin: 14px 5px;
  font-size: 14px;
  line-height: 17px;
`, Al = N.div`
  position: absolute;
  top: 25px;
  display: flex;
  align-items: center;
  z-index: 4;
  justify-content: space-between;
  width: 100%;

  p {
    font-weight: 700;
  }

  .arrow-back {
    width: 14px;
    margin-left: 12px;
  }

  .camera {
    width: 21px;
    margin-right: 12px;
  }
`, jl = N.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 12px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  svg {
    width: 8px;
    flex-shrink: 0;
  }
`, Ml = N.div`
  box-shadow: 0px 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
`, Nl = N.div`
  position: absolute;
  top: 20px;
  z-index: 2;
  width: 100%;

  .section {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 14px;
    box-sizing: border-box;
    margin-bottom: 10px;

    p {
      width: 280px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      font-size: 16px;
    }

    svg.close {
      width: 17px;
    }
  }
`, Pl = ({ post: e }) => /* @__PURE__ */ v(Ml, { children: [
	/* @__PURE__ */ v(Nl, { children: [e.caption && /* @__PURE__ */ _("div", {
		className: "section",
		children: /* @__PURE__ */ _(pl, { children: e.caption })
	}), /* @__PURE__ */ _("div", {
		className: "section",
		children: /* @__PURE__ */ _(yl, {
			profilePicture: e.profilePicture,
			username: e.username
		})
	})] }),
	/* @__PURE__ */ _(Tl, {}),
	/* @__PURE__ */ _(fl, { medias: e.medias })
] }), Fl = ({ post: e, className: t, env: n }) => {
	let r = e.type;
	switch (r === "story" && e.storyType && e.storyType !== "story" && (e.storyType === "reel" ? (r = "reel", e.locationName = "Reel") : e.storyType === "igtv" && (r = "igtv", e.locationName = "IGTV")), r) {
		case "image":
		case "multiMedia": return /* @__PURE__ */ _(Ec, { post: e });
		case "video":
		case "reel": return /* @__PURE__ */ _(El, {
			post: e,
			className: t
		});
		case "igtv": return /* @__PURE__ */ _(Pl, { post: e });
		case "story": return /* @__PURE__ */ _(il, {
			post: e,
			env: n
		});
		default: return /* @__PURE__ */ _(g, {});
	}
}, Il = N.div`
  font-family: Helvetica;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: 0.01em;\n        ";
		case "subheading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 13px;\n          line-height: 16px;\n          letter-spacing: -0.02em;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: 0.005em;\n          white-space: pre-line;\n        ";
		case "icons": return "\n          font-family: Helvetica Neue;\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 18px;\n          letter-spacing: 0.01em;\n        ";
	}
}};

  .sked-mention.sked-mention-facebook {
    color: hsl(214, 89%, 52%);

    &:hover {
      text-decoration: underline;
    }
  }
`, Ll = ({ username: e, profilePicture: t, small: n, scheduled: r }) => {
	let i = new b(r).format("MMM D [at] HH:mm");
	return i === "Invalid date" && (i = null), /* @__PURE__ */ v("div", {
		className: "sp-flex sp-items-center",
		children: [/* @__PURE__ */ _("div", {
			className: "sp-rounded-full sp-overflow-hidden  sp-m-4",
			style: {
				width: "40px",
				height: "40px",
				minWidth: "40px",
				minHeight: "40px"
			},
			children: /* @__PURE__ */ _(Ge, {
				src: t,
				alt: e
			})
		}), /* @__PURE__ */ _("div", {
			className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${n ? "sp-text-white" : ""}`,
			children: /* @__PURE__ */ v("div", {
				className: "",
				children: [/* @__PURE__ */ _(Il, {
					$variant: "heading",
					className: "sp-mb-1",
					children: e
				}), i && /* @__PURE__ */ _(Il, {
					$variant: "subheading",
					children: i
				})]
			})
		})]
	});
}, Rl = ({ children: e, href: t, target: n = "_blank", $isFlex: r = !1 }) => /* @__PURE__ */ _(Gs, {
	$isFlex: r,
	href: t,
	target: n,
	rel: "noreferrer",
	children: e
});
//#endregion
//#region ../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.mjs
function zl(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) {
		var i = e.length;
		for (t = 0; t < i; t++) e[t] && (n = zl(e[t])) && (r && (r += " "), r += n);
	} else for (n in e) e[n] && (r && (r += " "), r += n);
	return r;
}
function Bl() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = zl(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region lib/components/previews/facebook/Media.tsx
var Vl = N.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, Hl = N.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, Ul = ({ src: e, forCarousel: t, showOverlay: n, showAll: r, setShowAll: i, mediaCount: a }) => t ? /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _(Rl, {
	href: e,
	$isFlex: !0,
	children: /* @__PURE__ */ _(Hl, {
		src: e,
		className: ""
	})
}), !r && n && /* @__PURE__ */ v("div", {
	className: "sp-cursor-pointer",
	onClick: () => i(!0),
	children: [/* @__PURE__ */ _("div", {
		className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ",
		children: "\xA0"
	}), /* @__PURE__ */ v("div", {
		className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl",
		children: ["+", a - 4]
	})]
})] }) : /* @__PURE__ */ _(Rl, {
	href: e,
	children: /* @__PURE__ */ _(Vl, { src: e })
}), Wl = ({ url: e, isActiveSlide: t, isCarouselPost: n, controls: r = !0, backgroundColor: i, videoCoverObjectFit: a }) => {
	let { vid: o, videoCoverPreview: s, showVideoCover: c, resetVideo: l, handlePlay: u, handlePause: d, showResetButton: f } = Ys({ usePostTypeCheck: !1 }), [p, m] = h(!1), g = !r, y = g && c && !p;
	return t ? /* @__PURE__ */ _("div", {
		className: Bl("sp-w-full sp-h-full", { "sp-relative": !n }, { "sp-absolute": n }),
		children: /* @__PURE__ */ v(Qs, {
			$backgroundColor: i,
			$showVideoCover: c,
			$videoCoverObjectFit: a,
			children: [
				f && /* @__PURE__ */ _(tc, { onClick: () => {
					m(!1), l();
				} }),
				y && s && /* @__PURE__ */ _($s, {
					$backgroundColor: i,
					$objectFit: a,
					src: s,
					alt: ""
				}),
				g && /* @__PURE__ */ _(oc, {
					playing: p,
					onToggle: () => m((e) => !e)
				}),
				/* @__PURE__ */ _(Ws, {
					src: e,
					controls: r,
					playing: g ? p : !!s,
					onPlay: u,
					onPause: d,
					light: !g && c ? s : void 0,
					className: "sp-overflow-hidden sp-my-auto",
					width: "100%",
					height: "100%"
				}, o)
			]
		})
	}) : null;
}, Gl = ({ media: e, hidden: t = !1, forCarousel: n = !1, showOverlay: r, showAll: i, setShowAll: a, mediaCount: o, isActiveSlide: s = !0, controls: c, backgroundColor: l, videoCoverObjectFit: u }) => t && i === !1 ? null : e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ _(Wl, {
	url: e.url,
	isActiveSlide: s,
	isCarouselPost: n,
	controls: c,
	backgroundColor: l,
	videoCoverObjectFit: u
}) : /* @__PURE__ */ _(Ul, {
	src: e.url,
	forCarousel: n,
	showOverlay: r,
	showAll: i,
	setShowAll: a,
	mediaCount: o
}), Kl = N.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;
  overflow: hidden;
  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, ql = ({ medias: e }) => {
	let [t, n] = h(!1);
	return /* @__PURE__ */ _("div", {
		className: "sp-flex sp-flex-wrap sp-w-full",
		children: e.map((r, i) => !t && i > 3 ? null : /* @__PURE__ */ _(Kl, {
			className: "sp-relative",
			children: /* @__PURE__ */ _(Gl, {
				media: r,
				forCarousel: !0,
				hidden: i > 3,
				isActiveSlide: i === 0,
				mediaCount: e.length,
				showOverlay: i === 3 && e.length > 4,
				showAll: t,
				setShowAll: n
			})
		}, `fb-media-key-${i}`))
	});
}, Jl = () => /* @__PURE__ */ v("div", {
	className: "sp-flex sp-w-full sp-justify-center sp-py-2 sp-text-gray-700",
	children: [
		/* @__PURE__ */ _(Yl, {
			icon: "icon-facebook-like",
			text: "Like"
		}),
		/* @__PURE__ */ _(Yl, {
			icon: "icon-facebook-comment",
			text: "Comment"
		}),
		/* @__PURE__ */ _(Yl, {
			icon: "icon-facebook-share",
			text: "Share"
		})
	]
}), Yl = ({ icon: e, text: t }) => /* @__PURE__ */ v(Il, {
	$variant: "icons",
	className: "sp-flex sp-items-center sp-justify-center sp-w-1/3 ",
	children: [/* @__PURE__ */ _("div", { className: `sp-mr-2 sp-text-xl ${e}` }), /* @__PURE__ */ _("div", {
		className: "sp-text-gray-700",
		children: t
	})]
}), Xl = ({ medias: e }) => {
	let t = e.collection, n = t.length;
	return /* @__PURE__ */ v("div", { children: [n > 0 && /* @__PURE__ */ _(g, { children: n > 1 ? /* @__PURE__ */ _(ql, { medias: t }) : /* @__PURE__ */ _(Gl, {
		media: t[0],
		showOverlay: !1,
		showAll: !0,
		setShowAll: () => {},
		isActiveSlide: !0,
		mediaCount: n
	}) }), /* @__PURE__ */ _(Jl, {})] });
}, Zl = "JgUARf2HjedOQkin6wQs2Ll11upPpWG5gJ1NTX9c", Ql = ({ url: e }) => /* @__PURE__ */ _(x, {
	url: e,
	apiKey: Zl,
	size: "large",
	className: "sp-shadow-lg"
}), $l = ({ post: e }) => {
	let t = e.caption;
	return /* @__PURE__ */ v("div", {
		className: "sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0",
		children: [
			/* @__PURE__ */ _(Ll, {
				username: e.username,
				profilePicture: e.profilePicture,
				locationName: e.locationName,
				scheduled: e.scheduledFor
			}),
			/* @__PURE__ */ _("div", {
				className: "sp-flex sp-flex-col sp-mx-4 sp-pb-4",
				style: e.type === "text" && e.redirectUrl === "" ? { borderBottom: "1px solid #BFBEBE" } : {},
				children: /* @__PURE__ */ v(Il, {
					$variant: "caption",
					className: "sp-whitespace-pre-line sp-break-words",
					children: [/* @__PURE__ */ _(Y, {
						caption: t,
						targetPlatform: "FB"
					}), e.redirectUrl && e.type !== "text" && /* @__PURE__ */ v(g, { children: [" ", /* @__PURE__ */ _("a", {
						className: "sp-text-blue-400 sp-break-words",
						href: e.redirectUrl,
						target: "_blank",
						children: e.redirectUrl
					})] })]
				})
			}),
			e.type === "text" && e.redirectUrl && /* @__PURE__ */ _("div", {
				className: "sp-p-4",
				children: /* @__PURE__ */ _(Ql, { url: e.redirectUrl })
			}),
			/* @__PURE__ */ _(Xl, { medias: e.medias }),
			/* @__PURE__ */ _("div", {
				className: "sp-flex sp-flex-col sp-px-4 sp-pb-8",
				children: e.comment && e.comment.trim() !== "" && /* @__PURE__ */ v(Il, {
					$variant: "caption",
					className: "sp-whitespace-pre-line sp-break-words",
					children: [/* @__PURE__ */ _("span", {
						className: "sp-font-bold sp-mr-1",
						children: e.username
					}), /* @__PURE__ */ _(Y, {
						caption: e.comment,
						targetPlatform: "FB"
					})]
				})
			})
		]
	});
}, eu = ({ post: e, media: t }) => {
	let [n, r] = h(!1);
	return /* @__PURE__ */ _("div", {
		className: "sp-flex sp-flex-column sp-justify-center sp-h-full",
		children: /* @__PURE__ */ v("div", {
			className: "sp-flex sp-flex-column sp-justify-center sp-relative sp-h-full sp-w-full",
			children: [
				/* @__PURE__ */ _("div", {
					className: "sp-min-h-670px sp-w-full md:sp-min-h-710px sp-flex sp-flex-col sp-justify-center sp-bg-black",
					children: /* @__PURE__ */ _(Gl, {
						backgroundColor: "black",
						media: t,
						controls: !1,
						videoCoverObjectFit: "contain"
					})
				}),
				/* @__PURE__ */ _("div", {
					className: "sp-absolute sp-top-8 sp-flex sp-items-center sp-justify-between sp-w-full  sp-text-white sp-text-24px",
					children: /* @__PURE__ */ v("div", {
						className: "sp-mx-16px sp-w-full sp-flex sp-items-center sp-justify-between",
						children: [/* @__PURE__ */ _("div", {
							className: "sp-flex sp-items-center sp-justify-center",
							children: /* @__PURE__ */ _("i", { className: "fa-regular fa-xmark" })
						}), /* @__PURE__ */ v("div", {
							className: "sp-flex sp-items-center sp-gap-16px",
							children: [/* @__PURE__ */ _("div", {
								className: "sp-flex sp-items-center sp-justify-center",
								children: /* @__PURE__ */ _("i", { className: "fa-regular fa-magnifying-glass" })
							}), /* @__PURE__ */ _("div", {
								className: "sp-flex sp-items-center sp-justify-center",
								children: /* @__PURE__ */ _("i", { className: "fa-regular fa-circle-user" })
							})]
						})]
					})
				}),
				/* @__PURE__ */ v("div", {
					className: "sp-absolute sp-bottom-[50px] sp-right-[16px] sp-flex sp-flex-col sp-gap-[40px] sp-items-center sp-text-white sp-text-24px sp-z-10",
					children: [
						/* @__PURE__ */ _("div", {
							className: "sp-flex sp-items-center sp-justify-center",
							children: /* @__PURE__ */ _("i", { className: "fa-regular fa-thumbs-up" })
						}),
						/* @__PURE__ */ _("div", {
							className: "sp-flex sp-items-center sp-justify-center",
							children: /* @__PURE__ */ _("i", { className: "fa-regular fa-message" })
						}),
						/* @__PURE__ */ _("div", {
							className: "sp-flex sp-items-center sp-justify-center",
							children: /* @__PURE__ */ _("i", { className: "fa-regular fa-share" })
						}),
						/* @__PURE__ */ _("div", {
							className: "sp-flex sp-items-center sp-justify-center",
							children: /* @__PURE__ */ _("i", { className: "fa-regular fa-comment-lines" })
						}),
						/* @__PURE__ */ _("div", {
							className: "sp-flex sp-items-center sp-justify-center",
							children: /* @__PURE__ */ _("i", { className: "fa-regular fa-ellipsis" })
						})
					]
				}),
				/* @__PURE__ */ _("div", { className: "sp-absolute sp-bottom-0 sp-left-0 sp-w-full sp-h-64 sp-bg-gradient-to-t sp-from-black/60 sp-via-black/20 sp-to-transparent sp-pointer-events-none sp-z-[5]" }),
				/* @__PURE__ */ v("div", {
					className: `sp-absolute sp-bottom-[50px] sp-flex sp-flex-col sp-gap-3 sp-z-10 sp-transition-all sp-duration-200 ${n ? "sp-left-0 sp-right-0 sp-px-5 sp-bg-black/50 sp-p-3" : "sp-left-5 sp-max-w-[320px]"}`,
					children: [
						/* @__PURE__ */ v("div", {
							className: "sp-flex sp-items-center sp-gap-3",
							children: [/* @__PURE__ */ v("div", {
								className: "sp-flex sp-items-center sp-gap-[8px]",
								children: [
									/* @__PURE__ */ _("div", {
										className: "sp-w-[40px] sp-h-[40px] sp-rounded-full sp-overflow-hidden sp-bg-[#333] sp-flex sp-items-center sp-justify-center",
										children: /* @__PURE__ */ _("img", {
											src: e.profilePicture,
											className: "sp-w-full sp-h-full sp-object-cover"
										})
									}),
									/* @__PURE__ */ _("div", {
										className: "sp-flex sp-items-center sp-gap-1",
										children: /* @__PURE__ */ _("span", {
											className: "sp-text-white sp-font-semibold sp-text-[16px] sp-max-w-[180px] sp-overflow-hidden sp-whitespace-nowrap sp-text-ellipsis sp-inline-block",
											children: e.username
										})
									}),
									/* @__PURE__ */ _("div", {
										className: "sp-w-3 sp-h-3 sp-text-white sp-text-12px",
										children: /* @__PURE__ */ _("i", { className: "fa-regular fa-earth-americas" })
									})
								]
							}), /* @__PURE__ */ _("div", {
								className: "sp-flex-shrink-0 sp-ml-[12px]",
								children: /* @__PURE__ */ _("button", {
									className: "sp-bg-transparent  sp-border-[1px] sp-border-white/30 sp-border-solid sp-rounded-[9px] sp-text-white sp-text-[15px] sp-px-[12px] sp-py-[4px]",
									children: "Follow"
								})
							})]
						}),
						/* @__PURE__ */ v("div", {
							className: "sp-text-white sp-text-[16px] sp-leading-6",
							children: [/* @__PURE__ */ _("div", {
								className: n ? "sp-max-h-[300px] sp-overflow-y-auto sp-break-words" : "sp-line-clamp-2 sp-overflow-hidden sp-break-words",
								style: n ? { scrollbarWidth: "none" } : void 0,
								children: /* @__PURE__ */ _("span", { children: e.caption })
							}), e.caption && /* @__PURE__ */ _("button", {
								onClick: (e) => {
									e.stopPropagation(), r(!n);
								},
								className: "sp-text-gray-400 sp-text-sm sp-cursor-pointer sp-bg-transparent sp-border-none sp-p-0",
								children: n ? "less" : "more"
							})]
						}),
						/* @__PURE__ */ v("div", {
							className: "sp-flex sp-items-center sp-gap-1.5 sp-text-white/70 sp-text-[11px] sp-mt-2",
							children: [/* @__PURE__ */ _("i", { className: "fa-solid fa-music sp-text-[10px]" }), /* @__PURE__ */ _("span", {
								className: "sp-truncate",
								children: "Audio will be auto-matched after publishing"
							})]
						})
					]
				})
			]
		})
	});
}, tu = ({ post: e }) => /* @__PURE__ */ v("div", {
	className: "sp-pb-8",
	children: [/* @__PURE__ */ _(eu, {
		post: e,
		media: e.medias.collection[0]
	}), /* @__PURE__ */ _("div", {
		className: "sp-flex sp-flex-col sp-px-4 sp-py-8",
		children: e.comment && e.comment.trim() !== "" && /* @__PURE__ */ v(Il, {
			$variant: "caption",
			className: "sp-whitespace-pre-line sp-break-words",
			children: [/* @__PURE__ */ _("span", {
				className: "sp-font-bold sp-mr-1",
				children: e.username
			}), /* @__PURE__ */ _(Y, {
				caption: e.comment,
				targetPlatform: "FB"
			})]
		})
	})]
}), nu = ({ post: e }) => {
	let t = e.type, n = e.providedPost?.videoPostType;
	if (t === "video" && n === "reel") return /* @__PURE__ */ _(tu, { post: e });
	switch (t) {
		case "image":
		case "video":
		case "multiMedia":
		case "text": return /* @__PURE__ */ _($l, { post: e });
		case "story":
		case "fb-reel": return /* @__PURE__ */ _(tu, { post: e });
		default: return /* @__PURE__ */ _(g, {});
	}
}, ru = N.div`
  font-family: Helvetica;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: 0.015em;\n        ";
		case "subheading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: 0.015em;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: -0.025em;\n          white-space: pre-line;\n        ";
	}
}};
`, iu = ({ username: e, profilePicture: t, small: n }) => /* @__PURE__ */ v("div", {
	className: "sp-flex sp-items-center",
	children: [
		/* @__PURE__ */ _("div", {
			className: "sp-rounded-full sp-overflow-hidden sp-m-4",
			style: {
				width: "49px",
				height: "49px"
			},
			children: /* @__PURE__ */ _(Ge, {
				src: t,
				alt: e
			})
		}),
		/* @__PURE__ */ _("div", {
			className: `sp-flex sp-flex-grow sp-leading-tight ${n ? "sp-text-white" : ""}`,
			children: /* @__PURE__ */ v("div", {
				className: "sp-font-sans",
				children: [/* @__PURE__ */ _(ru, {
					$variant: "heading",
					className: "sp-mb-1",
					children: e
				}), /* @__PURE__ */ v(ru, {
					$variant: "subheading",
					className: "sp-text-gray-600",
					children: ["@", e]
				})]
			})
		}),
		/* @__PURE__ */ _("div", {
			className: "icon-twitter-down sp-mr-4 sp-text-2xl sp-text-gray-600",
			children: "\xA0"
		})
	]
}), au = N.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, ou = N.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, su = ({ src: e, forCarousel: t, showOverlay: n, showAll: r, setShowAll: i, mediaCount: a }) => t ? /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _(Rl, {
	href: e,
	$isFlex: !0,
	children: /* @__PURE__ */ _(ou, {
		src: e,
		className: ""
	})
}), !r && n && /* @__PURE__ */ v("div", {
	className: "sp-cursor-pointer",
	onClick: () => i(!0),
	children: [/* @__PURE__ */ _("div", {
		className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ",
		children: "\xA0"
	}), /* @__PURE__ */ v("div", {
		className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl",
		children: ["+", a - 4]
	})]
})] }) : /* @__PURE__ */ _(Rl, {
	href: e,
	children: /* @__PURE__ */ _(au, { src: e })
}), cu = ({ url: e, isActiveSlide: t }) => t ? /* @__PURE__ */ _("div", {
	className: "sp-bg-black sp-flex sp-items-center",
	children: /* @__PURE__ */ _(Ws, {
		src: e,
		controls: !0,
		playing: !1,
		className: "sp-relative",
		width: "100%",
		height: "auto"
	})
}) : null, lu = ({ media: e, hidden: t = !1, forCarousel: n = !1, showOverlay: r, showAll: i, setShowAll: a, mediaCount: o, isActiveSlide: s = !0 }) => t && i === !1 ? null : /* @__PURE__ */ v(g, { children: [(e.isVideo || e.url.includes(".mp4")) && /* @__PURE__ */ _(cu, {
	url: e.url,
	forCarousel: n,
	isActiveSlide: s
}), !(e.isVideo || e.url.includes(".mp4")) && /* @__PURE__ */ _(su, {
	src: e.url,
	forCarousel: n,
	showOverlay: r,
	showAll: i,
	setShowAll: a,
	mediaCount: o
})] }), uu = () => /* @__PURE__ */ _("div", {
	className: "sp-py-4 sp-px-2 sp-w-full",
	children: /* @__PURE__ */ v("div", {
		className: "sp-flex sp-w-full sp-justify-center sp-text-gray-600 sp-py-2",
		style: {
			borderTop: "0.5px solid #ebebe4",
			borderBottom: "0.5px solid #ebebe4"
		},
		children: [
			/* @__PURE__ */ _(du, { icon: "icon-twitter-reply" }),
			/* @__PURE__ */ _(du, { icon: "icon-twitter-retweet" }),
			/* @__PURE__ */ _(du, { icon: "icon-twitter-heart" }),
			/* @__PURE__ */ _(du, { icon: "icon-twitter-share" })
		]
	})
}), du = ({ icon: e }) => /* @__PURE__ */ _("div", {
	className: "sp-flex sp-items-center sp-justify-center sp-w-1/4 ",
	children: /* @__PURE__ */ _("div", { className: `sp-text-xl ${e}` })
}), fu = N.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, pu = ({ medias: e }) => {
	let [t, n] = h(!1);
	return /* @__PURE__ */ _("div", {
		className: "sp-flex sp-flex-wrap sp-w-full",
		children: e.map((r, i) => !t && i > 3 ? null : /* @__PURE__ */ _(fu, {
			className: "sp-relative",
			children: /* @__PURE__ */ _(lu, {
				media: r,
				forCarousel: !0,
				hidden: i > 3,
				mediaCount: e.length,
				showOverlay: i === 3 && e.length > 4,
				showAll: t,
				setShowAll: n
			})
		}, `fb-media-key-${i}`))
	});
}, mu = ({ medias: e }) => {
	let t = e.collection, n = t.length;
	return /* @__PURE__ */ v("div", {
		className: "sp-px-4",
		children: [n > 0 && /* @__PURE__ */ _(g, { children: n > 1 ? /* @__PURE__ */ _(pu, {
			medias: t,
			count: n
		}) : /* @__PURE__ */ _(lu, { media: t[0] }) }), /* @__PURE__ */ _("div", {
			className: "sp-flex sp-items-center sp-justify-between",
			children: /* @__PURE__ */ _(uu, {})
		})]
	});
}, hu = ({ post: e }) => {
	let t = e.caption;
	return /* @__PURE__ */ v("div", {
		className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0",
		children: [
			/* @__PURE__ */ _(iu, {
				username: e.username,
				profilePicture: e.profilePicture,
				locationName: e.locationName
			}),
			/* @__PURE__ */ _("div", {
				className: "sp-flex sp-flex-col sp-m-4",
				children: /* @__PURE__ */ v(ru, {
					$variant: "caption",
					className: "sp-whitespace-pre-line sp-break-words",
					children: [/* @__PURE__ */ _(Y, {
						caption: t,
						targetPlatform: "TW"
					}), e.redirectUrl && /* @__PURE__ */ v(g, { children: [" ", /* @__PURE__ */ _("a", {
						className: "sp-text-blue-400 sp-break-words",
						href: e.redirectUrl,
						target: "_blank",
						children: e.redirectUrl
					})] })]
				})
			}),
			e.type === "text" && e.redirectUrl && /* @__PURE__ */ _("div", {
				className: "sp-p-4",
				children: /* @__PURE__ */ _(Ql, { url: e.redirectUrl })
			}),
			/* @__PURE__ */ _(mu, { medias: e.medias })
		]
	});
}, gu = ({ post: e }) => {
	switch (e.type) {
		case "image":
		case "video":
		case "multiMedia":
		case "text": return /* @__PURE__ */ _(hu, { post: e });
		default: return /* @__PURE__ */ _(g, {});
	}
}, _u = N.div`
  font-family: Helvetica;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 14px;\n          line-height: 20px;\n          letter-spacing: 0.01em;\n        ";
		case "subheading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 12px;\n          line-height: 16px;\n          letter-spacing: 0.045em;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 14px;\n          line-height: 20px;\n          letter-spacing: 0.015em;\n          white-space: pre-line;\n        ";
		case "icons": return "\n          font-family: Helvetica Neue;\n          font-style: normal;\n          font-weight: normal;\n          font-size: 14px;\n          line-height: 28px;\n          letter-spacing: 0.035em;\n        ";
	}
}};

  .sked-mention.sked-mention-linkedin {
    color: #0a66c2; // copied from LI home feed - in caption creator they're black but feed are #0a66c2
    cursor: pointer;
    font-weight: bold; // LI mentions are bold

    &:hover {
      text-decoration: underline;
    }
  }
`, vu = ({ username: e, profilePicture: t, locationName: n, small: r }) => /* @__PURE__ */ v("div", {
	className: "sp-flex sp-items-center",
	children: [/* @__PURE__ */ _("div", {
		className: "sp-rounded-full sp-overflow-hidden sp-m-4",
		style: {
			width: "48px",
			height: "48px"
		},
		children: /* @__PURE__ */ _(Ge, {
			src: t,
			alt: e
		})
	}), /* @__PURE__ */ v("div", {
		className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${r ? "sp-text-white" : ""}`,
		children: [/* @__PURE__ */ _(_u, {
			$variant: "heading",
			children: e
		}), n && /* @__PURE__ */ _(_u, {
			$variant: "subheading",
			className: "sp-text-gray-600",
			children: n
		})]
	})]
}), yu = N.div`
  width: auto;
  margin: 0 auto;
  position: relative;
  text-align: left;
  z-index: 999;

  &:after {
    content: "";
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 5px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }
  &:before {
    content: "";
    width: 20px;
    height: 20px;
    transform: rotate(45deg);
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
    background: ${(e) => e.backgroundColor || "var(--white)"};
    position: absolute;
    z-index: 998;
    border-radius: 2px;
  }

  &.arrow-top:before {
    left: calc(50% - 10px);
    top: -4px;
  }
  &.arrow-right:before {
    top: calc(50% - 10px);
    right: -4px;
  }
  &.arrow-bottom:before {
    left: calc(50% - 10px);
    bottom: -4px;
  }
  &.arrow-left:before {
    top: calc(50% - 10px);
    left: -4px;
  }
`, bu = N.div`
  width: ${(e) => e.width || "auto"};
  margin: 0 auto;
  padding: 8px 12px;
  border-radius: 8px;
  background: ${(e) => e.backgroundColor || "var(--white)"};
  color: white;
  position: relative;
  z-index: 998;
  box-sizing: border-box;
  font-family: Helvetica;
  font-size: 12px;
  line-height: 18px;
  font-weight: 600;
`, xu = ({ backgroundColor: e, arrowPosition: t, children: n, width: r, ...i }) => /* @__PURE__ */ _(yu, {
	backgroundColor: e,
	className: `arrow-${t}`,
	children: /* @__PURE__ */ _(bu, {
		backgroundColor: e,
		width: r,
		...i,
		children: n
	})
}), Su = (e) => /* @__PURE__ */ v("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ _("g", {
		clipPath: "url(#clip0_4697_272)",
		children: /* @__PURE__ */ _("path", {
			d: "M7.99967 10.6666V7.99992M7.99967 5.33325H8.00634M14.6663 7.99992C14.6663 11.6818 11.6816 14.6666 7.99967 14.6666C4.31778 14.6666 1.33301 11.6818 1.33301 7.99992C1.33301 4.31802 4.31778 1.33325 7.99967 1.33325C11.6816 1.33325 14.6663 4.31802 14.6663 7.99992Z",
			stroke: "white",
			strokeWidth: 1.33333,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _("defs", { children: /* @__PURE__ */ _("clipPath", {
		id: "clip0_4697_272",
		children: /* @__PURE__ */ _("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
}), Cu = /* @__PURE__ */ A((/* @__PURE__ */ O(((e, t) => {
	(function(n, r) {
		/* istanbul ignore else */
		typeof j == "function" && typeof e == "object" && typeof t == "object" ? t.exports = r() : typeof define == "function" && define.amd ? define(function() {
			return r();
		}) : n.pluralize = r();
	})(e, function() {
		var e = [], t = [], n = {}, r = {}, i = {};
		function a(e) {
			return typeof e == "string" ? RegExp("^" + e + "$", "i") : e;
		}
		function o(e, t) {
			return e === t ? t : e === e.toLowerCase() ? t.toLowerCase() : e === e.toUpperCase() ? t.toUpperCase() : e[0] === e[0].toUpperCase() ? t.charAt(0).toUpperCase() + t.substr(1).toLowerCase() : t.toLowerCase();
		}
		function s(e, t) {
			return e.replace(/\$(\d{1,2})/g, function(e, n) {
				return t[n] || "";
			});
		}
		function c(e, t) {
			return e.replace(t[0], function(n, r) {
				var i = s(t[1], arguments);
				return o(n === "" ? e[r - 1] : n, i);
			});
		}
		function l(e, t, r) {
			if (!e.length || n.hasOwnProperty(e)) return t;
			for (var i = r.length; i--;) {
				var a = r[i];
				if (a[0].test(t)) return c(t, a);
			}
			return t;
		}
		function u(e, t, n) {
			return function(r) {
				var i = r.toLowerCase();
				return t.hasOwnProperty(i) ? o(r, i) : e.hasOwnProperty(i) ? o(r, e[i]) : l(i, r, n);
			};
		}
		function d(e, t, n, r) {
			return function(r) {
				var i = r.toLowerCase();
				return t.hasOwnProperty(i) ? !0 : !e.hasOwnProperty(i) && l(i, i, n) === i;
			};
		}
		function f(e, t, n) {
			var r = t === 1 ? f.singular(e) : f.plural(e);
			return (n ? t + " " : "") + r;
		}
		return f.plural = u(i, r, e), f.isPlural = d(i, r, e), f.singular = u(r, i, t), f.isSingular = d(r, i, t), f.addPluralRule = function(t, n) {
			e.push([a(t), n]);
		}, f.addSingularRule = function(e, n) {
			t.push([a(e), n]);
		}, f.addUncountableRule = function(e) {
			if (typeof e == "string") {
				n[e.toLowerCase()] = !0;
				return;
			}
			f.addPluralRule(e, "$0"), f.addSingularRule(e, "$0");
		}, f.addIrregularRule = function(e, t) {
			t = t.toLowerCase(), e = e.toLowerCase(), i[e] = t, r[t] = e;
		}, [
			["I", "we"],
			["me", "us"],
			["he", "they"],
			["she", "they"],
			["them", "them"],
			["myself", "ourselves"],
			["yourself", "yourselves"],
			["itself", "themselves"],
			["herself", "themselves"],
			["himself", "themselves"],
			["themself", "themselves"],
			["is", "are"],
			["was", "were"],
			["has", "have"],
			["this", "these"],
			["that", "those"],
			["echo", "echoes"],
			["dingo", "dingoes"],
			["volcano", "volcanoes"],
			["tornado", "tornadoes"],
			["torpedo", "torpedoes"],
			["genus", "genera"],
			["viscus", "viscera"],
			["stigma", "stigmata"],
			["stoma", "stomata"],
			["dogma", "dogmata"],
			["lemma", "lemmata"],
			["schema", "schemata"],
			["anathema", "anathemata"],
			["ox", "oxen"],
			["axe", "axes"],
			["die", "dice"],
			["yes", "yeses"],
			["foot", "feet"],
			["eave", "eaves"],
			["goose", "geese"],
			["tooth", "teeth"],
			["quiz", "quizzes"],
			["human", "humans"],
			["proof", "proofs"],
			["carve", "carves"],
			["valve", "valves"],
			["looey", "looies"],
			["thief", "thieves"],
			["groove", "grooves"],
			["pickaxe", "pickaxes"],
			["passerby", "passersby"]
		].forEach(function(e) {
			return f.addIrregularRule(e[0], e[1]);
		}), [
			[/s?$/i, "s"],
			[/[^\u0000-\u007F]$/i, "$0"],
			[/([^aeiou]ese)$/i, "$1"],
			[/(ax|test)is$/i, "$1es"],
			[/(alias|[^aou]us|t[lm]as|gas|ris)$/i, "$1es"],
			[/(e[mn]u)s?$/i, "$1s"],
			[/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, "$1"],
			[/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1i"],
			[/(alumn|alg|vertebr)(?:a|ae)$/i, "$1ae"],
			[/(seraph|cherub)(?:im)?$/i, "$1im"],
			[/(her|at|gr)o$/i, "$1oes"],
			[/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, "$1a"],
			[/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, "$1a"],
			[/sis$/i, "ses"],
			[/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, "$1$2ves"],
			[/([^aeiouy]|qu)y$/i, "$1ies"],
			[/([^ch][ieo][ln])ey$/i, "$1ies"],
			[/(x|ch|ss|sh|zz)$/i, "$1es"],
			[/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, "$1ices"],
			[/\b((?:tit)?m|l)(?:ice|ouse)$/i, "$1ice"],
			[/(pe)(?:rson|ople)$/i, "$1ople"],
			[/(child)(?:ren)?$/i, "$1ren"],
			[/eaux$/i, "$0"],
			[/m[ae]n$/i, "men"],
			["thou", "you"]
		].forEach(function(e) {
			return f.addPluralRule(e[0], e[1]);
		}), [
			[/s$/i, ""],
			[/(ss)$/i, "$1"],
			[/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, "$1fe"],
			[/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, "$1f"],
			[/ies$/i, "y"],
			[/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, "$1ie"],
			[/\b(mon|smil)ies$/i, "$1ey"],
			[/\b((?:tit)?m|l)ice$/i, "$1ouse"],
			[/(seraph|cherub)im$/i, "$1"],
			[/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, "$1"],
			[/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, "$1sis"],
			[/(movie|twelve|abuse|e[mn]u)s$/i, "$1"],
			[/(test)(?:is|es)$/i, "$1is"],
			[/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1us"],
			[/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, "$1um"],
			[/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, "$1on"],
			[/(alumn|alg|vertebr)ae$/i, "$1a"],
			[/(cod|mur|sil|vert|ind)ices$/i, "$1ex"],
			[/(matr|append)ices$/i, "$1ix"],
			[/(pe)(rson|ople)$/i, "$1rson"],
			[/(child)ren$/i, "$1"],
			[/(eau)x?$/i, "$1"],
			[/men$/i, "man"]
		].forEach(function(e) {
			return f.addSingularRule(e[0], e[1]);
		}), [
			"adulthood",
			"advice",
			"agenda",
			"aid",
			"aircraft",
			"alcohol",
			"ammo",
			"analytics",
			"anime",
			"athletics",
			"audio",
			"bison",
			"blood",
			"bream",
			"buffalo",
			"butter",
			"carp",
			"cash",
			"chassis",
			"chess",
			"clothing",
			"cod",
			"commerce",
			"cooperation",
			"corps",
			"debris",
			"diabetes",
			"digestion",
			"elk",
			"energy",
			"equipment",
			"excretion",
			"expertise",
			"firmware",
			"flounder",
			"fun",
			"gallows",
			"garbage",
			"graffiti",
			"hardware",
			"headquarters",
			"health",
			"herpes",
			"highjinks",
			"homework",
			"housework",
			"information",
			"jeans",
			"justice",
			"kudos",
			"labour",
			"literature",
			"machinery",
			"mackerel",
			"mail",
			"media",
			"mews",
			"moose",
			"music",
			"mud",
			"manga",
			"news",
			"only",
			"personnel",
			"pike",
			"plankton",
			"pliers",
			"police",
			"pollution",
			"premises",
			"rain",
			"research",
			"rice",
			"salmon",
			"scissors",
			"series",
			"sewage",
			"shambles",
			"shrimp",
			"software",
			"species",
			"staff",
			"swine",
			"tennis",
			"traffic",
			"transportation",
			"trout",
			"tuna",
			"wealth",
			"welfare",
			"whiting",
			"wildebeest",
			"wildlife",
			"you",
			/pok[eé]mon$/i,
			/[^aeiou]ese$/i,
			/deer$/i,
			/fish$/i,
			/measles$/i,
			/o[iu]s$/i,
			/pox$/i,
			/sheep$/i
		].forEach(f.addUncountableRule), f;
	});
})))(), 1), wu = ({ preferVideoCoverPreviewOverride: e, thumbnailUrl: t, contextVideoCoverPreview: n }) => e && n ? n : t, Tu = N.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, Eu = N.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, Du = ({ src: e, forCarousel: t, showOverlay: n, showAll: r, setShowAll: i, mediaCount: a, url: o }) => t ? /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _(Rl, {
	href: o || e,
	$isFlex: !0,
	children: /* @__PURE__ */ _(Eu, {
		src: e,
		className: ""
	})
}), !r && n && /* @__PURE__ */ v("div", {
	className: "sp-cursor-pointer",
	onClick: () => i(!0),
	children: [/* @__PURE__ */ _("div", {
		className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ",
		children: "\xA0"
	}), /* @__PURE__ */ v("div", {
		className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl",
		children: ["+", a - 4]
	})]
})] }) : /* @__PURE__ */ _(Rl, {
	href: o || e,
	children: /* @__PURE__ */ _(Tu, {
		src: e,
		title: "Click to see the full file in a new window."
	})
}), Ou = ({ url: e, thumbnailUrl: t, isActiveSlide: n, shouldUseVideoCoverPreviewOverride: r, width: i, height: a }) => {
	let [o, s] = h(!1), { videoCoverPreview: c, preferVideoCoverPreviewOverride: l } = u(Ks), { videoCoverPreview: d, showVideoCover: f } = Ys({
		usePostTypeCheck: !1,
		videoCoverPreviewOverride: wu({
			preferVideoCoverPreviewOverride: l && r,
			thumbnailUrl: t,
			contextVideoCoverPreview: c
		})
	}), p = i && a && i > 0 && a > 0 ? `${i} / ${a}` : null;
	if (!n) return null;
	let m = (e) => {
		console.error("Error loading video", e), s(!0);
	};
	return /* @__PURE__ */ v(ju, {
		className: "sp-flex sp-items-center sp-h-full",
		style: p ? { aspectRatio: p } : void 0,
		children: [o && /* @__PURE__ */ _("div", {
			className: "sp-text-xl sp-text-red-500 sp-mx-auto",
			children: "Failed to load this video."
		}), !o && /* @__PURE__ */ _(Ws, {
			src: e,
			controls: !0,
			light: f ? d : void 0,
			playing: !!d,
			onError: (e) => m(e),
			className: "sp-relative react-player",
			width: "100%",
			height: "100%"
		})]
	});
}, ku = ({ media: e, hidden: t = !1, forCarousel: n = !1, showOverlay: r, showAll: i, setShowAll: a, mediaCount: o, isActiveSlide: s = !0, shouldUseVideoCoverPreviewOverride: c = !1 }) => t && i === !1 ? null : /* @__PURE__ */ v(g, { children: [
	(e.isVideo || e.url.includes(".mp4")) && /* @__PURE__ */ _(Ou, {
		url: e.url,
		thumbnailUrl: e.thumbnailUrl,
		isActiveSlide: s,
		shouldUseVideoCoverPreviewOverride: c,
		width: e.width,
		height: e.height
	}),
	!(e.isVideo || e.url.includes(".mp4") || e.url.includes(".pdf")) && /* @__PURE__ */ _(Du, {
		src: e.url,
		forCarousel: n,
		showOverlay: r ?? !1,
		showAll: i ?? !1,
		setShowAll: a,
		mediaCount: o
	}),
	e.url.includes(".pdf") && /* @__PURE__ */ v("div", { children: [
		/* @__PURE__ */ v(Mu, { children: [
			/* @__PURE__ */ _("span", {
				className: "filename",
				title: e.fileName,
				children: e.fileName
			}),
			/* @__PURE__ */ _("span", {
				className: "dot",
				children: "●"
			}),
			/* @__PURE__ */ _("span", {
				className: "pages",
				children: (0, Cu.default)("page", e.pages, !0)
			}),
			/* @__PURE__ */ v(Nu, { children: [/* @__PURE__ */ _(Su, {}), /* @__PURE__ */ _(Pu, {
				id: "tooltip",
				children: /* @__PURE__ */ v(xu, {
					arrowPosition: "bottom",
					backgroundColor: "#1A1A1A",
					width: "250px",
					children: [
						"Previewing Page 1 of ",
						e.pages,
						". The complete document will be posted to LinkedIn."
					]
				})
			})] })
		] }),
		e.thumbnailUrl !== void 0 && /* @__PURE__ */ _(Du, {
			src: e.thumbnailUrl,
			url: e.url,
			forCarousel: !1,
			mediaCount: o,
			showAll: i ?? !1,
			setShowAll: a,
			showOverlay: r ?? !1
		}),
		/* @__PURE__ */ _(Au, { children: /* @__PURE__ */ _("a", {
			href: e.url,
			target: "_blank",
			rel: "noreferrer",
			children: "Click to download and view the full document in a new tab."
		}) })
	] })
] }), Au = N.span`
  background: rgba(0, 0, 0, 0.4);
  padding: 6px 8px;
  a {
    color: #fff;
    text-decoration: none;
  }
  font-family: Inter, Helvetica, Arial, sans-serif;
  font-size: 12px;
  display: flex;
`, ju = N.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  background: #000;

  .react-player {
    width: 100% !important;
    height: 100% !important;
  }

  .react-player > div {
    width: 100% !important;
    height: 100% !important;
  }

  .react-player__preview {
    width: 100%;
    height: 100%;
    background-size: cover !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
  }
`, Mu = N.div`
  background: rgba(0, 0, 0, 0.4);
  padding: 4px 8px;
  color: #fff;
  display: flex;
  align-items: center;

  .filename {
    font-family: Inter, Helvetica, Arial, sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    max-width: 80%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: default;
  }

  .dot {
    padding: 0 4px 0 6px;
    font-size: 6px;
    position: relative;
    top: 1px;
    line-height: 16px;
  }

  .pages {
    font-family: Inter, Helvetica, Arial, sans-serif;
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    white-space: nowrap;
  }

  svg {
    position: relative;
    top: 2px;
    margin-left: 4px;
  }
`, Nu = N.div`
  position: relative;
  display: inline-block;
  line-height: normal;

  svg {
    &:hover + #tooltip {
      display: block;
    }
  }
`, Pu = N.div`
  display: none;
  position: absolute;
  top: -60px;
  left: calc(-250px / 2 + 12px);
`, Fu = N.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, Iu = ({ medias: e }) => {
	let [t, n] = h(!1);
	return /* @__PURE__ */ _("div", {
		className: "sp-flex sp-flex-wrap sp-w-full",
		children: e.map((r, i) => !t && i > 3 ? null : /* @__PURE__ */ _(Fu, {
			className: "sp-relative",
			children: /* @__PURE__ */ _(ku, {
				media: r,
				forCarousel: !0,
				hidden: i > 3,
				mediaCount: e.length,
				shouldUseVideoCoverPreviewOverride: i === 0,
				showOverlay: i === 3 && e.length > 4,
				showAll: t,
				setShowAll: n
			})
		}, `fb-media-key-${i}`))
	});
}, Lu = () => /* @__PURE__ */ v("div", {
	className: "sp-flex sp-w-full sp-items-center sp-justify-center sp-py-4 sp-text-gray-700 sp-font-bold",
	children: [
		/* @__PURE__ */ _(Ru, {
			icon: "icon-linkedin-like",
			text: "Like",
			className: "sp-justify-start sp-ml-2"
		}, "ico-like"),
		/* @__PURE__ */ _(Ru, {
			icon: "icon-linkedin-comment",
			text: "Comment",
			className: "sp-justify-center"
		}, "ico-comment"),
		/* @__PURE__ */ _(Ru, {
			icon: "icon-linkedin-share",
			text: "Share",
			className: "sp-justify-end sp-mr-2"
		}, "ico-share")
	]
}), Ru = ({ icon: e, text: t, className: n = "" }) => /* @__PURE__ */ v(_u, {
	$variant: "icons",
	className: `sp-flex sp-items-center sp-w-1/3 ${n}`,
	children: [/* @__PURE__ */ _("div", { className: `sp-mr-1 sp-text-2xl ${e}` }), /* @__PURE__ */ _("div", {
		className: "sp-text-gray-700 sp-text-xl",
		children: t
	})]
}), zu = ({ medias: e, postType: t }) => {
	let n = e?.collection || [];
	if (t === "document") if (n.length === 0) n.push({});
	else {
		let t = e?.medias?.[0];
		t && (n[0].thumbnailUrl = t.thumbnailUrl, n[0].fileName = t.fileName, n[0].pages = t.meta?.pages, n[0].url = t.url);
	}
	t === "multiMedia" && n.length > 0 && (n = n.filter((e) => !e.url.includes(".pdf")));
	let r = n.length;
	return /* @__PURE__ */ v("div", { children: [r > 0 && /* @__PURE__ */ _(g, { children: r > 1 ? /* @__PURE__ */ _(Iu, { medias: n }) : /* @__PURE__ */ _(ku, {
		media: n[0],
		mediaCount: r,
		shouldUseVideoCoverPreviewOverride: !0,
		setShowAll: () => {},
		forCarousel: !1,
		showAll: !1,
		hidden: !1,
		isActiveSlide: !0,
		showOverlay: !1
	}) }), /* @__PURE__ */ _("div", {
		className: "sp-flex sp-items-center sp-justify-between",
		children: /* @__PURE__ */ _(Lu, {})
	})] });
}, Bu = ({ post: e, trackEvent: t }) => /* @__PURE__ */ v("div", {
	className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0",
	children: [
		/* @__PURE__ */ _(vu, {
			username: e.username,
			profilePicture: e.profilePicture,
			locationName: e.locationName
		}),
		e.caption && /* @__PURE__ */ v(_u, {
			$variant: "caption",
			className: "sp-whitespace-pre-line sp-break-words sp-flex sp-flex-col sp-m-8",
			children: [/* @__PURE__ */ _(Y, {
				caption: e.caption,
				targetPlatform: "LI",
				trackEvent: t
			}), e.redirectUrl && e.type !== "text" && /* @__PURE__ */ v(g, { children: [" ", /* @__PURE__ */ _("a", {
				className: "sp-text-blue-400 sp-break-words",
				href: e.redirectUrl,
				target: "_blank",
				children: e.redirectUrl
			})] })]
		}),
		e.type === "text" && e.redirectUrl && /* @__PURE__ */ _("div", {
			className: "sp-p-4",
			children: /* @__PURE__ */ _(Ql, { url: e.redirectUrl })
		}),
		/* @__PURE__ */ _(zu, {
			medias: e.medias,
			postType: e.type
		}),
		/* @__PURE__ */ _("div", {
			className: "sp-flex sp-flex-col sp-px-4 sp-pb-8",
			children: e.comment && /* @__PURE__ */ v(_u, {
				$variant: "caption",
				className: "sp-whitespace-pre-line sp-break-words",
				children: [/* @__PURE__ */ _("span", {
					className: "sp-font-bold sp-mr-1",
					children: e.username
				}), /* @__PURE__ */ _(Y, {
					caption: e.comment,
					targetPlatform: "LI"
				})]
			})
		})
	]
}), Vu = ({ post: e, trackEvent: t }) => {
	switch (e.type) {
		case "image":
		case "text":
		case "video":
		case "multiMedia":
		case "document": return /* @__PURE__ */ _(Bu, {
			post: e,
			trackEvent: t
		});
		default: return /* @__PURE__ */ _(g, {});
	}
}, Hu = N.span`
  font-family: Roboto, arial, sans-serif;

  ${({ $variant: e }) => {
	if (e === "buttonlabel") return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 14px;\n          line-height: 20px;\n          letter-spacing: 0.015em;\n        ";
}};
`, Uu = N.div`
  font-family: Roboto, arial, sans-serif;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: 0.01em;\n        ";
		case "subheading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 12px;\n          color: rgba(0,0,0,.54);\n          line-height: 16px;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 14px;\n          line-height: 20px;\n          letter-spacing: 0.015em;\n          white-space: pre-line;\n        ";
		case "icons": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 14px;\n          line-height: 28px;\n          letter-spacing: 0.035em;\n        ";
		case "title": return "\n          font-style: normal;\n          font-weight: medium;\n          font-size: 20px;\n          line-height: 28px;\n        ";
		case "subtitle": return "\n          font-weight: normal;\n          font-size: 14px;\n          line-height: 24px;\n        ";
	}
}};
`, Wu = N(Ge)`
  display: inherit;

  img {
    border-radius: 50%;
  }
`, Gu = ({ username: e, profilePicture: t }) => /* @__PURE__ */ v("div", {
	className: "sp-flex sp-items-center sp-pb-4",
	children: [/* @__PURE__ */ v("div", {
		className: "sp-flex sp-mr-1",
		style: {
			width: "38x",
			height: "38px"
		},
		children: [/* @__PURE__ */ _(Wu, {
			src: t,
			alt: e
		}), /* @__PURE__ */ _("div", {
			style: {
				position: "relative",
				top: "25px",
				right: "25%",
				marginLeft: "auto",
				fill: "#1a73e8",
				lineHeight: "18px",
				height: "18px"
			},
			children: /* @__PURE__ */ _("svg", {
				viewBox: "0 0 24 24",
				xmlns: "http://www.w3.org/2000/svg",
				style: { height: "18px" },
				children: /* @__PURE__ */ _("path", {
					stroke: "#fff",
					d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
				})
			})
		})]
	}), /* @__PURE__ */ v("div", {
		className: "sp-flex sp-flex-col sp-justify-center sp-leading-tight ",
		style: {
			width: "auto",
			height: "36px"
		},
		children: [/* @__PURE__ */ _(Uu, {
			$variant: "heading",
			className: "",
			children: e
		}), /* @__PURE__ */ _(Uu, {
			$variant: "subheading",
			className: "",
			children: "a minute ago"
		})]
	})]
}), Ku = N.img`
  object-fit: contain;
  position: relative;
  width: 100%;
  max-height: 290px;
`, qu = ({ src: e }) => /* @__PURE__ */ _(Rl, {
	href: e,
	children: /* @__PURE__ */ _(Ku, { src: e })
}), Ju = ({ url: e }) => /* @__PURE__ */ _("div", {
	className: "sp-flex sp-items-center sp-h-full",
	children: /* @__PURE__ */ _(Ws, {
		src: e,
		playing: !1,
		loop: !0,
		controls: !0,
		className: "sp-w-full",
		width: "100%",
		height: "auto"
	})
}), Yu = ({ media: e }) => {
	let [t, n] = h(0), r = m(null), i = e.length, a = (e) => {
		let t = r.current;
		if (!t) return;
		let a = Math.max(0, Math.min(e, i - 1));
		t.scrollTo({
			left: a * (t.clientWidth / 1.1),
			behavior: "smooth"
		}), n(a);
	};
	return /* @__PURE__ */ v("div", {
		className: "sp-relative",
		children: [
			/* @__PURE__ */ _("div", {
				className: "sp-text-white sp-bg-black sp-rounded-lg sp-p-2 sp-text-xl sp-w-auto sp-text-center",
				style: {
					opacity: .7,
					position: "absolute",
					right: "25px",
					zIndex: 100,
					top: "10px"
				},
				children: /* @__PURE__ */ v(Hu, { children: [
					t + 1,
					" / ",
					i
				] })
			}),
			/* @__PURE__ */ _(Xu, {
				ref: r,
				onScroll: () => {
					let e = r.current;
					if (!e) return;
					let t = e.clientWidth / 1.1;
					n(Math.round(e.scrollLeft / t));
				},
				children: e.map((e, t) => e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ _(Zu, {
					className: "sp-p-2",
					children: /* @__PURE__ */ _(Ju, { url: e.url })
				}, `item-${t}`) : /* @__PURE__ */ _(Zu, { children: /* @__PURE__ */ _(qu, { src: e.url }) }, `item-${t}`))
			}),
			t > 0 && /* @__PURE__ */ _(Qu, {
				type: "button",
				$side: "left",
				"aria-label": "Previous media",
				onClick: () => a(t - 1)
			}),
			t < i - 1 && /* @__PURE__ */ _(Qu, {
				type: "button",
				$side: "right",
				"aria-label": "Next media",
				onClick: () => a(t + 1)
			})
		]
	});
}, Xu = N.div`
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`, Zu = N.div`
  box-sizing: border-box;
  flex: 0 0 calc(100% / 1.1);
  min-width: 0;
  scroll-snap-align: start;

  img {
    object-fit: cover;
    width: 100%;
  }
`, Qu = N.button`
  background: rgb(255 255 255 / 80%);
  border: 0;
  border-radius: ${({ $side: e }) => e === "left" ? "0 10px 10px 0" : "10px 0 0 10px"};
  bottom: 0;
  cursor: pointer;
  height: 20%;
  margin: auto 0;
  min-height: 56px;
  position: absolute;
  ${({ $side: e }) => `${e}: 0;`}
  top: 0;
  width: 40px;
  z-index: 1;

  &::after {
    border-right: 3px solid #aaa;
    border-top: 3px solid #aaa;
    content: "";
    display: inline-block;
    height: 24px;
    transform: rotate(
      ${({ $side: e }) => e === "left" ? "-135deg" : "45deg"}
    );
    width: 24px;
  }
`, $u = ({ media: e }) => e.length === 1 ? e[0].isVideo || e[0].url.includes(".mp4") ? /* @__PURE__ */ _(Ju, { url: e[0].url }) : /* @__PURE__ */ _(qu, { src: e[0].url }) : /* @__PURE__ */ _(Yu, { media: e }), ed = ({ medias: e }) => {
	let t = e.collection, n = t.length;
	if (t && t.length > 0) return /* @__PURE__ */ _("div", {
		className: "sp-h-full sp-py-4",
		children: n && /* @__PURE__ */ _($u, { media: t })
	});
}, td = (e) => {
	switch (e) {
		case "BOOK": return "Book now";
		case "ORDER": return "Order online";
		case "SHOP": return "Buy";
		case "LEARN_MORE": return "Learn more";
		case "SIGN_UP": return "Sign up";
		case "CALL": return "Call now";
		default: return null;
	}
}, nd = ({ post: e }) => {
	let t = null, n = null;
	e.event && e.event.startDate && (t = new b(e.event.startDate), n = new b(e.event.endDate));
	let r = e.caption, i = td(e.callToAction.actionType);
	return /* @__PURE__ */ v("div", {
		className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0 sp-pt-4 sp-pb-6 sp-px-6",
		children: [
			/* @__PURE__ */ _(Gu, {
				username: e.username,
				profilePicture: e.profilePicture
			}),
			e.medias && e.medias.count > 0 && /* @__PURE__ */ _(ed, { medias: e.medias }),
			e.event && e.event.title && /* @__PURE__ */ v(Uu, {
				$variant: "title",
				children: [
					e.event.title,
					" ",
					e.topicType === "OFFER" && /* @__PURE__ */ _("span", {
						style: {
							display: "inline-block",
							height: "20px",
							width: "20px"
						},
						children: /* @__PURE__ */ _("svg", {
							focusable: "false",
							xmlns: "http://www.w3.org/2000/svg",
							viewBox: "0 0 24 24",
							fill: "#f4b400",
							style: { height: "20px" },
							children: /* @__PURE__ */ _("path", { d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z" })
						})
					})
				]
			}),
			t && e.topicType === "EVENT" && /* @__PURE__ */ _(Uu, {
				$variant: "subtitle",
				className: "sp-text-googlegray-500 sp-font-light",
				children: `${b(t).format("MMM D, LT")} -  ${b(n).format("MMM D, LT")}`
			}),
			t && e.topicType === "OFFER" && /* @__PURE__ */ _(Uu, {
				$variant: "subtitle",
				className: "",
				children: `Valid ${b(t).format("MMM D")} -  ${b(n).format("MMM D")}`
			}),
			r && /* @__PURE__ */ _(Uu, {
				$variant: "caption",
				className: `sp-flex sp-flex-col sp-mt-6 sp-pb-6 ${t ? "sp-text-googlegray-500 sp-font-light" : null}`,
				style: { fontSize: t ? "13px" : "" },
				children: /* @__PURE__ */ _(Y, { caption: r })
			}),
			e.topicType === "OFFER" && e.offer && /* @__PURE__ */ v(g, { children: [e.offer.couponCode && /* @__PURE__ */ v("div", {
				className: "sp-flex sp-flex-col sp-items-center sp-justify-center sp-mb-6 sp-bg-googlegray-100 sp-border-dashed sp-border-googlegray-200 sp-p-6",
				children: [
					/* @__PURE__ */ _(Hu, {
						className: "sp-text-googlegray-500 sp-text-xl sp-pb-2",
						children: "Show this code at the shop"
					}),
					/* @__PURE__ */ _(Hu, {
						className: "sp-font-medium sp-text-5xl sp-pb-2",
						children: e.offer.couponCode
					}),
					/* @__PURE__ */ _(Hu, {
						className: "sp-text-lg sp-font-bold",
						children: `Valid ${b(t).format("l, LT")} - ${b(n).format("l, LT")}`
					})
				]
			}), e.offer.redeemOnlineUrl && /* @__PURE__ */ _("a", {
				href: e.offer.redeemOnlineUrl,
				className: "sp-text-blue-700 sp-no-underline sp-text-2xl",
				target: "_blank",
				rel: "noreferrer",
				children: /* @__PURE__ */ _(Hu, { children: "Redeem online" })
			})] }),
			e.callToAction && i && /* @__PURE__ */ _("div", {
				className: "sp-mb-2 sp-pt-4 sp-my-2",
				children: /* @__PURE__ */ _("a", {
					href: e.callToAction.url,
					target: "_blank",
					className: "sp-no-underline sp-inline",
					children: /* @__PURE__ */ _(Hu, {
						$variant: "buttonlabel",
						style: { width: "auto" },
						className: " sp-text-white sp-bg-googleblue-500 sp-py-4 sp-px-6 sp-text-xl sp-no-underline hover:sp-bg-googleblue-600 sp-rounded hover:sp-shadow-lg",
						children: i
					})
				})
			}),
			e.topicType === "OFFER" && e.offer && e.offer.termsConditions && /* @__PURE__ */ _("div", {
				className: "sp-border-googlegray-300 sp-border-solid sp-mt-4 sp-pt-4",
				style: {
					borderWidth: 0,
					borderTopWidth: "1px"
				},
				children: /* @__PURE__ */ _(Hu, {
					className: "sp-text-base sp-text-googlegray-400",
					children: e.offer.termsConditions
				})
			})
		]
	});
}, rd = ({ post: e }) => {
	switch (e.type) {
		case "image":
		case "text":
		case "video":
		case "multiMedia":
		case "gmb": return /* @__PURE__ */ _(nd, { post: e });
		default: return /* @__PURE__ */ _(g, {});
	}
}, id = N.div`
  font-family: Helvetica;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 18px;\n          line-height: 20px;\n          letter-spacing: 0.01em;\n        ";
		case "subheading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 14px;\n          line-height: 16px;\n          letter-spacing: -0.02em;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: 0.005em;\n          white-space: pre-line;\n        ";
		case "icons": return "\n          font-family: Helvetica Neue;\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 18px;\n          letter-spacing: 0.01em;\n        ";
	}
}};
`, ad = ({ username: e, profilePicture: t, small: n, description: r }) => /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ v("div", {
	className: "sp-flex sp-items-center",
	children: [/* @__PURE__ */ _("div", {
		className: "sp-rounded-full sp-overflow-hidden  sp-m-4",
		style: {
			width: "40px",
			height: "40px",
			minWidth: "40px",
			minHeight: "40px"
		},
		children: /* @__PURE__ */ _(Ge, {
			src: t,
			alt: e
		})
	}), /* @__PURE__ */ _("div", {
		className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${n ? "sp-text-white" : ""}`,
		children: /* @__PURE__ */ _("div", {
			className: "",
			children: /* @__PURE__ */ _(id, {
				$variant: "subheading",
				className: "sp-mb-1",
				children: e
			})
		})
	})]
}), /* @__PURE__ */ _("div", {
	className: "sp-ml-8 sp-mr-4",
	style: { paddingLeft: "40px" },
	children: /* @__PURE__ */ _(id, {
		$variant: "caption",
		className: "sp-mb-1",
		children: /* @__PURE__ */ _(Y, { caption: r })
	})
})] }), od = ({ url: e, isActiveSlide: t }) => t ? /* @__PURE__ */ _("div", {
	className: "sp-bg-black sp-relative",
	style: {},
	children: /* @__PURE__ */ _(Ws, {
		src: e,
		controls: !0,
		playing: !1,
		width: "100%",
		height: "auto",
		className: ""
	})
}) : null, sd = ({ media: e, hidden: t = !1, forCarousel: n = !1, showAll: r, isActiveSlide: i = !0 }) => t && r === !1 ? null : /* @__PURE__ */ _(g, { children: (e.isVideo || e.url.includes(".mp4")) && /* @__PURE__ */ _(od, {
	url: e.url,
	forCarousel: n,
	isActiveSlide: i
}) }), cd = N.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, ld = ({ medias: e }) => {
	let [t, n] = h(!1);
	return /* @__PURE__ */ _("div", {
		className: "sp-flex sp-flex-wrap sp-w-full",
		children: e.map((r, i) => !t && i > 3 ? null : /* @__PURE__ */ _(cd, {
			className: "sp-relative",
			children: /* @__PURE__ */ _(sd, {
				media: r,
				forCarousel: !0,
				hidden: i > 3,
				mediaCount: e.length,
				showOverlay: i === 3 && e.length > 4,
				showAll: t,
				setShowAll: n
			})
		}, `fb-media-key-${i}`))
	});
}, ud = ({ medias: e }) => {
	let t = e.collection, n = t.length;
	return /* @__PURE__ */ _("div", { children: n > 0 && /* @__PURE__ */ _(g, { children: n > 1 ? /* @__PURE__ */ _(ld, {
		medias: t,
		count: n
	}) : /* @__PURE__ */ _(sd, { media: t[0] }) }) });
}, dd = ({ post: e }) => {
	let t = e.ytTitle;
	return /* @__PURE__ */ v("div", {
		className: "sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0 sp-pb-4",
		children: [
			/* @__PURE__ */ _(ud, { medias: e.medias }),
			/* @__PURE__ */ v("div", {
				className: "sp-mt-2 sp-mb-2 sp-flex sp-flex-col sp-border-0 sp-border-b sp-border-solid sp-border-gray-300",
				children: [/* @__PURE__ */ _("div", {
					className: "sp-mt-4 sp-mb-6 sp-m-2",
					children: /* @__PURE__ */ _(id, {
						$variant: "heading",
						className: "sp-whitespace-pre-line sp-break-words",
						children: t
					})
				}), /* @__PURE__ */ _("div", {})]
			}),
			/* @__PURE__ */ _(ad, {
				username: e.username,
				profilePicture: e.profilePicture,
				locationName: e.locationName,
				description: e.caption
			})
		]
	});
}, fd = ({ post: e }) => {
	switch (e.type) {
		case "video": return /* @__PURE__ */ _(dd, { post: e });
		default: return /* @__PURE__ */ _(g, {});
	}
}, pd = N.div`
  font-family: "Helvetica", sans-serif;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 20px;\n          text-decoration: none !important;\n          color: inherit !important;\n        ";
		case "subheading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 10px;\n          line-height: 16px;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 10px;\n          line-height: 15px;\n          white-space: pre-line;\n        ";
		case "icons": return "\n          font-family: Helvetica Neue;\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 18px;\n          letter-spacing: 0.01em;\n        ";
	}
}};
`, md = N.span`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 18px;\n          line-height: 20px;\n        ";
		case "bold": return "\n          font-style: normal;\n          font-weight: bold;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 12px;\n          line-height: 13px;\n          letter-spacing: 0.005em;\n          white-space: pre-line;\n        ";
		case "icons": return "\n          font-family: Helvetica Neue;\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 18px;\n          letter-spacing: 0.01em;\n        ";
	}
}};
`, hd = ({ username: e, boardTitle: t, boardSectionTitle: n, profilePicture: r, small: i, description: a, url: o, title: s }) => {
	let c = null;
	if (o) try {
		let { hostname: e } = new URL(o);
		c = e;
	} catch {}
	return /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ v("div", {
		className: "sp-p-2 sp-px-4",
		children: [
			o && c && /* @__PURE__ */ _("div", {
				className: "sp-pb-2",
				children: /* @__PURE__ */ v(pd, {
					$variant: "caption",
					children: [
						"Article from",
						" ",
						/* @__PURE__ */ _("a", {
							href: o,
							target: "_blank",
							style: {
								color: "inherit",
								textDecoration: "none"
							},
							rel: "noreferrer",
							children: /* @__PURE__ */ _(md, {
								$variant: "bold",
								children: c
							})
						})
					]
				})
			}),
			s && /* @__PURE__ */ _("div", {
				className: "sp-pb-2",
				children: /* @__PURE__ */ _(gd, {
					url: o,
					children: /* @__PURE__ */ _(pd, {
						$variant: "heading",
						children: s
					})
				})
			}),
			a && /* @__PURE__ */ _(pd, {
				$variant: "caption",
				children: /* @__PURE__ */ _(Y, {
					caption: a,
					targetPlatform: "PI"
				})
			})
		]
	}), /* @__PURE__ */ v("div", {
		className: "sp-flex sp-items-center sp-px-4",
		children: [/* @__PURE__ */ _("div", {
			className: "sp-rounded-full sp-overflow-hidden  sp-mr-2",
			style: {
				width: "40px",
				height: "40px",
				minWidth: "40px",
				minHeight: "40px"
			},
			children: /* @__PURE__ */ _(Ge, {
				src: r,
				alt: e
			})
		}), /* @__PURE__ */ _("div", {
			className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${i ? "sp-text-white" : ""}`,
			children: /* @__PURE__ */ v("div", {
				className: "",
				children: [
					/* @__PURE__ */ v(md, {
						$variant: "bold",
						className: "sp-mb-1",
						children: [e, " "]
					}),
					/* @__PURE__ */ _(md, { children: "saved to " }),
					n && /* @__PURE__ */ v(g, { children: [
						/* @__PURE__ */ _(md, {
							$variant: "bold",
							className: "sp-mb-1",
							children: n
						}),
						" ",
						"in "
					] }),
					/* @__PURE__ */ _(md, {
						$variant: "bold",
						className: "sp-mb-1",
						children: t
					})
				]
			})
		})]
	})] });
}, gd = ({ url: e, children: t }) => e ? /* @__PURE__ */ _("a", {
	href: e,
	target: "_blank",
	style: {
		color: "inherit",
		textDecoration: "none"
	},
	rel: "noreferrer",
	children: t
}) : /* @__PURE__ */ _("div", { children: t }), _d = N.img`
  object-fit: cover;
  position: relative;
  width: 100%;
  border-radius: 20px;
`, vd = ({ src: e }) => /* @__PURE__ */ _(_d, { src: e }), yd = ({ url: e, isActiveSlide: t }) => t ? /* @__PURE__ */ _("div", {
	className: "sp-bg-black sp-relative",
	style: { borderRadius: "10px" },
	children: /* @__PURE__ */ _(Ws, {
		src: e,
		controls: !0,
		playing: !1,
		width: "100%",
		height: "auto",
		className: ""
	})
}) : null, bd = ({ media: e, hidden: t = !1, forCarousel: n = !1, showAll: r, isActiveSlide: i = !0 }) => t && r === !1 ? null : e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ _(yd, {
	url: e.url,
	forCarousel: n,
	isActiveSlide: i
}) : /* @__PURE__ */ _(vd, { src: e.url }), xd = ({ medias: e }) => {
	let t = e.collection, n = t.length;
	return /* @__PURE__ */ _(Sd, { children: n > 0 && /* @__PURE__ */ _(bd, { media: t[0] }) });
}, Sd = N.div`
  border-radius: 20px;
  overflow: hidden;
`, Cd = ({ url: e, children: t }) => e ? /* @__PURE__ */ _("a", {
	href: e,
	target: "_blank",
	style: {
		color: "inherit",
		textDecoration: "none"
	},
	rel: "noreferrer",
	children: t
}) : /* @__PURE__ */ _("div", { children: t }), wd = ({ post: e }) => /* @__PURE__ */ v(Td, {
	className: "sp-bg-white md:sp-shadow-around sp-pb-4",
	style: {
		borderTopLeftRadius: "20px",
		borderTopRightRadius: "20px"
	},
	children: [/* @__PURE__ */ _("div", {
		className: "sp-pb-2",
		children: /* @__PURE__ */ _(Cd, {
			url: e.redirectUrl,
			children: /* @__PURE__ */ _(xd, { medias: e.medias })
		})
	}), /* @__PURE__ */ _(hd, {
		username: e.username,
		small: !1,
		profilePicture: e.profilePicture,
		description: e.caption,
		title: e.piTitle,
		boardTitle: e.boardTitle,
		boardSectionTitle: e.boardSectionTitle,
		url: e.redirectUrl
	})]
}), Td = N.div`
  padding: 35px 28px 28px;
`, Ed = ({ post: e }) => {
	switch (e.type) {
		case "video":
		case "image":
		case "multiMedia":
		case "text":
		case "story": return /* @__PURE__ */ _(wd, { post: e });
		default: return /* @__PURE__ */ _(g, {});
	}
}, Dd = N.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`, Od = N.img`
  display: block;
  object-fit: cover;
  position: relative;
  width: 100%;
`, kd = ({ src: e }) => /* @__PURE__ */ _(Od, { src: e }), Ad = ({ url: e, isActiveSlide: t }) => t ? /* @__PURE__ */ _("div", {
	className: "sp-relative",
	children: /* @__PURE__ */ _(Ws, {
		controls: !0,
		src: e,
		playing: !1,
		width: "100%",
		height: "auto",
		style: {
			display: "grid",
			placeContent: "center",
			minHeight: "600px",
			background: "grey"
		}
	})
}) : null, jd = ({ media: e, hidden: t = !1, showAll: n, isActiveSlide: r = !0 }) => t && n === !1 ? null : e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ _(Ad, {
	url: e.url,
	isActiveSlide: r
}) : /* @__PURE__ */ _(Dd, { children: /* @__PURE__ */ _(kd, { src: e.url }) }), Md = ({ medias: e }) => {
	let t = e.collection, n = t.length;
	return /* @__PURE__ */ _(Nd, { children: n > 0 && /* @__PURE__ */ _(jd, { media: t[0] }) });
}, Nd = N.div`
  overflow: hidden;
  border-radius: 15px;
  max-height: 867px;
  height: calc(100vh - 280px);
  background: grey;
`, Pd = N.p`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.015em;
  margin: 0;
  color: white;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
`, Fd = (e) => /* @__PURE__ */ v("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "10 6 14 14",
	...e,
	children: [/* @__PURE__ */ _("g", {
		filter: "url(#filter0_d_0_89)",
		children: /* @__PURE__ */ _("path", {
			d: "M23.6165 19.615C23.3689 19.8635 23.04 20 22.6891 20C22.3391 20 22.0093 19.8635 21.7617 19.615L19.4195 17.2735C18.4363 17.9069 17.2914 18.2435 16.1219 18.243C14.9112 18.2432 13.7277 17.8843 12.721 17.2118C11.7143 16.5392 10.9296 15.5832 10.4662 14.4647C10.0028 13.3462 9.88143 12.1153 10.1175 10.9278C10.3536 9.74027 10.9365 8.64946 11.7925 7.79325C12.6485 6.93706 13.7392 6.35396 14.9265 6.11769C16.1139 5.88142 17.3447 6.00259 18.4632 6.46589C19.5817 6.92919 20.5378 7.71379 21.2104 8.72049C21.883 9.72718 22.242 10.9107 22.242 12.1215C22.2426 13.2902 21.907 14.4344 21.2752 15.4176L23.6165 17.76C23.8621 18.0062 24 18.3398 24 18.6875C24 19.0352 23.8621 19.3688 23.6165 19.615ZM16.1219 8.625C15.6628 8.625 15.2081 8.71545 14.7839 8.89116C14.3598 9.06687 13.9743 9.32442 13.6497 9.6491C13.325 9.97378 13.0675 10.3592 12.8918 10.7834C12.7161 11.2077 12.6257 11.6623 12.6257 12.1215C12.6257 12.5807 12.7161 13.0353 12.8918 13.4595C13.0675 13.8838 13.325 14.2692 13.6497 14.5939C13.9743 14.9186 14.3598 15.1761 14.7839 15.3519C15.2081 15.5276 15.6628 15.618 16.1219 15.618C17.0493 15.618 17.9387 15.2496 18.5944 14.5938C19.2502 13.938 19.6186 13.0485 19.6186 12.1211C19.6186 11.1936 19.2502 10.3042 18.5944 9.64836C17.9387 8.99256 17.0493 8.62412 16.1219 8.62412V8.625Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _("defs", { children: /* @__PURE__ */ v("filter", {
		id: "filter0_d_0_89",
		x: 0,
		y: 0,
		width: 34,
		height: 34,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _("feOffset", { dy: 4 }),
			/* @__PURE__ */ _("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ _("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_89"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_89",
				result: "shape"
			})
		]
	}) })]
}), Id = (e) => /* @__PURE__ */ _("svg", {
	width: 16,
	height: 13,
	viewBox: "0 0 16 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ _("path", {
		d: "M14.0463 1.18364C13.2625 0.399877 12.2228 0 11.1831 0C10.1435 0 9.11978 0.399877 8.32003 1.18364L7.64823 1.85543L6.97644 1.18364C6.19268 0.399877 5.153 0 4.11332 0C2.46583 0 0.834332 0.991695 0.178533 2.95909C-0.253334 4.28668 0.114553 5.75823 1.10625 6.74992L7.15239 12.7961C7.4243 13.068 7.84018 13.068 8.11209 12.7961L14.0143 6.89388C15.6298 5.32636 15.6298 2.75115 14.0463 1.18364Z",
		fill: "white"
	})
}), Ld = (e) => /* @__PURE__ */ _("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ _("path", {
		d: "M1.68328 11.6584C0.823728 12.0881 -0.0881374 11.1763 0.34164 10.3167L1.5049 7.99021C2.12365 6.7527 2.05895 5.2833 1.33382 4.10496L0.201123 2.26433C-0.314794 1.42596 0.56357 0.425049 1.46184 0.827721L11.0744 5.13679C11.8442 5.48188 11.8671 6.56645 11.1125 6.94373L1.68328 11.6584Z",
		fill: "white"
	})
}), Rd = (e) => /* @__PURE__ */ v("svg", {
	width: 16,
	height: 4,
	viewBox: "0 0 16 4",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ _("circle", {
			cx: 2,
			cy: 2,
			r: 2,
			fill: "white"
		}),
		/* @__PURE__ */ _("circle", {
			cx: 8,
			cy: 2,
			r: 2,
			fill: "white"
		}),
		/* @__PURE__ */ _("circle", {
			cx: 14,
			cy: 2,
			r: 2,
			fill: "white"
		})
	]
}), zd = (e) => /* @__PURE__ */ v("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "10 6 14 8",
	...e,
	children: [/* @__PURE__ */ v("g", {
		filter: "url(#filter0_d_0_103)",
		children: [/* @__PURE__ */ _("path", {
			d: "M21 7C20.7545 7 20.5556 7.19899 20.5556 7.44444V9.55555H18.4444C18.199 9.55555 18 9.75453 18 10C18 10.2455 18.199 10.4444 18.4444 10.4444H20.5556V12.5556C20.5556 12.801 20.7545 13 21 13C21.2455 13 21.4444 12.801 21.4444 12.5556V10.4444H23.5555C23.801 10.4444 24 10.2455 24 10C24 9.75453 23.801 9.55555 23.5555 9.55555H21.4444V7.44444C21.4444 7.19899 21.2455 7 21 7Z",
			fill: "white"
		}), /* @__PURE__ */ _("path", {
			d: "M10.8872 14C11.0037 14.0002 11.1191 13.9808 11.2267 13.9429C11.3343 13.9051 11.432 13.8495 11.5141 13.7794L13.5 12.0955L15.4782 13.7729C15.6019 13.8802 15.7606 13.9537 15.9339 13.984C16.1072 14.0143 16.2872 13.9999 16.4508 13.9427C16.6144 13.8856 16.7541 13.7883 16.852 13.6633C16.9498 13.5383 17.0014 13.3913 17 13.2413V7.16129C17 6.8533 16.8557 6.55792 16.5988 6.34013C16.342 6.12235 15.9936 6 15.6304 6H11.3696C11.0063 6 10.658 6.12235 10.4011 6.34013C10.1443 6.55792 10 6.8533 10 7.16129V13.2477C10.0004 13.4471 10.094 13.6383 10.2603 13.7793C10.4266 13.9203 10.652 13.9997 10.8872 14ZM10.913 7.16129C10.913 7.05863 10.9611 6.96017 11.0468 6.88757C11.1324 6.81498 11.2485 6.77419 11.3696 6.77419H15.6304C15.7515 6.77419 15.8676 6.81498 15.9532 6.88757C16.0388 6.96017 16.0869 7.05863 16.0869 7.16129V13.1948L13.5 11.0013L10.913 13.1948V7.16129Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _("defs", { children: /* @__PURE__ */ v("filter", {
		id: "filter0_d_0_103",
		x: 0,
		y: 0,
		width: 34,
		height: 28,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _("feOffset", { dy: 4 }),
			/* @__PURE__ */ _("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ _("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_103"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_103",
				result: "shape"
			})
		]
	}) })]
}), Bd = N.div`
  box-shadow: 0px 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
`, Vd = N(Pd)`
  position: absolute;
  top: 17px;
  z-index: 2;
  display: flex;
  align-items: center;

  span {
    font-weight: bold;
    font-size: 16px;
  }

  svg {
    position: relative;
    left: -50%;
    width: 14px;
  }
`, Hd = N.div`
  position: absolute;
  right: 7px;
  bottom: 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  svg {
    width: 15px;
  }
`, Ud = N.div`
  width: 32px;
  display: grid;
  place-content: center;
  height: 32px;
`, Wd = N.div`
  width: 32px;
  height: 32px;
  opacity: 0.2;
  border-radius: 50%;
  box-shadow: 0px 4px 10px 0px #00000026;
  background: white;
  position: absolute;
`, Gd = N.div`
  background: url(${(e) => e.$profilePicture}) no-repeat center center;
  background-size: cover;
  width: 22px;
  height: 22px;
  border-radius: 50%;
`, Kd = N.div`
  position: absolute;
  z-index: 2;
  padding: 7px;
  display: flex;
  align-items: center;
  height: 22px;
  gap: 4px;
  bottom: 45px;

  p {
    text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
  }

  .bookmarkIconWrap {
    position: relative;
    top: -2px;
    left: 4px;
    height: 8px;

    svg {
      height: 8px;
    }
  }
`, qd = ({ url: e, children: t }) => e ? /* @__PURE__ */ _("a", {
	href: e,
	target: "_blank",
	style: {
		color: "inherit",
		textDecoration: "none"
	},
	rel: "noreferrer",
	children: t
}) : /* @__PURE__ */ _("div", { children: t }), Jd = ({ medias: e, profilePicture: t, username: n }) => /* @__PURE__ */ v("div", {
	className: "sp-relative",
	children: [
		/* @__PURE__ */ _("div", {
			className: "sp-flex sp-justify-center",
			children: /* @__PURE__ */ v(Vd, { children: [/* @__PURE__ */ _(Fd, {}), /* @__PURE__ */ _("span", { children: "Spotlight You" })] })
		}),
		/* @__PURE__ */ _(Md, { medias: e }),
		/* @__PURE__ */ v(Hd, { children: [
			/* @__PURE__ */ v(Ud, { children: [/* @__PURE__ */ _(Wd, {}), /* @__PURE__ */ _(Id, {})] }),
			/* @__PURE__ */ v(Ud, { children: [/* @__PURE__ */ _(Wd, {}), /* @__PURE__ */ _(Ld, {})] }),
			/* @__PURE__ */ v(Ud, { children: [/* @__PURE__ */ _(Wd, {}), /* @__PURE__ */ _(Rd, {})] })
		] }),
		/* @__PURE__ */ v(Kd, { children: [
			/* @__PURE__ */ _(Gd, { $profilePicture: t }),
			/* @__PURE__ */ v(Pd, {
				className: "sp-font-bold sp-mb-2",
				children: ["@", n]
			}),
			/* @__PURE__ */ _("div", {
				className: "bookmarkIconWrap",
				children: /* @__PURE__ */ _(zd, {})
			})
		] })
	]
}), Yd = ({ post: e }) => /* @__PURE__ */ _(Bd, { children: /* @__PURE__ */ _(qd, {
	url: e.redirectUrl,
	children: /* @__PURE__ */ _(Jd, {
		medias: e.medias,
		username: e.username,
		profilePicture: e.profilePicture
	})
}) }), Xd = ({ post: e }) => {
	switch (e.type) {
		case "video":
		case "image":
		case "multiMedia":
		case "text":
		case "story": return /* @__PURE__ */ _(Yd, { post: e });
		default: return /* @__PURE__ */ _(g, {});
	}
}, Zd = N.img`
  display: block;
  object-fit: contain;
  position: relative;
  width: 100%;
`, Qd = ({ url: e, isActiveSlide: t, videoCoverPreview: n }) => {
	let [r, i] = h(!1), [a, o] = h(!1), [s, c] = h(0);
	return d(() => {
		n && (i(!1), o(!1), c((e) => e + 1));
	}, [n]), t ? /* @__PURE__ */ v($d, {
		className: "sp-relative",
		style: {
			minHeight: "500px",
			width: "100%"
		},
		children: [!r && a && /* @__PURE__ */ _(ef, { children: /* @__PURE__ */ _(Xs, { onClick: () => {
			i(!1), o(!1), c((e) => e + 1);
		} }) }), /* @__PURE__ */ _(Ws, {
			playing: !!n,
			onPlay: () => {
				i(!0), o(!0);
			},
			onPause: () => i(!1),
			controls: !0,
			light: n,
			src: e,
			width: "100%",
			height: "auto",
			style: {
				display: n ? "flex" : "grid",
				placeContent: "center",
				minHeight: "500px",
				background: "black"
			}
		}, s)]
	}) : null;
}, $d = N.div`
  min-height: 500px;
  width: 100%;

  .react-player__preview {
    height: calc(-280px + 100vh) !important;
    background-color: black !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
    background-size: contain !important;
  }
`, ef = N.div`
  position: absolute;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.2);
  box-shadow:
    0px 4px 8px -2px rgba(16, 24, 40, 0.1),
    0px 2px 4px -2px rgba(16, 24, 40, 0.06);
  width: 56px;
  height: 56px;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  left: 50%;
  margin-left: -28px;
  margin-top: -28px;
  cursor: pointer;
  z-index: 99;
`, tf = ({ media: e, hidden: t = !1, showAll: n, isActiveSlide: r = !0, videoCoverPreview: i }) => t && n === !1 ? null : e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ _(Qd, {
	url: e.url,
	isActiveSlide: r,
	videoCoverPreview: i
}) : /* @__PURE__ */ _(Zd, { src: e.url }), nf = ({ current: e, ...t }) => /* @__PURE__ */ _("div", {
	style: { backgroundColor: `${e ? "#FFFFFF" : "#C4C4C4"}` },
	className: "\n    sp-rounded-full\n    sp-w-8px\n    sp-h-8px\n    sp-mx-1\n    sp-transition-all\n    sp-transition-duration-200\n    ease-in-out\n    sp-cursor-pointer\n    ",
	...t
}), rf = ({ count: e, current: t, titleCaptionHeight: n, onChange: r, isMultipleLinesDetected: i }) => /* @__PURE__ */ _("div", {
	className: "sp-absolute",
	style: {
		bottom: n - 3,
		left: 0,
		right: 0,
		backgroundColor: i ? "black" : void 0,
		height: 40
	},
	children: /* @__PURE__ */ _("div", {
		className: "sp-flex sp-items-center sp-justify-center sp-z-50 sp-py-4 sp-absolute",
		style: {
			left: "50%",
			transform: "translateX(-50%)",
			bottom: 0
		},
		id: "dottt",
		children: [...Array(e)].map((e, n) => /* @__PURE__ */ _(nf, {
			current: n + 1 === t,
			onClick: () => {
				r(n + 1);
			}
		}, n))
	})
}), af = ({ medias: e, count: t, titleCaptionHeight: n, isMultipleLinesDetected: r }) => {
	let [i, a] = h(1);
	return d(() => {
		i > e.length && a(e.length);
	}, [e.length]), /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _("div", {
		className: "sp-w-full sp-relative",
		style: { transform: r ? `translateY(-${(n + (t > 1 ? 35 : 10)) / 2}px)` : void 0 },
		children: /* @__PURE__ */ _(tf, { media: e[i - 1] })
	}), t > 1 && /* @__PURE__ */ _(rf, {
		count: t,
		current: i,
		titleCaptionHeight: n,
		onChange: (e) => a(e),
		isMultipleLinesDetected: r
	})] });
}, of = ({ medias: e, videoCoverPreview: t, postType: n, titleCaptionHeight: r, isMultipleLinesDetected: i }) => {
	let a = e.collection, o = a.length;
	return n === "multiMedia" || n?.toLowerCase() === "image" ? /* @__PURE__ */ _(sf, { children: /* @__PURE__ */ _(af, {
		medias: a,
		count: o,
		isMultipleLinesDetected: i,
		titleCaptionHeight: r
	}) }) : /* @__PURE__ */ _(sf, { children: o > 0 && /* @__PURE__ */ _(tf, {
		videoCoverPreview: t,
		media: a[0]
	}) });
}, sf = N.div`
  overflow: hidden;
  border-radius: 15px;
  align-items: center;
  overflow: hidden;
  border-radius: 15px;
  max-height: 867px;
  height: calc(100vh - 280px);
  background: black;
  display: flex;
  overflow: hidden;
`, cf = N.p`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.015em;
  margin: 0;
  color: white;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
`, lf = (e) => /* @__PURE__ */ v("svg", {
	width: 52,
	height: 49,
	viewBox: "0 0 52 49",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ _("g", {
		filter: "url(#filter0_d_0_24)",
		children: /* @__PURE__ */ _("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.1429 6C23.7143 6 26 9.01299 26 9.01299C26 9.01299 28.2857 6 32.8571 6C38.1905 6 42 10.1428 42 15.4156C42 21.4416 37.0188 26.8133 32.4762 30.8571C29.6716 33.3537 27.5238 35 26 35C24.4762 35 22.2674 33.3412 19.5238 30.8571C15.0583 26.814 10 21.4416 10 15.4156C10 10.1428 13.8095 6 19.1429 6Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _("defs", { children: /* @__PURE__ */ v("filter", {
		id: "filter0_d_0_24",
		x: 0,
		y: 0,
		width: 52,
		height: 49,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _("feOffset", { dy: 4 }),
			/* @__PURE__ */ _("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ _("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_24"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_24",
				result: "shape"
			})
		]
	}) })]
}), uf = (e) => /* @__PURE__ */ v("svg", {
	width: 51,
	height: 50,
	viewBox: "0 0 51 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ _("g", {
		opacity: .9,
		filter: "url(#filter0_d_0_25)",
		children: /* @__PURE__ */ _("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M36.1286 29.6848C39.2029 26.6131 41 23.4136 41 19.6882C41 12.1283 34.0609 6 25.5 6C16.9391 6 10 12.1283 10 19.6884C10 27.2485 17.1636 32.4385 25.7246 32.4385V34.9456C25.7246 35.74 26.5504 36.2512 27.2507 35.8726C29.4385 34.6901 33.4926 32.3184 36.1286 29.6848ZM17.9706 17.8423C19.1941 17.8423 20.1859 18.8244 20.1859 20.0341C20.1859 21.2463 19.1941 22.2284 17.9706 22.2284C16.7492 22.2284 15.7573 21.2463 15.7573 20.0341C15.7573 18.8244 16.7492 17.8423 17.9706 17.8423ZM27.7144 20.0341C27.7144 18.8244 26.7229 17.8423 25.5 17.8423C24.2772 17.8423 23.2858 18.8244 23.2858 20.0341C23.2858 21.2463 24.2773 22.2284 25.5 22.2284C26.7229 22.2284 27.7144 21.2463 27.7144 20.0341ZM33.0291 17.8423C34.2524 17.8423 35.2428 18.8244 35.2428 20.0341C35.2428 21.2463 34.2524 22.2284 33.0291 22.2284C31.8058 22.2284 30.814 21.2463 30.8142 20.0341C30.8142 18.8244 31.8058 17.8423 33.0291 17.8423Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _("defs", { children: /* @__PURE__ */ v("filter", {
		id: "filter0_d_0_25",
		x: 0,
		y: 0,
		width: 51,
		height: 50,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _("feOffset", { dy: 4 }),
			/* @__PURE__ */ _("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ _("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_25"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_25",
				result: "shape"
			})
		]
	}) })]
}), df = (e) => /* @__PURE__ */ v("svg", {
	width: 51,
	height: 44,
	viewBox: "0 0 51 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ _("g", {
		opacity: .9,
		filter: "url(#filter0_d_0_23)",
		children: /* @__PURE__ */ _("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M27.2228 7.13786C27.2228 6.13946 28.4318 5.62698 29.1629 6.31551L40.2873 16.7934C41.2662 17.7155 41.2321 19.2704 40.2135 20.1494L29.1259 29.7178C28.3833 30.3588 27.2228 29.8372 27.2228 28.8623V24.5263C27.2228 24.5263 15.318 22.4052 11.4993 29.3377C11.1432 29.984 9.75548 30.2101 10.0376 26.9853C11.2172 21.05 13.628 11.7838 27.2228 11.7838V7.13786Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _("defs", { children: /* @__PURE__ */ v("filter", {
		id: "filter0_d_0_23",
		x: 0,
		y: 0,
		width: 51,
		height: 44,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _("feOffset", { dy: 4 }),
			/* @__PURE__ */ _("feGaussianBlur", { stdDeviation: 5 }),
			/* @__PURE__ */ _("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_0_23"
			}),
			/* @__PURE__ */ _("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_0_23",
				result: "shape"
			})
		]
	}) })]
}), ff = (e) => /* @__PURE__ */ _("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ _("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12.1249 1.87579C12.1249 1.63512 11.9014 1.45676 11.6668 1.51012L5.6712 2.87348C5.5005 2.91229 5.37934 3.06409 5.37934 3.23914V12.0902H5.37897C5.3889 12.9029 4.5507 13.7484 3.35438 14.0689C2.01898 14.4267 0.743054 13.9951 0.504513 13.1048C0.265968 12.2146 1.15513 11.2028 2.49052 10.845C2.97713 10.7146 3.45585 10.6891 3.87934 10.7523V3.23914C3.87934 2.36382 4.48504 1.60493 5.33861 1.41083L11.3342 0.0474661C12.5075 -0.219354 13.6249 0.672475 13.6249 1.87579V10.2609C13.6564 11.0828 12.8123 11.9454 11.6011 12.2699C10.2657 12.6277 8.98976 12.1961 8.75123 11.3058C8.51269 10.4156 9.40185 9.4038 10.7372 9.04598C11.2234 8.91574 11.7017 8.89009 12.1249 8.95313V1.87579Z",
		fill: "white"
	})
}), pf = (e) => /* @__PURE__ */ v("svg", {
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ _("path", {
			d: "M27.4365 8.78874L27.2831 7.33075C27.1539 6.10359 26.1191 5.172 24.8852 5.172H5.11487C3.88093 5.172 2.84612 6.1036 2.71695 7.33075L2.56348 8.78874",
			stroke: "white",
			strokeWidth: 2.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _("path", {
			d: "M11.25 1L15.625 5.375",
			stroke: "white",
			strokeWidth: 1.875,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _("path", {
			d: "M19.375 1L15 5.375",
			stroke: "white",
			strokeWidth: 1.875,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _("path", {
			d: "M2.5 23.8585L2.71692 25.9193C2.8461 27.1465 3.88091 28.0781 5.11484 28.0781H24.8851C26.1191 28.0781 27.1539 27.1465 27.283 25.9193L27.5 23.8585",
			stroke: "white",
			strokeWidth: 2.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _("path", {
			d: "M1.28897 21.25V11.6692H3.3146V19.5799H7.42201V21.25H1.28897ZM10.7891 11.6692V21.25H8.76346V11.6692H10.7891ZM14.1866 11.6692L16.5023 18.9484H16.5912L18.9115 11.6692H21.157L17.8542 21.25H15.2438L11.9364 11.6692H14.1866ZM22.3102 21.25V11.6692H28.766V13.3393H24.3358V15.6222H28.4339V17.2923H24.3358V19.5799H28.7847V21.25H22.3102Z",
			fill: "white"
		})
	]
}), mf = (e) => /* @__PURE__ */ v("svg", {
	width: 23,
	height: 23,
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ _("circle", {
		cx: 9.04035,
		cy: 9.04035,
		r: 8.04035,
		stroke: "white",
		strokeWidth: 2
	}), /* @__PURE__ */ _("path", {
		d: "M21.2621 21.9124C21.6526 22.3029 22.2858 22.3029 22.6763 21.9124C23.0668 21.5219 23.0668 20.8887 22.6763 20.4982L21.2621 21.9124ZM14.1996 14.8499L21.2621 21.9124L22.6763 20.4982L15.6138 13.4357L14.1996 14.8499Z",
		fill: "white"
	})]
}), hf = (e) => /* @__PURE__ */ v("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [
		/* @__PURE__ */ _("circle", {
			cx: 10,
			cy: 10,
			r: 10,
			fill: "#FF0505"
		}),
		/* @__PURE__ */ _("rect", {
			x: 9,
			y: 5,
			width: 2,
			height: 9,
			rx: 1,
			fill: "white"
		}),
		/* @__PURE__ */ _("rect", {
			x: 5.5,
			y: 10.5,
			width: 2,
			height: 9,
			rx: 1,
			transform: "rotate(-90 5.5 10.5)",
			fill: "white"
		})
	]
}), gf = N.div`
  box-shadow: 0px 4px 10px #00000030;
  position: relative;
  border-radius: 15px;
  overflow: hidden;
  ${(e) => e.$env === "schedugram-client" && "\n    margin: 0 50px;\n    @media (max-width: 1279px) {\n      margin: 0;\n    }\n  "}
`, _f = N.div`
  position: absolute;
  top: 42px;
  z-index: 2;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
`, vf = N.div`
  display: flex;
  align-items: center;
  justify-content: center;
  p {
    font-weight: 600;
    color: white;
    font-family: "Inter";
  }
`, yf = N.p`
  opacity: 0.6;
  margin: 0;
`, bf = N.p`
  margin: 0 0 -2px 15px;
`, xf = N.span`
  display: block;
  height: 2px;
  width: 30px;
  background-color: white;
  margin: 0 auto;
`, Sf = N.div`
  z-index: 10;
  position: absolute;
  right: 10px;
  bottom: 18%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;

  svg {
    width: 45px;
    height: 45px;
  }
`, Cf = N.div`
  background: url(${(e) => e.$profilePicture}) no-repeat center center;
  background-size: cover;
  width: 50px;
  height: 50px;
  border: 3px solid white;
  border-radius: 50%;
  position: relative;
  display: grid;
  place-items: center;
  margin-bottom: 20px;

  svg {
    position: absolute;
    bottom: -10px;
    height: auto;
  }
`, wf = N.div`
  position: absolute;
  bottom: 0px;
  z-index: 2;
  padding: 10px;
  left: 0px;
  right: 0px;
  padding-bottom: 8px;
  overflow-wrap: break-word;
  word-break: break-word;
  ${({ $isTakingUpSpace: e }) => e ? "background-color: black;" : ""}

  a {
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
  }

  .description {
    line-height: 20px;
    width: 210px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }

  svg.musicIcon {
    width: 14px;
    height: 15px;
    flex-shrink: 0;
  }
`, Tf = ({ url: e, ContentItem: t }) => e ? /* @__PURE__ */ _("a", {
	href: e,
	target: "_blank",
	style: {
		color: "inherit",
		textDecoration: "none"
	},
	rel: "noreferrer",
	children: t
}) : /* @__PURE__ */ _("div", { children: t }), Ef = ({ medias: e, profilePicture: t, username: n, description: r, videoCoverPreview: a, title: o, postType: s }) => {
	let [c, l] = i.useState(!1), [u, d] = i.useState(0);
	return /* @__PURE__ */ v("div", {
		className: "sp-relative",
		children: [
			/* @__PURE__ */ _("div", {
				className: "sp-flex sp-justify-center",
				children: /* @__PURE__ */ v(_f, { children: [
					/* @__PURE__ */ _(pf, {}),
					/* @__PURE__ */ v(vf, { children: [/* @__PURE__ */ _(yf, { children: "Following" }), /* @__PURE__ */ v(bf, { children: ["For You ", /* @__PURE__ */ _(xf, {})] })] }),
					/* @__PURE__ */ _(mf, {})
				] })
			}),
			/* @__PURE__ */ _(of, {
				medias: e,
				videoCoverPreview: a,
				postType: s,
				isMultipleLinesDetected: c,
				titleCaptionHeight: u
			}),
			/* @__PURE__ */ _(Af, { profilePicture: t }),
			/* @__PURE__ */ _(kf, {
				username: n,
				title: o,
				description: r,
				onMultipleLinesDetected: l,
				onHeightDetected: d,
				isTakingUpSpace: c && Df(s)
			})
		]
	});
}, Df = (e) => e === "multiMedia" || e?.toLowerCase() === "image";
function Of(e, t = 50) {
	return e && e.clientHeight > t;
}
var kf = ({ username: e, title: t, description: n, onMultipleLinesDetected: r, onHeightDetected: a, isTakingUpSpace: o }) => {
	let s = i.useRef(null), [c, l] = i.useState(!1);
	return r = r || (() => {}), a = a || (() => {}), f(() => {
		if (s.current) {
			if (a(s.current.clientHeight), Of(s.current.querySelector(".title-caption"))) {
				r(!0);
				return;
			}
			r(!1);
		}
	}, [
		t,
		n,
		e
	]), /* @__PURE__ */ v(wf, {
		ref: s,
		$isTakingUpSpace: o,
		children: [
			/* @__PURE__ */ v(cf, {
				className: "sp-font-bold sp-mb-2",
				children: ["@", e]
			}),
			/* @__PURE__ */ v("div", {
				className: "title-caption",
				children: [
					t && /* @__PURE__ */ _(cf, {
						className: "title sp-font-bold sp-mb-1 sp-mt-4 sp-text-2xl",
						children: t
					}),
					/* @__PURE__ */ _("div", {
						className: c ? "sp-max-h-[200px] sp-overflow-y-auto sp-leading-5" : "description",
						children: /* @__PURE__ */ _(cf, { children: /* @__PURE__ */ _(Y, {
							caption: n,
							targetPlatform: "TT"
						}) })
					}),
					n && /* @__PURE__ */ _("button", {
						onClick: (e) => {
							e.preventDefault(), e.stopPropagation(), l(!c);
						},
						className: "sp-text-white/60 sp-text-sm sp-cursor-pointer sp-bg-transparent sp-border-none sp-p-0",
						children: c ? "less" : "more"
					})
				]
			}),
			/* @__PURE__ */ v("div", {
				className: "sp-flex sp-items-center sp-gap-1.5 sp-mt-3.5 sp-text-white/70 sp-text-[11px]",
				children: [/* @__PURE__ */ _(ff, { className: "musicIcon" }), /* @__PURE__ */ _("span", {
					className: "sp-truncate",
					children: "Audio will be auto-matched after publishing"
				})]
			})
		]
	});
}, Af = ({ profilePicture: e }) => /* @__PURE__ */ v(Sf, { children: [
	/* @__PURE__ */ _(Cf, {
		$profilePicture: e,
		children: /* @__PURE__ */ _(hf, { className: "sp-w-8" })
	}),
	/* @__PURE__ */ _(lf, {}),
	/* @__PURE__ */ _(uf, {}),
	/* @__PURE__ */ _(df, {})
] }), jf = ({ post: e, env: t, videoCoverPreview: n }) => /* @__PURE__ */ _(g, { children: /* @__PURE__ */ _(gf, {
	$env: t,
	children: /* @__PURE__ */ _(Tf, {
		ContentItem: /* @__PURE__ */ _(Ef, {
			medias: e.medias,
			username: e.username,
			profilePicture: e.profilePicture,
			description: e.caption,
			videoCoverPreview: n,
			title: e.postOptions?.title,
			postType: e.type
		}),
		url: e.redirectUrl
	})
}) }), Mf = jf, Nf = ({ post: e, env: t, videoCoverPreview: n }) => {
	switch (e.type) {
		case "image":
		case "multiMedia": return /* @__PURE__ */ _(Mf, {
			post: e,
			env: t,
			videoCoverPreview: n
		});
		case "video":
		case "text":
		case "story": return /* @__PURE__ */ _(jf, {
			post: e,
			env: t,
			videoCoverPreview: n
		});
		default: return /* @__PURE__ */ _(g, {});
	}
}, Pf = N.div`
  font-family: Helvetica;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: 0.015em;\n        ";
		case "subheading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: 0.015em;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 15px;\n          line-height: 20px;\n          letter-spacing: -0.025em;\n          white-space: pre-line;\n        ";
	}
}};
`, Ff = ({ username: e, profilePicture: t, small: n }) => /* @__PURE__ */ v("div", {
	className: "sp-flex sp-items-center",
	children: [/* @__PURE__ */ _("div", {
		className: "sp-rounded-full sp-overflow-hidden sp-m-4",
		style: {
			width: "49px",
			height: "49px"
		},
		children: /* @__PURE__ */ _(Ge, {
			src: t,
			alt: e
		})
	}), /* @__PURE__ */ _("div", {
		className: `sp-flex sp-flex-grow sp-leading-tight ${n ? "sp-text-white" : ""}`,
		children: /* @__PURE__ */ _("div", {
			className: "sp-font-sans",
			children: /* @__PURE__ */ _(Pf, {
				$variant: "heading",
				className: "sp-mb-1",
				children: e
			})
		})
	})]
}), If = N.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, Lf = N.img`
  flex-shrink: 0;
  min-width: 100%;
  min-height: 100%;
  object-fit: cover;
  object-position: center;
  max-width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;

  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
  flex-direction: column;
`, Rf = ({ src: e, forCarousel: t, showOverlay: n, showAll: r, setShowAll: i, mediaCount: a }) => t ? /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _(Rl, {
	href: e,
	$isFlex: !0,
	children: /* @__PURE__ */ _(Lf, {
		src: e,
		className: ""
	})
}), !r && n && /* @__PURE__ */ v("div", {
	className: "sp-cursor-pointer",
	onClick: () => i(!0),
	children: [/* @__PURE__ */ _("div", {
		className: "sp-absolute sp-bg-gray-900 sp-opacity-50 sp-z-10 sp-w-full sp-h-full sp-text-3xl sp-text-white sp-text-opacity-100 ",
		children: "\xA0"
	}), /* @__PURE__ */ v("div", {
		className: "sp-absolute sp-z-20 sp-h-full sp-w-full sp-flex sp-justify-center sp-items-center sp-text-white sp-text-3xl",
		children: ["+", a - 4]
	})]
})] }) : /* @__PURE__ */ _(Rl, {
	href: e,
	children: /* @__PURE__ */ _(If, { src: e })
}), zf = ({ url: e, isActiveSlide: t }) => t ? /* @__PURE__ */ _("div", {
	className: "sp-bg-black sp-flex sp-items-center",
	children: /* @__PURE__ */ _(Ws, {
		src: e,
		controls: !0,
		playing: !1,
		className: "sp-relative",
		width: "100%",
		height: "auto"
	})
}) : null, Bf = ({ media: e, hidden: t = !1, forCarousel: n = !1, showOverlay: r, showAll: i, setShowAll: a, mediaCount: o, isActiveSlide: s = !0 }) => t && i === !1 ? null : /* @__PURE__ */ v(g, { children: [(e.isVideo || e.url.includes(".mp4")) && /* @__PURE__ */ _(zf, {
	url: e.url,
	forCarousel: n,
	isActiveSlide: s
}), !(e.isVideo || e.url.includes(".mp4")) && /* @__PURE__ */ _(Rf, {
	src: e.url,
	forCarousel: n,
	showOverlay: r,
	showAll: i,
	setShowAll: a,
	mediaCount: o
})] }), Vf = () => /* @__PURE__ */ _("div", {
	className: "sp-py-2 sp-w-full",
	children: /* @__PURE__ */ v("div", {
		className: "sp-flex sp-w-full sp-justify-start sp-text-black sp-py-4 sp-pl-0",
		children: [
			/* @__PURE__ */ _(Hf, { icon: "icon-instagram-heart" }),
			/* @__PURE__ */ _(Hf, { icon: "icon-instagram-comment" }),
			/* @__PURE__ */ _(Hf, { icon: "icon-twitter-retweet" }),
			/* @__PURE__ */ _(Hf, { icon: "icon-instagram-share" })
		]
	})
}), Hf = ({ icon: e }) => /* @__PURE__ */ _("div", {
	className: "sp-flex sp-items-center sp-justify-start sp-pr-4 ",
	children: /* @__PURE__ */ _("div", { className: `sp-text-xl ${e}` })
}), Uf = N.div`
  position: relative;
  width: calc(50% - 10px);
  margin: 5px;

  &:after {
    content: "";
    display: block;
    padding-bottom: 100%;
  }
`, Wf = ({ medias: e }) => {
	let [t, n] = h(!1);
	return /* @__PURE__ */ _("div", {
		className: "sp-flex sp-flex-wrap sp-w-full",
		children: e.map((r, i) => !t && i > 3 ? null : /* @__PURE__ */ _(Uf, {
			className: "sp-relative",
			children: /* @__PURE__ */ _(Bf, {
				media: r,
				forCarousel: !0,
				hidden: i > 3,
				mediaCount: e.length,
				showOverlay: i === 3 && e.length > 4,
				showAll: t,
				setShowAll: n
			})
		}, `fb-media-key-${i}`))
	});
}, Gf = ({ medias: e }) => {
	let t = e.collection, n = t.length;
	return /* @__PURE__ */ v("div", {
		className: "sp-px-4",
		children: [n > 0 && /* @__PURE__ */ _(g, { children: n > 1 ? /* @__PURE__ */ _(Wf, {
			medias: t,
			count: n
		}) : /* @__PURE__ */ _(Bf, { media: t[0] }) }), /* @__PURE__ */ _("div", {
			className: "sp-flex sp-items-center sp-justify-between",
			children: /* @__PURE__ */ _(Vf, {})
		})]
	});
}, Kf = ({ post: e }) => {
	let t = e.caption;
	return /* @__PURE__ */ v("div", {
		className: "sp-text-sm sp-bg-white md:sp-shadow-around sp-border-b-2 sp-border-purple-550 md:sp-border-b-0",
		children: [
			/* @__PURE__ */ _(Ff, {
				username: e.username,
				profilePicture: e.profilePicture,
				locationName: e.locationName
			}),
			/* @__PURE__ */ _("div", {
				className: "sp-flex sp-flex-col sp-m-4",
				children: /* @__PURE__ */ v(Pf, {
					$variant: "caption",
					className: "sp-whitespace-pre-line sp-break-words",
					children: [/* @__PURE__ */ _(Y, {
						caption: t,
						targetPlatform: "TH"
					}), e.redirectUrl && /* @__PURE__ */ v(g, { children: [" ", /* @__PURE__ */ _("a", {
						className: "sp-text-blue-400 sp-break-words",
						href: e.redirectUrl,
						target: "_blank",
						children: e.redirectUrl
					})] })]
				})
			}),
			e.type === "text" && e.redirectUrl && /* @__PURE__ */ _("div", {
				className: "sp-p-4",
				children: /* @__PURE__ */ _(Ql, { url: e.redirectUrl })
			}),
			/* @__PURE__ */ _(Gf, { medias: e.medias })
		]
	});
}, qf = ({ post: e }) => {
	switch (e.type) {
		case "image":
		case "video":
		case "multiMedia":
		case "text": return /* @__PURE__ */ _(Kf, { post: e });
		default: return /* @__PURE__ */ _(g, {});
	}
}, Jf = N.div`
  font-family: "Helvetica", sans-serif;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 25px;\n          line-height: 30px;\n          text-decoration: none !important;\n          color: inherit !important;\n        ";
		case "subheading": return "\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 16px;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 13px;\n          line-height: 18px;\n          white-space: pre-line;\n        ";
		case "link": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 13px;\n          line-height: 18px;\n          white-space: pre-line;\n          font-weight: bold;\n          color: black;\n          text-decoration: none;\n          &:hover {\n            text-decoration: underline;\n          }\n        ";
		case "icons": return "\n          font-family: Helvetica Neue;\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 18px;\n          letter-spacing: 0.01em;\n        ";
	}
}};
`, Yf = N.span`
  font-family: "Helvetica", sans-serif;
  font-size: 14px;

  ${({ $variant: e }) => {
	switch (e) {
		case "heading": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 18px;\n          line-height: 20px;\n        ";
		case "bold": return "\n          font-style: normal;\n          font-weight: bold;\n        ";
		case "caption": return "\n          font-style: normal;\n          font-weight: normal;\n          font-size: 18px;\n          line-height: 20px;\n          letter-spacing: 0.005em;\n          white-space: pre-line;\n        ";
		case "icons": return "\n          font-family: Helvetica Neue;\n          font-style: normal;\n          font-weight: bold;\n          font-size: 15px;\n          line-height: 18px;\n          letter-spacing: 0.01em;\n        ";
	}
}};
`, Xf = ({ username: e, profilePicture: t, small: n, description: r, url: i }) => /* @__PURE__ */ _(g, { children: /* @__PURE__ */ v("div", {
	className: "sp-pt-4 sp-pb-2 sp-px-0 sp-flex sp-flex-row",
	children: [/* @__PURE__ */ _("div", {
		className: "sp-flex sp-px-1",
		children: /* @__PURE__ */ _("div", {
			className: "sp-rounded-full sp-overflow-hidden  sp-mr-4",
			style: {
				width: "40px",
				height: "40px",
				minWidth: "40px",
				minHeight: "40px"
			},
			children: /* @__PURE__ */ _(Ge, {
				src: t,
				alt: e
			})
		})
	}), /* @__PURE__ */ v("div", { children: [
		/* @__PURE__ */ _("div", {
			className: `sp-flex sp-flex-col sp-justify-center sp-leading-tight ${n ? "sp-text-white" : ""}`,
			children: /* @__PURE__ */ _("div", {
				className: "",
				children: /* @__PURE__ */ v(Yf, {
					$variant: "bold",
					className: "sp-mb-1",
					children: [e, " "]
				})
			})
		}),
		r && /* @__PURE__ */ _(Jf, {
			$variant: "caption",
			children: /* @__PURE__ */ _(Y, { caption: r })
		}),
		i && /* @__PURE__ */ v("div", {
			className: "sp-py-2",
			children: [" ", /* @__PURE__ */ _("a", {
				href: i,
				target: "_blank",
				rel: "noreferrer",
				children: /* @__PURE__ */ _(Jf, {
					$variant: "link",
					children: "URL for post"
				})
			})]
		})
	] })]
}) }), Zf = N.img`
  object-fit: cover;
  position: relative;
  width: 100%;
`, Qf = ({ src: e }) => /* @__PURE__ */ _(Zf, { src: e }), $f = ({ url: e, isActiveSlide: t }) => t ? /* @__PURE__ */ _("div", {
	className: "sp-relative",
	style: {},
	children: /* @__PURE__ */ _(Ws, {
		src: e,
		controls: !0,
		playing: !1,
		width: "100%",
		height: "auto",
		className: ""
	})
}) : null, ep = ({ media: e, hidden: t = !1, forCarousel: n = !1, showAll: r, isActiveSlide: i = !0 }) => t && r === !1 ? null : e.isVideo || e.url.includes(".mp4") ? /* @__PURE__ */ _($f, {
	url: e.url,
	forCarousel: n,
	isActiveSlide: i
}) : /* @__PURE__ */ _(Qf, { src: e.url }), tp = ({ medias: e }) => {
	let t = e.collection, n = t.length;
	return /* @__PURE__ */ _(np, { children: n > 0 && /* @__PURE__ */ _(ep, { media: t[0] }) });
}, np = N.div`
  overflow: hidden;
`, rp = ({ url: e, children: t }) => e ? /* @__PURE__ */ _("a", {
	href: e,
	target: "_blank",
	style: {
		color: "inherit",
		textDecoration: "none"
	},
	rel: "noreferrer",
	children: t
}) : /* @__PURE__ */ _("div", { children: t }), ip = ({ post: e }) => /* @__PURE__ */ v(ap, {
	className: "sp-bg-white md:sp-shadow-around sp-pb-6",
	style: {
		borderTopLeftRadius: "20px",
		borderTopRightRadius: "20px"
	},
	children: [/* @__PURE__ */ _(Xf, {
		username: e.username,
		profilePicture: e.profilePicture,
		description: e.caption,
		small: !1,
		url: e.redirectUrl
	}), /* @__PURE__ */ _("div", {
		className: "sp-pb-2",
		style: { paddingLeft: "47px" },
		children: /* @__PURE__ */ _(rp, {
			url: e.redirectUrl,
			children: /* @__PURE__ */ _(tp, { medias: e.medias })
		})
	})]
}), ap = N.div`
  padding: 1.1em;
`, op = ({ post: e }) => {
	switch (e.type) {
		case "video":
		case "image":
		case "multiMedia":
		case "text":
		case "story": return /* @__PURE__ */ _(ip, { post: e });
		default: return /* @__PURE__ */ _(g, {});
	}
}, sp = class extends a {
	constructor(t) {
		super(t), e(this, "post", void 0), this.state = { hasError: !1 }, this.post = t.post;
	}
	static getDerivedStateFromError(e) {
		return { hasError: !0 };
	}
	componentDidCatch(e, t) {
		console.log(e);
	}
	render() {
		return this.state.hasError ? /* @__PURE__ */ v("div", {
			className: "sp-flex sp-flex-col sp-items-center sp-justify-center sp-w-full sp-border-2 sp-border-solid sp-border-gray-300 sp-rounded-lg sp-p-8 sp-h-500px sp-shadow-lg",
			children: [/* @__PURE__ */ _("div", {
				className: "sp-text-4xl sp-mb-8 sp-text-red-500 sp-font-bold",
				children: "Failed to load preview"
			}), /* @__PURE__ */ _("div", {
				className: "sp-text-3xl sp-text-red-500",
				children: "Please contact Sked support"
			})]
		}) : this.props.children;
	}
}, cp = {
	FB: [
		"text",
		"image",
		"video",
		"multiMedia",
		"fb-reel"
	],
	GMB: [
		"text",
		"image",
		"video",
		"multiMedia",
		"story",
		"fb-reel",
		"gmb"
	],
	IG: [
		"image",
		"video",
		"multiMedia",
		"story",
		"fb-reel"
	],
	LI: [
		"text",
		"image",
		"multiMedia",
		"video",
		"document",
		"fb-reel"
	],
	OT: [
		"image",
		"video",
		"multiMedia",
		"story",
		"text",
		"fb-reel"
	],
	PI: [
		"image",
		"video",
		"multiMedia",
		"fb-reel"
	],
	SC: [
		"image",
		"video",
		"multiMedia",
		"story",
		"text",
		"fb-reel"
	],
	TH: [
		"audio",
		"image",
		"video",
		"multiMedia",
		"text",
		"fb-reel"
	],
	TT: [
		"video",
		"image",
		"multiMedia",
		"fb-reel"
	],
	TW: [
		"text",
		"image",
		"video",
		"multiMedia",
		"fb-reel"
	],
	YT: ["video", "fb-reel"]
}, lp = {
	FB: "Facebook",
	GMB: "Google Business Profile",
	IG: "Instagram",
	LI: "LinkedIn",
	OT: "Other",
	PI: "Pinterest",
	SC: "Snapchat",
	TH: "Threads",
	TT: "TikTok",
	TW: "X",
	YT: "YouTube"
}, up = (e) => {
	let t = bp(e), n = xp(t), r = pp(e), i = Sp(r), a = cp[t];
	return a ? a.includes(r) ? r === "multiMedia" && mp(e) ? {
		platform: t,
		platformName: n,
		reason: "unsupported-document-media",
		supported: !1,
		type: "document",
		typeName: Sp("document")
	} : t === "TT" && r === "multiMedia" && gp(e) ? {
		platform: t,
		platformName: n,
		reason: "unsupported-media-combination",
		supported: !1,
		type: "mixedMedia",
		typeName: "Mixed media posts"
	} : {
		platform: t,
		platformName: n,
		reason: "supported",
		supported: !0,
		type: r,
		typeName: i
	} : {
		platform: t,
		platformName: n,
		reason: "unsupported-post-type",
		supported: !1,
		type: r,
		typeName: i
	} : {
		platform: t,
		platformName: n,
		reason: "unknown-platform",
		supported: !1,
		type: r,
		typeName: i
	};
}, dp = (e) => up(e).supported, fp = (e) => {
	let t = up(e);
	if (t.supported) return null;
	let n = `${t.typeName} aren't available on ${t.platformName}.`;
	return t.reason === "unsupported-media-combination" && t.platform === "TT" && (n = "Mixed photo and video posts aren't available on TikTok."), t.reason === "unsupported-document-media" && t.platform === "LI" && (n = "Document posts on LinkedIn can't be combined with other media."), {
		title: "Post preview not available",
		message: n
	};
}, pp = (e) => {
	let t = bp(e), n = e?.type || e?.providedPost?.type || "text";
	return (e?.videoPostType || e?.providedPost?.videoPostType || null) === "reel" ? t === "FB" || t === "IG" ? "fb-reel" : "reel" : n === "reel" && t === "IG" ? "fb-reel" : n === "fb-reel" ? t !== "FB" && t !== "IG" ? "video" : "fb-reel" : n;
}, mp = (e) => yp(e).some(hp), hp = (e) => {
	let t = e.type?.toLowerCase() || "", n = e.url?.toLowerCase().split(/[?#]/)[0] || "";
	return e.isDocument === !0 || t.includes("document") || t.includes("pdf") || n.endsWith(".pdf");
}, gp = (e) => {
	let t = yp(e);
	return t.some(_p) && t.some(vp);
}, _p = (e) => {
	let t = e.type?.toLowerCase() || "", n = e.url?.toLowerCase().split(/[?#]/)[0] || "";
	return e.isVideo === !0 || t.startsWith("video/") || /\.(m4v|mov|mp4|mpeg|mpg|webm)$/.test(n);
}, vp = (e) => {
	let t = e.type?.toLowerCase() || "", n = e.url?.toLowerCase().split(/[?#]/)[0] || "";
	return e.isVideo === !1 || t.startsWith("image/") || /\.(avif|gif|heic|jpeg|jpg|png|webp)$/.test(n);
}, yp = (e) => e && (e.medias?.collection || e.mediaFiles || e.providedPost?.mediaFiles) || [], bp = (e) => e?.platform || e?.platformType || "IG", xp = (e) => lp[e] || e, Sp = (e) => {
	switch (e) {
		case "fb-reel":
		case "reel": return "Reels";
		case "multiMedia": return "Carousel posts";
		case "story": return "Stories";
		case "text": return "Text posts";
		case "document": return "Document posts";
		case "video": return "Video posts";
		case "image":
		case "photo": return "Image posts";
		default: return `${Cp(e)} posts`;
	}
}, Cp = (e) => e.length > 0 ? `${e[0].toUpperCase()}${e.slice(1)}` : e, wp = ({ className: e, copy: t, post: n }) => {
	let r = t || fp(n);
	return r ? /* @__PURE__ */ v("div", {
		className: ["sp-box-border sp-flex sp-w-full sp-items-start sp-gap-3 sp-rounded-lg sp-bg-[#fffbeb] sp-p-2 sp-font-sans sp-antialiased", e].filter(Boolean).join(" "),
		"data-testid": "unsupported-post-preview-placeholder",
		"data-preview-placeholder": "unsupported",
		children: [/* @__PURE__ */ _("div", { className: "sp-w-0.5 sp-self-stretch sp-rounded-[3px] sp-bg-[#d97706]" }), /* @__PURE__ */ v("div", {
			className: "sp-flex sp-min-w-0 sp-flex-1 sp-flex-col sp-gap-1 sp-py-1",
			children: [/* @__PURE__ */ v("div", {
				className: "sp-flex sp-items-center sp-gap-2",
				children: [/* @__PURE__ */ _("svg", {
					"aria-hidden": "true",
					className: "sp-size-5 sp-shrink-0",
					fill: "none",
					viewBox: "0 0 20 20",
					children: /* @__PURE__ */ _("path", {
						d: "M9.999 7.5v3.333m0 2.5h.009M8.845 3.243 2.24 14.583A1.25 1.25 0 0 0 3.322 16.5h13.355a1.25 1.25 0 0 0 1.083-1.917L11.155 3.243a1.25 1.25 0 0 0-2.31 0Z",
						stroke: "#d97706",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						strokeWidth: "1.5"
					})
				}), /* @__PURE__ */ _("div", {
					className: "sp-min-w-0 sp-flex-1 sp-text-sm sp-font-medium sp-leading-5 sp-text-[#333333]",
					children: r.title
				})]
			}), /* @__PURE__ */ _("div", {
				className: "sp-text-sm sp-font-normal sp-leading-5 sp-text-[#808080]",
				children: r.message
			})]
		})]
	}) : null;
}, Tp = (e) => {
	if (e === null) return null;
	if (e.type !== "fb-reel") return e;
	switch (e.platform) {
		case "FB": return e;
		case "IG": return {
			...e,
			type: "reel"
		};
		default: return {
			...e,
			type: "video"
		};
	}
}, Ep = ({ alignTriggerWithTextEnd: e = !1, buttonClassName: t, caption: n, captionMode: r = "cssClamp", charsPerLine: i, className: a, collapseTriggerLabel: o = "Show less", collapsedCaption: s, collapsedLines: c, contentClassName: l, expandedContentClassName: u, expanded: d, expandOnContentClick: f = !1, hideTriggerWhenExpanded: p = !1, leadingText: m, measurementText: h, onExpandedChange: g, prefix: y, renderCaption: b, scrollOnExpandMaxHeight: x, suffix: S, targetPlatform: C, triggerNode: w, triggerStyle: T, trackEvent: E, triggerLabel: D, wideCharacterWeight: O }) => {
	let k = Op({
		charsPerLine: i,
		leadingText: m,
		text: h ?? n,
		wideCharacterWeight: O
	}) > c, A = d ? o : D, j = r === "textSlice" && !d && k ? s ?? n : n, M = e && !d && k ? kp({
		charsPerLine: i,
		collapsedLines: c,
		leadingText: m,
		text: h ?? n,
		triggerLabel: D,
		triggerStyle: T,
		wideCharacterWeight: O
	}) : T, N = d && x ? { maxHeight: x } : void 0;
	return /* @__PURE__ */ v("div", {
		className: ["sp-relative", a].filter(Boolean).join(" "),
		children: [/* @__PURE__ */ v("div", {
			"aria-expanded": k ? d : void 0,
			className: [
				"sp-break-words",
				f && k ? "sp-cursor-pointer" : void 0,
				!d && k && r === "cssClamp" ? Fp(c) : void 0,
				d && x ? "sp-overflow-y-auto" : void 0,
				l,
				d ? u : void 0
			].filter(Boolean).join(" "),
			onClick: (e) => {
				let t = e.target;
				!f || !k || !(t instanceof HTMLElement) || t.closest("a, button") || g(!d);
			},
			style: N,
			children: [
				y,
				b ? b({ caption: j }) : /* @__PURE__ */ _(Y, {
					caption: j,
					targetPlatform: C,
					trackEvent: E
				}),
				S
			]
		}), k && !(d && p) ? /* @__PURE__ */ _("button", {
			"aria-expanded": d,
			className: [
				d ? "sp-inline" : "sp-absolute sp-bottom-0 sp-right-0 sp-inline",
				"sp-border-0 sp-bg-transparent sp-p-0 sp-text-left sp-font-inherit sp-leading-inherit",
				t
			].filter(Boolean).join(" "),
			onClick: () => g(!d),
			style: M,
			type: "button",
			children: !d && w ? w : A
		}) : null]
	});
}, Dp = ({ charsPerLine: e, collapsedLines: t, expanded: n, leadingText: r, lineHeight: i, text: a, wideCharacterWeight: o }) => {
	let s = Op({
		charsPerLine: e,
		leadingText: r,
		text: a,
		wideCharacterWeight: o
	});
	return Math.min(n ? s : t, s) * i;
}, Op = ({ charsPerLine: e, leadingText: t, text: n, wideCharacterWeight: r }) => {
	let i = n.trim();
	return i ? i.split(/\r?\n/).reduce((n, i, a) => {
		let o = a === 0 && t ? `${t} ${i}` : i;
		return n + Math.max(1, Math.ceil(Np(o, r) / e));
	}, 0) : 0;
}, kp = ({ charsPerLine: e, collapsedLines: t, leadingText: n, text: r, triggerLabel: i, triggerStyle: a, wideCharacterWeight: o }) => {
	let s = Ap({
		charsPerLine: e,
		collapsedLines: t,
		leadingText: n,
		text: r,
		wideCharacterWeight: o
	}), c = Math.max(2, i.length), l = Math.min(s + .5, Math.max(0, e - c));
	return {
		...a,
		left: `${l}ch`,
		right: "auto"
	};
}, Ap = ({ charsPerLine: e, collapsedLines: t, leadingText: n, text: r, wideCharacterWeight: i }) => {
	let a = r.trim();
	if (!a) return 0;
	let o = a.split(/\r?\n/).flatMap((t, r) => jp(r === 0 && n ? `${n} ${t}` : t, e, i));
	return Np((o[Math.min(t, o.length) - 1] ?? "").trimEnd(), i);
}, jp = (e, t, n) => {
	if (!e) return [""];
	let r = [];
	if (!n || n <= 1) {
		for (let n = 0; n < e.length; n += t) r.push(e.slice(n, n + t));
		return r;
	}
	let i = "", a = 0;
	for (let o of e) {
		let e = Pp(o, n);
		i && a + e > t && (r.push(i), i = "", a = 0), i += o, a += e;
	}
	return i && r.push(i), r;
}, Mp = /[\u1100-\u11ff\u2e80-\u9fff\uf900-\ufaff\uac00-\ud7af]/, Np = (e, t = 1) => t <= 1 ? e.length : Array.from(e).reduce((e, n) => e + Pp(n, t), 0), Pp = (e, t = 1) => t > 1 && Mp.test(e) ? t : 1, Fp = (e) => e <= 1 ? "sp-line-clamp-1" : e === 2 ? "sp-line-clamp-2" : e === 3 ? "sp-line-clamp-3" : e === 4 ? "sp-line-clamp-4" : e === 5 ? "sp-line-clamp-5" : "sp-line-clamp-6", Ip = (...e) => e.filter(Boolean).join(" "), Lp = ({ children: e, className: t, platform: n, style: r }) => /* @__PURE__ */ _("div", {
	className: Ip("sp-box-border sp-mx-auto sp-w-full sp-min-w-[280px] sp-max-w-[400px] sp-overflow-hidden sp-rounded-lg sp-border sp-border-solid sp-border-[#e6e6e6] sp-bg-white sp-text-[16px] sp-leading-5 sp-text-black sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)] sp-antialiased", t),
	"data-preview-variant": "uplift",
	"data-preview-platform": n,
	style: {
		fontFamily: "Inter, Helvetica, Arial, sans-serif",
		...r
	},
	children: e
}), X = ({ alt: e = "", className: t, onError: n, src: r, ...i }) => {
	let [a, o] = h(!1), s = Ip("sp-h-10 sp-w-10 sp-shrink-0 sp-rounded-full sp-bg-[#eef0f2] sp-object-cover", t);
	return !r || a ? /* @__PURE__ */ _("span", {
		"aria-label": e,
		className: Ip(s, "sp-flex sp-items-center sp-justify-center sp-overflow-hidden sp-text-sm sp-font-semibold sp-leading-none sp-text-[#4b5563]"),
		role: "img",
		children: Rp(e)
	}) : /* @__PURE__ */ _("img", {
		alt: e,
		className: Ip("sp-block", s),
		onError: (e) => {
			o(!0), n?.(e);
		},
		src: r,
		...i
	});
}, Rp = (e) => e.trim().charAt(0).toUpperCase() || "?", zp = ({ className: e, ...t }) => /* @__PURE__ */ _("div", {
	className: Ip("sp-overflow-hidden sp-truncate sp-text-base sp-font-semibold sp-leading-none sp-text-black", e),
	...t
}), Bp = ({ className: e, ...t }) => /* @__PURE__ */ _("div", {
	className: Ip("sp-box-border sp-min-h-0 sp-min-w-0 sp-overflow-hidden sp-bg-[#e4e6eb]", e),
	...t
}), Vp = 0, Hp = 1, Up = .05, Wp = "sp-right-4 sp-top-[112px]", Gp = ({ audioControlsClassName: e, autoPlay: t = !1, autoplayMode: n = "none", backgroundColor: r, className: i, controls: a = !1, customControls: o = !1, fit: s, gateCover: c, intrinsicRatio: l, isActive: u = !0, loop: d = !1, measureWhenInactive: f = !1, muted: p = !1, onError: g, onIntrinsicDimensions: y, poster: b, publishedRatio: x, source: S, videoClassName: C }) => {
	let w = m(null), T = `${S}:${b ?? ""}`, [E, D] = h({
		hasEnded: !1,
		hasPlayed: !1,
		identity: T,
		isPlaying: !1,
		resetKey: 0
	}), [O, k] = h({
		identity: T,
		isMuted: p,
		policyMuted: p,
		volume: Hp
	}), [A, j] = h(!1), M = E.identity === T ? E : {
		hasEnded: !1,
		hasPlayed: !1,
		identity: T,
		isPlaying: !1,
		resetKey: 0
	}, { hasEnded: N, hasPlayed: P, isPlaying: F, resetKey: I } = M, L = O.identity === T && O.policyMuted === p ? O : {
		identity: T,
		isMuted: p,
		policyMuted: p,
		volume: O.identity === T ? O.volume : Hp
	}, { isMuted: ee, volume: te } = L, ne = c ?? (o && !!(b && b !== S)), re = !ne && t, R = o && (!re || P) && !N && (!a || !P), ie = o && P && N, ae = o && !a;
	if (!u) return f ? /* @__PURE__ */ _("video", {
		"aria-hidden": "true",
		className: "sp-hidden",
		onLoadedMetadata: (e) => {
			y?.(e.currentTarget.videoWidth, e.currentTarget.videoHeight);
		},
		preload: "metadata",
		src: S
	}) : null;
	let oe = () => {
		let e = w.current;
		e && (e.paused ? e.play() : e.pause());
	}, se = () => {
		let e = w.current;
		if (!e) return;
		let t = !ee;
		if (e.muted = t, !t && e.muted) {
			console.warn("[UpliftVideoPlayer] Browser prevented unmuting the video.");
			return;
		}
		if (!t && e.volume === 0) {
			e.volume = Hp, k({
				...L,
				isMuted: t,
				volume: Hp
			});
			return;
		}
		k({
			...L,
			isMuted: t
		});
	}, ce = (e) => {
		let t = w.current;
		if (!t) return;
		let n = Math.min(Hp, Math.max(Vp, Number(e.target.value)));
		t.volume = n, n === 0 ? t.muted = !0 : t.muted && (t.muted = !1), k({
			...L,
			isMuted: t.muted,
			volume: n
		});
	}, le = () => {
		let e = w.current;
		e && k({
			...L,
			isMuted: e.muted,
			volume: e.volume
		});
	};
	return /* @__PURE__ */ v("div", {
		className: ["sp-relative sp-h-full sp-w-full sp-overflow-hidden", i].filter(Boolean).join(" "),
		"data-uplift-video-player": "true",
		"data-uplift-fit": s,
		"data-uplift-intrinsic-ratio": l,
		"data-uplift-video-autoplay": re ? "true" : "false",
		"data-uplift-video-autoplay-mode": n,
		"data-uplift-video-cover-gated": ne ? "true" : "false",
		"data-uplift-media-kind": "video",
		"data-uplift-poster": b,
		"data-uplift-published-ratio": x,
		"data-uplift-video-playing": F ? "true" : "false",
		style: r ? { backgroundColor: r } : void 0,
		children: [
			/* @__PURE__ */ _("video", {
				className: [
					"sp-block sp-h-full sp-w-full",
					r ? "" : "sp-bg-[#111]",
					C || "sp-object-cover"
				].filter(Boolean).join(" "),
				controls: a,
				autoPlay: re,
				loop: d,
				muted: ee,
				onEnded: () => {
					D((e) => ({
						...M,
						resetKey: e.identity === T ? e.resetKey : M.resetKey,
						hasEnded: !0,
						isPlaying: !1
					}));
				},
				onError: g,
				onLoadedMetadata: (e) => {
					y?.(e.currentTarget.videoWidth, e.currentTarget.videoHeight);
				},
				onPause: () => D((e) => ({
					...M,
					resetKey: e.identity === T ? e.resetKey : M.resetKey,
					isPlaying: !1
				})),
				onPlay: () => {
					le(), D((e) => ({
						...M,
						resetKey: e.identity === T ? e.resetKey : M.resetKey,
						hasEnded: !1,
						hasPlayed: !0,
						isPlaying: !0
					}));
				},
				onVolumeChange: le,
				playsInline: !0,
				poster: b,
				preload: "metadata",
				ref: w,
				src: S,
				style: r ? { backgroundColor: r } : void 0
			}, `${T}:${I}`),
			ne && !P && b ? /* @__PURE__ */ _("img", {
				alt: "",
				className: ["sp-absolute sp-inset-0 sp-block sp-h-full sp-w-full", C || "sp-object-cover"].filter(Boolean).join(" "),
				src: b
			}) : null,
			R ? /* @__PURE__ */ _("button", {
				"aria-label": F ? "Pause video" : "Play video",
				className: ["sp-absolute sp-inset-0 sp-flex sp-items-center sp-justify-center sp-border-0 sp-bg-transparent sp-p-0 sp-text-white", "sp-cursor-pointer"].join(" "),
				onClick: oe,
				type: "button",
				children: /* @__PURE__ */ _("span", {
					className: ["sp-flex sp-h-[52px] sp-w-[52px] sp-items-center sp-justify-center sp-rounded-full sp-bg-black/40 sp-transition-opacity", F || N ? "sp-opacity-0" : "sp-opacity-100"].join(" "),
					children: _(F ? qp : Kp, {})
				})
			}) : null,
			ie ? /* @__PURE__ */ _("button", {
				"aria-label": "Replay video",
				className: "sp-absolute sp-left-1/2 sp-top-1/2 sp-flex sp-h-14 sp-w-14 sp-cursor-pointer sp-items-center sp-justify-center sp-rounded-lg sp-border-0 sp-bg-black/30 sp-p-0 sp-text-white sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)]",
				onClick: () => {
					re && k({
						...L,
						isMuted: p
					}), D((e) => ({
						hasEnded: !1,
						hasPlayed: !1,
						identity: T,
						isPlaying: !1,
						resetKey: e.identity === T ? e.resetKey + 1 : 1
					}));
				},
				style: { transform: "translate(-50%, -50%)" },
				type: "button",
				children: /* @__PURE__ */ _(Jp, {})
			}) : null,
			ae ? /* @__PURE__ */ v("div", {
				className: ["sp-absolute sp-z-10 sp-flex sp-flex-row-reverse sp-items-center sp-gap-2", e || Wp].join(" "),
				onBlur: (e) => {
					e.currentTarget.contains(e.relatedTarget) || j(!1);
				},
				onFocus: () => j(!0),
				onMouseEnter: () => j(!0),
				onMouseLeave: () => j(!1),
				children: [/* @__PURE__ */ _("button", {
					"aria-label": ee || te === 0 ? "Unmute video" : "Mute video",
					className: "sp-flex sp-h-8 sp-w-8 sp-cursor-pointer sp-items-center sp-justify-center sp-rounded-full sp-border-0 sp-bg-black/40 sp-p-0 sp-text-white",
					onClick: se,
					type: "button",
					children: _(ee || te === 0 ? Yp : Xp, {})
				}), A ? /* @__PURE__ */ _("input", {
					"aria-label": "Volume",
					"aria-valuetext": `${Math.round(te * 100)}%`,
					className: "sp-h-1 sp-w-16 sp-cursor-pointer",
					max: String(Hp),
					min: String(Vp),
					onChange: ce,
					step: String(Up),
					type: "range",
					value: te
				}) : null]
			}) : null
		]
	});
}, Kp = () => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	fill: "none",
	height: "26",
	viewBox: "0 0 24 28",
	width: "24",
	children: /* @__PURE__ */ _("path", {
		d: "M22 14L2 26V2L22 14Z",
		fill: "currentColor"
	})
}), qp = () => /* @__PURE__ */ v("svg", {
	"aria-hidden": "true",
	fill: "none",
	height: "24",
	viewBox: "0 0 20 24",
	width: "20",
	children: [/* @__PURE__ */ _("rect", {
		fill: "currentColor",
		height: "22",
		rx: "1",
		width: "6",
		x: "1",
		y: "1"
	}), /* @__PURE__ */ _("rect", {
		fill: "currentColor",
		height: "22",
		rx: "1",
		width: "6",
		x: "13",
		y: "1"
	})]
}), Jp = () => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	className: "sp-block sp-translate-x-[1px]",
	fill: "none",
	height: "28",
	viewBox: "0 0 36 34",
	width: "28",
	children: /* @__PURE__ */ _("path", {
		d: "M2.333 13.667s3.342-4.553 6.056-7.27C11.104 3.68 14.856 2 19 2c8.284 0 15 6.716 15 15s-6.716 15-15 15c-6.839 0-12.608-4.576-14.414-10.833M2.333 13.667v-10m0 10h10",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2.9"
	})
}), Yp = () => /* @__PURE__ */ v("svg", {
	"aria-hidden": "true",
	fill: "none",
	height: "18",
	viewBox: "0 0 24 24",
	width: "18",
	children: [
		/* @__PURE__ */ _("path", {
			d: "M11 5L6 9H2v6h4l5 4V5z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _("line", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: "2",
			x1: "23",
			x2: "17",
			y1: "9",
			y2: "15"
		}),
		/* @__PURE__ */ _("line", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: "2",
			x1: "17",
			x2: "23",
			y1: "9",
			y2: "15"
		})
	]
}), Xp = () => /* @__PURE__ */ v("svg", {
	"aria-hidden": "true",
	fill: "none",
	height: "18",
	viewBox: "0 0 24 24",
	width: "18",
	children: [
		/* @__PURE__ */ _("path", {
			d: "M11 5L6 9H2v6h4l5 4V5z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _("path", {
			d: "M15.54 8.46a5 5 0 0 1 0 7.07",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: "2"
		}),
		/* @__PURE__ */ _("path", {
			d: "M19.07 4.93a10 10 0 0 1 0 14.14",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: "2"
		})
	]
}), Zp = [
	"TT",
	"IG",
	"FB",
	"LI"
], Qp = [
	"IG",
	"FB",
	"LI"
], $p = (e) => e ? typeof e == "string" ? e : e.platformType || e.TYPE || "" : "", em = (e) => Zp.includes($p(e)), tm = (e) => Qp.includes($p(e)), nm = (e = []) => e.filter((e) => em(e)), rm = ({ platforms: e = [], selectedPlatform: t }) => t === "LINKED" ? e.some((e) => em(e)) : em(t), im = ({ platforms: e = [], selectedPlatform: t }) => {
	let n = (t === "LINKED" ? e : [t || ""]).filter((e) => em(e));
	return n.length > 0 && n.every((e) => tm(e));
}, am = ({ isStory: e, isVideoPost: t, mediaUrlCount: n, storyType: r }) => n > 1 || n > 0 && !t || e && r !== "reel" ? !1 : t, om = ({ hasCoverPoster: e, platform: t, surface: n }) => e ? t !== "IG" || n !== "reel" && n !== "story" : !1, sm = [
	".mp4",
	".mov",
	".webm",
	".m4v"
], cm = (e) => e?.url || e?.thumbnailUrl || "", Z = (e) => {
	if (!e) return !1;
	if (e.isVideo || e.type?.toLowerCase().startsWith("video/")) return !0;
	let t = cm(e).toLowerCase().split(/[?#]/)[0];
	return sm.some((e) => t.endsWith(e));
}, lm = (e, t) => Z(e[t]) ? e.slice(0, t).filter(Z).length : t, um = ({ coverScope: e = "singlePostOnly", media: t, mediaCount: n = 1, mediaIndex: r = 0, preferVideoCoverPreviewOverride: i = !1, videoCoverPreview: a }) => {
	let o = cm(t), s = a || void 0, c = t?.thumbnailUrl || void 0;
	return (e === "allVideos" || e === "firstVideoOnly" && r === 0 || e === "singlePostOnly" && n === 1 || i && r === 0) && s ? s : c || o || void 0;
}, dm = ({ fit: e, media: t, platform: n, surface: r }) => ({
	fit: e || hm({
		media: t,
		platform: n,
		surface: r
	}),
	intrinsicRatio: mm(t),
	publishedRatio: gm({
		media: t,
		platform: n,
		surface: r
	})
}), fm = ({ fit: e, media: t, platform: n, surface: r, width: i }) => {
	let a = dm({
		fit: e,
		media: t,
		platform: n,
		surface: r
	}), o = bm(a.publishedRatio);
	return {
		...a,
		height: xm(i / o),
		width: i
	};
}, pm = (e) => ({
	autoPlay: !1,
	autoplayMode: "none",
	loop: !1,
	muted: !1
}), mm = (e) => {
	let t = e?.width, n = e?.height;
	if (!(!t || !n || t <= 0 || n <= 0)) return `${t} / ${n}`;
}, hm = ({ media: e, platform: t, surface: n }) => (t === "IG" || t === "FB") && n === "reel" || (t === "LI" || t === "YT" || t === "OT" || t === "TT") && n === "video" || t === "PI" && n === "pin" && Z(e) ? "contain" : "cover", gm = ({ media: e, platform: t, surface: n }) => t === "IG" && (n === "feed" || n === "carousel") ? ym({
	fallbackRatio: "1 / 1",
	maxRatio: 1.91,
	maxRatioLabel: "1.91 / 1",
	media: e,
	minRatio: 4 / 5,
	minRatioLabel: "4 / 5"
}) : t === "OT" ? n === "video" ? vm({
	fallbackRatio: "16 / 9",
	media: e
}) : "1 / 1" : n === "story" || n === "reel" || t === "SC" || t === "TT" ? "9 / 16" : t === "PI" && n === "pin" ? Z(e) ? ym({
	fallbackRatio: "1 / 1",
	maxRatio: 1.91,
	maxRatioLabel: "1.91 / 1",
	media: e,
	minRatio: 1 / 2,
	minRatioLabel: "1 / 2"
}) : _m(e) : t === "TW" && n === "video" ? ym({
	fallbackRatio: "16 / 9",
	maxRatio: 1.91,
	maxRatioLabel: "1.91 / 1",
	media: e,
	minRatio: 9 / 16,
	minRatioLabel: "9 / 16"
}) : t === "TW" && n === "grid" ? ym({
	fallbackRatio: "1 / 1",
	maxRatio: 1.91,
	maxRatioLabel: "1.91 / 1",
	media: e,
	minRatio: 9 / 16,
	minRatioLabel: "9 / 16"
}) : t === "TH" && n === "video" ? ym({
	fallbackRatio: "4 / 5",
	maxRatio: 1.91,
	maxRatioLabel: "1.91 / 1",
	media: e,
	minRatio: 9 / 16,
	minRatioLabel: "9 / 16"
}) : t === "TH" && n === "grid" || t === "FB" && n === "grid" ? ym({
	fallbackRatio: "1 / 1",
	maxRatio: 1.91,
	maxRatioLabel: "1.91 / 1",
	media: e,
	minRatio: 4 / 5,
	minRatioLabel: "4 / 5"
}) : t === "LI" && (n === "grid" || n === "video") ? ym({
	fallbackRatio: n === "video" ? "16 / 9" : "1 / 1",
	maxRatio: n === "video" ? 16 / 9 : 1.91,
	maxRatioLabel: n === "video" ? "16 / 9" : "1.91 / 1",
	media: e,
	minRatio: n === "video" ? 9 / 16 : 1 / 1.91,
	minRatioLabel: n === "video" ? "9 / 16" : "1 / 1.91"
}) : t === "GMB" ? n === "carousel" ? "1 / 1" : "400 / 264" : t === "YT" && n === "video" ? vm({
	fallbackRatio: "16 / 9",
	media: e
}) : "1 / 1", _m = (e) => {
	let t = e?.width, n = e?.height;
	return !t || !n || t <= 0 || n <= 0 ? "400 / 264" : t / n <= 2 / 3 ? "2 / 3" : `${t} / ${n}`;
}, vm = ({ fallbackRatio: e, media: t }) => {
	let n = t?.width, r = t?.height;
	return !n || !r || n <= 0 || r <= 0 ? e : `${n} / ${r}`;
}, ym = ({ fallbackRatio: e, maxRatio: t, maxRatioLabel: n, media: r, minRatio: i, minRatioLabel: a }) => {
	let o = r?.width, s = r?.height;
	if (!o || !s || o <= 0 || s <= 0) return e;
	let c = o / s;
	return c < i ? a : c > t ? n : `${o} / ${s}`;
}, bm = (e) => {
	let [t, n] = e.split("/").map((e) => Number(e.trim()));
	return !t || !n || t <= 0 || n <= 0 ? 1 : t / n;
}, xm = (e) => Math.round(e * 1e3) / 1e3, Q = ({ audioControlsClassName: e, backgroundColor: t, className: n, controls: r, coverScope: i, customVideoControls: a, fit: o, imageClassName: s, isActive: c = !0, media: l, mediaCount: u = 1, mediaIndex: d = 0, measureWhenInactive: f = !1, onIntrinsicDimensions: p, platform: m, preferVideoCoverPreviewOverride: h, surface: g, videoClassName: v, videoCoverPreview: y }) => {
	let b = cm(l), x = Z(l), S = dm({
		fit: o,
		media: l,
		platform: m,
		surface: g
	}), C = S.fit === "contain" ? "sp-object-contain" : "sp-object-cover", w = /* @__PURE__ */ _("div", {
		className: ["sp-h-full sp-w-full sp-bg-[#e6e6e6]", n].filter(Boolean).join(" "),
		"data-uplift-fit": S.fit,
		"data-uplift-media-kind": "empty",
		"data-uplift-published-ratio": S.publishedRatio
	});
	if (!b) return w;
	if (x) {
		let o = um({
			coverScope: i,
			media: l,
			mediaCount: u,
			mediaIndex: d,
			preferVideoCoverPreviewOverride: h,
			videoCoverPreview: y
		}), s = pm({
			isActive: c,
			platform: m,
			surface: g
		}), x = om({
			hasCoverPoster: !!(o && o !== b),
			platform: m,
			surface: g
		}), w = g === "reel" || g === "story", T = a ?? (w || x), E = r ?? (!T || x && !w);
		return /* @__PURE__ */ _(Gp, {
			audioControlsClassName: e,
			autoPlay: s.autoPlay,
			autoplayMode: s.autoplayMode,
			backgroundColor: t,
			className: n,
			controls: E,
			customControls: T,
			fit: S.fit,
			gateCover: x,
			intrinsicRatio: S.intrinsicRatio,
			isActive: c,
			loop: s.loop,
			measureWhenInactive: f,
			muted: s.muted,
			onIntrinsicDimensions: (e, t) => p?.(b, e, t),
			poster: o,
			publishedRatio: S.publishedRatio,
			source: b,
			videoClassName: [C, v].filter(Boolean).join(" ")
		}, b);
	}
	return /* @__PURE__ */ _(Sm, {
		fallbackSource: l?.thumbnailUrl,
		source: b,
		terminalFallback: w,
		alt: "",
		className: [
			"sp-block sp-h-full sp-w-full",
			C,
			n,
			s
		].filter(Boolean).join(" "),
		"data-uplift-fit": S.fit,
		"data-uplift-intrinsic-ratio": S.intrinsicRatio,
		"data-uplift-media-kind": "image",
		"data-uplift-published-ratio": S.publishedRatio,
		onLoad: (e) => {
			p?.(b, e.currentTarget.naturalWidth, e.currentTarget.naturalHeight);
		}
	}, `${b}\u0000${l?.thumbnailUrl ?? ""}`);
}, Sm = ({ fallbackSource: e, onError: t, source: n, terminalFallback: r, ...i }) => {
	let [a, o] = h([]), s = [n, ...e && e !== n ? [e] : []].find((e) => !a.includes(e));
	return s ? /* @__PURE__ */ _("img", {
		...i,
		onError: (e) => {
			o((e) => e.includes(s) ? e : [...e, s]), t?.(e);
		},
		src: s
	}, s) : r;
}, Cm = (e) => {
	let [t, n] = h(() => /* @__PURE__ */ new Map()), r = JSON.stringify(e.map(cm).filter(Boolean)), i = p(() => new Set(JSON.parse(r)), [r]), a = l((e, t, r) => {
		!e || !i.has(e) || !Number.isFinite(t) || !Number.isFinite(r) || t <= 0 || r <= 0 || n((n) => {
			let i = n.get(e);
			if (i?.width === t && i.height === r) return n;
			let a = new Map(n);
			return a.set(e, {
				height: r,
				width: t
			}), a;
		});
	}, [i]);
	return {
		medias: p(() => e.map((e) => {
			let n = t.get(cm(e));
			return n ? {
				...e,
				height: n.height,
				width: n.width
			} : e;
		}), [t, e]),
		reportIntrinsicDimensions: a
	};
}, wm = {
	collection: [],
	count: 0
}, $ = (e) => !!e?.trim(), Tm = (e) => {
	let t = e.medias?.collection ?? [], n = e;
	return {
		id: e.id,
		caption: e.caption || "",
		comment: e.comment || "",
		platform: e.platform,
		type: e.type,
		storyType: e.storyType || null,
		medias: e.medias ? {
			collection: t,
			count: e.medias.count ?? t.length
		} : wm,
		username: e.username || "",
		profilePicture: e.profilePicture || "",
		followerCount: n.followedBy ?? n.followed_by ?? n.providedPost?.followed_by ?? null,
		imageUrl: e.image_url || "",
		locationName: e.locationName || null,
		redirectUrl: e.redirectUrl || "",
		storyUrl: e.storyUrl || "",
		storyLabel: e.storyLabel || "",
		storyStickerHeight: e.storyStickerHeight || null,
		tags: Array.isArray(e.providedPost?.tags) ? e.providedPost.tags : [],
		productTags: Array.isArray(e.providedPost?.productTags) ? e.providedPost.productTags : [],
		callToAction: e.callToAction || "",
		event: e.event || "",
		topicType: e.topicType || null,
		ytTitle: e.ytTitle || null,
		piTitle: e.piTitle || null,
		boardTitle: e.boardTitle || null,
		collaboratingIgUsers: n.collaboratingIgUsers ?? n.providedPost?.collaboratingIgUsers,
		providedPost: e.providedPost,
		sourcePost: e
	};
}, Em = /* @__PURE__ */ new Set([
	"fb-reel",
	"image",
	"multiMedia",
	"story",
	"text",
	"video"
]), Dm = 44, Om = 32, km = 5, Am = 3, jm = 20, Mm = 30, Nm = 55, Pm = 49, Fm = 48, Im = 20, Lm = 16, Rm = 36, zm = 1, Bm = 54, Vm = 622, Hm = (e) => e instanceof Element && !!e.closest("a, button"), Um = (e) => e.platform === "FB" && (Em.has(e.type) || jh(e)), Wm = ({ post: e, className: t, trackEvent: n, videoCoverPreview: r }) => {
	let i = e.type === "fb-reel" || jh(e), a = e.type === "story";
	return _(i ? _h : a ? yh : Gm, {
		post: e,
		className: t,
		trackEvent: n,
		videoCoverPreview: r
	});
}, Gm = ({ post: e, className: t, trackEvent: n, videoCoverPreview: r }) => {
	let { medias: i, reportIntrinsicDimensions: a } = Cm(e.medias.collection), [o, s] = h(!1), c = mh(e, i), l = ch({
		caption: e.caption,
		charsPerLine: c.charsPerLine,
		collapsedLines: c.collapsedLines,
		expanded: o,
		lineHeight: c.lineHeight
	}), u = [e.caption, o ? "expanded" : "collapsed"].join("|"), [d, p] = h(null), g = [e.username, e.comment].join("|"), [y, b] = h(null), x = m(null), S = m(null), C = d?.key === u ? d.height : void 0, w = y?.key === g ? y.height : void 0, T = eh(e, i, o, C, w), E = $(e.caption);
	return f(() => {
		if (!o) {
			p(null);
			return;
		}
		let e = x.current;
		if (!e) return;
		let t = Math.ceil(e.scrollHeight);
		t > 0 && Math.abs(t - l) > 1 && p({
			height: t,
			key: u
		});
	}, [
		o,
		u,
		l
	]), f(() => {
		if (!e.comment.trim()) {
			b(null);
			return;
		}
		let t = S.current;
		if (!t) return;
		let n = Math.ceil(t.scrollHeight);
		n > 0 && n !== w && b({
			height: n,
			key: g
		});
	}, [
		g,
		w,
		e.comment
	]), /* @__PURE__ */ _(Lp, {
		className: ["sp-relative sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-bg-white sp-text-[#141414]", t].filter(Boolean).join(" "),
		platform: "FB",
		style: { height: T.height },
		children: /* @__PURE__ */ v("article", {
			className: "sp-relative sp-w-full",
			"data-uplift-renderer": "facebook",
			"data-uplift-layout": T.dataLayout,
			style: { height: T.height },
			children: [
				/* @__PURE__ */ _(qm, { post: e }),
				E && /* @__PURE__ */ _("div", {
					ref: x,
					className: ["sp-absolute sp-left-4 sp-top-[68px] sp-w-[368px] sp-overflow-hidden sp-break-words sp-whitespace-pre-line sp-leading-5 [&_a]:sp-text-[#1877f2] [&_a]:sp-no-underline", T.captionClassName].join(" "),
					style: { height: T.captionHeight },
					children: /* @__PURE__ */ _(Jm, {
						caption: e.caption,
						charsPerLine: Dm,
						collapsedLines: c.collapsedLines,
						expanded: o,
						onExpandedChange: s,
						trackEvent: n
					})
				}),
				T.kind === "link" && /* @__PURE__ */ _(Zm, {
					layout: T,
					post: e,
					videoCoverPreview: r
				}),
				T.kind === "video" && /* @__PURE__ */ _(Xm, {
					layout: T,
					media: i[0],
					onIntrinsicDimensions: a,
					post: e,
					videoCoverPreview: r
				}),
				T.kind === "single-media" && /* @__PURE__ */ _(Ym, {
					media: i[0],
					mediaCount: i.length,
					mediaIndex: 0,
					onIntrinsicDimensions: a,
					rect: T.mediaRects[0],
					videoCoverPreview: r
				}),
				T.kind === "media-link" && T.mediaRects.map((t, n) => /* @__PURE__ */ _(Ym, {
					href: Z(i[n]) ? void 0 : e.redirectUrl,
					media: i[n],
					mediaCount: i.length,
					mediaIndex: lm(i, n),
					onIntrinsicDimensions: a,
					rect: t,
					videoCoverPreview: r,
					children: t.overlayCount ? /* @__PURE__ */ v("div", {
						className: "sp-absolute sp-inset-0 sp-flex sp-items-center sp-justify-center sp-bg-black/45 sp-text-[26px] sp-font-medium sp-leading-none sp-text-white",
						children: ["+", t.overlayCount]
					}) : null
				}, Km(i[n], t))),
				T.kind === "media-link" && T.linkCardTop !== void 0 && /* @__PURE__ */ _(gh, {
					post: e,
					top: T.linkCardTop
				}),
				T.kind === "collage" && T.mediaRects.map((e, t) => /* @__PURE__ */ _(Ym, {
					media: i[t],
					mediaCount: i.length,
					mediaIndex: lm(i, t),
					onIntrinsicDimensions: a,
					rect: e,
					videoCoverPreview: r,
					children: e.overlayCount ? /* @__PURE__ */ v("div", {
						className: "sp-absolute sp-inset-0 sp-flex sp-items-center sp-justify-center sp-bg-black/45 sp-text-[26px] sp-font-medium sp-leading-none sp-text-white",
						children: ["+", e.overlayCount]
					}) : null
				}, Km(i[t], e))),
				/* @__PURE__ */ _(Qm, { top: T.actionsTop }),
				T.firstCommentTop !== void 0 && /* @__PURE__ */ _($m, {
					commentRef: S,
					post: e,
					top: T.firstCommentTop,
					trackEvent: n
				})
			]
		})
	});
}, Km = (e, t) => [
	e?.url ?? e?.thumbnailUrl ?? e?.fileName ?? "media",
	t.left,
	t.top,
	t.width,
	t.height
].join("-"), qm = ({ post: e }) => /* @__PURE__ */ v("header", {
	className: "sp-absolute sp-left-4 sp-top-4 sp-flex sp-w-[368px] sp-items-center sp-justify-between",
	children: [/* @__PURE__ */ v("div", {
		className: "sp-flex sp-items-center sp-gap-2",
		children: [/* @__PURE__ */ _(X, {
			className: "sp-h-10 sp-w-10",
			src: e.profilePicture,
			alt: e.username
		}), /* @__PURE__ */ v("div", {
			className: "sp-flex sp-flex-col sp-items-start sp-gap-1",
			children: [/* @__PURE__ */ _(zp, {
				className: "sp-text-base sp-leading-none",
				children: e.username
			}), /* @__PURE__ */ v("div", {
				className: "sp-flex sp-items-center sp-gap-1 sp-text-sm sp-leading-none sp-text-[#808080]",
				children: [
					/* @__PURE__ */ _("span", { children: "Just now" }),
					/* @__PURE__ */ _("span", {
						"aria-hidden": "true",
						children: "."
					}),
					/* @__PURE__ */ _(Sh, {})
				]
			})]
		})]
	}), /* @__PURE__ */ _(Dh, {
		className: "sp-text-[#808080]",
		size: 32
	})]
}), Jm = ({ caption: e, charsPerLine: t, collapsedLines: n, expanded: r, onExpandedChange: i, trackEvent: a }) => {
	let o = uh({
		caption: e,
		charsPerLine: t,
		collapsedLines: n
	}), s = o !== e.trim(), c = r || !s ? e : `${o}... `;
	return /* @__PURE__ */ v("div", {
		"aria-expanded": s ? r : void 0,
		className: ["sp-break-words sp-whitespace-pre-line", s ? "sp-cursor-pointer" : void 0].filter(Boolean).join(" "),
		onClick: (e) => {
			let t = e.target;
			!s || !(t instanceof HTMLElement) || t.closest("a, button") || i(!r);
		},
		children: [/* @__PURE__ */ _(Y, {
			caption: c,
			targetPlatform: "FB",
			trackEvent: a
		}), s ? /* @__PURE__ */ v(g, { children: [r ? " " : null, /* @__PURE__ */ _("button", {
			"aria-expanded": r,
			className: "sp-inline sp-cursor-pointer sp-border-0 sp-bg-transparent sp-p-0 sp-text-left sp-font-inherit sp-leading-inherit sp-text-[#808080]",
			onClick: () => i(!r),
			type: "button",
			children: r ? "Show less" : "See more"
		})] }) : null]
	});
}, Ym = ({ children: e, href: t, media: n, mediaCount: r, mediaIndex: i, onIntrinsicDimensions: a, rect: o, videoCoverPreview: s }) => {
	let c = "sp-absolute sp-overflow-hidden sp-bg-[#e4e6eb]", l = {
		height: o.height,
		left: o.left,
		top: o.top,
		width: o.width
	}, u = /* @__PURE__ */ v(g, { children: [n && /* @__PURE__ */ _(Q, {
		coverScope: "firstVideoOnly",
		media: n,
		mediaCount: r,
		mediaIndex: i,
		onIntrinsicDimensions: a,
		platform: "FB",
		surface: "grid",
		videoCoverPreview: s
	}), e] });
	return t ? /* @__PURE__ */ _("a", {
		"aria-label": `Open ${Ah(t)} in a new tab`,
		className: `${c} sp-block sp-text-inherit sp-no-underline`,
		"data-uplift-media-frame-ratio": `${o.width} / ${o.height}`,
		href: t,
		rel: "noreferrer",
		style: l,
		target: "_blank",
		children: u
	}) : /* @__PURE__ */ _("div", {
		className: c,
		"data-uplift-media-frame-ratio": `${o.width} / ${o.height}`,
		style: l,
		children: u
	});
}, Xm = ({ layout: e, media: t, onIntrinsicDimensions: n, post: r, videoCoverPreview: i }) => /* @__PURE__ */ v("div", {
	className: "sp-absolute sp-left-0 sp-w-full sp-overflow-hidden sp-bg-black",
	"data-uplift-media-frame-ratio": e.mediaRects[0] ? `${e.mediaRects[0].width} / ${e.mediaRects[0].height}` : void 0,
	style: {
		height: e.contentHeight,
		top: e.contentTop
	},
	children: [/* @__PURE__ */ _(Q, {
		coverScope: "singlePostOnly",
		media: t ?? {
			isVideo: !0,
			thumbnailUrl: r.imageUrl,
			url: r.imageUrl
		},
		platform: "FB",
		onIntrinsicDimensions: n,
		surface: "grid",
		videoCoverPreview: i
	}), /* @__PURE__ */ _("div", {
		className: "sp-absolute sp-bottom-4 sp-right-4 sp-flex sp-h-7 sp-w-7 sp-items-center sp-justify-center sp-rounded-full sp-bg-black/50 sp-text-white",
		children: /* @__PURE__ */ _(kh, { size: 20 })
	})]
}), Zm = ({ layout: e, post: t, videoCoverPreview: n }) => {
	let r = t.medias.collection[0] ?? {
		thumbnailUrl: t.imageUrl || n,
		url: t.imageUrl || n
	};
	return /* @__PURE__ */ _("a", {
		className: "sp-absolute sp-left-0 sp-block sp-w-full sp-overflow-hidden sp-text-inherit sp-no-underline",
		href: t.redirectUrl,
		rel: "noreferrer",
		style: {
			height: e.contentHeight,
			top: e.contentTop
		},
		target: "_blank",
		children: e.linkHasBody ? /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _("div", {
			className: "sp-relative sp-h-[273px] sp-w-full sp-overflow-hidden sp-bg-[#e4e6eb]",
			children: /* @__PURE__ */ _(Q, {
				media: r,
				platform: "FB",
				surface: "grid"
			})
		}), /* @__PURE__ */ v("div", {
			className: "sp-box-border sp-h-[55px] sp-w-full sp-bg-[#f2f2f2] sp-px-4 sp-py-2",
			children: [/* @__PURE__ */ _("div", {
				className: "sp-truncate sp-text-xs sp-leading-5 sp-text-[#65676b]",
				children: Ah(t.redirectUrl)
			}), /* @__PURE__ */ _("div", {
				className: "sp-truncate sp-text-[15px] sp-font-semibold sp-leading-[19px] sp-text-[#141414]",
				children: t.redirectUrl
			})]
		})] }) : /* @__PURE__ */ _("div", {
			className: "sp-relative sp-h-[273px] sp-w-full sp-overflow-hidden sp-bg-[#e4e6eb]",
			children: /* @__PURE__ */ _(Q, {
				media: r,
				platform: "FB",
				surface: "grid"
			})
		})
	});
}, Qm = ({ top: e }) => /* @__PURE__ */ v("footer", {
	className: "sp-absolute sp-left-0 sp-flex sp-h-10 sp-w-full sp-items-start sp-gap-8 sp-px-4 sp-text-sm sp-font-medium sp-leading-none sp-text-[#808080]",
	style: { top: e },
	children: [
		/* @__PURE__ */ _(bh, {
			icon: /* @__PURE__ */ _(Ch, {}),
			count: 1
		}),
		/* @__PURE__ */ _(bh, {
			icon: /* @__PURE__ */ _(wh, {}),
			count: 1
		}),
		/* @__PURE__ */ _(bh, {
			className: "sp-gap-1",
			icon: /* @__PURE__ */ _(Th, {}),
			count: 1
		})
	]
}), $m = ({ commentRef: e, post: t, top: n, trackEvent: r }) => /* @__PURE__ */ v("div", {
	className: "sp-absolute sp-left-4 sp-w-[368px] sp-whitespace-pre-line sp-break-words sp-text-base sp-leading-5 [&_a]:sp-text-[#1877f2] [&_a]:sp-no-underline",
	"data-uplift-first-comment": "facebook",
	ref: e,
	style: { top: n },
	children: [/* @__PURE__ */ _("span", {
		className: "sp-mr-1 sp-font-semibold",
		children: t.username
	}), /* @__PURE__ */ _(Y, {
		caption: t.comment.trim(),
		targetPlatform: "FB",
		trackEvent: r
	})]
}), eh = (e, t, n, r, i) => {
	let a = mh(e, t), o = r ?? ch({
		caption: e.caption,
		charsPerLine: a.charsPerLine,
		collapsedLines: a.collapsedLines,
		expanded: n,
		lineHeight: a.lineHeight
	}), s = a.className, c = o > 0, l = t.length, u = i ?? lh(e);
	if (e.redirectUrl && l > 0) {
		let e = nh(t, o), n = Math.max(...e.mediaRects.map((e) => e.top + e.height)), r = n, i = r + Nm + 12;
		return th({
			actionsTop: i,
			captionHeight: o,
			captionClassName: s,
			contentHeight: n - e.contentTop,
			contentTop: e.contentTop,
			dataLayout: "facebook-media-link",
			height: i + Pm,
			kind: "media-link",
			linkCardTop: r,
			mediaRects: e.mediaRects
		}, u);
	}
	if (l <= 1 && (e.type === "video" || Z(t[0]))) {
		let e = sh(t[0], oh(140, o)), n = e.top + e.height + 12;
		return th({
			actionsTop: n,
			captionHeight: o,
			captionClassName: s,
			contentHeight: e.height,
			contentTop: e.top,
			dataLayout: "facebook-video",
			height: n + Pm,
			kind: "video",
			mediaRects: [e]
		}, u);
	}
	if (e.redirectUrl) {
		let e = c && o >= 180, t = oh(e ? 264 : 140, o), n = e ? 273 : 328, r = t + n + (e ? 16 : -1);
		return th({
			actionsTop: r,
			captionHeight: o,
			captionClassName: s,
			contentHeight: n,
			contentTop: t,
			dataLayout: e ? "facebook-hashtag" : "facebook-link",
			height: r + Pm,
			kind: "link",
			linkHasBody: !e,
			mediaRects: []
		}, u);
	}
	if (l === 0) {
		let e = oh(138, o), t = o === 0 ? rh : Math.max(e, o >= 180 ? 260 : o >= 100 ? 180 : 138);
		return th({
			actionsTop: t,
			captionHeight: o,
			captionClassName: s,
			contentHeight: 0,
			contentTop: 0,
			dataLayout: "facebook-text",
			height: t + Pm,
			kind: "text",
			mediaRects: []
		}, u);
	}
	return th({
		...nh(t, o),
		captionHeight: o,
		captionClassName: s
	}, u);
}, th = (e, t) => {
	if (t <= 0) return e;
	let n = e.actionsTop + Pm;
	return {
		...e,
		firstCommentTop: n,
		height: n + t + Lm
	};
}, nh = (e, t) => {
	let n = e.length;
	if (n === 1) {
		if (t >= 700) {
			let n = sh(e[0], oh(780, t)), r = n.top + n.height + 12;
			return {
				actionsTop: r,
				contentHeight: n.height,
				contentTop: n.top,
				dataLayout: "facebook-image-long",
				height: r + Pm,
				kind: "single-media",
				mediaRects: [n]
			};
		}
		if (t >= 180) {
			let n = sh(e[0], oh(264, t)), r = n.top + n.height + 12;
			return {
				actionsTop: r,
				contentHeight: n.height,
				contentTop: n.top,
				dataLayout: "facebook-image-hashtag",
				height: r + Pm,
				kind: "single-media",
				mediaRects: [n]
			};
		}
		let n = sh(e[0], oh(137, t)), r = n.top + n.height + 12;
		return {
			actionsTop: r,
			contentHeight: n.height,
			contentTop: n.top,
			dataLayout: "facebook-image",
			height: r + Pm,
			kind: "single-media",
			mediaRects: [n]
		};
	}
	if (n === 2) {
		let e = oh(137, t), n = e + 196 + 10;
		return {
			actionsTop: n,
			contentHeight: 196,
			contentTop: e,
			dataLayout: "facebook-collage-2",
			height: n + Pm,
			kind: "collage",
			mediaRects: [{
				height: 196,
				left: 0,
				top: e,
				width: 196
			}, {
				height: 196,
				left: 204,
				top: e,
				width: 196
			}]
		};
	}
	if (n === 3) {
		let n = oh(144, t);
		if (hh(e)) {
			let e = n + 400 + 16;
			return {
				actionsTop: e,
				contentHeight: 400,
				contentTop: n,
				dataLayout: "facebook-collage-3-portrait",
				height: e + Pm,
				kind: "collage",
				mediaRects: [
					{
						height: 400,
						left: 0,
						top: n,
						width: 196
					},
					{
						height: 196,
						left: 204,
						top: n,
						width: 196
					},
					{
						height: 196,
						left: 204,
						top: n + 204,
						width: 196
					}
				]
			};
		}
		let r = n + 204, i = n + 400 + 16;
		return {
			actionsTop: i,
			contentHeight: 400,
			contentTop: n,
			dataLayout: "facebook-collage-3",
			height: i + Pm,
			kind: "collage",
			mediaRects: [
				{
					height: 196,
					left: 0,
					top: n,
					width: 400
				},
				{
					height: 196,
					left: 0,
					top: r,
					width: 196
				},
				{
					height: 196,
					left: 204,
					top: r,
					width: 196
				}
			]
		};
	}
	if (n === 4) {
		let e = oh(144, t), n = e + 204, r = e + 400 + 16;
		return {
			actionsTop: r,
			contentHeight: 400,
			contentTop: e,
			dataLayout: "facebook-collage-4",
			height: r + Pm,
			kind: "collage",
			mediaRects: [
				{
					height: 196,
					left: 0,
					top: e,
					width: 196
				},
				{
					height: 196,
					left: 204,
					top: e,
					width: 196
				},
				{
					height: 196,
					left: 0,
					top: n,
					width: 196
				},
				{
					height: 196,
					left: 204,
					top: n,
					width: 196
				}
			]
		};
	}
	let r = oh(144, t), i = r + 204, a = r + 332 + 16;
	return {
		actionsTop: a,
		contentHeight: 332,
		contentTop: r,
		dataLayout: n > 5 ? "facebook-collage-5-plus" : "facebook-collage-5",
		height: a + Pm,
		kind: "collage",
		mediaRects: [
			{
				height: 196,
				left: 0,
				top: r,
				width: 196
			},
			{
				height: 196,
				left: 204,
				top: r,
				width: 196
			},
			{
				height: 128,
				left: 0,
				top: i,
				width: 128
			},
			{
				height: 128,
				left: 136,
				top: i,
				width: 128
			},
			{
				height: 128,
				left: 272,
				overlayCount: n > 5 ? n - 4 : void 0,
				top: i,
				width: 128
			}
		]
	};
}, rh = 68, ih = 68, ah = 9, oh = (e, t) => t > 0 ? Math.max(e, ih + t + ah) : rh, sh = (e, t) => {
	let n = fm({
		media: e,
		platform: "FB",
		surface: "grid",
		width: 400
	});
	return {
		height: n.height,
		left: 0,
		top: t,
		width: n.width
	};
}, ch = ({ caption: e, charsPerLine: t, collapsedLines: n, expanded: r, lineHeight: i }) => e.trim().length === 0 ? 0 : Dp({
	charsPerLine: t,
	collapsedLines: n,
	expanded: r,
	lineHeight: i,
	text: e
}), lh = (e) => {
	let t = e.comment.trim();
	return t ? Op({
		charsPerLine: Fm,
		leadingText: e.username,
		text: t
	}) * Im : 0;
}, uh = ({ caption: e, charsPerLine: t, collapsedLines: n, triggerText: r = "... See more" }) => {
	let i = e.trim();
	if (Op({
		charsPerLine: t,
		text: i
	}) <= n) return i;
	let a = i;
	for (; a.length > 0 && dh({
		charsPerLine: t,
		text: `${a}${r}`
	}) > n;) a = a.slice(0, -1).trimEnd();
	return a;
}, dh = ({ charsPerLine: e, text: t }) => fh(t, e).length, fh = (e, t) => e.trim().split(/\r?\n/).flatMap((e) => ph(e, t)), ph = (e, t) => {
	if (!e) return [""];
	let n = [], r = "";
	for (let i of e.match(/\S+\s*/g) ?? []) {
		let e = `${r}${i}`;
		for (r && e.trimEnd().length > t ? (n.push(r.trimEnd()), r = i.trimStart()) : r = e; r.length > t;) n.push(r.slice(0, t)), r = r.slice(t);
	}
	return r && n.push(r.trimEnd()), n;
}, mh = (e, t) => t.length > 0 || e.redirectUrl ? {
	charsPerLine: Dm,
	className: "sp-text-base",
	collapsedLines: Am,
	lineHeight: jm
} : Op({
	charsPerLine: Om,
	text: e.caption
}) <= 2 ? {
	charsPerLine: Om,
	className: "sp-text-2xl sp-leading-[30px]",
	collapsedLines: km,
	lineHeight: Mm
} : {
	charsPerLine: Dm,
	className: "sp-text-base",
	collapsedLines: km,
	lineHeight: jm
}, hh = (e) => e.length > 0 && e.every((e) => typeof e.width == "number" && typeof e.height == "number" && e.height > e.width), gh = ({ post: e, top: t }) => /* @__PURE__ */ v("a", {
	className: "sp-absolute sp-left-0 sp-box-border sp-block sp-h-[55px] sp-w-full sp-border-0 sp-border-b sp-border-solid sp-border-[#c4c4c4] sp-bg-[#f2f2f2] sp-px-4 sp-py-2 sp-text-inherit sp-no-underline",
	href: e.redirectUrl,
	rel: "noreferrer",
	style: { top: t },
	target: "_blank",
	children: [/* @__PURE__ */ _("div", {
		className: "sp-truncate sp-text-xs sp-leading-5 sp-text-[#65676b]",
		children: Ah(e.redirectUrl)
	}), /* @__PURE__ */ _("div", {
		className: "sp-truncate sp-text-[15px] sp-font-semibold sp-leading-[19px] sp-text-[#141414]",
		children: e.redirectUrl
	})]
}), _h = ({ post: e, className: t, trackEvent: n, videoCoverPreview: r }) => {
	let i = e.medias.collection[0], [a, o] = h(!1), s = r || i?.thumbnailUrl || e.imageUrl, c = i?.url || e.imageUrl, l = $(e.caption), u = l && Op({
		charsPerLine: Rm,
		text: e.caption
	}) > zm, f = a && u, p = {
		...i || {},
		thumbnailUrl: s,
		url: c || s
	};
	return d(() => {
		u || o(!1);
	}, [u]), /* @__PURE__ */ _(Lp, {
		className: ["sp-relative sp-h-[800px] sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-none sp-border-0 sp-bg-black sp-text-white sp-shadow-none", t].filter(Boolean).join(" "),
		platform: "FB",
		children: /* @__PURE__ */ v("div", {
			className: "sp-relative sp-h-full sp-w-full",
			"data-uplift-renderer": "facebook",
			"data-uplift-layout": "facebook-reel",
			children: [
				/* @__PURE__ */ _("div", {
					className: "sp-absolute sp-inset-0",
					"data-uplift-media-frame-ratio": "9 / 16",
					children: /* @__PURE__ */ _(Q, {
						backgroundColor: "#000",
						className: "sp-h-full sp-w-full",
						coverScope: "singlePostOnly",
						customVideoControls: !0,
						media: {
							...p,
							isVideo: Z(p)
						},
						platform: "FB",
						surface: "reel",
						videoCoverPreview: r
					})
				}),
				/* @__PURE__ */ _("div", { className: "sp-absolute sp-inset-x-0 sp-top-[546px] sp-h-[254px] sp-bg-gradient-to-t sp-from-[rgba(0,0,0,0.6)] sp-to-transparent" }),
				f && /* @__PURE__ */ _("div", {
					className: "sp-pointer-events-none sp-absolute sp-inset-0 sp-bg-black/40",
					"data-uplift-caption-backdrop": "true"
				}),
				/* @__PURE__ */ v("div", {
					className: "sp-absolute sp-left-4 sp-top-8 sp-flex sp-h-6 sp-w-[368px] sp-items-center sp-justify-between",
					children: [/* @__PURE__ */ _(Oh, {}), /* @__PURE__ */ v("div", {
						className: "sp-flex sp-items-center sp-gap-4",
						children: [/* @__PURE__ */ _(Eh, {}), /* @__PURE__ */ _(X, {
							className: "sp-h-6 sp-w-6",
							src: e.profilePicture,
							alt: e.username
						})]
					})]
				}),
				/* @__PURE__ */ v("div", {
					className: "sp-absolute sp-left-[352px] sp-top-[424px] sp-flex sp-w-8 sp-flex-col sp-gap-10 sp-text-white",
					children: [
						/* @__PURE__ */ _(Ch, { size: 32 }),
						/* @__PURE__ */ _(wh, { size: 32 }),
						/* @__PURE__ */ _(Th, { size: 32 }),
						/* @__PURE__ */ _(wh, { size: 32 }),
						/* @__PURE__ */ _(Dh, { size: 32 })
					]
				}),
				/* @__PURE__ */ v("div", {
					className: "sp-absolute sp-left-5 sp-flex sp-w-[298px] sp-flex-col sp-gap-3",
					style: { bottom: Bm },
					children: [/* @__PURE__ */ v("div", {
						className: "sp-flex sp-items-center sp-gap-3",
						children: [
							/* @__PURE__ */ _(X, {
								className: "sp-h-10 sp-w-10",
								src: e.profilePicture,
								alt: e.username
							}),
							/* @__PURE__ */ _(zp, {
								className: "sp-text-white",
								children: e.username
							}),
							/* @__PURE__ */ _("button", {
								className: "sp-rounded-[9px] sp-border sp-border-solid sp-border-white/30 sp-bg-transparent sp-px-2 sp-py-1 sp-text-[15px] sp-font-medium sp-leading-none sp-text-white",
								type: "button",
								children: "Follow"
							})
						]
					}), l && /* @__PURE__ */ _(vh, {
						caption: e.caption,
						expanded: f,
						onExpandedChange: o,
						trackEvent: n
					})]
				})
			]
		})
	});
}, vh = ({ caption: e, expanded: t, onExpandedChange: n, trackEvent: r }) => {
	if (!(Op({
		charsPerLine: Rm,
		text: e
	}) > zm)) return /* @__PURE__ */ _("div", {
		className: "sp-text-base sp-leading-5 sp-text-white",
		children: /* @__PURE__ */ _(Y, {
			caption: e,
			targetPlatform: "FB",
			trackEvent: r
		})
	});
	let i = uh({
		caption: e,
		charsPerLine: Rm,
		collapsedLines: zm,
		triggerText: "...more"
	}), a = () => n(!t);
	return /* @__PURE__ */ v("div", { children: [/* @__PURE__ */ v("div", {
		className: ["sp-break-words sp-whitespace-pre-line sp-text-base sp-leading-5 sp-text-white [&_*]:sp-inline", t ? "sp-overflow-y-auto sp-pr-1" : "sp-overflow-hidden"].filter(Boolean).join(" "),
		style: t ? { maxHeight: Vm } : void 0,
		children: [/* @__PURE__ */ _("span", {
			"aria-expanded": t,
			className: "sp-cursor-pointer",
			onClick: (e) => {
				Hm(e.target) || a();
			},
			onKeyDown: (e) => {
				Hm(e.target) || (e.key === "Enter" || e.key === " ") && (e.preventDefault(), a());
			},
			role: "button",
			tabIndex: 0,
			children: /* @__PURE__ */ _(Y, {
				caption: t ? e : i,
				targetPlatform: "FB",
				trackEvent: r
			})
		}), t ? null : /* @__PURE__ */ _("button", {
			"aria-expanded": t,
			className: "sp-inline sp-cursor-pointer sp-border-none sp-bg-transparent sp-p-0 sp-text-sm sp-text-gray-400",
			onClick: (e) => {
				e.stopPropagation(), a();
			},
			type: "button",
			children: "...more"
		})]
	}), t ? /* @__PURE__ */ _("button", {
		"aria-expanded": t,
		className: "sp-cursor-pointer sp-border-none sp-bg-transparent sp-p-0 sp-text-sm sp-text-gray-400",
		onClick: (e) => {
			e.stopPropagation(), a();
		},
		type: "button",
		children: "less"
	}) : null] });
}, yh = ({ post: e, className: t, trackEvent: n, videoCoverPreview: r }) => {
	let i = e.medias.collection[0], a = i?.url || e.imageUrl || i?.thumbnailUrl || "", o = r || i?.thumbnailUrl || e.imageUrl, s = {
		...i || {},
		isVideo: Z(i) || Z({
			thumbnailUrl: o,
			url: a || o
		}),
		thumbnailUrl: o,
		url: a || o
	};
	return /* @__PURE__ */ _(Lp, {
		className: ["sp-relative sp-h-[710px] sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-none sp-border-0 sp-bg-black sp-text-white sp-shadow-none", t].filter(Boolean).join(" "),
		platform: "FB",
		children: /* @__PURE__ */ v("div", {
			className: "sp-relative sp-h-full sp-w-full",
			"data-uplift-renderer": "facebook",
			"data-uplift-layout": "facebook-story",
			children: [
				a ? /* @__PURE__ */ _("div", {
					className: "sp-absolute sp-inset-0",
					"data-uplift-media-frame-ratio": "9 / 16",
					children: /* @__PURE__ */ _(Q, {
						className: "sp-h-full sp-w-full",
						coverScope: "singlePostOnly",
						customVideoControls: !0,
						media: s,
						platform: "FB",
						surface: "story",
						videoCoverPreview: r
					})
				}) : /* @__PURE__ */ _("div", { className: "sp-absolute sp-inset-0 sp-bg-[#1b4f9c]" }),
				/* @__PURE__ */ _("div", {
					className: "sp-absolute sp-left-[11px] sp-top-2.5 sp-h-1 sp-w-[380px] sp-rounded-full sp-bg-white/70",
					children: /* @__PURE__ */ _("div", { className: "sp-h-full sp-w-[190.504px] sp-rounded-full sp-bg-white" })
				}),
				/* @__PURE__ */ v("div", {
					className: "sp-absolute sp-left-2.5 sp-top-6 sp-flex sp-h-[36.487px] sp-w-[280px] sp-items-center sp-gap-2.5",
					children: [
						/* @__PURE__ */ _(X, {
							className: "sp-h-[36.487px] sp-w-[36.487px]",
							src: e.profilePicture,
							alt: e.username
						}),
						/* @__PURE__ */ _(zp, {
							className: "sp-text-sm sp-leading-[14px] sp-text-white",
							children: e.username
						}),
						/* @__PURE__ */ _("span", {
							className: "sp-text-sm sp-leading-none sp-text-white/70",
							children: "15h"
						})
					]
				}),
				/* @__PURE__ */ v("div", {
					className: "sp-absolute sp-left-[317px] sp-top-[33.5px] sp-flex sp-h-[18px] sp-w-[74px] sp-items-center sp-justify-between sp-text-white",
					children: [
						/* @__PURE__ */ _(Eh, { size: 18 }),
						/* @__PURE__ */ _(Dh, { size: 18 }),
						/* @__PURE__ */ _(Oh, { size: 18 })
					]
				}),
				!a && $(e.caption) && /* @__PURE__ */ _("div", {
					className: "sp-absolute sp-left-[104px] sp-top-[341px] sp-w-[191px] sp-text-center sp-text-[22px] sp-font-semibold sp-leading-[27px] sp-text-white",
					children: /* @__PURE__ */ _(Y, {
						caption: e.caption,
						targetPlatform: "FB",
						trackEvent: n
					})
				})
			]
		})
	});
}, bh = ({ className: e, count: t, icon: n }) => /* @__PURE__ */ v("span", {
	className: ["sp-flex sp-items-center sp-gap-2", e].filter(Boolean).join(" "),
	children: [n, /* @__PURE__ */ _("span", { children: t })]
}), xh = ({ children: e, size: t = 24, className: n = "sp-text-[#808080]", viewBox: r = "0 0 24 24" }) => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	className: n,
	fill: "none",
	height: t,
	viewBox: r,
	width: t,
	children: e
}), Sh = () => /* @__PURE__ */ _(xh, {
	size: 12,
	viewBox: "0 0 12 12",
	children: /* @__PURE__ */ _("path", {
		d: "M6 0C2.685 0 0 2.685 0 6C0 9.315 2.685 12 6 12C9.315 12 12 9.315 12 6C12 2.685 9.315 0 6 0ZM6 1.5C6.495 1.5 6.96 1.635 7.41 1.785C7.095 2.085 6.735 2.355 6.795 2.625C6.855 2.895 7.83 2.82 7.83 3.375C7.83 3.78 7.2 3.9 7.635 4.365C8.16 4.89 6.675 5.835 6.645 6.525C6.6 7.77 7.905 7.98 8.94 7.98C9.57 7.98 9.735 8.28 9.69 8.64C8.88 9.795 7.5 10.515 5.985 10.515C5.415 10.515 4.89 10.38 4.395 10.185C4.725 9.525 3.975 8.22 3.27 7.8C2.925 7.455 2.19 7.59 1.77 7.425C1.635 7.02 1.5 6.615 1.485 6.165C1.53 6.09 1.605 6.03 1.725 6.03C2.01 6.03 2.4 6.6 2.61 6.54C2.88 6.48 1.5 4.575 2.145 4.2C2.445 4.02 3.045 4.785 2.85 3.96C2.67 3.195 3.39 3.54 3.84 3.345C4.23 3.18 4.515 2.73 4.035 2.46C3.945 2.415 3.84 2.31 3.705 2.175C4.38 1.77 5.16 1.515 6 1.515V1.5ZM9.465 3.135C9.735 3.465 9.945 3.825 10.125 4.215V4.26C10.065 4.365 9.96 4.425 9.795 4.59C9.375 5.01 9.315 4.275 9.135 4.125C8.94 3.945 8.235 4.155 8.145 3.93C8.04 3.66 8.895 3.3 9.465 3.135Z",
		fill: "currentColor"
	})
}), Ch = ({ size: e = 24 }) => /* @__PURE__ */ _(xh, {
	className: "sp-text-current",
	size: e,
	children: /* @__PURE__ */ _("path", {
		d: "M7 22V11M2 13V20C2 21.1046 2.89543 22 4 22H17.4262C18.907 22 20.1662 20.9197 20.3914 19.4562L21.4683 12.4562C21.7479 10.6389 20.3418 9 18.5032 9H15C14.4477 9 14 8.55228 14 8V4.46584C14 3.10399 12.896 2 11.5342 2C11.2093 2 10.915 2.1913 10.7831 2.48812L7.26394 10.4061C7.10344 10.7673 6.74532 11 6.35013 11H4C2.89543 11 2 11.8954 2 13Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.5"
	})
}), wh = ({ size: e = 24 }) => /* @__PURE__ */ _(xh, {
	className: "sp-text-current",
	size: e,
	children: /* @__PURE__ */ _("path", {
		d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.2C21 14.8802 21 15.7202 20.673 16.362C20.3854 16.9265 19.9265 17.3854 19.362 17.673C18.7202 18 17.8802 18 16.2 18H13.6837C13.0597 18 12.7477 18 12.4492 18.0613C12.1844 18.1156 11.9282 18.2055 11.6875 18.3285C11.4162 18.4671 11.1725 18.662 10.6852 19.0518L8.29976 20.9602C7.88367 21.2931 7.67563 21.4595 7.50054 21.4597C7.34827 21.4599 7.20422 21.3906 7.10923 21.2716C7 21.1348 7 20.8684 7 20.3355V18C6.07003 18 5.60504 18 5.22354 17.8978C4.18827 17.6204 3.37962 16.8117 3.10222 15.7765C3 15.395 3 14.93 3 14V7.8Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.5"
	})
}), Th = ({ size: e = 24 }) => /* @__PURE__ */ _(xh, {
	className: "sp-text-current",
	size: e,
	children: /* @__PURE__ */ _("path", {
		d: "M20.7914 12.6074C21.0355 12.3981 21.1575 12.2935 21.2023 12.169C21.2415 12.0598 21.2415 11.9402 21.2023 11.831C21.1575 11.7065 21.0355 11.6018 20.7914 11.3926L12.3206 4.13196C11.9004 3.77176 11.6903 3.59167 11.5124 3.58725C11.3578 3.58342 11.2101 3.65134 11.1124 3.77122C11 3.90915 11 4.18589 11 4.73936V9.03462C8.86532 9.40808 6.91159 10.4897 5.45971 12.1139C3.87682 13.8845 3.00123 16.1759 3 18.551V19.163C4.04934 17.8989 5.35951 16.8765 6.84076 16.1659C8.1467 15.5394 9.55842 15.1683 11 15.0705V19.2606C11 19.8141 11 20.0908 11.1124 20.2288C11.2101 20.3486 11.3578 20.4166 11.5124 20.4127C11.6903 20.4083 11.9004 20.2282 12.3206 19.868L20.7914 12.6074Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.5"
	})
}), Eh = ({ size: e = 24 }) => /* @__PURE__ */ _(xh, {
	className: "sp-text-white",
	size: e,
	children: /* @__PURE__ */ _("path", {
		d: "m21 21-4.3-4.3M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), Dh = ({ className: e = "sp-text-white", size: t = 24 }) => /* @__PURE__ */ v(xh, {
	className: e,
	size: t,
	viewBox: "0 0 32 32",
	children: [
		/* @__PURE__ */ _("path", {
			d: "M16 17.3333C16.7364 17.3333 17.3333 16.7364 17.3333 16C17.3333 15.2636 16.7364 14.6667 16 14.6667C15.2636 14.6667 14.6667 15.2636 14.6667 16C14.6667 16.7364 15.2636 17.3333 16 17.3333Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _("path", {
			d: "M25.3333 17.3333C26.0697 17.3333 26.6667 16.7364 26.6667 16C26.6667 15.2636 26.0697 14.6667 25.3333 14.6667C24.597 14.6667 24 15.2636 24 16C24 16.7364 24.597 17.3333 25.3333 17.3333Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _("path", {
			d: "M6.66667 17.3333C7.40305 17.3333 8 16.7364 8 16C8 15.2636 7.40305 14.6667 6.66667 14.6667C5.93029 14.6667 5.33333 15.2636 5.33333 16C5.33333 16.7364 5.93029 17.3333 6.66667 17.3333Z",
			fill: "currentColor"
		})
	]
}), Oh = ({ size: e = 24 }) => /* @__PURE__ */ _(xh, {
	className: "sp-text-white",
	size: e,
	children: /* @__PURE__ */ _("path", {
		d: "m6 6 12 12M18 6 6 18",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: "2"
	})
}), kh = ({ size: e = 24 }) => /* @__PURE__ */ _(xh, {
	className: "sp-text-current",
	size: e,
	children: /* @__PURE__ */ _("path", {
		d: "M4 9v6h4l5 4V5L8 9H4Zm13 1 4 4m0-4-4 4",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), Ah = (e) => {
	try {
		return new URL(e).hostname;
	} catch {
		return e;
	}
}, jh = (e) => e.type === "video" && e.providedPost?.videoPostType === "reel", Mh = (e) => typeof e == "object" && !!e, Nh = (e) => {
	if (typeof e != "number" && (typeof e != "string" || !/^-?(?:\d+\.?\d*|\.\d+)$/.test(e.trim()))) return null;
	let t = typeof e == "number" ? e : Number(e.trim());
	return Number.isFinite(t) && t >= 0 && t <= 100 ? t : null;
}, Ph = (e) => {
	let t = e.coordinates;
	if (Mh(t) && typeof t.x == "number" && typeof t.y == "number" && Number.isFinite(t.x) && Number.isFinite(t.y) && t.x >= 0 && t.x <= 100 && t.y >= 0 && t.y <= 100) return {
		x: t.x,
		y: t.y
	};
	let n = Nh(e.left), r = Nh(e.top);
	return n === null || r === null ? null : {
		x: n,
		y: r
	};
}, Fh = (e) => Array.isArray(e) ? e.flatMap((e) => {
	if (!Mh(e) || typeof e.value != "string") return [];
	let t = e.value.trim().replace(/^@+/, ""), n = Ph(e);
	return t && n ? [{
		value: t,
		...n
	}] : [];
}) : [], Ih = ({ ariaLabel: e = "Media carousel", className: t, countClassName: n = "sp-right-2.5 sp-top-2.5", dotClassName: r = "sp-bottom-3 sp-left-1/2 -sp-translate-x-1/2", medias: i, onIndexChange: a, arrowClassName: o, renderSlide: s, showArrows: c = !0, showCount: l = !0, showDots: u = !0, slideClassName: d }) => {
	let [f, p] = h(0), m = Math.min(f, Math.max(0, i.length - 1)), g = m > 0, y = m < i.length - 1, b = Lh(i.length, m);
	return i.length === 0 ? null : /* @__PURE__ */ v("div", {
		"aria-label": e,
		className: ["sp-relative sp-h-full sp-w-full sp-overflow-hidden", t].filter(Boolean).join(" "),
		"data-uplift-carousel-count": i.length,
		"data-uplift-carousel-index": m + 1,
		children: [
			/* @__PURE__ */ _("div", {
				className: "sp-flex sp-h-full sp-transition-transform sp-duration-200",
				style: { transform: `translateX(-${m * 100}%)` },
				children: i.map((e, t) => /* @__PURE__ */ _("div", {
					className: ["sp-relative sp-h-full sp-w-full sp-shrink-0", d].filter(Boolean).join(" "),
					"data-uplift-carousel-slide": t + 1,
					children: s(e, {
						index: t,
						isActive: t === m
					})
				}, t))
			}),
			c && g ? /* @__PURE__ */ _(Rh, {
				ariaLabel: "Previous media",
				className: ["sp-left-2", o].filter(Boolean).join(" "),
				direction: "previous",
				onClick: () => {
					if (g) {
						let e = m - 1;
						p(e), a?.(e);
					}
				}
			}) : null,
			c && y ? /* @__PURE__ */ _(Rh, {
				ariaLabel: "Next media",
				className: ["sp-right-2", o].filter(Boolean).join(" "),
				direction: "next",
				onClick: () => {
					if (y) {
						let e = m + 1;
						p(e), a?.(e);
					}
				}
			}) : null,
			l ? /* @__PURE__ */ v("div", {
				className: ["sp-absolute sp-rounded-full sp-bg-black/40 sp-px-2 sp-py-1 sp-text-sm sp-leading-none sp-text-white", n].join(" "),
				children: [
					m + 1,
					"/",
					i.length
				]
			}) : null,
			u ? /* @__PURE__ */ _("div", {
				className: ["sp-absolute sp-flex sp-items-center sp-gap-1", r].join(" "),
				children: b.map((e) => /* @__PURE__ */ _("span", {
					className: ["sp-block sp-h-1.5 sp-w-1.5 sp-rounded-full", e === m ? "sp-bg-[#0095f6]" : "sp-bg-[#c7c7c7]"].join(" "),
					"data-uplift-carousel-dot": e + 1
				}, e))
			}) : null
		]
	});
}, Lh = (e, t) => {
	let n = Math.min(e, 5), r = Math.max(0, e - n), i = Math.min(Math.max(0, t - 2), r);
	return Array.from({ length: n }, (e, t) => i + t);
}, Rh = ({ ariaLabel: e, className: t, direction: n, onClick: r }) => /* @__PURE__ */ _("button", {
	"aria-label": e,
	className: ["sp-absolute sp-top-1/2 sp-flex sp-h-8 sp-w-8 -sp-translate-y-1/2 sp-items-center sp-justify-center sp-rounded-full sp-border-0 sp-bg-white/90 sp-p-0 sp-text-black sp-shadow-[0_2px_8px_rgba(0,0,0,0.18)]", t].join(" "),
	onClick: r,
	type: "button",
	children: /* @__PURE__ */ _("svg", {
		"aria-hidden": "true",
		fill: "none",
		height: "20",
		viewBox: "0 0 24 24",
		width: "20",
		children: n === "next" ? /* @__PURE__ */ _("path", {
			d: "m9 18 6-6-6-6",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2"
		}) : /* @__PURE__ */ _("path", {
			d: "m15 18-6-6 6-6",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "2"
		})
	})
}), zh = /* @__PURE__ */ new Set(["image", "multiMedia"]), Bh = /* @__PURE__ */ new Set([
	"image",
	"multiMedia",
	"reel",
	"story",
	"video"
]), Vh = 16, Hh = 33, Uh = 52, Wh = 11, Gh = 16, Kh = 4, qh = 1, Jh = 50, Yh = 1, Xh = (e) => typeof e == "object" && !!e, Zh = (e) => Array.isArray(e) && e.some((e) => Xh(e) && typeof e.value == "string" && e.value.trim().length > 0), Qh = (e) => e.platform === "IG" && Bh.has(e.type), $h = ({ post: e, className: t, trackEvent: n, videoCoverPreview: r }) => fg(e) ? /* @__PURE__ */ _(rg, {
	post: e,
	className: t,
	showFirstComment: !0,
	trackEvent: n,
	videoCoverPreview: r
}) : pg(e) ? /* @__PURE__ */ _(rg, {
	dataLayout: "instagram-igtv",
	post: e,
	className: t,
	trackEvent: n,
	title: "Video",
	videoCoverPreview: r
}) : e.type === "story" ? /* @__PURE__ */ _(ng, {
	post: e,
	className: t,
	videoCoverPreview: r
}) : zh.has(e.type) ? /* @__PURE__ */ _(eg, {
	post: e,
	className: t,
	trackEvent: n,
	videoCoverPreview: r
}) : null, eg = ({ post: e, className: t, trackEvent: n, videoCoverPreview: r }) => {
	let i = Zh(e.productTags), a = Fh(e.tags), o = !i && a.length > 0;
	return /* @__PURE__ */ _(tg, {
		className: t,
		hasProductTags: i,
		hasUserTags: o,
		post: e,
		trackEvent: n,
		userTags: a,
		videoCoverPreview: r
	}, `${e.id}:${o}`);
}, tg = ({ post: e, className: t, hasProductTags: n, hasUserTags: r, trackEvent: i, userTags: a, videoCoverPreview: o }) => {
	let { medias: s, reportIntrinsicDimensions: c } = Cm(dg(e)), l = s.length > 1, u = $(e.caption), d = e.comment.trim(), [p, y] = h(0), [b, x] = h(!1), [S, C] = h(!1), [w, T] = h(!1), E = m(null), D = m(null), O = Math.min(p, Math.max(0, s.length - 1)), k = fm({
		media: s[0],
		platform: "IG",
		surface: l ? "carousel" : "feed",
		width: 400
	}), A = 57 + k.height, j = A + 12.391, M = j + 11, N = j + 40, P = sg({
		actionsTop: j,
		caption: e.caption,
		captionExpanded: b,
		captionTop: N,
		firstComment: d,
		firstCommentExpanded: S,
		hasCaption: u,
		username: e.username
	}), F = A - 85.609, I = A - 42.609, L = mg(s.length, O), ee = !l || O === 0;
	return f(() => {
		let e = E.current, t = D.current;
		if (!e || !t) return;
		let n = () => {
			let n = t.getBoundingClientRect().height || t.scrollHeight;
			n <= 0 || (e.style.height = `${N + n + Hh}px`);
		};
		if (n(), typeof ResizeObserver > "u") return;
		let r = new ResizeObserver(n);
		return r.observe(t), () => r.disconnect();
	}, [
		b,
		N,
		d,
		S,
		e.caption,
		e.username
	]), /* @__PURE__ */ _(Lp, {
		className: ["sp-relative sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-none sp-border-0 sp-text-sm sp-leading-4 sp-shadow-none", t].filter(Boolean).join(" "),
		platform: "IG",
		children: /* @__PURE__ */ v("article", {
			ref: E,
			className: "sp-relative sp-w-full",
			"data-uplift-renderer": "instagram",
			"data-uplift-layout": "instagram-feed",
			style: { height: P },
			children: [
				/* @__PURE__ */ v("header", {
					className: "sp-absolute sp-left-[10px] sp-top-[11px] sp-flex sp-h-[34px] sp-w-[380px] sp-items-center sp-justify-between",
					children: [/* @__PURE__ */ _(ig, { post: e }), /* @__PURE__ */ _(Tg, { className: "sp-text-black" })]
				}),
				/* @__PURE__ */ v("div", {
					className: "sp-absolute sp-left-0 sp-w-full sp-overflow-hidden sp-bg-[#f2f2f2]",
					"data-uplift-media-frame-ratio": k.publishedRatio,
					onClick: () => T(!1),
					style: {
						height: k.height,
						top: 57
					},
					children: [l ? /* @__PURE__ */ _(Ih, {
						ariaLabel: "Instagram feed carousel",
						arrowClassName: "sp-z-20",
						countClassName: "sp-right-[10px] sp-top-[9px]",
						medias: s,
						onIndexChange: (e) => {
							y(e), T(!1);
						},
						renderSlide: (e, { index: t, isActive: n }) => /* @__PURE__ */ _(og, {
							className: "sp-h-full",
							coverScope: "none",
							isActive: n,
							media: e,
							mediaCount: s.length,
							mediaIndex: t,
							measureWhenInactive: t === 0,
							onIntrinsicDimensions: c,
							surface: "carousel"
						}),
						showDots: !1,
						showCount: !1
					}) : s[0] && /* @__PURE__ */ _(og, {
						media: s[0],
						videoCoverPreview: o,
						className: "sp-h-full",
						onIntrinsicDimensions: c
					}), r && ee && w && /* @__PURE__ */ _(vg, { tags: a })]
				}),
				n && /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _(gg, {
					style: { top: F },
					children: /* @__PURE__ */ _(Og, {})
				}), /* @__PURE__ */ v("div", {
					className: "sp-absolute sp-left-0 sp-box-border sp-flex sp-h-[43px] sp-w-full sp-items-center sp-justify-between sp-bg-[#c77735] sp-px-2 sp-text-base sp-font-semibold sp-leading-4 sp-text-white",
					style: { top: I },
					children: [/* @__PURE__ */ _("span", { children: "Shop now" }), /* @__PURE__ */ _(Ag, {})]
				})] }),
				r && ee && /* @__PURE__ */ _(_g, {
					expanded: w,
					onClick: () => T((e) => !e),
					style: { top: I },
					children: /* @__PURE__ */ _(kg, {})
				}),
				l && /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ v("div", {
					className: "sp-absolute sp-left-[354px] sp-top-[66px] sp-flex sp-h-[27px] sp-w-9 sp-items-center sp-justify-center sp-rounded-full sp-bg-black/40 sp-text-sm sp-leading-none sp-text-white",
					children: [
						O + 1,
						"/",
						s.length
					]
				}), /* @__PURE__ */ _("div", {
					className: "sp-absolute sp-left-[177px] sp-flex sp-h-[7px] sp-w-[47px] sp-items-center sp-justify-center sp-gap-1",
					style: { top: M },
					children: L.map((e) => {
						let t = s[e];
						return /* @__PURE__ */ _("span", { className: ["sp-block sp-rounded-full", e === O ? "sp-h-[6px] sp-w-[6px] sp-bg-[#0095f6]" : "sp-h-[5px] sp-w-[5px] sp-bg-[#d9d9d9]"].join(" ") }, t.url ?? t.thumbnailUrl ?? t.fileName ?? `${e}-${t.type ?? "media"}-${t.width ?? "w"}x${t.height ?? "h"}`);
					})
				})] }),
				/* @__PURE__ */ v("div", {
					className: "sp-absolute sp-left-2 sp-flex sp-h-[27px] sp-w-[381px] sp-items-center sp-justify-between",
					style: { top: j },
					children: [/* @__PURE__ */ v("div", {
						className: "sp-flex sp-items-center sp-gap-3",
						children: [
							/* @__PURE__ */ _(yg, {}),
							/* @__PURE__ */ _(xg, {}),
							/* @__PURE__ */ _(Sg, {})
						]
					}), /* @__PURE__ */ _(wg, {})]
				}),
				(u || d) && /* @__PURE__ */ v("div", {
					ref: D,
					className: "sp-absolute sp-left-[10px] sp-flex sp-w-[370px] sp-flex-col sp-gap-[11px]",
					"data-uplift-caption-stack": "instagram-feed",
					style: { top: N },
					children: [u && /* @__PURE__ */ _(ag, {
						caption: e.caption,
						charsPerLine: Uh,
						collapsedLines: Kh,
						dataSlot: "feed-caption",
						expanded: b,
						onExpandedChange: x,
						textClassName: "sp-text-sm sp-leading-4",
						targetPlatform: "IG",
						trackEvent: i,
						username: e.username
					}), d && /* @__PURE__ */ _(ag, {
						accessibilityLabel: "first comment",
						caption: d,
						charsPerLine: Uh,
						collapsedLines: qh,
						dataSlot: "feed-first-comment",
						expanded: S,
						onExpandedChange: C,
						targetPlatform: "IG",
						textClassName: "sp-text-sm sp-leading-4",
						trackEvent: i,
						username: e.username
					})]
				})
			]
		})
	});
}, ng = ({ post: e, className: t, videoCoverPreview: n }) => {
	let r = dg(e), i = r[0], a = jc(e.storyStickerHeight);
	return /* @__PURE__ */ _(Lp, {
		className: ["sp-relative sp-h-[710px] sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-none sp-border-0 sp-bg-black sp-text-white sp-shadow-none", t].filter(Boolean).join(" "),
		platform: "IG",
		children: /* @__PURE__ */ v("div", {
			className: "sp-relative sp-h-full sp-w-full",
			"data-ig-story-frame": !0,
			"data-uplift-renderer": "instagram",
			"data-uplift-layout": "instagram-story",
			"data-uplift-media-frame-ratio": "9 / 16",
			children: [
				r.length > 1 ? /* @__PURE__ */ _(Ih, {
					ariaLabel: "Instagram story carousel",
					className: "sp-absolute sp-inset-0",
					countClassName: "sp-right-5 sp-top-[76px]",
					dotClassName: "sp-left-1/2 sp-top-3 -sp-translate-x-1/2",
					medias: r,
					renderSlide: (e, { index: t, isActive: i }) => /* @__PURE__ */ _(og, {
						className: "sp-absolute sp-inset-0 sp-h-full",
						coverScope: "firstVideoOnly",
						isActive: i,
						media: e,
						mediaCount: r.length,
						mediaIndex: lm(r, t),
						surface: "story",
						videoCoverPreview: n
					}),
					showDots: !1
				}) : i && /* @__PURE__ */ _(og, {
					media: i,
					videoCoverPreview: n,
					className: "sp-absolute sp-inset-0 sp-h-full",
					surface: "story"
				}),
				/* @__PURE__ */ _("div", { className: "sp-absolute sp-left-[11px] sp-top-[9px] sp-h-0.5 sp-w-[378px] sp-rounded-full sp-bg-white/70" }),
				/* @__PURE__ */ v("div", {
					className: "sp-absolute sp-left-6 sp-right-[11px] sp-top-7 sp-flex sp-items-center sp-justify-between",
					children: [/* @__PURE__ */ v("div", {
						className: "sp-flex sp-items-center sp-gap-3.5",
						children: [/* @__PURE__ */ _(X, {
							className: "sp-h-[34px] sp-w-[34px]",
							src: e.profilePicture,
							alt: e.username
						}), /* @__PURE__ */ v("div", {
							className: "sp-flex sp-items-center sp-gap-2 sp-text-[15px] sp-leading-none",
							children: [/* @__PURE__ */ _("span", {
								className: "sp-font-semibold",
								children: e.username
							}), /* @__PURE__ */ _("span", {
								className: "sp-text-white/60",
								children: "15h"
							})]
						})]
					}), /* @__PURE__ */ v("div", {
						className: "sp-flex sp-items-center sp-gap-5",
						children: [/* @__PURE__ */ _(Tg, { className: "sp-text-white" }), /* @__PURE__ */ _(Eg, {})]
					})]
				}),
				e.storyUrl && /* @__PURE__ */ v("a", {
					className: "sp-absolute sp-left-1/2 sp-box-border sp-flex sp-h-11 sp-w-fit sp-min-w-0 -sp-translate-x-1/2 sp-items-center sp-justify-center sp-gap-2.5 sp-rounded-[5.666px] sp-bg-white sp-px-[13px] sp-text-center sp-text-[26.761px] sp-font-bold sp-uppercase sp-leading-[1.2] sp-text-[#436ce1] sp-no-underline sp-shadow-[2px_3px_9px_rgba(0,0,0,0.2)]",
					"data-ig-story-link-sticker": !0,
					"data-story-sticker-label-length": (e.storyLabel || "View products").length,
					"data-story-sticker-height": e.storyStickerHeight ?? .8,
					href: e.storyUrl,
					rel: "noreferrer",
					style: {
						maxWidth: "calc(100% - 32px)",
						top: a
					},
					target: "_blank",
					children: [/* @__PURE__ */ _("span", {
						className: "sp-flex sp-shrink-0",
						children: /* @__PURE__ */ _(Dg, {})
					}), /* @__PURE__ */ _("span", {
						className: "sp-min-w-0 sp-truncate",
						children: e.storyLabel || "View products"
					})]
				}),
				/* @__PURE__ */ v("div", {
					className: "sp-absolute sp-left-[17px] sp-top-[656px] sp-flex sp-items-center sp-gap-5 sp-opacity-80",
					children: [
						/* @__PURE__ */ _("div", {
							className: "sp-box-border sp-flex sp-h-[47px] sp-w-[276px] sp-items-center sp-rounded-full sp-border-[1.5px] sp-border-solid sp-border-white sp-pl-[22px] sp-pr-5 sp-text-lg sp-leading-none",
							children: "Send Message"
						}),
						/* @__PURE__ */ _(bg, {}),
						/* @__PURE__ */ _(Cg, {})
					]
				})
			]
		})
	});
}, rg = ({ post: e, className: t, dataLayout: n = "instagram-reel", showFirstComment: r = !1, trackEvent: i, title: a = "Reels", videoCoverPreview: o }) => {
	let s = dg(e)[0], c = $(e.caption), l = r ? e.comment.trim() : "", [u, f] = h(!1), p = c && cg({
		caption: e.caption,
		charsPerLine: Jh,
		collapsedLines: Yh
	}) !== e.caption.trim(), m = u && p;
	return d(() => {
		p || f(!1);
	}, [p]), /* @__PURE__ */ v(Lp, {
		className: ["sp-relative sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-none sp-border-0 sp-shadow-none", t].filter(Boolean).join(" "),
		platform: "IG",
		children: [/* @__PURE__ */ v("div", {
			className: "sp-relative sp-h-[710px] sp-w-full sp-bg-black sp-text-white",
			"data-uplift-renderer": "instagram",
			"data-uplift-layout": n,
			"data-uplift-media-frame-ratio": "9 / 16",
			children: [
				s && /* @__PURE__ */ _(og, {
					backgroundColor: "#000",
					media: s,
					videoCoverPreview: o,
					className: "sp-absolute sp-inset-x-0 sp-top-0 sp-h-[710px]",
					customVideoControls: !0,
					surface: "reel"
				}),
				/* @__PURE__ */ _("div", { className: "sp-absolute sp-inset-x-0 sp-top-0 sp-h-[254px] sp-bg-gradient-to-b sp-from-black/40 sp-to-transparent" }),
				/* @__PURE__ */ _("div", { className: "sp-absolute sp-inset-x-0 sp-top-[404px] sp-h-[254px] sp-bg-gradient-to-t sp-from-black/60 sp-to-transparent" }),
				m && /* @__PURE__ */ _("div", {
					className: "sp-pointer-events-none sp-absolute sp-inset-0 sp-bg-black/40",
					"data-uplift-caption-backdrop": "true"
				}),
				/* @__PURE__ */ v("header", {
					className: "sp-absolute sp-left-5 sp-right-5 sp-top-9 sp-flex sp-items-center sp-justify-between",
					children: [
						/* @__PURE__ */ _(jg, {}),
						/* @__PURE__ */ _("div", {
							className: "sp-text-lg sp-font-bold sp-leading-none sp-tracking-normal",
							children: a
						}),
						/* @__PURE__ */ _(Mg, {})
					]
				}),
				/* @__PURE__ */ v("div", {
					className: "sp-absolute sp-right-5 sp-top-[344px] sp-flex sp-flex-col sp-gap-7",
					children: [
						/* @__PURE__ */ _(yg, { className: "sp-text-white" }),
						/* @__PURE__ */ _(xg, { className: "sp-text-white" }),
						/* @__PURE__ */ _(Sg, { className: "sp-text-white" }),
						/* @__PURE__ */ _(Tg, { className: "sp-text-white" })
					]
				}),
				/* @__PURE__ */ v("div", {
					className: "sp-absolute sp-bottom-[72px] sp-left-[19px] sp-right-16 sp-flex sp-max-h-[566px] sp-flex-col sp-gap-3 sp-overflow-hidden",
					"data-uplift-reel-info": "true",
					children: [/* @__PURE__ */ v("div", {
						className: "sp-flex sp-shrink-0 sp-items-center sp-gap-3",
						children: [
							/* @__PURE__ */ _(X, {
								className: "sp-h-[34px] sp-w-[34px]",
								src: e.profilePicture,
								alt: e.username
							}),
							/* @__PURE__ */ _("span", {
								className: "sp-text-[15px] sp-font-semibold sp-leading-none",
								children: e.username
							}),
							/* @__PURE__ */ _("button", {
								className: "sp-cursor-default sp-rounded-[9px] sp-border sp-border-solid sp-border-white/30 sp-bg-transparent sp-px-2 sp-py-1 sp-text-[15px] sp-font-medium sp-leading-none sp-text-white",
								type: "button",
								children: "Follow"
							})
						]
					}), c && /* @__PURE__ */ _("div", {
						className: "sp-min-h-0 sp-overflow-y-auto",
						"data-uplift-reel-caption-scroll": "true",
						children: /* @__PURE__ */ _(ag, {
							caption: e.caption,
							charsPerLine: Jh,
							collapsedLines: Yh,
							dataSlot: "reel-caption",
							expanded: m,
							onExpandedChange: f,
							textClassName: "sp-whitespace-pre-line sp-text-[15px] sp-leading-[18px] sp-text-white [&_*]:sp-inline",
							targetPlatform: "IG",
							trackEvent: i
						})
					})]
				}),
				/* @__PURE__ */ v("footer", {
					className: "sp-absolute sp-inset-x-0 sp-bottom-0 sp-flex sp-h-[52px] sp-items-center sp-justify-around sp-bg-black sp-px-6",
					children: [
						/* @__PURE__ */ _(Ng, {}),
						/* @__PURE__ */ _(Pg, {}),
						/* @__PURE__ */ _(Fg, {}),
						/* @__PURE__ */ _(Ig, {}),
						/* @__PURE__ */ _(X, {
							className: "sp-h-[22px] sp-w-[22px]",
							src: e.profilePicture,
							alt: e.username
						})
					]
				})
			]
		}), l && /* @__PURE__ */ v("div", {
			className: "sp-box-border sp-w-full sp-break-words sp-bg-white sp-px-[5px] sp-py-[14px] sp-text-sm sp-leading-[17px] sp-text-black",
			"data-uplift-first-comment": "instagram-reel",
			children: [/* @__PURE__ */ _("span", {
				className: "sp-mr-1 sp-font-semibold",
				children: e.username
			}), /* @__PURE__ */ _(Y, {
				caption: l,
				targetPlatform: "IG",
				trackEvent: i
			})]
		})]
	});
}, ig = ({ post: e }) => {
	let t = (e.collaboratingIgUsers ?? []).filter((t) => t.username !== e.username), n = e.locationName?.trim();
	if (t.length === 0) return /* @__PURE__ */ v("div", {
		className: "sp-flex sp-min-w-0 sp-items-center sp-gap-2",
		children: [/* @__PURE__ */ _(X, {
			className: "sp-h-[34px] sp-w-[34px]",
			src: e.profilePicture,
			alt: e.username
		}), /* @__PURE__ */ v("div", {
			className: "sp-min-w-0 sp-max-w-[320px]",
			children: [/* @__PURE__ */ _(zp, {
				className: "sp-text-sm sp-leading-[14px]",
				children: e.username
			}), n && /* @__PURE__ */ _("div", {
				className: "sp-truncate sp-text-[13px] sp-font-normal sp-leading-[14px] sp-text-[#262626]",
				title: n,
				children: n
			})]
		})]
	});
	let r = t.length === 1 ? t[0]?.username : `${t.length} others`;
	return /* @__PURE__ */ v("div", {
		className: "sp-flex sp-min-w-0 sp-items-center sp-gap-2",
		children: [/* @__PURE__ */ v("div", {
			className: "sp-relative sp-h-[34px] sp-w-[34px] sp-shrink-0",
			children: [/* @__PURE__ */ _(X, {
				className: "sp-absolute sp-bottom-0 sp-left-0 sp-z-10 sp-h-6 sp-w-6 sp-border sp-border-solid sp-border-white",
				src: e.profilePicture,
				alt: e.username
			}), /* @__PURE__ */ _(X, {
				className: "sp-absolute sp-right-0 sp-top-0 sp-h-6 sp-w-6 sp-border sp-border-solid sp-border-white",
				src: t[0]?.profilePictureUrl,
				alt: t[0]?.username ?? ""
			})]
		}), /* @__PURE__ */ v("div", {
			className: "sp-min-w-0 sp-max-w-[320px] sp-text-black",
			children: [/* @__PURE__ */ v("div", {
				className: "sp-truncate sp-whitespace-nowrap sp-text-sm sp-leading-4",
				children: [/* @__PURE__ */ _("span", {
					className: "sp-font-semibold",
					children: e.username
				}), r ? /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _("span", { children: " and " }), /* @__PURE__ */ _("span", {
					className: "sp-font-semibold",
					children: r
				})] }) : null]
			}), n && /* @__PURE__ */ _("div", {
				className: "sp-truncate sp-text-[13px] sp-font-normal sp-leading-[14px] sp-text-[#262626]",
				title: n,
				children: n
			})]
		})]
	});
}, ag = ({ accessibilityLabel: e, caption: t, charsPerLine: n, clampCollapsedWithCss: r = !1, collapsedLines: i, dataSlot: a, expanded: o, onExpandedChange: s, targetPlatform: c, textClassName: l, trackEvent: u, username: d }) => {
	let f = cg({
		caption: t,
		charsPerLine: n,
		collapsedLines: i,
		leadingText: d
	});
	return (r ? lg({
		caption: t,
		charsPerLine: n,
		leadingText: d
	}) > i : f !== t.trim()) ? /* @__PURE__ */ v("div", {
		"aria-expanded": o,
		"aria-label": e ? `${o ? "Collapse" : "Expand"} ${e}` : void 0,
		className: [
			l,
			"sp-cursor-pointer sp-break-words",
			!o && r ? ug(i) : void 0,
			o || r ? void 0 : "sp-overflow-hidden"
		].filter(Boolean).join(" "),
		"data-uplift-instagram-text": a,
		onClick: (e) => {
			e.target instanceof Element && e.target.closest("a, button") || s(!o);
		},
		role: "button",
		tabIndex: 0,
		onKeyDown: (e) => {
			e.target instanceof Element && e.target.closest("a, button") || (e.key === "Enter" || e.key === " ") && (e.preventDefault(), s(!o));
		},
		children: [
			d ? /* @__PURE__ */ _("span", {
				className: "sp-mr-1 sp-font-semibold",
				children: d
			}) : null,
			/* @__PURE__ */ _(Y, {
				caption: o || r ? t : f,
				targetPlatform: c,
				trackEvent: u
			}),
			o || r ? null : /* @__PURE__ */ _("span", {
				className: "sp-ml-0.5 sp-font-inherit sp-leading-inherit sp-text-inherit",
				children: "..."
			})
		]
	}) : /* @__PURE__ */ v("div", {
		className: l,
		"data-uplift-instagram-text": a,
		children: [d ? /* @__PURE__ */ _("span", {
			className: "sp-mr-1 sp-font-semibold",
			children: d
		}) : null, /* @__PURE__ */ _(Y, {
			caption: t,
			targetPlatform: c,
			trackEvent: u
		})]
	});
}, og = ({ media: e, backgroundColor: t, className: n, coverScope: r = "singlePostOnly", customVideoControls: i, isActive: a, mediaCount: o, mediaIndex: s, measureWhenInactive: c, onIntrinsicDimensions: l, surface: u = "feed", videoCoverPreview: d }) => /* @__PURE__ */ _(Q, {
	backgroundColor: t,
	className: n,
	coverScope: r,
	customVideoControls: i,
	isActive: a,
	media: e,
	mediaCount: o,
	mediaIndex: s,
	measureWhenInactive: c,
	onIntrinsicDimensions: l,
	platform: "IG",
	surface: u,
	videoCoverPreview: d
}), sg = ({ actionsTop: e, caption: t, captionExpanded: n, captionTop: r, firstComment: i, firstCommentExpanded: a, hasCaption: o, username: s }) => {
	let c = o ? Dp({
		charsPerLine: Uh,
		collapsedLines: Kh,
		expanded: n,
		leadingText: s,
		lineHeight: Gh,
		text: t
	}) : 0, l = i ? Dp({
		charsPerLine: Uh,
		collapsedLines: qh,
		expanded: a,
		leadingText: s,
		lineHeight: Gh,
		text: i
	}) : 0;
	if (!c && !l) return e + 27 + Vh;
	let u = c && l ? Wh : 0;
	return r + c + l + u + Hh;
}, cg = ({ caption: e, charsPerLine: t, collapsedLines: n, leadingText: r }) => {
	let i = e.trim();
	if (!i) return "";
	let a = r ? r.length + 1 : 0, o = t * n - a - 3;
	return i.length <= o ? i : i.slice(0, Math.max(0, o)).trimEnd();
}, lg = ({ caption: e, charsPerLine: t, leadingText: n }) => (n ? `${n} ${e}` : e).trim().split(/\r?\n/).reduce((e, n) => e + Math.max(1, Math.ceil(n.length / t)), 0), ug = (e) => e <= 1 ? "sp-line-clamp-1" : e === 2 ? "sp-line-clamp-2" : e === 3 ? "sp-line-clamp-3" : "sp-line-clamp-4", dg = (e) => e.medias.collection.length > 0 ? e.medias.collection : [{
	isVideo: !1,
	thumbnailUrl: e.imageUrl,
	url: e.imageUrl
}], fg = (e) => e.type === "video" || e.type === "reel" || e.type === "story" && e.storyType === "reel", pg = (e) => e.type === "story" && e.storyType === "igtv", mg = (e, t) => {
	let n = Math.min(e, 5), r = Math.max(0, e - n), i = Math.min(Math.max(0, t - 2), r);
	return Array.from({ length: n }, (e, t) => i + t);
}, hg = ({ children: e, className: t = "sp-text-black", size: n = 24, viewBox: r = "0 0 24 24" }) => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	className: t,
	fill: "none",
	height: n,
	viewBox: r,
	width: n,
	children: e
}), gg = ({ children: e, style: t }) => /* @__PURE__ */ _("div", {
	className: "sp-absolute sp-left-[10px] sp-flex sp-h-7 sp-w-7 sp-items-center sp-justify-center sp-rounded-full sp-bg-[#3f3f3f]/90 sp-text-white",
	style: t,
	children: e
}), _g = ({ children: e, expanded: t, onClick: n, style: r }) => /* @__PURE__ */ _("button", {
	"aria-expanded": t,
	"aria-label": `${t ? "Hide" : "Show"} user tags`,
	className: "sp-absolute sp-left-[10px] sp-z-20 sp-flex sp-h-7 sp-w-7 sp-cursor-pointer sp-items-center sp-justify-center sp-rounded-full sp-border-0 sp-bg-[rgba(38,38,38,0.64)] sp-p-0 sp-text-white sp-shadow-[0_1px_2px_rgba(0,0,0,0.16)] sp-transition-[background-color,transform] sp-duration-150 hover:sp-bg-[rgba(38,38,38,0.76)] active:sp-scale-95 focus-visible:sp-outline focus-visible:sp-outline-2 focus-visible:sp-outline-offset-2 focus-visible:sp-outline-white",
	onClick: n,
	style: r,
	type: "button",
	children: e
}), vg = ({ tags: e }) => /* @__PURE__ */ _("div", {
	className: "sp-pointer-events-none sp-absolute sp-inset-0 sp-z-10 sp-overflow-hidden",
	"data-uplift-instagram-user-tags": !0,
	children: e.map((e) => /* @__PURE__ */ v("div", {
		className: "sp-pointer-events-auto sp-absolute sp-flex -sp-translate-x-1/2 -sp-translate-y-full sp-flex-col sp-items-center sp-pb-[6px]",
		"data-uplift-instagram-user-tag": e.value,
		onClick: (e) => e.stopPropagation(),
		style: {
			left: `${e.x}%`,
			top: `${e.y}%`
		},
		children: [/* @__PURE__ */ _("a", {
			"aria-label": `View ${e.value} on Instagram`,
			className: "sp-block sp-max-w-[220px] sp-truncate sp-whitespace-nowrap sp-rounded-lg sp-bg-[rgba(38,38,38,0.72)] sp-px-3 sp-py-[9px] sp-text-sm sp-font-semibold sp-leading-4 sp-text-white sp-no-underline sp-shadow-[0_1px_2px_rgba(0,0,0,0.14)] hover:sp-bg-[rgba(38,38,38,0.82)]",
			href: `https://instagram.com/${encodeURIComponent(e.value)}`,
			rel: "noreferrer",
			target: "_blank",
			children: e.value
		}), /* @__PURE__ */ _("span", {
			"aria-hidden": "true",
			className: "sp-absolute sp-bottom-0 sp-left-1/2 sp-h-0 sp-w-0 -sp-translate-x-1/2 sp-border-x-[6px] sp-border-b-0 sp-border-t-[6px] sp-border-solid sp-border-x-transparent sp-border-t-[rgba(38,38,38,0.72)]",
			"data-uplift-instagram-user-tag-pointer": !0
		})]
	}, `${e.value}-${e.x}-${e.y}`))
}), yg = ({ className: e = "sp-text-black" }) => /* @__PURE__ */ _(hg, {
	className: e,
	children: /* @__PURE__ */ _("path", {
		d: "M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), bg = () => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	className: "sp-text-white",
	fill: "none",
	height: "22",
	viewBox: "0 0 24 24",
	width: "25.356",
	children: /* @__PURE__ */ _("path", {
		d: "M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 0 0 0-7.8Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), xg = ({ className: e = "sp-text-black" }) => /* @__PURE__ */ _(hg, {
	className: e,
	children: /* @__PURE__ */ _("path", {
		d: "M21 11.5a8.4 8.4 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7A8.4 8.4 0 0 1 4 11.5a8.5 8.5 0 1 1 17 0Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), Sg = ({ className: e = "sp-text-black" }) => /* @__PURE__ */ _(hg, {
	className: e,
	children: /* @__PURE__ */ _("path", {
		d: "m22 2-7 20-4-9-9-4 20-7Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), Cg = () => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	className: "sp-text-white",
	fill: "none",
	height: "18",
	viewBox: "0 0 24 24",
	width: "22.24",
	children: /* @__PURE__ */ _("path", {
		d: "m22 2-7 20-4-9-9-4 20-7Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), wg = () => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	className: "sp-text-black",
	fill: "none",
	height: "24",
	viewBox: "5 0 14 24",
	width: "14",
	children: /* @__PURE__ */ _("path", {
		d: "M6 3h12v18l-6-4-6 4V3Z",
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), Tg = ({ className: e = "sp-text-black" }) => /* @__PURE__ */ _(hg, {
	className: e,
	viewBox: "0 0 24 24",
	children: /* @__PURE__ */ _("path", {
		d: "M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
		fill: "currentColor"
	})
}), Eg = () => /* @__PURE__ */ _(hg, {
	className: "sp-text-white",
	children: /* @__PURE__ */ _("path", {
		d: "m18 6-12 12M6 6l12 12",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: "2"
	})
}), Dg = () => /* @__PURE__ */ _(hg, {
	className: "sp-text-[#436ce1]",
	size: 28,
	children: /* @__PURE__ */ _("path", {
		d: "M10 13a5 5 0 0 0 7.1 0l2-2a5 5 0 0 0-7.1-7.1l-1.1 1.1M14 11a5 5 0 0 0-7.1 0l-2 2A5 5 0 0 0 12 20.1l1.1-1.1",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), Og = () => /* @__PURE__ */ _(hg, {
	className: "sp-text-white",
	size: 16,
	viewBox: "0 0 16 16",
	children: /* @__PURE__ */ _("path", {
		d: "M5.25 6.25V5a2.75 2.75 0 1 1 5.5 0v1.25h1.03c.63 0 1.15.48 1.22 1.1l.58 5.25A1.25 1.25 0 0 1 12.34 14H3.66a1.25 1.25 0 0 1-1.24-1.4L3 7.35c.07-.62.59-1.1 1.22-1.1h1.03Zm1.5 0h2.5V5a1.25 1.25 0 1 0-2.5 0v1.25Zm-.75 2a.75.75 0 0 0 .75-.75H5.25c0 .41.34.75.75.75Zm4 0a.75.75 0 0 0 .75-.75h-1.5c0 .41.34.75.75.75Z",
		fill: "currentColor"
	})
}), kg = () => /* @__PURE__ */ _(hg, {
	className: "sp-text-white",
	size: 16,
	viewBox: "0 0 16 16",
	children: /* @__PURE__ */ _("path", {
		d: "M8 8.25a3.25 3.25 0 1 0 0-6.5 3.25 3.25 0 0 0 0 6.5Zm-5.6 4.93c.62-2.33 2.74-4.05 5.6-4.05s4.98 1.72 5.6 4.05c.17.64-.35 1.07-.94 1.07H3.34c-.59 0-1.11-.43-.94-1.07Z",
		fill: "currentColor"
	})
}), Ag = () => /* @__PURE__ */ _(hg, {
	className: "sp-text-white",
	size: 22,
	children: /* @__PURE__ */ _("path", {
		d: "m9 4 6 7-6 7",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), jg = () => /* @__PURE__ */ _(hg, {
	className: "sp-text-white",
	children: /* @__PURE__ */ _("path", {
		d: "m15 18-6-6 6-6",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), Mg = () => /* @__PURE__ */ _(hg, {
	className: "sp-text-white",
	children: /* @__PURE__ */ _("path", {
		d: "M4 8a2 2 0 0 1 2-2h2l2-2h4l2 2h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8Zm8 9a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), Ng = () => /* @__PURE__ */ _(hg, {
	className: "sp-text-white",
	size: 22,
	children: /* @__PURE__ */ _("path", {
		d: "m3 10 9-7 9 7v10a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1V10Z",
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), Pg = () => /* @__PURE__ */ _(hg, {
	className: "sp-text-white",
	size: 22,
	children: /* @__PURE__ */ _("path", {
		d: "m21 21-4.3-4.3M19 11a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), Fg = () => /* @__PURE__ */ v(hg, {
	className: "sp-text-white",
	size: 22,
	children: [/* @__PURE__ */ _("path", {
		d: "M12 7v10M7 12h10",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: "2"
	}), /* @__PURE__ */ _("rect", {
		height: "18",
		rx: "5",
		stroke: "currentColor",
		strokeWidth: "1.8",
		width: "18",
		x: "3",
		y: "3"
	})]
}), Ig = () => /* @__PURE__ */ _(hg, {
	className: "sp-text-white",
	size: 22,
	children: /* @__PURE__ */ _("path", {
		d: "M4 7h16v13H4V7Zm2-4 2.5 4M12 3l2.5 4M18 3l2 4",
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), Lg = /* @__PURE__ */ new Set([
	"document",
	"image",
	"multiMedia",
	"text",
	"video"
]), Rg = 40, zg = 3, Bg = 20, Vg = 104, Hg = "JgUARf2HjedOQkin6wQs2Ll11upPpWG5gJ1NTX9c", Ug = 12, Wg = 16, Gg = 20, Kg = 36, qg = 620, Jg = 12, Yg = 20, Xg = (e) => e.platform === "LI" && Lg.has(e.type) && (e.type === "document" || !I_(e)), Zg = ({ post: e, className: t, videoCoverPreview: n, preferVideoCoverPreviewOverride: r, trackEvent: i }) => {
	let { medias: a, reportIntrinsicDimensions: o } = Cm(k_(e)), [s, c] = h(!1), l = f_(e, s), u = [
		e.caption,
		e.redirectUrl ?? "",
		s ? "expanded" : "collapsed"
	].join("|"), [d, p] = h(null), g = m(null), y = d?.key === u ? d.height : void 0, b = x_(e), x = E_(e, a, s, y);
	return f(() => {
		if (!s) {
			p(null);
			return;
		}
		let e = g.current;
		if (!e) return;
		let t = Math.ceil(e.scrollHeight);
		t > 0 && Math.abs(t - l) > 1 && p({
			height: t,
			key: u
		});
	}, [
		s,
		u,
		l
	]), /* @__PURE__ */ _(Lp, {
		className: ["sp-relative sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-none sp-border-0 sp-bg-white sp-text-base sp-leading-5 sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)]", t].filter(Boolean).join(" "),
		platform: "LI",
		children: /* @__PURE__ */ v("article", {
			className: "sp-relative sp-w-full sp-bg-white",
			"data-uplift-layout": x.dataLayout,
			"data-uplift-renderer": "linkedin",
			style: { height: x.height },
			children: [
				/* @__PURE__ */ _(Qg, { post: e }),
				x.captionHeight > 0 && /* @__PURE__ */ _($g, {
					captionRef: g,
					expanded: s,
					height: x.captionHeight,
					onExpandedChange: c,
					post: e,
					top: x.captionTop,
					trackEvent: i
				}),
				b && x.linkRect.height > 0 && /* @__PURE__ */ _(t_, {
					rect: x.linkRect,
					url: b
				}),
				x.kind === "document" && /* @__PURE__ */ _(n_, {
					media: x.documentMedia,
					rect: x.documentRect
				}, M_(x.documentMedia)),
				x.kind === "single-media" && /* @__PURE__ */ _(e_, {
					media: a[0],
					mediaCount: a.length,
					mediaIndex: 0,
					onIntrinsicDimensions: o,
					preferVideoCoverPreviewOverride: r,
					rect: x.mediaRects[0],
					videoCoverPreview: n
				}),
				x.kind === "collage" && /* @__PURE__ */ _("div", {
					className: "sp-absolute sp-overflow-hidden sp-bg-white",
					"data-linkedin-media-count": Math.min(a.length, 5),
					style: {
						height: 400,
						left: 0,
						top: x.collageTop,
						width: 400
					},
					children: x.mediaRects.map((e, t) => /* @__PURE__ */ _(e_, {
						media: a[t],
						mediaCount: a.length,
						mediaIndex: lm(a, t),
						onIntrinsicDimensions: o,
						preferVideoCoverPreviewOverride: r,
						rect: e,
						videoCoverPreview: n,
						children: a.length > 5 && t === 4 ? /* @__PURE__ */ v("div", {
							className: "sp-absolute sp-inset-0 sp-flex sp-items-center sp-justify-center sp-bg-black/40 sp-text-2xl sp-font-semibold sp-leading-none sp-text-white",
							children: ["+", a.length - 5]
						}) : null
					}, N_(a[t], e)))
				}),
				x.dividerTop ? /* @__PURE__ */ _("span", {
					"aria-hidden": "true",
					className: "sp-absolute sp-left-4 sp-h-px sp-w-[368px] sp-bg-[#e6e6e6]",
					style: { top: x.dividerTop }
				}) : null,
				/* @__PURE__ */ _(r_, { top: x.actionsTop }),
				x.firstCommentHeight > 0 && /* @__PURE__ */ _(a_, {
					height: x.firstCommentHeight,
					post: e,
					top: x.firstCommentTop,
					trackEvent: i
				})
			]
		})
	});
}, Qg = ({ post: e }) => /* @__PURE__ */ v("header", {
	className: "sp-absolute sp-left-4 sp-top-4 sp-flex sp-h-[51px] sp-w-[368px] sp-items-center sp-gap-2",
	children: [/* @__PURE__ */ _(X, {
		alt: e.username,
		className: "sp-h-12 sp-w-12 sp-rounded-full",
		src: e.profilePicture
	}), /* @__PURE__ */ v("div", {
		className: "sp-flex sp-h-[51px] sp-min-w-0 sp-flex-1 sp-items-start sp-justify-between",
		children: [/* @__PURE__ */ v("div", {
			className: "sp-min-w-0",
			children: [
				/* @__PURE__ */ _(zp, {
					className: "sp-text-base sp-font-semibold sp-leading-[19px]",
					children: e.username
				}),
				/* @__PURE__ */ _("div", {
					"aria-hidden": "true",
					className: "sp-h-4 sp-text-xs sp-leading-4",
					children: "\xA0"
				}),
				/* @__PURE__ */ v("div", {
					className: "sp-flex sp-items-center sp-gap-1 sp-text-xs sp-leading-4 sp-text-[#333]",
					children: [
						/* @__PURE__ */ _("span", { children: "Just now" }),
						/* @__PURE__ */ _("span", {
							className: "sp-text-sm sp-font-semibold sp-leading-4 sp-text-black",
							children: "·"
						}),
						/* @__PURE__ */ _(ev, {})
					]
				})
			]
		}), /* @__PURE__ */ _($_, {})]
	})]
}), $g = ({ captionRef: e, expanded: t, height: n, onExpandedChange: r, post: i, top: a, trackEvent: o }) => {
	let s = y_(i), c = __(i, t);
	return /* @__PURE__ */ _("div", {
		ref: e,
		className: "sp-absolute sp-left-4 sp-w-[368px] sp-overflow-hidden sp-whitespace-pre-line sp-break-words sp-text-base sp-leading-5 sp-text-black [&_a]:sp-font-semibold [&_a]:sp-text-[#4f31ff] [&_a]:sp-no-underline",
		style: {
			height: n,
			top: a
		},
		children: /* @__PURE__ */ _(Ep, {
			caption: i.caption,
			captionMode: "textSlice",
			charsPerLine: Rg,
			collapsedCaption: v_(i),
			collapsedLines: zg,
			contentClassName: "sp-whitespace-pre-line",
			expanded: t,
			expandOnContentClick: !0,
			measurementText: g_(i),
			onExpandedChange: r,
			targetPlatform: "LI",
			trackEvent: o,
			triggerLabel: "...more",
			buttonClassName: "sp-bg-white sp-text-base sp-font-medium sp-leading-5 sp-text-[#808080] sp-cursor-pointer",
			suffix: c ? /* @__PURE__ */ v(g, { children: [" ", /* @__PURE__ */ _("a", {
				className: "sp-break-words sp-font-semibold sp-text-[#4f31ff] sp-no-underline",
				href: s,
				rel: "noreferrer",
				target: "_blank",
				children: s
			})] }) : null
		})
	});
}, e_ = ({ children: e, media: t, mediaCount: n, mediaIndex: r, onIntrinsicDimensions: i, preferVideoCoverPreviewOverride: a, rect: o, videoCoverPreview: s }) => {
	let c = P_(t);
	return /* @__PURE__ */ v(Bp, {
		className: "sp-absolute sp-bg-[#f2f2f2]",
		"data-uplift-media-frame-ratio": `${o.width} / ${o.height}`,
		style: {
			height: o.height,
			left: o.left,
			top: o.top,
			width: o.width
		},
		children: [
			/* @__PURE__ */ _(Q, {
				coverScope: c ? "none" : void 0,
				media: t,
				mediaCount: n,
				mediaIndex: r,
				onIntrinsicDimensions: i,
				platform: "LI",
				preferVideoCoverPreviewOverride: a,
				surface: c ? "video" : "grid",
				videoCoverPreview: c ? s : void 0
			}),
			c && /* @__PURE__ */ _("div", {
				className: "sp-absolute sp-right-4 sp-top-4 sp-rounded sp-bg-[#454545] sp-px-2 sp-py-1 sp-text-xs sp-font-semibold sp-leading-[15px] sp-text-white",
				children: "02:30"
			}),
			e
		]
	});
}, t_ = ({ rect: e, url: t }) => {
	let [n, r] = h(() => W_.get(Y_(t)) ?? null);
	d(() => {
		let e = !0;
		if (!G_(t)) {
			r(null);
			return;
		}
		let n = W_.get(Y_(t));
		if (n) {
			r(n);
			return;
		}
		r(null);
		let i = setTimeout(() => {
			K_(t).then((t) => {
				e && r(t);
			});
		}, H_);
		return () => {
			e = !1, clearTimeout(i);
		};
	}, [t]);
	let i = n?.imageUrl || "", a = n?.title || Z_(t), o = n?.description || "";
	return /* @__PURE__ */ v("a", {
		className: "sp-absolute sp-box-border sp-flex sp-items-center sp-gap-3 sp-overflow-hidden sp-rounded-lg sp-border sp-border-solid sp-border-[#e6e6e6] sp-bg-white sp-p-3 sp-text-inherit sp-no-underline",
		href: Y_(t),
		rel: "noreferrer",
		target: "_blank",
		style: {
			height: e.height,
			left: e.left,
			top: e.top,
			width: e.width
		},
		children: [/* @__PURE__ */ _("div", {
			className: "sp-flex sp-h-20 sp-w-[120px] sp-shrink-0 sp-items-center sp-justify-center sp-overflow-hidden sp-rounded-lg sp-bg-[#f4f4f6] sp-text-[#676767]",
			children: i ? /* @__PURE__ */ _("img", {
				alt: "",
				className: "sp-h-full sp-w-full sp-object-cover",
				src: i
			}) : /* @__PURE__ */ _(nv, {})
		}), /* @__PURE__ */ v("div", {
			"data-linkedin-link-card": "compact",
			className: "sp-flex sp-h-20 sp-min-w-0 sp-flex-1 sp-flex-col sp-justify-center sp-gap-1",
			children: [
				/* @__PURE__ */ _("div", {
					className: "sp-line-clamp-1 sp-text-sm sp-font-semibold sp-leading-5 sp-text-[#333]",
					children: a
				}),
				o ? /* @__PURE__ */ _("div", {
					className: "sp-line-clamp-2 sp-text-xs sp-leading-4 sp-text-[#333]",
					children: o
				}) : null,
				/* @__PURE__ */ _("div", {
					className: "sp-truncate sp-text-xs sp-leading-4 sp-text-[#666]",
					children: X_(t)
				})
			]
		})]
	});
}, n_ = ({ media: e, rect: t }) => {
	let n = R_(e), r = z_(e), i = e?.thumbnailUrl || e?.url || "", a = !!(i && !L_(i)), o = Math.max(1, r - 1), [s, c] = h(1), l = Math.min(s, o), u = [l, l + 1].filter((e) => e <= r), d = l < o, f = l > 1, p = () => {
		e?.url && window.open(e.url, "_blank", "noreferrer");
	};
	return /* @__PURE__ */ _("div", {
		className: "sp-absolute sp-box-border sp-block sp-overflow-hidden sp-bg-white sp-p-2 sp-text-inherit sp-no-underline",
		"data-linkedin-document-card": "true",
		onClick: (e) => {
			e.target instanceof HTMLElement && e.target.closest("button") || p();
		},
		onKeyDown: (e) => {
			e.target instanceof HTMLElement && e.target.closest("button") || (e.key === "Enter" || e.key === " ") && (e.preventDefault(), p());
		},
		role: "link",
		style: {
			height: t.height,
			left: t.left,
			top: t.top,
			width: t.width
		},
		tabIndex: 0,
		children: /* @__PURE__ */ v("div", {
			className: "sp-relative sp-flex sp-h-full sp-w-full sp-gap-2 sp-overflow-hidden",
			children: [
				u.map((e) => /* @__PURE__ */ _("div", {
					className: "sp-relative sp-h-full sp-w-[200px] sp-shrink-0 sp-overflow-hidden sp-border-2 sp-border-solid sp-border-[#6840f5] sp-bg-[#f4f4f6]",
					children: e === 1 && a ? /* @__PURE__ */ _("img", {
						alt: "",
						className: "sp-h-full sp-w-full sp-object-cover",
						src: i
					}) : /* @__PURE__ */ v("div", {
						className: "sp-flex sp-h-full sp-w-full sp-flex-col sp-items-center sp-justify-center sp-gap-2 sp-text-[#676767]",
						children: [/* @__PURE__ */ _(tv, {}), /* @__PURE__ */ v("span", {
							className: "sp-text-xs sp-font-semibold sp-leading-4",
							children: ["Page ", e]
						})]
					})
				}, e)),
				/* @__PURE__ */ v("div", {
					className: "sp-absolute sp-left-0 sp-top-2 sp-rounded-lg sp-bg-black/70 sp-px-2 sp-py-1 sp-text-xs sp-leading-4 sp-text-white",
					children: [/* @__PURE__ */ _("span", {
						className: "sp-font-semibold",
						children: n
					}), /* @__PURE__ */ v("span", { children: [
						" ",
						"• ",
						r,
						" ",
						r === 1 ? "page" : "pages"
					] })]
				}),
				f && /* @__PURE__ */ _("button", {
					"aria-label": "Previous document pages",
					className: "sp-absolute sp-left-0 sp-top-1/2 sp-flex sp-h-6 sp-w-6 -sp-translate-y-1/2 sp-items-center sp-justify-center sp-rounded-lg sp-border-0 sp-bg-black/70 sp-p-0 sp-text-white",
					onClick: () => c((e) => Math.max(1, e - 1)),
					type: "button",
					children: /* @__PURE__ */ _(cv, {})
				}),
				d && /* @__PURE__ */ _("button", {
					"aria-label": "Next document pages",
					className: "sp-absolute sp-right-0 sp-top-1/2 sp-flex sp-h-6 sp-w-6 -sp-translate-y-1/2 sp-items-center sp-justify-center sp-rounded-lg sp-border-0 sp-bg-black/70 sp-p-0 sp-text-white",
					onClick: () => c((e) => Math.min(o, e + 1)),
					type: "button",
					children: /* @__PURE__ */ _(sv, {})
				}),
				/* @__PURE__ */ _("button", {
					"aria-label": "Open document",
					className: "sp-absolute sp-bottom-0 sp-right-0 sp-flex sp-h-6 sp-w-6 sp-items-center sp-justify-center sp-rounded-lg sp-border-0 sp-bg-black/70 sp-p-0 sp-text-white",
					onClick: p,
					type: "button",
					children: /* @__PURE__ */ _(lv, {})
				})
			]
		})
	});
}, r_ = ({ top: e }) => /* @__PURE__ */ v("footer", {
	className: "sp-absolute sp-left-4 sp-flex sp-h-5 sp-w-[368px] sp-items-center sp-gap-6 sp-text-sm sp-font-semibold sp-leading-none sp-text-[#676767]",
	style: { top: e },
	children: [
		/* @__PURE__ */ _(i_, {
			icon: /* @__PURE__ */ _(rv, {}),
			count: 1
		}),
		/* @__PURE__ */ _(i_, {
			icon: /* @__PURE__ */ _(iv, {}),
			count: 1
		}),
		/* @__PURE__ */ _(i_, {
			icon: /* @__PURE__ */ _(av, {}),
			count: 1
		}),
		/* @__PURE__ */ _(i_, {
			icon: /* @__PURE__ */ _(ov, {}),
			count: 1
		})
	]
}), i_ = ({ icon: e, count: t }) => /* @__PURE__ */ v("span", {
	className: "sp-flex sp-items-center sp-gap-1",
	children: [/* @__PURE__ */ _("span", {
		className: "sp-flex sp-h-5 sp-w-5 sp-items-center sp-justify-center sp-leading-none",
		children: e
	}), /* @__PURE__ */ _("span", {
		className: "sp-leading-[17px]",
		children: t
	})]
}), a_ = ({ height: e, post: t, top: n, trackEvent: r }) => /* @__PURE__ */ v("div", {
	className: "sp-absolute sp-left-4 sp-w-[368px] sp-overflow-hidden sp-whitespace-pre-line sp-break-words sp-text-sm sp-leading-5 sp-text-black [&_a]:sp-font-semibold [&_a]:sp-text-[#4f31ff] [&_a]:sp-no-underline",
	style: {
		height: e,
		top: n
	},
	children: [/* @__PURE__ */ _("span", {
		className: "sp-mr-1 sp-font-semibold",
		children: t.username
	}), /* @__PURE__ */ _(Y, {
		caption: t.comment.trim(),
		targetPlatform: "LI",
		trackEvent: r
	})]
}), o_ = {
	height: 0,
	left: 0,
	top: 0,
	width: 0
}, s_ = 79, c_ = 72, l_ = 151, u_ = 159, d_ = 12, f_ = (e, t) => $(e.caption) ? Dp({
	charsPerLine: Rg,
	collapsedLines: zg,
	expanded: t,
	lineHeight: Bg,
	text: g_(e)
}) : 0, p_ = (e) => e.comment.trim() ? Op({
	charsPerLine: Rg,
	leadingText: e.username,
	text: e.comment
}) * Yg : 0, m_ = (e, t) => t ? h_(e) + t + Wg : e + Kg, h_ = (e) => e + Gg + Jg, g_ = (e) => y_(e) ? `${e.caption} ${y_(e)}` : e.caption, __ = (e, t) => !!(y_(e) && (t || Op({
	charsPerLine: Rg,
	text: g_(e)
}) <= zg)), v_ = (e) => {
	let t = e.caption.trim();
	if (Op({
		charsPerLine: Rg,
		text: g_(e)
	}) <= zg) return t;
	let n = t;
	for (; n.length > 0 && Op({
		charsPerLine: Rg,
		text: `${n}...more`
	}) > zg;) n = n.slice(0, -1).trimEnd();
	return n;
}, y_ = (e) => e.redirectUrl && !b_(e) && !e.caption.includes(e.redirectUrl) ? e.redirectUrl : "", b_ = (e) => !!(x_(e) && (e.type === "text" || e.type === "image" || e.type === "multiMedia" || e.type === "video")), x_ = (e) => e.redirectUrl || S_(e.caption), S_ = (e) => {
	let t = e.match(/\b((?:https?:\/\/|www\.)[^\s<]+)/i)?.[1]?.replace(/[),.;!?]+$/, "");
	return t ? t.startsWith("www.") ? `https://${t}` : t : "";
}, C_ = ({ captionExpanded: e, captionHeight: t, hasLinkCard: n }) => {
	let r = w_(t, e), i = n ? r : 0;
	return {
		firstContentTop: r,
		linkTop: i,
		mediaTop: n ? i + Vg + Ug : r
	};
}, w_ = (e, t) => e > 0 ? t ? s_ + e + d_ : Math.max(l_, s_ + e + d_) : c_, T_ = (e, t) => e > 0 ? t ? s_ + e + d_ : Math.max(u_, s_ + e + d_) : c_, E_ = (e, t, n, r) => {
	let i = e.type === "text" && !!x_(e), a = b_(e), o = r ?? f_(e, n), { firstContentTop: s, linkTop: c, mediaTop: l } = C_({
		captionExpanded: n,
		captionHeight: o,
		hasLinkCard: a
	}), u = $(e.caption) && /(^|\s)#\w+/.test(e.caption), d = p_(e);
	if (i) {
		let e = s + Vg + Ug;
		return {
			actionsTop: e,
			captionHeight: o,
			captionTop: s_,
			dataLayout: "linkedin-link",
			firstCommentHeight: d,
			firstCommentTop: h_(e),
			height: m_(e, d),
			kind: "link",
			documentRect: o_,
			linkRect: {
				height: Vg,
				left: 16,
				top: s,
				width: 368
			},
			mediaRects: []
		};
	}
	if (e.type === "text" || t.length === 0) {
		let e = u ? 78 : s_, t = o === 0 ? c_ : Math.max(u ? 240 : 159, e + o + 20);
		return {
			actionsTop: t,
			captionHeight: o,
			captionTop: e,
			dataLayout: u ? "linkedin-text-hashtag" : "linkedin-text",
			dividerTop: o === 0 ? void 0 : t - 11,
			firstCommentHeight: d,
			firstCommentTop: h_(t),
			height: m_(t, d),
			kind: "text",
			documentRect: o_,
			linkRect: o_,
			mediaRects: []
		};
	}
	if (e.type === "document") {
		let t = w_(o, n), r = t + 299 + Ug;
		return {
			actionsTop: r,
			captionHeight: o,
			captionTop: s_,
			dataLayout: "linkedin-document",
			documentMedia: A_(e),
			documentRect: {
				height: 299,
				left: 0,
				top: t,
				width: 400
			},
			firstCommentHeight: d,
			firstCommentTop: h_(r),
			height: m_(r, d),
			kind: "document",
			linkRect: o_,
			mediaRects: []
		};
	}
	if (t.length === 1 && (P_(t[0]) || e.type === "video")) {
		let e = D_(t[0], "video", l), n = e.top + e.height + Ug;
		return {
			actionsTop: n,
			captionHeight: o,
			captionTop: s_,
			dataLayout: a ? "linkedin-video-link" : "linkedin-video",
			firstCommentHeight: d,
			firstCommentTop: h_(n),
			height: m_(n, d),
			kind: "single-media",
			documentRect: o_,
			linkRect: a ? {
				height: Vg,
				left: 16,
				top: c,
				width: 368
			} : o_,
			mediaRects: [e]
		};
	}
	if (t.length === 1) {
		let e = D_(t[0], "grid", l), n = e.top + e.height + Ug, r = m_(n, d);
		return {
			actionsTop: n,
			captionHeight: o,
			captionTop: s_,
			dataLayout: a ? "linkedin-image-link" : "linkedin-image",
			firstCommentHeight: d,
			firstCommentTop: h_(n),
			height: !a && o > 0 ? Math.max(r, qg) : r,
			kind: "single-media",
			documentRect: o_,
			linkRect: a ? {
				height: Vg,
				left: 16,
				top: c,
				width: 368
			} : o_,
			mediaRects: [e]
		};
	}
	let f = a ? l : T_(o, n), p = f + 400 + 16;
	return {
		actionsTop: p,
		captionHeight: o,
		captionTop: 83,
		collageTop: f,
		dataLayout: `linkedin-collage-${Math.min(t.length, 5)}${t.length > 5 ? "-plus" : ""}${a ? "-link" : ""}`,
		firstCommentHeight: d,
		firstCommentTop: h_(p),
		height: m_(p, d),
		kind: "collage",
		documentRect: o_,
		linkRect: a ? {
			height: Vg,
			left: 16,
			top: c,
			width: 368
		} : o_,
		mediaRects: O_(t.length)
	};
}, D_ = (e, t, n) => {
	let r = fm({
		media: e,
		platform: "LI",
		surface: t,
		width: 400
	});
	return {
		height: r.height,
		left: 0,
		top: n,
		width: r.width
	};
}, O_ = (e) => e === 2 ? [{
	height: 400,
	left: 0,
	top: 0,
	width: 199
}, {
	height: 400,
	left: 201,
	top: 0,
	width: 199
}] : e === 3 ? [
	{
		height: 240,
		left: 0,
		top: 0,
		width: 400
	},
	{
		height: 158,
		left: 0,
		top: 242,
		width: 199
	},
	{
		height: 158,
		left: 201,
		top: 242,
		width: 199
	}
] : e === 4 ? [
	{
		height: 240,
		left: 0,
		top: 0,
		width: 400
	},
	{
		height: 158,
		left: 0,
		top: 242,
		width: 132
	},
	{
		height: 158,
		left: 134,
		top: 242,
		width: 132
	},
	{
		height: 158,
		left: 268,
		top: 242,
		width: 132
	}
] : [
	{
		height: 240,
		left: 0,
		top: 0,
		width: 199
	},
	{
		height: 240,
		left: 201,
		top: 0,
		width: 199
	},
	{
		height: 158,
		left: 0,
		top: 242,
		width: 132
	},
	{
		height: 158,
		left: 134,
		top: 242,
		width: 132
	},
	{
		height: 158,
		left: 268,
		top: 242,
		width: 132
	}
], k_ = (e) => {
	if (e.type === "text") return [];
	let t = e.medias.collection.filter((e) => !e.url?.includes(".pdf"));
	return t.length > 0 ? t : [{
		isVideo: e.type === "video",
		thumbnailUrl: e.imageUrl,
		url: e.imageUrl
	}];
}, A_ = (e) => e.medias.collection.find(F_) ?? j_(e)[0] ?? (e.imageUrl ? {
	fileName: R_({ url: e.imageUrl }),
	isVideo: !1,
	thumbnailUrl: e.imageUrl,
	url: e.imageUrl
} : void 0), j_ = (e) => e.sourcePost.medias?.medias?.filter(F_) ?? [], M_ = (e) => [
	e?.url ?? "",
	e?.thumbnailUrl ?? "",
	e?.pages ?? ""
].join("|"), N_ = (e, t) => [
	e?.url ?? e?.thumbnailUrl ?? e?.fileName ?? "media",
	t.left,
	t.top,
	t.width,
	t.height
].join("-"), P_ = (e) => Z(e), F_ = (e) => !!(e && (e.type === "application/pdf" || L_(e.url) || L_(e.thumbnailUrl) || L_(e.fileName))), I_ = (e) => L_(e.imageUrl) || e.medias.collection.some(F_), L_ = (e) => !!e?.toLowerCase().includes(".pdf"), R_ = (e) => e?.fileName || B_(e?.url) || B_(e?.thumbnailUrl) || "Document.pdf", z_ = (e) => {
	let t = e;
	return e?.pages || t?.meta?.pages || 1;
}, B_ = (e) => {
	if (!e) return "";
	try {
		let t = new URL(e).pathname.split("/").filter(Boolean).pop();
		return t ? decodeURIComponent(t) : "";
	} catch {
		let t = e.split("/").filter(Boolean).pop();
		return t ? decodeURIComponent(t) : "";
	}
}, V_ = (e) => `https://api.microlink.io/?${new URLSearchParams({
	apiKey: Hg,
	url: Y_(e)
}).toString()}`, H_ = 800, U_ = /* @__PURE__ */ new Map(), W_ = /* @__PURE__ */ new Map(), G_ = (e) => {
	try {
		let { hostname: t } = new URL(Y_(e));
		return /\.[^.\s]{2,}$/.test(t);
	} catch {
		return !1;
	}
}, K_ = (e) => {
	let t = Y_(e), n = U_.get(t);
	if (n) return n;
	let r = fetch(V_(e)).then((e) => {
		if (!e.ok) throw Error(`microlink request failed: ${e.status}`);
		return e.json();
	}).then((e) => {
		if (e?.status !== "success" || !e.data) return null;
		let n = q_(e.data);
		return W_.set(t, n), n;
	}).catch(() => (U_.delete(t), null));
	return U_.set(t, r), r;
}, q_ = (e) => ({
	description: e.description || "",
	imageUrl: J_(e.image) || J_(e.logo),
	title: e.title || ""
}), J_ = (e) => e ? typeof e == "string" ? e : e.url || "" : "", Y_ = (e) => /^https?:\/\//i.test(e) ? e : `https://${e}`, X_ = (e) => {
	let t = Y_(e);
	try {
		return new URL(t).hostname.replace(/^www\./i, "") || e;
	} catch {
		return e.replace(/^https?:\/\//i, "").replace(/^www\./i, "");
	}
}, Z_ = (e) => {
	let t = X_(e);
	try {
		return new URL(Y_(e)).pathname.split("/").filter(Boolean).pop()?.replace(/[-_]+/g, " ").trim() || t || e;
	} catch {
		return t || e;
	}
}, Q_ = ({ children: e, className: t = "sp-text-current", size: n = 20, viewBox: r = "0 0 24 24" }) => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	className: t,
	fill: "none",
	height: n,
	viewBox: r,
	width: n,
	children: e
}), $_ = () => /* @__PURE__ */ _(Q_, {
	className: "sp-text-[#333]",
	size: 32,
	children: /* @__PURE__ */ _("path", {
		d: "M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
		fill: "currentColor"
	})
}), ev = () => /* @__PURE__ */ v(Q_, {
	className: "sp-text-[#333]",
	size: 12,
	children: [/* @__PURE__ */ _("path", {
		d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	}), /* @__PURE__ */ _("path", {
		d: "M3.6 9h16.8M3.6 15h16.8M12 3a13.8 13.8 0 0 1 0 18M12 3a13.8 13.8 0 0 0 0 18",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})]
}), tv = () => /* @__PURE__ */ v(Q_, {
	className: "sp-text-[#676767]",
	size: 54,
	children: [/* @__PURE__ */ _("path", {
		d: "M7 3h7l5 5v13H7V3Z",
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: "1.6"
	}), /* @__PURE__ */ _("path", {
		d: "M14 3v5h5M10 13h6M10 17h6",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.6"
	})]
}), nv = () => /* @__PURE__ */ v(Q_, {
	size: 32,
	children: [/* @__PURE__ */ _("path", {
		d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	}), /* @__PURE__ */ _("path", {
		d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})]
}), rv = () => /* @__PURE__ */ _(Q_, {
	viewBox: "0 0 20 20",
	children: /* @__PURE__ */ _("path", {
		d: "M5.83333 18.3333V9.16667M1.66667 10.8333V16.6667C1.66667 17.5871 2.41286 18.3333 3.33333 18.3333H14.5219C15.7558 18.3333 16.8052 17.4331 16.9928 16.2135L17.8902 10.3801C18.1232 8.86575 16.9515 7.5 15.4193 7.5H12.5C12.0398 7.5 11.6667 7.1269 11.6667 6.66667V3.72153C11.6667 2.58666 10.7467 1.66667 9.6118 1.66667C9.34111 1.66667 9.09582 1.82608 8.98588 2.07344L6.05328 8.67178C5.91953 8.97272 5.6211 9.16667 5.29177 9.16667H3.33333C2.41286 9.16667 1.66667 9.91286 1.66667 10.8333Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), iv = () => /* @__PURE__ */ _(Q_, {
	viewBox: "0 0 20 20",
	children: /* @__PURE__ */ _("path", {
		d: "M5.83301 7.49999H14.1663V8.33333H5.83301V7.49999ZM5.83301 10.8333H11.6663V9.99999H5.83301V10.8333ZM19.1663 9.16666C19.1787 10.0791 18.9699 10.981 18.5577 11.7951C18.1456 12.6093 17.5424 13.3115 16.7997 13.8417L9.99967 18.3333V15H6.66634C5.11924 15 3.63551 14.3854 2.54155 13.2915C1.44759 12.1975 0.833008 10.7138 0.833008 9.16666C0.833008 7.61957 1.44759 6.13583 2.54155 5.04187C3.63551 3.94791 5.11924 3.33333 6.66634 3.33333H13.333C14.8801 3.33333 16.3638 3.94791 17.4578 5.04187C18.5518 6.13583 19.1663 7.61957 19.1663 9.16666ZM17.4997 9.16666C17.4997 8.06159 17.0607 7.00178 16.2793 6.22038C15.4979 5.43898 14.4381 4.99999 13.333 4.99999H6.66634C5.56127 4.99999 4.50146 5.43898 3.72006 6.22038C2.93866 7.00178 2.49967 8.06159 2.49967 9.16666C2.49967 10.2717 2.93866 11.3315 3.72006 12.1129C4.50146 12.8943 5.56127 13.3333 6.66634 13.3333H11.6663V15.2333L15.833 12.5C16.361 12.1219 16.7888 11.6206 17.0792 11.0398C17.3697 10.4589 17.514 9.81594 17.4997 9.16666Z",
		fill: "currentColor"
	})
}), av = () => /* @__PURE__ */ _(Q_, {
	viewBox: "0 0 20 20",
	children: /* @__PURE__ */ _("path", {
		d: "M14.1667 8.33333L17.5 5L14.1667 1.66667M17.5 5H6.5C5.09987 5 4.3998 5 3.86502 5.27248C3.39462 5.51217 3.01217 5.89462 2.77248 6.36502C2.5 6.8998 2.5 7.59987 2.5 9V9.16667M2.5 15H13.5C14.9001 15 15.6002 15 16.135 14.7275C16.6054 14.4878 16.9878 14.1054 17.2275 13.635C17.5 13.1002 17.5 12.4001 17.5 11V10.8333M5.83333 11.6667L2.5 15L5.83333 18.3333",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), ov = () => /* @__PURE__ */ _(Q_, {
	viewBox: "0 0 20 20",
	children: /* @__PURE__ */ _("path", {
		d: "M17.5 2.5L0 8.33333L6.38333 11.8833L13.3333 6.66667L8.11667 13.6167L11.6667 20L17.5 2.5Z",
		fill: "currentColor"
	})
}), sv = () => /* @__PURE__ */ _(Q_, {
	className: "sp-text-white",
	size: 18,
	children: /* @__PURE__ */ _("path", {
		d: "m9 18 6-6-6-6",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), cv = () => /* @__PURE__ */ _(Q_, {
	className: "sp-text-white",
	size: 18,
	children: /* @__PURE__ */ _("path", {
		d: "m15 18-6-6 6-6",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), lv = () => /* @__PURE__ */ _(Q_, {
	className: "sp-text-white",
	size: 16,
	children: /* @__PURE__ */ _("path", {
		d: "M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5M3 3l6 6M21 3l-6 6M3 21l6-6M21 21l-6-6",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), uv = /* @__PURE__ */ new Set([
	"image",
	"multiMedia",
	"text",
	"video"
]), dv = 48, fv = 320, pv = 24, mv = 20, hv = 36, gv = 6, _v = 8, vv = 8, yv = 20, bv = 2, xv = (e) => e.platform === "TW" && uv.has(e.type), Sv = ({ post: e, className: t, videoCoverPreview: n, trackEvent: r }) => {
	let { medias: i, reportIntrinsicDimensions: a } = Cm(Lv(e)), [o, s] = h(!1), c = kv(e, i, o), l = Iv(e) ? e.redirectUrl : "";
	return /* @__PURE__ */ _(Lp, {
		className: ["sp-relative sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-bg-white sp-text-base sp-leading-5", t].filter(Boolean).join(" "),
		platform: "TW",
		children: /* @__PURE__ */ v("article", {
			className: "sp-relative sp-m-4 sp-w-[368px] sp-bg-white",
			"data-uplift-layout": c.dataLayout,
			"data-uplift-renderer": "twitter",
			style: { height: c.height },
			children: [
				/* @__PURE__ */ _(X, {
					alt: e.username,
					className: "sp-absolute sp-left-0 sp-top-0 sp-h-10 sp-w-10",
					src: e.profilePicture
				}),
				/* @__PURE__ */ _(Cv, { username: e.username }),
				c.captionHeight > 0 && /* @__PURE__ */ _("div", {
					className: "sp-absolute sp-left-12 sp-w-[320px] sp-overflow-hidden sp-whitespace-pre-line sp-break-words sp-text-base sp-leading-5 sp-text-black [&_a]:sp-text-[#1694e0] [&_a]:sp-no-underline",
					"data-uplift-caption": "twitter",
					style: {
						height: c.captionHeight,
						top: pv
					},
					children: /* @__PURE__ */ _(wv, {
						caption: e.caption,
						expanded: o,
						onExpandedChange: s,
						suffixUrl: l,
						trackEvent: r
					})
				}),
				c.kind === "link" && /* @__PURE__ */ _(Ev, {
					media: i[0],
					post: e,
					rect: c.linkRect
				}),
				c.kind === "single-media" && /* @__PURE__ */ _(Tv, {
					media: i[0],
					mediaCount: i.length,
					mediaIndex: 0,
					onIntrinsicDimensions: a,
					rect: c.mediaRects[0],
					videoCoverPreview: n
				}),
				c.kind === "collage" && /* @__PURE__ */ _("div", {
					className: "sp-absolute sp-overflow-hidden sp-rounded-lg sp-bg-white",
					"data-twitter-media-count": Math.min(i.length, 4),
					style: {
						height: 180,
						left: dv,
						top: c.mediaTop,
						width: fv
					},
					children: c.mediaRects.map((e, t) => /* @__PURE__ */ _(Tv, {
						media: i[t],
						mediaCount: i.length,
						mediaIndex: lm(i, t),
						onIntrinsicDimensions: a,
						rect: {
							...e,
							left: e.left - dv,
							top: e.top - c.mediaTop
						},
						videoCoverPreview: zv(i[t]) ? n : void 0
					}, Rv(i[t], e)))
				}),
				/* @__PURE__ */ _(Dv, { top: c.actionsTop })
			]
		})
	});
}, Cv = ({ username: e }) => /* @__PURE__ */ v("header", {
	className: "sp-absolute sp-left-12 sp-top-0 sp-flex sp-h-6 sp-w-[320px] sp-items-center sp-justify-between sp-gap-2",
	children: [/* @__PURE__ */ v("div", {
		className: "sp-flex sp-min-w-0 sp-items-center sp-gap-1",
		children: [
			/* @__PURE__ */ _("span", {
				className: "sp-truncate sp-text-base sp-font-semibold sp-leading-[19px] sp-text-black",
				children: e
			}),
			/* @__PURE__ */ v("span", {
				className: "sp-truncate sp-text-sm sp-leading-[17px] sp-text-[#666]",
				children: ["@", Bv(e)]
			}),
			/* @__PURE__ */ _("span", {
				className: "sp-text-sm sp-font-semibold sp-leading-[17px] sp-text-[#666]",
				children: "."
			}),
			/* @__PURE__ */ _("span", {
				className: "sp-whitespace-nowrap sp-text-sm sp-leading-[17px] sp-text-[#666]",
				children: "Just now"
			})
		]
	}), /* @__PURE__ */ _(Wv, {})]
}), wv = ({ caption: e, expanded: t, onExpandedChange: n, suffixUrl: r, trackEvent: i }) => /* @__PURE__ */ _(Ep, {
	buttonClassName: "sp-bg-white sp-pl-1 sp-text-[#526572] sp-cursor-pointer",
	caption: e,
	charsPerLine: hv,
	collapsedLines: gv,
	contentClassName: "sp-whitespace-pre-line",
	expanded: t,
	measurementText: [e.trim(), r].filter(Boolean).join(" "),
	onExpandedChange: n,
	suffix: r ? /* @__PURE__ */ v(g, { children: [e.trim() ? " " : "", /* @__PURE__ */ _("a", {
		className: "sp-break-words sp-text-[#1694e0] sp-no-underline",
		href: r,
		rel: "noreferrer",
		target: "_blank",
		children: r
	})] }) : null,
	targetPlatform: "TW",
	trackEvent: i,
	triggerLabel: "Show more"
}), Tv = ({ media: e, mediaCount: t, mediaIndex: n, onIntrinsicDimensions: r, rect: i, videoCoverPreview: a }) => {
	let o = zv(e);
	return /* @__PURE__ */ _(Bp, {
		className: "sp-absolute sp-rounded-lg",
		"data-uplift-media-frame-ratio": `${i.width} / ${i.height}`,
		style: {
			height: i.height,
			left: i.left,
			top: i.top,
			width: i.width
		},
		children: /* @__PURE__ */ _(Q, {
			coverScope: "firstVideoOnly",
			media: e,
			mediaCount: t,
			mediaIndex: n,
			onIntrinsicDimensions: r,
			platform: "TW",
			surface: o ? "video" : "grid",
			videoCoverPreview: o ? a : void 0
		})
	});
}, Ev = ({ media: e, post: t, rect: n }) => /* @__PURE__ */ v("a", {
	className: "sp-absolute sp-block sp-overflow-hidden sp-rounded-2xl sp-border sp-border-solid sp-border-[#c4c4c4] sp-text-inherit sp-no-underline",
	href: t.redirectUrl,
	rel: "noreferrer",
	style: {
		height: n.height,
		left: n.left,
		top: n.top,
		width: n.width
	},
	target: "_blank",
	children: [/* @__PURE__ */ _("div", {
		className: "sp-h-[203px] sp-w-full sp-overflow-hidden sp-bg-[#d8d8d8]",
		children: /* @__PURE__ */ _(Q, {
			media: e,
			platform: "TW",
			surface: "grid"
		})
	}), /* @__PURE__ */ v("div", {
		className: "sp-box-border sp-h-[55px] sp-w-full sp-px-4 sp-py-2",
		children: [/* @__PURE__ */ _("div", {
			className: "sp-truncate sp-text-sm sp-leading-5 sp-text-[#808080]",
			children: Vv(t.redirectUrl)
		}), /* @__PURE__ */ _("div", {
			className: "sp-truncate sp-text-base sp-leading-[19px] sp-text-black",
			children: Hv(t.redirectUrl)
		})]
	})]
}), Dv = ({ top: e }) => /* @__PURE__ */ v("footer", {
	className: "sp-absolute sp-left-12 sp-flex sp-h-5 sp-w-[320px] sp-items-center sp-justify-between sp-text-sm sp-leading-[17px] sp-text-[#526572]",
	style: { top: e },
	children: [/* @__PURE__ */ v("div", {
		className: "sp-flex sp-items-start sp-gap-8",
		children: [
			/* @__PURE__ */ _(Ov, { icon: /* @__PURE__ */ _(Gv, {}) }),
			/* @__PURE__ */ _(Ov, { icon: /* @__PURE__ */ _(Kv, {}) }),
			/* @__PURE__ */ _(Ov, { icon: /* @__PURE__ */ _(qv, {}) }),
			/* @__PURE__ */ _(Ov, { icon: /* @__PURE__ */ _(Jv, {}) })
		]
	}), /* @__PURE__ */ v("div", {
		className: "sp-flex sp-items-center sp-gap-2",
		children: [/* @__PURE__ */ _(Yv, {}), /* @__PURE__ */ _(Xv, {})]
	})]
}), Ov = ({ icon: e }) => /* @__PURE__ */ v("span", {
	className: "sp-flex sp-items-center sp-gap-1",
	children: [e, /* @__PURE__ */ _("span", { children: "1" })]
}), kv = (e, t, n) => {
	let r = e.type === "text" && !!e.redirectUrl, i = t[0], a = Fv(e, n), o = Nv(a);
	if (r) {
		let e = {
			height: 258,
			left: dv,
			top: o,
			width: 320
		}, t = e.top + e.height + vv;
		return {
			actionsTop: t,
			captionHeight: a,
			dataLayout: "twitter-link",
			height: Pv(t),
			kind: "link",
			linkRect: e,
			mediaTop: o,
			mediaRects: []
		};
	}
	if (e.type === "text" && t.length === 0) {
		let e = Nv(a);
		return {
			actionsTop: e,
			captionHeight: a,
			dataLayout: "twitter-text",
			height: Pv(e),
			kind: "text",
			linkRect: jv,
			mediaTop: o,
			mediaRects: []
		};
	}
	if (e.type === "video" || zv(i)) {
		let e = Av(i, "video", o), t = e.top + e.height + vv;
		return {
			actionsTop: t,
			captionHeight: a,
			dataLayout: "twitter-video",
			height: Pv(t),
			kind: "single-media",
			linkRect: jv,
			mediaTop: o,
			mediaRects: [e]
		};
	}
	if (t.length <= 1) {
		let e = Av(i, "grid", o), t = e.top + e.height + vv;
		return {
			actionsTop: t,
			captionHeight: a,
			dataLayout: "twitter-image",
			height: Pv(t),
			kind: "single-media",
			linkRect: jv,
			mediaTop: o,
			mediaRects: [e]
		};
	}
	let s = o + 180 + vv;
	return {
		actionsTop: s,
		captionHeight: a,
		dataLayout: `twitter-collage-${Math.min(t.length, 4)}${t.length > 4 ? "-plus" : ""}`,
		height: Pv(s),
		kind: "collage",
		linkRect: jv,
		mediaTop: o,
		mediaRects: Mv(t.length, o)
	};
}, Av = (e, t, n) => {
	let r = fm({
		media: e,
		platform: "TW",
		surface: t,
		width: fv
	});
	return {
		height: r.height,
		left: dv,
		top: n,
		width: r.width
	};
}, jv = {
	height: 0,
	left: 0,
	top: 0,
	width: 0
}, Mv = (e, t) => e === 2 ? [{
	height: 180,
	left: dv,
	top: t,
	width: 158
}, {
	height: 180,
	left: 210,
	top: t,
	width: 158
}] : e === 3 ? [
	{
		height: 180,
		left: dv,
		top: t,
		width: 158
	},
	{
		height: 88,
		left: 210,
		top: t,
		width: 158
	},
	{
		height: 88,
		left: 210,
		top: t + 92,
		width: 158
	}
] : [
	{
		height: 88,
		left: dv,
		top: t,
		width: 158
	},
	{
		height: 88,
		left: 210,
		top: t,
		width: 158
	},
	{
		height: 88,
		left: dv,
		top: t + 92,
		width: 158
	},
	{
		height: 88,
		left: 210,
		top: t + 92,
		width: 158
	}
], Nv = (e) => e > 0 ? pv + e + _v : 28, Pv = (e) => e + yv - bv, Fv = (e, t) => {
	let n = [e.caption.trim(), Iv(e) ? e.redirectUrl : ""].filter(Boolean).join(" ");
	if (!n) return 0;
	let r = n.split("\n").reduce((e, t) => e + Math.max(1, Math.ceil(t.length / hv)), 0), i = Math.min(t ? r : gv, r), a = t && r > gv ? mv : 0;
	return i * mv + a;
}, Iv = (e) => !!e.redirectUrl && e.type !== "text", Lv = (e) => {
	if (e.type === "text" && !e.redirectUrl) return [];
	if (e.type === "text" && e.redirectUrl) return e.imageUrl ? [{
		isVideo: !1,
		thumbnailUrl: e.imageUrl,
		url: e.imageUrl
	}] : [];
	let t = e.medias.collection;
	return t.length > 0 ? t : [{
		isVideo: e.type === "video",
		thumbnailUrl: e.imageUrl,
		url: e.imageUrl
	}];
}, Rv = (e, t) => [
	e?.url ?? e?.thumbnailUrl ?? e?.fileName ?? "media",
	t.left,
	t.top,
	t.width,
	t.height
].join("-"), zv = (e) => Z(e), Bv = (e) => e.toLowerCase().replace(/[^a-z0-9_]+/g, ""), Vv = (e) => {
	try {
		return new URL(e).hostname;
	} catch {
		return e;
	}
}, Hv = (e) => {
	let t = Vv(e);
	return t === e ? e : t;
}, Uv = ({ children: e, className: t = "sp-text-current", size: n = 20 }) => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	className: t,
	fill: "none",
	height: n,
	viewBox: "0 0 24 24",
	width: n,
	children: e
}), Wv = () => /* @__PURE__ */ _(Uv, {
	className: "sp-text-[#c4c4c4]",
	size: 24,
	children: /* @__PURE__ */ _("path", {
		d: "M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
		fill: "currentColor"
	})
}), Gv = () => /* @__PURE__ */ _(Uv, { children: /* @__PURE__ */ _("path", {
	d: "M21 11.5a8.5 8.5 0 0 1-8.5 8.5 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7A8.4 8.4 0 0 1 4 11.5a8.5 8.5 0 1 1 17 0Z",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), Kv = () => /* @__PURE__ */ _(Uv, { children: /* @__PURE__ */ _("path", {
	d: "m17 1 4 4-4 4M3 11V9a4 4 0 0 1 4-4h14M7 23l-4-4 4-4M21 13v2a4 4 0 0 1-4 4H3",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), qv = () => /* @__PURE__ */ _(Uv, { children: /* @__PURE__ */ _("path", {
	d: "M20.8 4.6a5.4 5.4 0 0 0-7.6 0L12 5.8l-1.2-1.2a5.4 5.4 0 1 0-7.6 7.6L12 21l8.8-8.8a5.4 5.4 0 0 0 0-7.6Z",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), Jv = () => /* @__PURE__ */ _(Uv, { children: /* @__PURE__ */ _("path", {
	d: "M4 20V10M10.7 20V4M17.3 20v-7",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeWidth: "2"
}) }), Yv = () => /* @__PURE__ */ _(Uv, { children: /* @__PURE__ */ _("path", {
	d: "M6 4.5A1.5 1.5 0 0 1 7.5 3h9A1.5 1.5 0 0 1 18 4.5V21l-6-3.5L6 21V4.5Z",
	stroke: "currentColor",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), Xv = () => /* @__PURE__ */ _(Uv, { children: /* @__PURE__ */ _("path", {
	d: "M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7M12 16V4m0 0 4 4m-4-4-4 4",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), Zv = /* @__PURE__ */ new Set([
	"audio",
	"image",
	"multiMedia",
	"text",
	"video"
]), Qv = (e) => e.platform === "TH" && Zv.has(e.type), $v = ({ post: e, className: t, trackEvent: n, videoCoverPreview: r }) => {
	let { medias: i, reportIntrinsicDimensions: a } = Cm(sy(e)), o = e.type === "text" && !!e.redirectUrl, s = e.type === "audio", c = $(e.caption), l = c || !!(e.redirectUrl && e.type !== "text");
	return /* @__PURE__ */ _(Lp, {
		className: ["sp-rounded-lg sp-border-[#e6e6e6] sp-p-4 sp-text-base sp-leading-5 sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)]", t].filter(Boolean).join(" "),
		platform: "TH",
		children: /* @__PURE__ */ v("article", {
			className: "sp-flex sp-items-start sp-gap-2",
			"data-uplift-renderer": "threads",
			"data-uplift-layout": cy(e, i),
			children: [/* @__PURE__ */ _(X, {
				alt: e.username,
				className: "sp-h-10 sp-w-10 sp-shrink-0",
				src: e.profilePicture
			}), /* @__PURE__ */ v("div", {
				className: "sp-flex sp-min-w-0 sp-flex-1 sp-flex-col sp-gap-2",
				children: [
					/* @__PURE__ */ _(ey, { username: e.username }),
					l && /* @__PURE__ */ v("div", {
						className: "sp-whitespace-pre-line sp-break-words sp-text-base sp-leading-5 [&_a]:sp-text-[#1694e0] [&_a]:sp-no-underline",
						children: [c && /* @__PURE__ */ _(Y, {
							caption: e.caption,
							targetPlatform: "TH",
							trackEvent: n
						}), e.redirectUrl && e.type !== "text" && /* @__PURE__ */ v(g, { children: [c && " ", /* @__PURE__ */ _("a", {
							className: "sp-break-words sp-text-[#1694e0] sp-no-underline",
							href: e.redirectUrl,
							rel: "noreferrer",
							target: "_blank",
							children: e.redirectUrl
						})] })]
					}),
					o && /* @__PURE__ */ _(ry, { url: e.redirectUrl }),
					s && /* @__PURE__ */ _(iy, {}),
					i.length > 0 && /* @__PURE__ */ _(ty, {
						medias: i,
						onIntrinsicDimensions: a,
						videoCoverPreview: r
					}),
					/* @__PURE__ */ _(ay, {})
				]
			})]
		})
	});
}, ey = ({ username: e }) => /* @__PURE__ */ v("header", {
	className: "sp-flex sp-min-w-0 sp-items-center sp-justify-between sp-gap-2",
	children: [/* @__PURE__ */ v("div", {
		className: "sp-flex sp-min-w-0 sp-items-center sp-gap-1",
		children: [/* @__PURE__ */ _("span", {
			className: "sp-truncate sp-text-base sp-font-semibold sp-leading-5 sp-text-black",
			children: e
		}), /* @__PURE__ */ _("span", {
			className: "sp-whitespace-nowrap sp-text-sm sp-leading-5 sp-text-[#666]",
			children: "Just now"
		})]
	}), /* @__PURE__ */ _(my, {})]
}), ty = ({ medias: e, onIntrinsicDimensions: t, videoCoverPreview: n }) => {
	let [r, i] = h(0), a = e.length > 0 ? r % e.length : 0;
	if (e.length === 1) {
		let r = e[0], i = ly(r), a = dm({
			media: r,
			platform: "TH",
			surface: i ? "video" : "grid"
		});
		return /* @__PURE__ */ _("div", {
			className: ["sp-relative sp-overflow-hidden sp-rounded-lg sp-bg-[#f2f2f2]", i ? "sp-w-[265px]" : "sp-w-full"].filter(Boolean).join(" "),
			"data-uplift-media-frame-ratio": a.publishedRatio,
			style: { aspectRatio: a.publishedRatio },
			children: /* @__PURE__ */ _(ny, {
				className: "sp-h-full sp-w-full",
				media: r,
				mediaCount: e.length,
				mediaIndex: 0,
				onIntrinsicDimensions: t,
				videoCoverPreview: i ? n : void 0
			})
		});
	}
	let o = uy(e, a);
	return /* @__PURE__ */ v("div", {
		className: "sp-relative",
		"data-threads-carousel-controls": "true",
		children: [
			/* @__PURE__ */ _("div", {
				className: "sp-flex sp-h-[169px] sp-w-full sp-gap-2 sp-overflow-hidden",
				"data-threads-carousel-start-index": a,
				"data-threads-media-count": o.length,
				children: o.map(({ media: r, originalIndex: i }, a) => /* @__PURE__ */ _(ny, {
					className: [a === 0 ? "sp-w-[236px]" : "sp-w-[123px]", "sp-shrink-0 sp-rounded-lg"].filter(Boolean).join(" "),
					media: r,
					mediaCount: e.length,
					mediaIndex: lm(e, i),
					onIntrinsicDimensions: t,
					videoCoverPreview: ly(r) ? n : void 0
				}, `${r.url}-${i}`))
			}),
			/* @__PURE__ */ _(by, {
				ariaLabel: "Previous media",
				direction: "previous",
				onClick: () => {
					i((t) => (t + e.length - 1) % e.length);
				}
			}),
			/* @__PURE__ */ _(by, {
				ariaLabel: "Next media",
				direction: "next",
				onClick: () => {
					i((t) => (t + 1) % e.length);
				}
			})
		]
	});
}, ny = ({ media: e, className: t, children: n, mediaCount: r = 1, mediaIndex: i = 0, onIntrinsicDimensions: a, videoCoverPreview: o }) => ly(e) ? /* @__PURE__ */ v(Bp, {
	className: ["sp-relative", t].filter(Boolean).join(" "),
	children: [/* @__PURE__ */ _(Q, {
		coverScope: "firstVideoOnly",
		media: e,
		mediaCount: r,
		mediaIndex: i,
		onIntrinsicDimensions: a,
		platform: "TH",
		surface: "video",
		videoCoverPreview: o
	}), n]
}) : /* @__PURE__ */ v(Bp, {
	className: ["sp-relative", t].filter(Boolean).join(" "),
	children: [/* @__PURE__ */ _(Q, {
		media: e,
		onIntrinsicDimensions: a,
		platform: "TH",
		surface: "grid"
	}), n]
}), ry = ({ url: e }) => /* @__PURE__ */ v("a", {
	className: "sp-block sp-overflow-hidden sp-rounded-2xl sp-border sp-border-solid sp-border-[#c4c4c4] sp-text-inherit sp-no-underline",
	href: e,
	rel: "noreferrer",
	target: "_blank",
	children: [/* @__PURE__ */ _("div", { className: "sp-h-[203px] sp-bg-[#d8d8d8]" }), /* @__PURE__ */ v("div", {
		className: "sp-px-4 sp-py-2",
		children: [/* @__PURE__ */ _("div", {
			className: "sp-truncate sp-text-sm sp-leading-5 sp-text-[#808080]",
			children: dy(e)
		}), /* @__PURE__ */ _("div", {
			className: "sp-truncate sp-text-base sp-leading-5 sp-text-black",
			children: "Why does my dog have a pink nose?"
		})]
	})]
}), iy = () => /* @__PURE__ */ v("div", {
	className: "sp-box-border sp-flex sp-w-[225px] sp-items-center sp-gap-2 sp-rounded-lg sp-border sp-border-solid sp-border-[#e6e6e6] sp-bg-white sp-px-4 sp-py-2",
	"data-threads-audio-card": "true",
	children: [/* @__PURE__ */ _(yy, {}), /* @__PURE__ */ _("div", {
		className: "sp-flex sp-h-6 sp-w-[153px] sp-items-center sp-gap-0.5",
		children: fy.map((e, t) => /* @__PURE__ */ _("span", { className: ["sp-w-0.5 sp-rounded-full sp-bg-[#111]", e].filter(Boolean).join(" ") }, `${e}-${t}`))
	})]
}), ay = () => /* @__PURE__ */ v("footer", {
	className: "sp-flex sp-items-start sp-gap-6 sp-text-sm sp-leading-5 sp-text-[#526572]",
	children: [
		/* @__PURE__ */ _(oy, { icon: /* @__PURE__ */ _(hy, {}) }),
		/* @__PURE__ */ _(oy, { icon: /* @__PURE__ */ _(gy, {}) }),
		/* @__PURE__ */ _(oy, { icon: /* @__PURE__ */ _(_y, {}) }),
		/* @__PURE__ */ _(vy, {})
	]
}), oy = ({ icon: e }) => /* @__PURE__ */ v("span", {
	className: "sp-flex sp-items-center sp-gap-1",
	children: [e, /* @__PURE__ */ _("span", { children: "1" })]
}), sy = (e) => {
	if (e.type === "text" || e.type === "audio") return [];
	let t = e.medias.collection;
	return t.length > 0 ? t : [{
		isVideo: e.type === "video",
		thumbnailUrl: e.imageUrl,
		url: e.imageUrl
	}];
}, cy = (e, t) => e.type === "audio" ? "threads-audio" : e.type === "text" && e.redirectUrl ? "threads-link" : e.type === "text" ? "threads-text" : t.length > 1 ? t.some(ly) ? "threads-carousel-video" : "threads-carousel-image" : t[0] && ly(t[0]) ? "threads-single-video" : "threads-single-image", ly = (e) => Z(e), uy = (e, t) => Array.from({ length: Math.min(e.length, 4) }, (n, r) => {
	let i = (t + r) % e.length;
	return {
		media: e[i],
		originalIndex: i
	};
}), dy = (e) => {
	try {
		return new URL(e).hostname;
	} catch {
		return e;
	}
}, fy = [
	"sp-h-[8px]",
	"sp-h-[11px]",
	"sp-h-[14px]",
	"sp-h-[17px]",
	"sp-h-[20px]",
	"sp-h-[14px]",
	"sp-h-[11px]",
	"sp-h-[17px]",
	"sp-h-[20px]",
	"sp-h-[8px]",
	"sp-h-[11px]",
	"sp-h-[14px]",
	"sp-h-[17px]",
	"sp-h-[20px]",
	"sp-h-[14px]",
	"sp-h-[11px]",
	"sp-h-[17px]",
	"sp-h-[20px]",
	"sp-h-[8px]",
	"sp-h-[11px]",
	"sp-h-[14px]",
	"sp-h-[17px]",
	"sp-h-[20px]",
	"sp-h-[14px]"
], py = ({ children: e, className: t = "sp-text-current", size: n = 20 }) => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	className: t,
	fill: "none",
	height: n,
	viewBox: "0 0 24 24",
	width: n,
	children: e
}), my = () => /* @__PURE__ */ _(py, {
	size: 24,
	children: /* @__PURE__ */ _("path", {
		d: "M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM19 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
		fill: "currentColor"
	})
}), hy = () => /* @__PURE__ */ _(py, { children: /* @__PURE__ */ _("path", {
	d: "M20.8 4.6a5.4 5.4 0 0 0-7.6 0L12 5.8l-1.2-1.2a5.4 5.4 0 1 0-7.6 7.6L12 21l8.8-8.8a5.4 5.4 0 0 0 0-7.6Z",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), gy = () => /* @__PURE__ */ _(py, { children: /* @__PURE__ */ _("path", {
	d: "M21 11.5a8.5 8.5 0 0 1-8.5 8.5 8.4 8.4 0 0 1-3.8-.9L3 21l1.9-5.7A8.4 8.4 0 0 1 4 11.5a8.5 8.5 0 1 1 17 0Z",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), _y = () => /* @__PURE__ */ _(py, { children: /* @__PURE__ */ _("path", {
	d: "m17 1 4 4-4 4M3 11V9a4 4 0 0 1 4-4h14M7 23l-4-4 4-4M21 13v2a4 4 0 0 1-4 4H3",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), vy = () => /* @__PURE__ */ _(py, { children: /* @__PURE__ */ _("path", {
	d: "m22 2-7 20-4-9-9-4 20-7Z",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), yy = () => /* @__PURE__ */ _(py, {
	size: 24,
	children: /* @__PURE__ */ _("path", {
		d: "M8 5v14l11-7L8 5Z",
		fill: "currentColor"
	})
}), by = ({ ariaLabel: e, direction: t, onClick: n }) => /* @__PURE__ */ _("button", {
	"aria-label": e,
	className: ["sp-absolute sp-top-1/2 sp-z-10 sp-flex sp-h-8 sp-w-8 sp-cursor-pointer sp-items-center sp-justify-center sp-rounded-full sp-border sp-border-solid sp-border-[#d8d8d8] sp-bg-white sp-p-0 sp-text-[#526572] sp-shadow-[0_2px_6px_rgba(16,24,40,0.18)]", t === "previous" ? "sp-left-2" : "sp-right-2"].join(" "),
	onClick: n,
	style: { transform: "translateY(-50%)" },
	type: "button",
	children: /* @__PURE__ */ _(xy, { direction: t })
}), xy = ({ direction: e }) => /* @__PURE__ */ _(py, {
	size: 18,
	children: /* @__PURE__ */ _("path", {
		d: e === "previous" ? "m15 18-6-6 6-6" : "m9 6 6 6-6 6",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), Sy = (e) => /* @__PURE__ */ _("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: /* @__PURE__ */ _("g", {
		id: "annotation-heart",
		children: /* @__PURE__ */ v("g", {
			id: "Icon",
			children: [/* @__PURE__ */ _("path", {
				d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V13.5C21 14.8978 21 15.5967 20.7716 16.1481C20.4672 16.8831 19.8831 17.4672 19.1481 17.7716C18.5967 18 17.8978 18 16.5 18C16.0114 18 15.7671 18 15.5405 18.0535C15.2383 18.1248 14.9569 18.2656 14.7185 18.4645C14.5397 18.6137 14.3931 18.8091 14.1 19.2L12.64 21.1467C12.4229 21.4362 12.3143 21.5809 12.1812 21.6327C12.0647 21.678 11.9353 21.678 11.8188 21.6327C11.6857 21.5809 11.5771 21.4362 11.36 21.1467L9.9 19.2C9.60685 18.8091 9.46028 18.6137 9.2815 18.4645C9.04312 18.2656 8.76169 18.1248 8.45951 18.0535C8.23287 18 7.98858 18 7.5 18C6.10218 18 5.40326 18 4.85195 17.7716C4.11687 17.4672 3.53284 16.8831 3.22836 16.1481C3 15.5967 3 14.8978 3 13.5V7.8Z",
				stroke: "black",
				strokeWidth: 3,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}), /* @__PURE__ */ _("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M11.9973 8.33059C11.1975 7.4216 9.8639 7.17708 8.86188 8.00945C7.85986 8.84182 7.71879 10.2335 8.50568 11.2179C8.97361 11.8033 10.1197 12.8531 10.9719 13.6079C11.3237 13.9195 11.4996 14.0753 11.7114 14.1385C11.8925 14.1926 12.102 14.1926 12.2832 14.1385C12.4949 14.0753 12.6708 13.9195 13.0226 13.6079C13.8748 12.8531 15.0209 11.8033 15.4888 11.2179C16.2757 10.2335 16.1519 8.83306 15.1326 8.00945C14.1134 7.18584 12.797 7.4216 11.9973 8.33059Z",
				stroke: "black",
				strokeWidth: 3,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		})
	})
}), Cy = (e) => /* @__PURE__ */ v("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...e,
	children: [/* @__PURE__ */ _("g", {
		id: "Share - Pinterest 1",
		clipPath: "url(#clip0_0_27)",
		children: /* @__PURE__ */ _("path", {
			id: "Vector",
			d: "M17.4997 11.6667C18.4163 11.6667 19.1663 12.4167 19.1663 13.3333V18.3333C19.1663 19.25 18.4163 20 17.4997 20H2.49967C1.58301 20 0.833008 19.25 0.833008 18.3333V13.3333C0.833008 12.4167 1.58301 11.6667 2.49967 11.6667C3.41634 11.6667 4.16634 12.4167 4.16634 13.3333V16.6667H15.833V13.3333C15.833 12.4167 16.583 11.6667 17.4997 11.6667ZM7.34967 7.36667C6.69967 8.01667 5.64134 8.025 4.99134 7.36667C4.34134 6.71667 4.33301 5.66667 4.98301 5.01667L9.99134 0L15.008 5.00833C15.658 5.65833 15.6663 6.71667 15.0163 7.36667C14.3663 8.01667 13.308 8.025 12.658 7.36667L11.658 6.375V11.525C11.658 11.967 11.4824 12.391 11.1699 12.7035C10.8573 13.0161 10.4334 13.1917 9.99134 13.1917C9.54931 13.1917 9.12539 13.0161 8.81283 12.7035C8.50027 12.391 8.32467 11.967 8.32467 11.525V6.38333L7.34967 7.36667Z",
			fill: "black"
		})
	}), /* @__PURE__ */ _("defs", { children: /* @__PURE__ */ _("clipPath", {
		id: "clip0_0_27",
		children: /* @__PURE__ */ _("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
}), wy = /* @__PURE__ */ new Set([
	"image",
	"multiMedia",
	"video"
]), Ty = 42, Ey = 2, Dy = 2, Oy = 20, ky = 40, Ay = 30, jy = 48, My = 16, Ny = 52, Py = 16, Fy = 5, Iy = (e) => e.platform === "PI" && wy.has(e.type), Ly = ({ post: e, className: t, trackEvent: n, videoCoverPreview: r }) => {
	let [i, a] = h(!1), o = m(null), s = Ky(e, i), c = ib(e), l = rb(e), { medias: u, reportIntrinsicDimensions: d } = Cm(c.length > 0 ? c : [l]), p = c.length > 0 ? u : c, g = u[0] || l, v = [
		e.piTitle ?? "",
		e.caption,
		p.length,
		i ? "expanded" : "collapsed"
	].join("|"), [y, b] = h(null), x = y?.key === v ? y.height : s;
	if (f(() => {
		if (!i) {
			b(null);
			return;
		}
		let e = o.current;
		if (!e) return;
		let t = () => {
			let t = Math.ceil(Math.max(e.scrollHeight, e.offsetHeight));
			t > 0 && Math.abs(t - s) > 1 && b((e) => e?.key === v && e.height === t ? e : {
				height: t,
				key: v
			});
		};
		t();
		let n = typeof requestAnimationFrame == "function" ? requestAnimationFrame(t) : void 0, r = typeof ResizeObserver == "function" ? new ResizeObserver(t) : void 0;
		return r?.observe(e), () => {
			n !== void 0 && cancelAnimationFrame(n), r?.disconnect();
		};
	}, [
		v,
		i,
		s
	]), e.type === "text") return null;
	let S = !!(g && ob(g)), C = tb(g), w = !S && C.name !== "pinterest-image-portrait" ? $y(C, x) : void 0, T = w === void 0 ? void 0 : { "--pinterest-shell-height": `${w}px` };
	return /* @__PURE__ */ _("div", {
		className: [
			"sp-box-border sp-mx-auto sp-overflow-hidden sp-bg-white sp-font-sans sp-text-black sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)] sp-antialiased",
			S ? "sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-rounded-[32px]" : eb(C, x, w),
			t
		].filter(Boolean).join(" "),
		"data-preview-platform": "PI",
		"data-preview-variant": "uplift",
		style: T,
		children: S ? /* @__PURE__ */ _(Ry, {
			bodyHeight: x,
			bodyRef: o,
			captionExpanded: i,
			media: g,
			onCaptionExpandedChange: a,
			onIntrinsicDimensions: d,
			post: e,
			trackEvent: n,
			videoCoverPreview: r
		}) : /* @__PURE__ */ _(zy, {
			layout: C,
			bodyHeight: x,
			bodyRef: o,
			captionExpanded: i,
			carouselMedias: p,
			media: g,
			onCaptionExpandedChange: a,
			onIntrinsicDimensions: d,
			post: e,
			trackEvent: n
		})
	});
}, Ry = ({ bodyHeight: e, bodyRef: t, captionExpanded: n, media: r, onCaptionExpandedChange: i, onIntrinsicDimensions: a, post: o, trackEvent: s, videoCoverPreview: c }) => /* @__PURE__ */ v("article", {
	className: "sp-flex sp-h-full sp-flex-col",
	"data-uplift-layout": "pinterest-video",
	"data-uplift-renderer": "pinterest",
	children: [/* @__PURE__ */ _(Vy, {
		media: r,
		onIntrinsicDimensions: a,
		videoCoverPreview: c
	}), /* @__PURE__ */ v("div", {
		className: "sp-box-border sp-flex sp-flex-1 sp-flex-col sp-gap-3 sp-p-4",
		"data-pinterest-video-content": "true",
		children: [
			/* @__PURE__ */ _(Hy, { post: o }),
			/* @__PURE__ */ _(Uy, {
				bodyHeight: e,
				bodyRef: t,
				captionExpanded: n,
				onCaptionExpandedChange: i,
				post: o,
				trackEvent: s
			}),
			/* @__PURE__ */ _(Wy, {
				showVisit: !1,
				width: "narrow"
			})
		]
	})]
}), zy = ({ layout: e, bodyHeight: t, bodyRef: n, captionExpanded: r, carouselMedias: i, media: a, onCaptionExpandedChange: o, onIntrinsicDimensions: s, post: c, trackEvent: l }) => e.name === "pinterest-image-portrait" ? /* @__PURE__ */ v("article", {
	className: "sp-box-border sp-flex sp-w-full sp-flex-col",
	"data-uplift-layout": e.name,
	"data-uplift-renderer": "pinterest",
	children: [
		/* @__PURE__ */ _(By, {
			carouselMedias: i,
			layout: e,
			media: a,
			onIntrinsicDimensions: s
		}),
		/* @__PURE__ */ v("div", {
			className: "sp-box-border sp-w-full sp-px-4 sp-pt-4",
			children: [/* @__PURE__ */ _(Hy, { post: c }), t > 0 ? /* @__PURE__ */ _(Uy, {
				bodyHeight: t,
				bodyRef: n,
				captionExpanded: r,
				onCaptionExpandedChange: o,
				post: c,
				trackEvent: l
			}) : null]
		}),
		/* @__PURE__ */ _(Wy, {
			className: "sp-mx-4 sp-mb-4 sp-mt-4",
			showVisit: !!c.redirectUrl,
			width: "narrow"
		})
	]
}) : /* @__PURE__ */ v("article", {
	className: "sp-relative sp-h-full sp-w-full",
	"data-uplift-layout": e.name,
	"data-uplift-renderer": "pinterest",
	children: [
		/* @__PURE__ */ _(By, {
			carouselMedias: i,
			layout: e,
			media: a,
			onIntrinsicDimensions: s
		}),
		/* @__PURE__ */ v("div", {
			className: "sp-absolute sp-left-4 sp-w-[368px]",
			style: {
				height: Qy(t),
				top: e.contentTop
			},
			children: [/* @__PURE__ */ _(Hy, { post: c }), t > 0 ? /* @__PURE__ */ _(Uy, {
				bodyHeight: t,
				bodyRef: n,
				captionExpanded: r,
				onCaptionExpandedChange: o,
				post: c,
				trackEvent: l
			}) : null]
		}),
		/* @__PURE__ */ _(Wy, {
			showVisit: !!c.redirectUrl,
			top: e.contentTop + Qy(t) + My
		})
	]
}), By = ({ carouselMedias: e, layout: t, media: n, onIntrinsicDimensions: r }) => /* @__PURE__ */ _(Bp, {
	className: [
		"sp-overflow-hidden sp-bg-[#f2f2f2]",
		t.name !== "pinterest-image-portrait" && "sp-absolute",
		t.mediaClassName
	].filter(Boolean).join(" "),
	"data-uplift-media-frame-ratio": `${t.mediaWidth} / ${t.mediaHeight}`,
	style: {
		height: t.mediaHeight,
		left: t.name === "pinterest-image-portrait" ? void 0 : t.mediaLeft,
		top: t.name === "pinterest-image-portrait" ? void 0 : t.mediaTop,
		width: t.mediaWidth
	},
	children: e.length > 1 ? /* @__PURE__ */ _(Ih, {
		ariaLabel: "Pinterest media carousel",
		medias: e,
		renderSlide: (n, { index: i, isActive: a }) => /* @__PURE__ */ _(Q, {
			imageClassName: t.imageClassName,
			isActive: a,
			media: n,
			mediaCount: e.length,
			mediaIndex: i,
			onIntrinsicDimensions: r,
			platform: "PI",
			surface: "pin"
		})
	}) : /* @__PURE__ */ _(Q, {
		imageClassName: t.imageClassName,
		media: n,
		onIntrinsicDimensions: r,
		platform: "PI",
		surface: "pin"
	})
}), Vy = ({ media: e, onIntrinsicDimensions: t, videoCoverPreview: n }) => {
	let r = dm({
		media: e,
		platform: "PI",
		surface: "pin"
	});
	return ob(e) ? /* @__PURE__ */ _("div", {
		className: "sp-relative sp-w-full sp-overflow-hidden sp-rounded-t-[32px] sp-bg-[#f2f2f2]",
		"data-uplift-media-frame-ratio": r.publishedRatio,
		style: { aspectRatio: r.publishedRatio },
		children: /* @__PURE__ */ _(Q, {
			className: "sp-h-full sp-w-full",
			coverScope: "singlePostOnly",
			customVideoControls: !0,
			media: e,
			onIntrinsicDimensions: t,
			platform: "PI",
			surface: "pin",
			videoCoverPreview: n
		})
	}) : null;
}, Hy = ({ post: e }) => {
	let t = ab(e.followerCount);
	return /* @__PURE__ */ v("header", {
		className: "sp-flex sp-h-12 sp-items-center sp-gap-2",
		children: [/* @__PURE__ */ _(X, {
			alt: e.username,
			className: "sp-h-12 sp-w-12",
			src: e.profilePicture
		}), /* @__PURE__ */ v("div", {
			className: "sp-min-w-0",
			children: [/* @__PURE__ */ _("div", {
				className: "sp-truncate sp-text-base sp-font-semibold sp-leading-5",
				children: e.username
			}), t ? /* @__PURE__ */ _("div", {
				className: "sp-text-xs sp-leading-4 sp-text-[#1a1a1a]",
				children: t
			}) : null]
		})]
	});
}, Uy = ({ bodyHeight: e, bodyRef: t, captionExpanded: n, onCaptionExpandedChange: r, post: i, trackEvent: a }) => {
	let o = $(i.piTitle), s = $(i.caption);
	return !o && !s ? null : /* @__PURE__ */ v("div", {
		ref: t,
		className: "sp-mt-3 sp-flex sp-flex-col sp-break-words",
		"data-pinterest-body": "true",
		style: {
			height: n ? void 0 : e,
			minHeight: n ? void 0 : e
		},
		children: [o ? /* @__PURE__ */ _("div", {
			className: "sp-line-clamp-1 sp-h-[30px] sp-text-xl sp-font-semibold sp-leading-[30px]",
			children: i.piTitle
		}) : null, s ? /* @__PURE__ */ _(Ep, {
			buttonClassName: "sp-bg-white sp-pl-1 sp-text-base sp-font-semibold sp-leading-5 sp-text-black sp-cursor-pointer",
			alignTriggerWithTextEnd: !0,
			caption: i.caption,
			charsPerLine: Ty,
			className: "sp-text-base sp-leading-5",
			collapsedLines: Dy,
			contentClassName: "sp-whitespace-pre-line sp-text-base sp-leading-5",
			expanded: n,
			expandOnContentClick: !0,
			hideTriggerWhenExpanded: !0,
			onExpandedChange: r,
			targetPlatform: "PI",
			trackEvent: a,
			triggerLabel: "more",
			wideCharacterWeight: Ey
		}) : null]
	});
}, Wy = ({ className: e, showVisit: t, top: n, width: r = "narrow" }) => /* @__PURE__ */ v("footer", {
	className: [
		"sp-grid sp-h-[52px] sp-grid-cols-[24px_1fr_24px] sp-items-center",
		r === "wide" ? "sp-w-[400px]" : "sp-w-[368px]",
		n !== void 0 && "sp-absolute sp-left-4",
		e
	].filter(Boolean).join(" "),
	"data-pinterest-actions-width": r,
	style: n === void 0 ? void 0 : { top: n },
	children: [
		/* @__PURE__ */ _("span", {
			className: "sp-flex sp-h-6 sp-w-6 sp-items-center sp-justify-center sp-justify-self-start",
			children: /* @__PURE__ */ _(Sy, { "aria-hidden": "true" })
		}),
		/* @__PURE__ */ v("div", {
			className: "sp-flex sp-h-[52px] sp-items-center sp-justify-center sp-gap-2 sp-justify-self-center",
			children: [t && /* @__PURE__ */ _("span", {
				className: "sp-flex sp-h-[52px] sp-w-20 sp-items-center sp-justify-center sp-rounded-full sp-bg-[#efefef] sp-text-lg sp-font-semibold sp-leading-7 sp-text-[#333]",
				children: "Visit"
			}), /* @__PURE__ */ _("span", {
				className: "sp-flex sp-h-[52px] sp-w-[94px] sp-items-center sp-justify-center sp-rounded-full sp-bg-[#e60022] sp-text-lg sp-font-semibold sp-leading-7 sp-text-white",
				children: "Save"
			})]
		}),
		/* @__PURE__ */ _("span", {
			className: "sp-flex sp-h-5 sp-w-5 sp-items-center sp-justify-center sp-justify-self-end",
			children: /* @__PURE__ */ _(Cy, { "aria-hidden": "true" })
		})
	]
}), Gy = 16, Ky = (e, t = !1) => {
	let n = $(e.piTitle), r = $(e.caption);
	return (n ? Ay : 0) + (r ? Math.max(ky, qy(e.caption, t)) : 0);
}, qy = (e, t) => {
	let n = Jy(e);
	return Math.min(t ? n : Dy, n) * Oy;
}, Jy = (e) => {
	let t = e.trim();
	return t ? t.split(/\r?\n/).reduce((e, t) => e + Yy(t, Ty), 0) : 0;
}, Yy = (e, t) => {
	let n = e.trim().split(/\s+/).filter(Boolean);
	if (n.length === 0) return 1;
	let r = 1, i = 0;
	return n.forEach((e) => {
		let n = Zy(e);
		if (i === 0) {
			i = n, r += Math.max(0, Math.ceil(n / t) - 1), i = n % t || t;
			return;
		}
		let a = i + 1 + n;
		if (a <= t) {
			i = a;
			return;
		}
		r += 1, i = n, n > t && (r += Math.ceil(n / t) - 1, i = n % t || t);
	}), r;
}, Xy = (e) => (e.codePointAt(0) ?? 0) > 255, Zy = (e) => Array.from(e).reduce((e, t) => e + (Xy(t) ? Ey : 1), 0), Qy = (e) => e > 0 ? 60 + e : jy, $y = (e, t) => e.contentTop + Qy(t) + My + Ny + Py, eb = (e, t, n) => e.name === "pinterest-image-portrait" || n === void 0 ? "sp-w-[400px] sp-rounded-[32px]" : "sp-h-[var(--pinterest-shell-height)] sp-w-[400px] sp-rounded-[32px]", tb = (e) => {
	let t = nb(e) ?? 400 / 264, n = fm({
		media: e,
		platform: "PI",
		surface: "pin",
		width: 400
	}), r = n.height;
	return {
		contentTop: r + Gy,
		imageClassName: "sp-object-center",
		mediaClassName: "sp-rounded-t-[32px]",
		mediaHeight: r,
		mediaLeft: 0,
		mediaTop: 0,
		mediaWidth: n.width,
		name: t < 1 ? "pinterest-image-portrait" : "pinterest-image-horizontal"
	};
}, nb = (e) => {
	if (!(!e?.width || !e.height || e.width <= 0 || e.height <= 0)) return e.width / e.height;
}, rb = (e) => e.medias.collection[0] || {
	isVideo: e.type === "video",
	thumbnailUrl: e.imageUrl,
	url: e.imageUrl
}, ib = (e) => {
	if (e.type !== "image" && e.type !== "multiMedia" || e.medias.collection.length < 2 || e.medias.collection.length > Fy) return [];
	let t = e.medias.collection.filter((e) => !ob(e));
	return t.length === e.medias.collection.length ? t : [];
}, ab = (e) => typeof e != "number" || !Number.isFinite(e) ? null : `${new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 }).format(Math.max(0, e))} ${e === 1 ? "follower" : "followers"}`, ob = (e) => Z(e), sb = /* @__PURE__ */ new Set([
	"image",
	"multiMedia",
	"video"
]), cb = 36, lb = 2, ub = (e) => {
	if (e.platform !== "TT" || !sb.has(e.type)) return !1;
	let t = Sb(e);
	return e.type === "video" || t.every((e) => !Cb(e));
}, db = ({ post: e, className: t, trackEvent: n, videoCoverPreview: r }) => {
	let i = Sb(e), a = e.type === "video" || Cb(i[0]), o = a ? "tiktok-video" : "tiktok-carousel-photo", s = i[0], [c, l] = h(!1), u = $(e.caption) && Op({
		charsPerLine: cb,
		text: e.caption
	}) > lb, f = c && u;
	return d(() => {
		u || l(!1);
	}, [u]), /* @__PURE__ */ v("div", {
		className: ["sp-relative sp-mx-auto sp-h-[856px] sp-w-[400px] sp-overflow-hidden sp-rounded-none sp-bg-black sp-font-sans sp-text-white sp-shadow-none sp-antialiased", t].filter(Boolean).join(" "),
		"data-preview-platform": "TT",
		"data-preview-variant": "uplift",
		"data-uplift-layout": o,
		"data-uplift-renderer": "tiktok",
		children: [
			a ? /* @__PURE__ */ _(fb, {
				isVideoPost: a,
				media: s,
				videoCoverPreview: r
			}) : /* @__PURE__ */ _(pb, { medias: i }),
			a ? /* @__PURE__ */ _(mb, {}) : null,
			f && /* @__PURE__ */ _("div", {
				className: "sp-pointer-events-none sp-absolute sp-inset-x-0 sp-bottom-[70px] sp-top-0 sp-bg-black/40",
				"data-uplift-caption-backdrop": "true"
			}),
			/* @__PURE__ */ _(hb, {}),
			/* @__PURE__ */ _(_b, { post: e }),
			/* @__PURE__ */ _(vb, {
				captionExpanded: f,
				isCaptionExpandable: u,
				onCaptionExpandedChange: l,
				post: e,
				trackEvent: n
			}),
			/* @__PURE__ */ _(yb, {})
		]
	});
}, fb = ({ media: e, isVideoPost: t, videoCoverPreview: n }) => {
	let r = e?.url || e?.thumbnailUrl || "";
	return t ? /* @__PURE__ */ _("div", {
		className: "sp-absolute sp-left-0 sp-top-0 sp-h-[856px] sp-w-full sp-bg-black",
		"data-uplift-media-frame-ratio": "9 / 16",
		children: /* @__PURE__ */ _(Q, {
			backgroundColor: "#000",
			className: "sp-h-full sp-w-full",
			controls: !1,
			coverScope: "singlePostOnly",
			customVideoControls: !0,
			media: e,
			platform: "TT",
			surface: "video",
			videoCoverPreview: n
		})
	}) : /* @__PURE__ */ _("div", {
		className: "sp-absolute sp-left-0 sp-top-[132px] sp-h-[545px] sp-w-full sp-overflow-hidden sp-bg-[#111]",
		children: r && /* @__PURE__ */ _(Q, {
			media: e,
			platform: "TT",
			surface: "carousel"
		})
	});
}, pb = ({ medias: e }) => /* @__PURE__ */ _("div", {
	className: "sp-absolute sp-left-0 sp-top-[132px] sp-h-[545px] sp-w-full sp-overflow-hidden sp-bg-[#111]",
	children: /* @__PURE__ */ _(Ih, {
		ariaLabel: "TikTok photo carousel",
		arrowClassName: "sp-z-20",
		dotClassName: "sp-bottom-3 sp-left-1/2 -sp-translate-x-1/2",
		medias: e,
		renderSlide: (t, { index: n, isActive: r }) => /* @__PURE__ */ _(Q, {
			isActive: r,
			media: t,
			mediaCount: e.length,
			mediaIndex: n,
			platform: "TT",
			surface: "carousel"
		}),
		showCount: !1
	})
}), mb = () => /* @__PURE__ */ _("div", { className: "sp-absolute sp-left-0 sp-top-[532px] sp-h-[254px] sp-w-full sp-bg-gradient-to-t sp-from-black/60 sp-to-transparent sp-opacity-50" }), hb = () => /* @__PURE__ */ v("header", {
	className: "sp-absolute sp-left-4 sp-right-4 sp-top-[50px] sp-flex sp-items-start sp-justify-between",
	children: [
		/* @__PURE__ */ _(gb, {}),
		/* @__PURE__ */ v("div", {
			className: "sp-absolute sp-left-[107px] sp-top-[5px] sp-flex sp-items-start sp-gap-[19px] sp-text-base sp-font-semibold sp-leading-[1.21] sp-tracking-[0.24px] sp-drop-shadow-[0_5px_12px_rgba(0,0,0,0.15)]",
			children: [/* @__PURE__ */ _("span", {
				className: "sp-opacity-60",
				children: "Following"
			}), /* @__PURE__ */ v("span", {
				className: "sp-relative",
				children: ["For you", /* @__PURE__ */ _("span", { className: "sp-absolute sp-left-1/2 sp-top-[27px] sp-h-[2px] sp-w-[26px] -sp-translate-x-1/2 sp-bg-white" })]
			})]
		}),
		/* @__PURE__ */ _(Tb, { className: "sp-absolute sp-left-[346px] sp-top-[5px] sp-text-white" })
	]
}), gb = () => /* @__PURE__ */ v(wb, {
	className: "sp-text-white",
	size: 30,
	viewBox: "0 0 30 28",
	children: [/* @__PURE__ */ _("path", {
		d: "M6.5 5.5h17c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2h-17c-1.1 0-2-.9-2-2v-14c0-1.1.9-2 2-2ZM10.5 5.5 7.5 2M18.5 5.5 22 2M8 26h14",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	}), /* @__PURE__ */ _("text", {
		fill: "currentColor",
		fontFamily: "Inter, sans-serif",
		fontSize: "8.8",
		fontWeight: "700",
		textAnchor: "middle",
		x: "15",
		y: "17.2",
		children: "LIVE"
	})]
}), _b = ({ post: e }) => /* @__PURE__ */ v("aside", {
	className: "sp-absolute sp-left-[332px] sp-top-[412px] sp-flex sp-w-[45px] sp-flex-col sp-items-center sp-gap-9",
	children: [
		/* @__PURE__ */ v("div", {
			className: "sp-relative sp-h-[58.273px] sp-w-[45px]",
			children: [/* @__PURE__ */ _(X, {
				alt: e.username,
				className: "sp-box-border sp-h-[45px] sp-w-[45px] sp-border-2 sp-border-white",
				src: e.profilePicture
			}), /* @__PURE__ */ _("span", {
				className: "sp-absolute sp-bottom-[-10px] sp-left-1/2 sp-flex sp-h-[20px] sp-w-[20px] -sp-translate-x-1/2 sp-items-center sp-justify-center sp-rounded-full sp-bg-[#fe2c55] sp-text-lg sp-font-semibold sp-leading-none",
				children: "+"
			})]
		}),
		/* @__PURE__ */ _("div", {
			className: "sp-flex sp-h-[31px] sp-w-[34.207px] sp-items-center sp-justify-center",
			children: /* @__PURE__ */ _(Eb, {})
		}),
		/* @__PURE__ */ _("div", {
			className: "sp-flex sp-h-[33.246px] sp-w-[34.354px] sp-items-center sp-justify-center",
			children: /* @__PURE__ */ _(Db, {})
		}),
		/* @__PURE__ */ _("div", {
			className: "sp-flex sp-h-[27.491px] sp-w-[35.51px] sp-items-center sp-justify-center",
			children: /* @__PURE__ */ _(Ob, {})
		})
	]
}), vb = ({ captionExpanded: e, isCaptionExpandable: t, onCaptionExpandedChange: n, post: r, trackEvent: i }) => {
	let a = $(r.caption);
	return /* @__PURE__ */ v("div", {
		className: ["sp-absolute sp-left-4 sp-w-[315px] sp-text-sm sp-leading-[1.1]", a ? "sp-bottom-[84px] sp-min-h-[64px]" : "sp-top-[708px]"].join(" "),
		"data-uplift-tiktok-caption": "true",
		children: [/* @__PURE__ */ _("div", {
			className: "sp-font-bold sp-leading-normal",
			children: r.username
		}), a ? /* @__PURE__ */ v("div", {
			className: ["sp-relative sp-mt-1", e ? "sp-max-h-[200px] sp-overflow-y-auto" : ""].filter(Boolean).join(" "),
			children: [/* @__PURE__ */ _("div", {
				"aria-expanded": t ? e : void 0,
				className: ["sp-break-words", !e && t ? "sp-w-[261px] sp-line-clamp-2" : "sp-pr-2"].join(" "),
				children: /* @__PURE__ */ _(Y, {
					caption: r.caption,
					targetPlatform: "TT",
					trackEvent: i
				})
			}), t ? /* @__PURE__ */ _("button", {
				"aria-expanded": e,
				className: ["sp-border-0 sp-bg-transparent sp-p-0 sp-text-left sp-font-medium sp-leading-[1.33] sp-text-white sp-opacity-80", e ? "sp-mt-1" : "sp-absolute sp-bottom-0 sp-left-[267px]"].join(" "),
				onClick: () => n(!e),
				type: "button",
				children: e ? "less" : "more"
			}) : null]
		}) : null]
	});
}, yb = () => /* @__PURE__ */ v("nav", {
	className: "sp-absolute sp-left-0 sp-top-[786px] sp-h-[70px] sp-w-full sp-bg-[#070707]",
	children: [
		/* @__PURE__ */ _(bb, {
			className: "sp-left-[26px] sp-top-1.5 sp-w-[26px]",
			icon: /* @__PURE__ */ _(kb, {}),
			label: "Home"
		}),
		/* @__PURE__ */ _(bb, {
			className: "sp-left-[104px] sp-top-2 sp-w-[33px]",
			icon: /* @__PURE__ */ _(Ab, {}),
			label: "Friends"
		}),
		/* @__PURE__ */ _(xb, {}),
		/* @__PURE__ */ _(bb, {
			className: "sp-left-[268px] sp-top-2 sp-w-6",
			icon: /* @__PURE__ */ _(jb, {}),
			label: "Inbox"
		}),
		/* @__PURE__ */ _(bb, {
			className: "sp-left-[346px] sp-top-2 sp-w-7",
			icon: /* @__PURE__ */ _(Mb, {}),
			label: "Profile"
		})
	]
}), bb = ({ className: e, icon: t, label: n }) => /* @__PURE__ */ v("div", {
	className: ["sp-absolute sp-flex sp-flex-col sp-items-center sp-gap-0.5 sp-text-[9px] sp-font-medium sp-leading-[1.33]", e].join(" "),
	children: [t, /* @__PURE__ */ _("span", { children: n })]
}), xb = () => /* @__PURE__ */ v("div", {
	className: "sp-absolute sp-left-[178.49px] sp-top-2 sp-h-[29.318px] sp-w-[44.821px]",
	children: [
		/* @__PURE__ */ _("span", { className: "sp-absolute sp-left-[7.91px] sp-top-0 sp-h-[29.002px] sp-w-[36.912px] sp-rounded-[6.435px] sp-bg-[#fe2c55]" }),
		/* @__PURE__ */ _("span", { className: "sp-absolute sp-left-0 sp-top-0 sp-h-[29.002px] sp-w-[36.912px] sp-rounded-[6.435px] sp-bg-[#20d5ec]" }),
		/* @__PURE__ */ _("span", {
			className: "sp-absolute sp-left-[3.955px] sp-top-0 sp-flex sp-h-[29.002px] sp-w-[36.912px] sp-items-center sp-justify-center sp-rounded-[6.435px] sp-bg-white sp-text-[23px] sp-leading-none sp-text-[#333]",
			children: "+"
		})
	]
}), Sb = (e) => (e.medias.collection.length ? e.medias.collection : [{
	isVideo: e.type === "video",
	thumbnailUrl: e.imageUrl,
	url: e.imageUrl
}]).filter(Boolean), Cb = (e) => Z(e), wb = ({ children: e, className: t = "sp-text-current", fill: n = "none", size: r = 24, viewBox: i = "0 0 24 24" }) => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	className: t,
	fill: n,
	height: r,
	viewBox: i,
	width: r,
	children: e
}), Tb = ({ className: e }) => /* @__PURE__ */ _(wb, {
	className: e ?? "sp-text-white",
	size: 22,
	children: /* @__PURE__ */ _("path", {
		d: "m20 20-4.3-4.3m2.3-5.2a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: "2.2"
	})
}), Eb = () => /* @__PURE__ */ _(wb, {
	className: "sp-text-white",
	fill: "currentColor",
	size: 45,
	children: /* @__PURE__ */ _("path", { d: "M12 21.4 10.6 20C5.6 15.5 2.3 12.5 2.3 8.8 2.3 5.8 4.7 3.5 7.6 3.5c1.7 0 3.3.8 4.4 2 1-1.2 2.7-2 4.4-2 3 0 5.3 2.3 5.3 5.3 0 3.7-3.3 6.7-8.3 11.2L12 21.4Z" })
}), Db = () => /* @__PURE__ */ v(wb, {
	className: "sp-text-white",
	fill: "currentColor",
	size: 45,
	children: [
		/* @__PURE__ */ _("path", { d: "M4 11.5C4 7.4 7.6 4 12 4s8 3.4 8 7.5S16.4 19 12 19c-.8 0-1.7-.1-2.4-.4L5.7 21l1-3.9A7.2 7.2 0 0 1 4 11.5Z" }),
		/* @__PURE__ */ _("circle", {
			cx: "8.8",
			cy: "11.5",
			fill: "black",
			r: "1"
		}),
		/* @__PURE__ */ _("circle", {
			cx: "12",
			cy: "11.5",
			fill: "black",
			r: "1"
		}),
		/* @__PURE__ */ _("circle", {
			cx: "15.2",
			cy: "11.5",
			fill: "black",
			r: "1"
		})
	]
}), Ob = () => /* @__PURE__ */ _(wb, {
	className: "sp-text-white",
	fill: "currentColor",
	size: 45,
	children: /* @__PURE__ */ _("path", { d: "M20 3v7.2C12.6 10.7 8.2 14.1 6.4 21 5.8 14 9.2 8.1 20 7.3V3Z" })
}), kb = () => /* @__PURE__ */ _(wb, {
	className: "sp-text-white",
	fill: "currentColor",
	size: 22,
	children: /* @__PURE__ */ _("path", { d: "M3 10.5 11 3l8 7.5V20h-5v-6H8v6H3v-9.5Z" })
}), Ab = () => /* @__PURE__ */ _(wb, {
	className: "sp-text-white",
	size: 22,
	children: /* @__PURE__ */ _("path", {
		d: "M8.5 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm7 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5ZM3 19c.5-3.4 2.4-5.2 5.5-5.2S13.5 15.6 14 19H3Zm10.5-3.8c.7-.7 1.6-1 2.8-1 2.3 0 3.7 1.3 4.1 3.8h-4.5",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	})
}), jb = () => /* @__PURE__ */ v(wb, {
	className: "sp-text-white",
	size: 22,
	children: [/* @__PURE__ */ _("path", {
		d: "M4 5h16v12H8l-4 3V5Z",
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: "1.8"
	}), /* @__PURE__ */ _("path", {
		d: "M8 9h8M8 13h5",
		stroke: "currentColor",
		strokeWidth: "1.8"
	})]
}), Mb = () => /* @__PURE__ */ v(wb, {
	className: "sp-text-white",
	size: 22,
	children: [/* @__PURE__ */ _("circle", {
		cx: "12",
		cy: "7",
		r: "3.2",
		stroke: "currentColor",
		strokeWidth: "1.8"
	}), /* @__PURE__ */ _("path", {
		d: "M5 20c.8-4.1 3.1-6.1 7-6.1s6.2 2 7 6.1",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeWidth: "1.8"
	})]
}), Nb = /* @__PURE__ */ new Set([
	"gmb",
	"image",
	"multiMedia",
	"text",
	"video"
]), Pb = 58, Fb = 20, Ib = 2, Lb = 5, Rb = 8, zb = 4, Bb = 435, Vb = 559, Hb = 44, Ub = 17, Wb = 360, Gb = 484, Kb = 24, qb = 16, Jb = 40, Yb = (e) => e.platform === "GMB" && Nb.has(e.type) && !!dx(e), Xb = ({ post: e, className: t, videoCoverPreview: n }) => {
	let r = dx(e), i = fx(e), a = px(e.callToAction), o = mx(e.event), [s, c] = h(!1), l = !!(o && hx(o)) && (e.topicType === "EVENT" || e.topicType === "OFFER" || r === "gmb-single-image-buy" || r === "gmb-single-image-sign-up"), u = $(e.caption);
	return r ? /* @__PURE__ */ v("article", {
		className: Ox("sp-relative sp-mx-auto sp-w-[400px] sp-overflow-hidden sp-rounded-lg sp-bg-white sp-font-sans sp-text-black sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)] sp-antialiased", yx(r, u), t),
		"data-preview-platform": "GMB",
		"data-preview-variant": "uplift",
		"data-uplift-layout": r,
		"data-uplift-renderer": "google-my-business",
		style: bx({
			action: a,
			caption: e.caption,
			expanded: s,
			hasCaption: u,
			layout: r
		}),
		children: [
			/* @__PURE__ */ _(Zb, { post: e }),
			r === "gmb-text" ? /* @__PURE__ */ _(Qb, {
				action: a,
				caption: e.caption,
				captionExpanded: s,
				collapsedLines: Lb,
				onCaptionExpandedChange: c
			}) : null,
			r === "gmb-link" ? /* @__PURE__ */ _(Qb, {
				action: a,
				caption: e.caption,
				captionExpanded: s,
				collapsedLines: Rb,
				onCaptionExpandedChange: c
			}) : null,
			r.startsWith("gmb-single-image") ? /* @__PURE__ */ _($b, {
				action: a,
				event: o,
				media: i[0],
				post: e,
				showEvent: l,
				hasCaption: u,
				captionExpanded: s,
				onCaptionExpandedChange: c
			}) : null,
			r === "gmb-carousel" || r === "gmb-carousel-book" ? /* @__PURE__ */ _(ex, {
				action: a,
				hasCaption: u,
				medias: i,
				post: e,
				captionExpanded: s,
				onCaptionExpandedChange: c
			}) : null,
			r === "gmb-video" || r === "gmb-video-learn-more" ? /* @__PURE__ */ _(tx, {
				action: a,
				hasCaption: u,
				media: i[0],
				post: e,
				captionExpanded: s,
				onCaptionExpandedChange: c,
				videoCoverPreview: n
			}) : null
		]
	}) : null;
}, Zb = ({ post: e }) => /* @__PURE__ */ v("header", {
	className: "sp-absolute sp-left-4 sp-top-4 sp-flex sp-w-[368px] sp-items-center sp-gap-2",
	children: [/* @__PURE__ */ v("div", {
		className: "sp-relative sp-h-12 sp-w-12 sp-shrink-0",
		children: [/* @__PURE__ */ _(X, {
			alt: e.username,
			className: "sp-h-12 sp-w-12",
			src: e.profilePicture
		}), /* @__PURE__ */ _(Px, {})]
	}), /* @__PURE__ */ v("div", {
		className: "sp-flex sp-min-w-0 sp-flex-1 sp-items-center sp-justify-between",
		children: [/* @__PURE__ */ v("div", {
			className: "sp-flex sp-min-w-0 sp-flex-col sp-justify-center sp-gap-1",
			children: [/* @__PURE__ */ _("div", {
				className: "sp-truncate sp-text-base sp-font-normal sp-leading-none sp-text-black",
				children: e.username
			}), /* @__PURE__ */ _("div", {
				className: "sp-text-sm sp-font-normal sp-leading-none sp-text-[#4d4d4d]",
				children: "Just now"
			})]
		}), /* @__PURE__ */ v("div", {
			className: "sp-flex sp-shrink-0 sp-items-start sp-gap-2 sp-text-black",
			children: [/* @__PURE__ */ _(Fx, {}), /* @__PURE__ */ _(Ix, {})]
		})]
	})]
}), Qb = ({ action: e, caption: t, captionExpanded: n, collapsedLines: r, onCaptionExpandedChange: i }) => /* @__PURE__ */ v("div", {
	className: "sp-ml-[15px] sp-mr-[17px] sp-pt-[75px] sp-pb-[17px]",
	children: [/* @__PURE__ */ _(rx, {
		caption: t,
		collapsedLines: r,
		expanded: n,
		onExpandedChange: i
	}), /* @__PURE__ */ _(ux, {
		action: e,
		className: "sp-static sp-mt-6"
	})]
}), $b = ({ action: e, event: t, media: n, post: r, hasCaption: i, captionExpanded: a, onCaptionExpandedChange: o, showEvent: s }) => /* @__PURE__ */ v("div", {
	className: "sp-pt-[79px]",
	children: [/* @__PURE__ */ _(cx, { media: n }), /* @__PURE__ */ v("div", {
		className: "sp-ml-[15px] sp-mr-[17px] sp-mt-4 sp-pb-[17px]",
		children: [
			s ? /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _(ox, { event: t }), /* @__PURE__ */ _(sx, { event: t })] }) : null,
			i ? /* @__PURE__ */ _(rx, {
				caption: r.caption,
				className: s ? "sp-mt-4" : void 0,
				collapsedLines: Lb,
				expanded: a,
				onExpandedChange: o
			}) : null,
			/* @__PURE__ */ _(ux, {
				action: e,
				className: "sp-static sp-mt-6"
			})
		]
	})]
}), ex = ({ action: e, captionExpanded: t, hasCaption: n, medias: r, onCaptionExpandedChange: i, post: a }) => {
	let [o, s] = h(0), c = Math.min(o, Math.max(0, r.length - 1)), l = Sx({
		caption: a.caption,
		collapsedLines: zb,
		defaultTop: Vb,
		expanded: t,
		gap: Hb,
		hasCaption: n,
		top: Bb
	});
	return /* @__PURE__ */ v(g, { children: [
		/* @__PURE__ */ _("div", {
			className: "sp-absolute sp-left-[-1px] sp-top-[79px] sp-h-[340px] sp-w-[400px] sp-overflow-hidden",
			children: /* @__PURE__ */ _(Ih, {
				ariaLabel: "Google Business media carousel",
				arrowClassName: "sp-z-20",
				medias: r,
				onIndexChange: s,
				renderSlide: (e, { index: t }) => /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _(lx, {
					className: "sp-left-0 sp-top-0 sp-h-[340px] sp-w-[340px]",
					media: e,
					surface: "carousel"
				}), r[t + 1] ? /* @__PURE__ */ _(lx, {
					className: "sp-left-[348px] sp-top-0 sp-h-[340px] sp-w-[340px]",
					media: r[t + 1],
					surface: "carousel"
				}) : null] }),
				showCount: !1,
				showDots: !1
			})
		}),
		/* @__PURE__ */ v("span", {
			className: "sp-absolute sp-left-[347px] sp-top-[95px] sp-rounded-[24px] sp-bg-black/40 sp-px-2 sp-py-0.5 sp-text-xs sp-font-medium sp-leading-5 sp-text-white",
			"data-uplift-carousel-counter": "true",
			children: [
				c + 1,
				"/",
				Math.max(1, r.length)
			]
		}),
		n ? /* @__PURE__ */ _(nx, {
			caption: a.caption,
			className: "sp-left-4 sp-top-[435px]",
			collapsedLines: zb,
			expanded: t,
			onExpandedChange: i
		}) : null,
		/* @__PURE__ */ _(ux, {
			action: e,
			className: n ? "sp-top-[559px]" : "sp-top-[435px]",
			style: n ? { top: l } : void 0
		})
	] });
}, tx = ({ action: e, captionExpanded: t, hasCaption: n, media: r, onCaptionExpandedChange: i, post: a, videoCoverPreview: o }) => {
	let s = r?.url || a.imageUrl || r?.thumbnailUrl || "", c = o || r?.thumbnailUrl || a.imageUrl || s, l = Sx({
		caption: a.caption,
		collapsedLines: Lb,
		defaultTop: Gb,
		expanded: t,
		gap: Kb,
		hasCaption: n,
		top: Wb
	});
	return /* @__PURE__ */ v(g, { children: [
		/* @__PURE__ */ _("div", {
			className: "sp-absolute sp-left-[-1px] sp-top-[79px] sp-h-[264px] sp-w-[400px] sp-overflow-hidden sp-bg-[#e6e6e6]",
			"data-uplift-media-frame-ratio": "400 / 264",
			children: /* @__PURE__ */ _(Q, {
				className: "sp-h-full sp-w-full",
				coverScope: "singlePostOnly",
				customVideoControls: !0,
				media: {
					...r || {},
					isVideo: !0,
					thumbnailUrl: c,
					url: s
				},
				platform: "GMB",
				surface: "video",
				videoCoverPreview: o
			})
		}),
		n ? /* @__PURE__ */ _(nx, {
			caption: a.caption,
			className: "sp-left-4 sp-top-[360px]",
			collapsedLines: Lb,
			expanded: t,
			onExpandedChange: i
		}) : null,
		/* @__PURE__ */ _(ux, {
			action: e,
			className: n ? "sp-top-[484px]" : "sp-top-[360px]",
			style: n ? { top: l } : void 0
		})
	] });
}, nx = ({ caption: e = "", className: t, collapsedLines: n, expanded: r, onExpandedChange: i }) => $(e) ? /* @__PURE__ */ _("div", {
	className: Ox("sp-absolute sp-w-[368px] sp-whitespace-pre-line sp-break-words sp-text-sm sp-font-normal sp-leading-5 sp-text-black [&_a]:sp-text-[#3771e0] [&_a]:sp-no-underline", t),
	children: /* @__PURE__ */ _(ix, {
		caption: e,
		collapsedLines: n,
		expanded: r,
		onExpandedChange: i
	})
}) : null, rx = ({ caption: e = "", className: t, collapsedLines: n, expanded: r, onExpandedChange: i }) => $(e) ? /* @__PURE__ */ _("div", {
	className: Ox("sp-w-full sp-whitespace-pre-line sp-break-words sp-text-sm sp-font-normal sp-leading-5 sp-text-black [&_a]:sp-text-[#3771e0] [&_a]:sp-no-underline", t),
	children: /* @__PURE__ */ _(ix, {
		caption: e,
		collapsedLines: n,
		expanded: r,
		onExpandedChange: i
	})
}) : null, ix = ({ caption: e, collapsedLines: t, expanded: n, onExpandedChange: r }) => {
	let i = wx(e) > t;
	return /* @__PURE__ */ v("div", {
		className: "sp-relative",
		children: [/* @__PURE__ */ _("div", {
			"aria-expanded": i ? n : void 0,
			className: Ox("sp-break-words sp-whitespace-pre-line", !n && i ? Ex(t) : void 0),
			children: /* @__PURE__ */ _(ax, { caption: e })
		}), i ? /* @__PURE__ */ _("button", {
			"aria-expanded": n,
			className: Ox(n ? "sp-inline" : "sp-absolute sp-bottom-0 sp-right-0 sp-inline", "sp-border-0 sp-bg-white sp-p-0 sp-pl-1 sp-text-left sp-font-inherit sp-leading-inherit sp-text-[#4d4d4d]"),
			onClick: () => r(!n),
			type: "button",
			children: n ? "Show less" : "...more"
		}) : null]
	});
}, ax = ({ caption: e }) => {
	if (!e) return null;
	let t = e.split(kx);
	return /* @__PURE__ */ _(g, { children: t.map((e, t) => e ? Ax.test(e) ? /* @__PURE__ */ _("a", {
		href: e,
		rel: "noreferrer",
		target: "_blank",
		children: e
	}, `${e}-${t}`) : e : null) });
}, ox = ({ event: e }) => /* @__PURE__ */ _("p", {
	className: "sp-m-0 sp-w-full sp-truncate sp-text-xl sp-font-medium sp-leading-7 sp-text-[#202125]",
	children: e?.title || "PINK NOSE DOG"
}), sx = ({ event: e }) => {
	let t = gx(e);
	return /* @__PURE__ */ _("p", {
		className: "sp-m-0 sp-mt-[10px] sp-w-full sp-truncate sp-text-sm sp-font-medium sp-leading-5 sp-text-[#70747a]",
		children: t
	});
}, cx = ({ media: e }) => {
	let t = e?.url || e?.thumbnailUrl || "";
	return /* @__PURE__ */ _("div", {
		className: "sp-ml-[-1px] sp-h-[264px] sp-w-[400px] sp-overflow-hidden sp-bg-[#e6e6e6]",
		"data-uplift-media-frame-ratio": "400 / 264",
		children: t ? /* @__PURE__ */ _(Q, {
			media: e,
			platform: "GMB",
			surface: "feed"
		}) : null
	});
}, lx = ({ className: e, media: t, surface: n = "feed" }) => {
	let r = t?.url || t?.thumbnailUrl || "";
	return /* @__PURE__ */ _("div", {
		className: Ox("sp-absolute sp-overflow-hidden sp-bg-[#e6e6e6]", e || "sp-left-0 sp-top-[80px] sp-h-[264px] sp-w-[400px]"),
		"data-uplift-media-frame-ratio": n === "carousel" ? "1 / 1" : "400 / 264",
		children: r ? /* @__PURE__ */ _(Q, {
			media: t,
			platform: "GMB",
			surface: n
		}) : null
	});
}, ux = ({ action: e, className: t, style: n }) => {
	if (!e) return null;
	let r = t?.includes("sp-static"), i = /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _(Nx, { icon: e.icon }), /* @__PURE__ */ _("span", {
		className: "sp-text-sm sp-font-medium sp-leading-5 sp-text-[#3771e0]",
		children: e.label
	})] }), a = Ox(r ? null : "sp-absolute sp-left-4", "sp-box-border sp-flex sp-h-10 sp-w-fit sp-items-center sp-gap-1 sp-rounded-[20px] sp-border sp-border-solid sp-border-[#c4c4c4] sp-px-4 sp-py-2 sp-text-[#3771e0] sp-no-underline", t || "sp-top-[484px]");
	return e.url ? /* @__PURE__ */ _("a", {
		className: a,
		href: e.url,
		rel: "noreferrer",
		style: n,
		target: "_blank",
		children: i
	}) : /* @__PURE__ */ _("div", {
		className: a,
		style: n,
		children: i
	});
}, dx = (e) => {
	let t = fx(e), n = px(e.callToAction), r = t.length > 0, i = t.some(Dx);
	if (!r && (e.type === "text" || e.type === "gmb")) return e.redirectUrl ? "gmb-link" : "gmb-text";
	if (i) return n ? n.actionType === "LEARN_MORE" ? "gmb-video-learn-more" : null : "gmb-video";
	if (t.length > 1) return n ? n.actionType === "BOOK" ? "gmb-carousel-book" : null : "gmb-carousel";
	if (!r) return null;
	if (!n) return "gmb-single-image";
	switch (n.actionType) {
		case "BOOK": return "gmb-single-image-book";
		case "LEARN_MORE": return "gmb-single-image-learn-more";
		case "SHOP": return "gmb-single-image-buy";
		case "SIGN_UP": return "gmb-single-image-sign-up";
		default: return "gmb-single-image";
	}
}, fx = (e) => (e.medias.collection.length ? e.medias.collection : e.imageUrl ? [{
	isVideo: e.type === "video",
	thumbnailUrl: e.imageUrl,
	url: e.imageUrl
}] : []).filter(Boolean), px = (e) => {
	if (!e || typeof e == "string") return null;
	switch (e.actionType) {
		case "BOOK": return {
			actionType: "BOOK",
			icon: "book",
			label: "Book",
			url: e.url
		};
		case "CALL": return {
			actionType: "CALL",
			icon: "info",
			label: "Call now",
			url: e.url
		};
		case "LEARN_MORE": return {
			actionType: "LEARN_MORE",
			icon: "info",
			label: "Learn more",
			url: e.url
		};
		case "ORDER": return {
			actionType: "ORDER",
			icon: "shopping-cart",
			label: "Order online",
			url: e.url
		};
		case "SHOP": return {
			actionType: "SHOP",
			icon: "shopping-cart",
			label: "Buy",
			url: e.url
		};
		case "SIGN_UP": return {
			actionType: "SIGN_UP",
			icon: "book",
			label: "Sign up",
			url: e.url
		};
		default: return null;
	}
}, mx = (e) => e && typeof e == "object" ? e : null, hx = (e) => !!(e && typeof e == "object" && e.title && e.startDate && e.endDate), gx = (e) => {
	if (!e?.startDate || !e?.endDate) return "";
	let t = new Date(e.startDate), n = new Date(e.endDate);
	return Number.isNaN(t.getTime()) || Number.isNaN(n.getTime()) ? "" : `${_x(t)}, ${vx(t)} - ${vx(n)}`;
}, _x = (e) => new Intl.DateTimeFormat("en-GB", {
	day: "2-digit",
	month: "short",
	timeZone: "UTC"
}).format(e), vx = (e) => new Intl.DateTimeFormat("en-US", {
	hour: "numeric",
	hour12: !0,
	minute: "2-digit",
	timeZone: "UTC"
}).format(e).toLowerCase(), yx = (e, t) => {
	if (!t) switch (e) {
		case "gmb-carousel":
		case "gmb-carousel-book": return "sp-h-[492px]";
		case "gmb-single-image":
		case "gmb-single-image-book":
		case "gmb-single-image-buy":
		case "gmb-single-image-learn-more":
		case "gmb-single-image-sign-up": return "sp-min-h-[416px]";
		case "gmb-link":
		case "gmb-text": return "sp-min-h-[88px]";
		default: return "sp-h-[416px]";
	}
	switch (e) {
		case "gmb-carousel":
		case "gmb-carousel-book": return "sp-h-[616px]";
		case "gmb-single-image":
		case "gmb-single-image-book":
		case "gmb-single-image-buy":
		case "gmb-single-image-learn-more":
		case "gmb-single-image-sign-up": return "sp-min-h-[416px]";
		case "gmb-link": return "sp-min-h-[252px]";
		case "gmb-text": return "sp-min-h-[192px]";
		default: return "sp-h-[540px]";
	}
}, bx = ({ action: e, caption: t, expanded: n, hasCaption: r, layout: i }) => {
	if (r) {
		if (i === "gmb-carousel" || i === "gmb-carousel-book") return { height: xx({
			action: e,
			bottomPadding: Ub,
			caption: t,
			collapsedLines: zb,
			defaultHeight: 616,
			expanded: n,
			gap: Hb,
			top: Bb
		}) };
		if (i === "gmb-video" || i === "gmb-video-learn-more") return { height: xx({
			action: e,
			bottomPadding: qb,
			caption: t,
			collapsedLines: Lb,
			defaultHeight: 540,
			expanded: n,
			gap: Kb,
			top: Wb
		}) };
	}
}, xx = ({ action: e, bottomPadding: t, caption: n, collapsedLines: r, defaultHeight: i, expanded: a, gap: o, top: s }) => {
	let c = s + Cx({
		caption: n,
		collapsedLines: r,
		expanded: a
	}) + o + (e ? Jb : 0) + t;
	return Math.max(i, c);
}, Sx = ({ caption: e, collapsedLines: t, defaultTop: n, expanded: r, gap: i, hasCaption: a, top: o }) => {
	if (!a) return n;
	let s = Cx({
		caption: e,
		collapsedLines: t,
		expanded: r
	});
	return Math.max(n, o + s + i);
}, Cx = ({ caption: e = "", collapsedLines: t, expanded: n }) => {
	let r = wx(e);
	return Math.min(n ? r : t, r) * Fb;
}, wx = (e) => {
	let t = e.trim();
	return t ? t.split(/\r?\n/).reduce((e, t) => {
		let n = Array.from(t).reduce((e, t) => e + Tx(t), 0);
		return e + Math.max(1, Math.ceil(n / Pb));
	}, 0) : 0;
}, Tx = (e) => jx.test(e) ? Ib : 1, Ex = (e) => e === Rb ? "sp-line-clamp-8" : e === zb ? "sp-line-clamp-4" : "sp-line-clamp-5", Dx = (e) => Z(e), Ox = (...e) => e.filter(Boolean).join(" "), kx = /(https?:\/\/[^\s]+)/g, Ax = /^https?:\/\/[^\s]+$/, jx = /[\u1100-\u11ff\u2e80-\u9fff\uf900-\ufaff\uac00-\ud7af]/u, Mx = ({ children: e, className: t = "sp-text-current", fill: n = "none", size: r = 24, viewBox: i = "0 0 24 24" }) => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	className: t,
	fill: n,
	height: r,
	viewBox: i,
	width: r,
	children: e
}), Nx = ({ icon: e }) => {
	switch (e) {
		case "book": return /* @__PURE__ */ _(Lx, {});
		case "shopping-cart": return /* @__PURE__ */ _(zx, {});
		default: return /* @__PURE__ */ _(Rx, {});
	}
}, Px = () => /* @__PURE__ */ v(Mx, {
	className: "sp-absolute -sp-bottom-1 -sp-right-1",
	fill: "none",
	size: 24,
	viewBox: "0 0 24 24",
	children: [/* @__PURE__ */ _("path", {
		d: "M12 2.5 5 5.6v5.7c0 4.4 2.8 8.4 7 9.9 4.2-1.5 7-5.5 7-9.9V5.6l-7-3.1Z",
		fill: "#3771e0"
	}), /* @__PURE__ */ _("path", {
		d: "m8.1 11.8 2.5 2.5 5.4-5.7",
		stroke: "#fff",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})]
}), Fx = () => /* @__PURE__ */ _(Mx, { children: /* @__PURE__ */ _("path", {
	d: "M12 4v10m0-10 3.5 3.5M12 4 8.5 7.5M5 11v8h14v-8",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "2"
}) }), Ix = () => /* @__PURE__ */ v(Mx, {
	fill: "currentColor",
	children: [
		/* @__PURE__ */ _("circle", {
			cx: "12",
			cy: "5",
			r: "1.8"
		}),
		/* @__PURE__ */ _("circle", {
			cx: "12",
			cy: "12",
			r: "1.8"
		}),
		/* @__PURE__ */ _("circle", {
			cx: "12",
			cy: "19",
			r: "1.8"
		})
	]
}), Lx = () => /* @__PURE__ */ _(Mx, { children: /* @__PURE__ */ _("path", {
	d: "M7 4h10v16l-5-3-5 3V4Z",
	stroke: "currentColor",
	strokeLinejoin: "round",
	strokeWidth: "2"
}) }), Rx = () => /* @__PURE__ */ v(Mx, { children: [/* @__PURE__ */ _("circle", {
	cx: "12",
	cy: "12",
	r: "9",
	stroke: "currentColor",
	strokeWidth: "2"
}), /* @__PURE__ */ _("path", {
	d: "M12 10v6m0-9h.01",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeWidth: "2"
})] }), zx = () => /* @__PURE__ */ _(Mx, { children: /* @__PURE__ */ _("path", {
	d: "M4 5h2l2 10h9.5l2-7H7m2 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: "2"
}) }), Bx = /* @__PURE__ */ new Set([
	"image",
	"multiMedia",
	"story",
	"video"
]), Vx = (e) => e.platform === "SC" && Bx.has(e.type) && !!qx(e), Hx = ({ post: e, className: t, videoCoverPreview: n }) => {
	let r = qx(e);
	return r ? /* @__PURE__ */ v("div", {
		className: ["sp-relative sp-mx-auto sp-h-[823px] sp-w-[400px] sp-overflow-hidden sp-rounded-t-[16px] sp-bg-[#1e1e1e] sp-font-sans sp-text-white sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)] sp-antialiased", t].filter(Boolean).join(" "),
		"data-preview-platform": "SC",
		"data-preview-variant": "uplift",
		"data-snapchat-media-count": e.medias.count,
		"data-uplift-layout": "snapchat-default",
		"data-uplift-renderer": "snapchat",
		children: [
			/* @__PURE__ */ v("div", {
				className: "sp-absolute sp-left-0 sp-top-0 sp-h-[704px] sp-w-full sp-overflow-hidden sp-bg-white",
				"data-uplift-media-frame-ratio": "400 / 704",
				children: [/* @__PURE__ */ _(Ux, {
					media: r,
					videoCoverPreview: n
				}), /* @__PURE__ */ _(Wx, { post: e })]
			}),
			/* @__PURE__ */ _("div", { className: "sp-absolute sp-left-[180.5px] sp-top-[712px] sp-h-[6px] sp-w-[39px] sp-rounded-lg sp-bg-[#717171]" }),
			/* @__PURE__ */ _(Gx, {})
		]
	}) : null;
}, Ux = ({ media: e, videoCoverPreview: t }) => /* @__PURE__ */ _(Q, {
	className: "sp-absolute sp-inset-0 sp-block sp-h-full sp-w-full sp-bg-[#f2f2f2] sp-object-cover",
	coverScope: "singlePostOnly",
	customVideoControls: Jx(e),
	media: e,
	platform: "SC",
	surface: "story",
	videoCoverPreview: t
}), Wx = ({ post: e }) => /* @__PURE__ */ v("header", {
	className: "sp-absolute sp-left-4 sp-top-4 sp-flex sp-w-[368px] sp-items-center sp-justify-between sp-text-white",
	children: [/* @__PURE__ */ v("div", {
		className: "sp-flex sp-min-w-0 sp-items-center sp-gap-2",
		children: [/* @__PURE__ */ _(X, {
			alt: e.username,
			className: "sp-h-10 sp-w-10 sp-shrink-0",
			src: e.profilePicture
		}), /* @__PURE__ */ v("div", {
			className: "sp-min-w-0",
			children: [/* @__PURE__ */ _("div", {
				className: "sp-truncate sp-text-base sp-font-semibold sp-leading-5",
				children: e.username
			}), /* @__PURE__ */ _("div", {
				className: "sp-text-xs sp-font-medium sp-leading-4 sp-text-white/80",
				children: "Just now"
			})]
		})]
	}), /* @__PURE__ */ v("div", {
		className: "sp-flex sp-shrink-0 sp-items-center sp-gap-4",
		children: [/* @__PURE__ */ _(Xx, {}), /* @__PURE__ */ _(Zx, {})]
	})]
}), Gx = () => /* @__PURE__ */ v("div", {
	className: "sp-absolute sp-left-0 sp-top-[726px] sp-box-border sp-flex sp-h-[50px] sp-w-full sp-items-start sp-gap-4 sp-px-2",
	children: [
		/* @__PURE__ */ _(Kx, {
			className: "sp-w-16",
			children: /* @__PURE__ */ _(Qx, {})
		}),
		/* @__PURE__ */ _("div", {
			className: "sp-flex sp-h-[50px] sp-min-w-0 sp-flex-1 sp-items-center sp-rounded-[40px] sp-bg-[#404040] sp-px-4 sp-text-base sp-font-semibold sp-leading-5",
			children: "Send a Chat"
		}),
		/* @__PURE__ */ _(Kx, {
			className: "sp-w-16",
			children: /* @__PURE__ */ _($x, {})
		})
	]
}), Kx = ({ children: e, className: t }) => /* @__PURE__ */ _("div", {
	className: ["sp-flex sp-h-[50px] sp-shrink-0 sp-items-center sp-justify-center sp-rounded-[40px] sp-bg-[#404040] sp-text-white", t].filter(Boolean).join(" "),
	children: e
}), qx = (e) => {
	let t = e.medias.collection[0];
	return t?.url || t?.thumbnailUrl ? t : e.imageUrl ? {
		isVideo: e.type === "video",
		thumbnailUrl: e.imageUrl,
		url: e.imageUrl
	} : null;
}, Jx = (e) => Z(e), Yx = ({ children: e, className: t = "sp-text-current", fill: n = "none", size: r = 24, viewBox: i = "0 0 24 24" }) => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	className: t,
	fill: n,
	height: r,
	viewBox: i,
	width: r,
	children: e
}), Xx = () => /* @__PURE__ */ v(Yx, {
	size: 24,
	children: [/* @__PURE__ */ _("path", {
		d: "M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	}), /* @__PURE__ */ _("path", {
		d: "M13.7 21a2 2 0 0 1-3.4 0",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})]
}), Zx = () => /* @__PURE__ */ v(Yx, {
	fill: "currentColor",
	size: 24,
	children: [
		/* @__PURE__ */ _("circle", {
			cx: "5",
			cy: "12",
			r: "2"
		}),
		/* @__PURE__ */ _("circle", {
			cx: "12",
			cy: "12",
			r: "2"
		}),
		/* @__PURE__ */ _("circle", {
			cx: "19",
			cy: "12",
			r: "2"
		})
	]
}), Qx = () => /* @__PURE__ */ v(Yx, {
	size: 32,
	viewBox: "0 0 32 32",
	children: [/* @__PURE__ */ _("path", {
		d: "M9.5 10 11 7h10l1.5 3H26a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h3.5Z",
		stroke: "currentColor",
		strokeLinejoin: "round",
		strokeWidth: "2.4"
	}), /* @__PURE__ */ _("circle", {
		cx: "16",
		cy: "17",
		r: "5",
		stroke: "currentColor",
		strokeWidth: "2.4"
	})]
}), $x = () => /* @__PURE__ */ _(Yx, {
	fill: "currentColor",
	size: 32,
	viewBox: "0 0 32 32",
	children: /* @__PURE__ */ _("path", { d: "M27.6 4.8 4.5 15.1c-1.8.8-1.6 3.5.3 4l8.1 2.1 2.1 8.1c.5 1.9 3.2 2.1 4 .3L29.2 6.4c.5-1.1-.5-2.1-1.6-1.6Zm-5.5 7.1-5.8 13.2-1.2-4.8 7-8.4Zm-8.4 7-4.8-1.2 13.2-5.8-8.4 7Z" })
}), eS = 48, tS = 3, nS = (e) => e.platform === "YT" && e.type === "video", rS = ({ post: e, className: t, videoCoverPreview: n }) => {
	let { medias: r, reportIntrinsicDimensions: i } = Cm([sS(e)]), a = r[0], o = $(e.caption), [s, c] = h(!1), l = dm({
		media: a,
		platform: "YT",
		surface: "video"
	});
	return /* @__PURE__ */ v("article", {
		className: ["sp-mx-auto sp-w-[400px] sp-min-w-[400px] sp-max-w-[400px] sp-overflow-hidden sp-rounded-lg sp-border sp-border-solid sp-border-[#e6e6e6] sp-bg-white sp-font-sans sp-text-black sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)] sp-antialiased", t].filter(Boolean).join(" "),
		"data-preview-platform": "YT",
		"data-preview-variant": "uplift",
		"data-uplift-layout": "youtube-video",
		"data-uplift-renderer": "youtube",
		children: [/* @__PURE__ */ _("div", {
			className: "sp-relative sp-w-full sp-overflow-hidden sp-bg-black",
			"data-uplift-media-frame-ratio": l.publishedRatio,
			style: { aspectRatio: l.publishedRatio },
			children: /* @__PURE__ */ _(Q, {
				className: "sp-h-full sp-w-full",
				coverScope: "singlePostOnly",
				media: a,
				onIntrinsicDimensions: i,
				platform: "YT",
				surface: "video",
				videoCoverPreview: n
			})
		}), /* @__PURE__ */ v("div", {
			className: "sp-flex sp-flex-col sp-gap-3 sp-p-4",
			children: [
				/* @__PURE__ */ _("div", {
					className: "sp-line-clamp-2 sp-text-lg sp-font-semibold sp-leading-6",
					children: e.ytTitle || "Untitled video"
				}),
				/* @__PURE__ */ v("div", {
					className: "sp-flex sp-items-center sp-gap-3",
					children: [/* @__PURE__ */ _(X, {
						alt: e.username,
						className: "sp-h-10 sp-w-10",
						src: e.profilePicture
					}), /* @__PURE__ */ v("div", {
						className: "sp-min-w-0",
						children: [/* @__PURE__ */ _("div", {
							className: "sp-truncate sp-text-sm sp-font-semibold sp-leading-5",
							children: e.username
						}), /* @__PURE__ */ _("div", {
							className: "sp-text-xs sp-leading-4 sp-text-[#606060]",
							children: "Just now"
						})]
					})]
				}),
				o ? /* @__PURE__ */ _(iS, {
					caption: e.caption,
					expanded: s,
					onExpandedChange: c
				}) : null,
				/* @__PURE__ */ _(aS, {})
			]
		})]
	});
}, iS = ({ caption: e, expanded: t, onExpandedChange: n }) => /* @__PURE__ */ _("div", {
	className: "sp-whitespace-pre-line sp-break-words sp-text-sm sp-leading-5 sp-text-[#333] [&_a]:sp-text-[#065fd4] [&_a]:sp-no-underline",
	children: /* @__PURE__ */ _(Ep, {
		buttonClassName: "sp-bg-white sp-pl-1 sp-text-[#606060] sp-cursor-pointer",
		caption: e,
		charsPerLine: eS,
		collapsedLines: tS,
		contentClassName: "sp-whitespace-pre-line",
		expanded: t,
		onExpandedChange: n,
		triggerLabel: "more"
	})
}), aS = () => /* @__PURE__ */ v("footer", {
	className: "sp-flex sp-items-center sp-justify-between sp-border-0 sp-border-t sp-border-solid sp-border-[#e6e6e6] sp-pt-3 sp-text-xs sp-font-medium sp-leading-none sp-text-[#606060]",
	children: [
		/* @__PURE__ */ _(oS, {
			icon: /* @__PURE__ */ _(lS, {}),
			label: "Like"
		}),
		/* @__PURE__ */ _(oS, {
			icon: /* @__PURE__ */ _(uS, {}),
			label: "Comment"
		}),
		/* @__PURE__ */ _(oS, {
			icon: /* @__PURE__ */ _(dS, {}),
			label: "Share"
		})
	]
}), oS = ({ icon: e, label: t }) => /* @__PURE__ */ v("span", {
	className: "sp-flex sp-items-center sp-gap-1.5",
	children: [e, t]
}), sS = (e) => e.medias.collection[0] || {
	isVideo: !0,
	thumbnailUrl: e.imageUrl,
	url: e.imageUrl
}, cS = ({ children: e }) => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	fill: "none",
	height: "18",
	viewBox: "0 0 24 24",
	width: "18",
	children: e
}), lS = () => /* @__PURE__ */ _(cS, { children: /* @__PURE__ */ _("path", {
	d: "M7 10v10H4a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1h3Zm0 0 4.6-6.2c.6-.8 1.9-.4 1.9.6V9h4.3a2 2 0 0 1 2 2.3l-1 6.5a2 2 0 0 1-2 1.7H7V10Z",
	stroke: "currentColor",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), uS = () => /* @__PURE__ */ _(cS, { children: /* @__PURE__ */ _("path", {
	d: "M5 5h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-7l-5 4v-4H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z",
	stroke: "currentColor",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}) }), dS = () => /* @__PURE__ */ v(cS, { children: [/* @__PURE__ */ _("path", {
	d: "M18 8 8 13l10 5V8Z",
	stroke: "currentColor",
	strokeLinejoin: "round",
	strokeWidth: "1.8"
}), /* @__PURE__ */ _("path", {
	d: "M8 13H3",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeWidth: "1.8"
})] }), fS = /* @__PURE__ */ new Set([
	"image",
	"multiMedia",
	"story",
	"text",
	"video"
]), pS = 44, mS = 4, hS = (e) => e.platform === "OT" && fS.has(e.type), gS = ({ post: e, className: t, videoCoverPreview: n }) => {
	let { medias: r, reportIntrinsicDimensions: i } = Cm(SS(e)), a = r[0], o = CS(e, a), s = $(e.caption), [c, l] = h(!1);
	return /* @__PURE__ */ v("article", {
		className: ["sp-mx-auto sp-w-full sp-min-w-[280px] sp-max-w-[400px] sp-overflow-hidden sp-rounded-lg sp-border sp-border-solid sp-border-[#e6e6e6] sp-bg-white sp-font-sans sp-text-black sp-shadow-[0_4px_8px_-2px_rgba(16,24,40,0.1),0_2px_4px_-2px_rgba(16,24,40,0.06)] sp-antialiased", t].filter(Boolean).join(" "),
		"data-preview-platform": "OT",
		"data-preview-variant": "uplift",
		"data-uplift-layout": o,
		"data-uplift-renderer": "other-notification",
		children: [
			/* @__PURE__ */ _(_S, { post: e }),
			s ? /* @__PURE__ */ _(vS, {
				caption: e.caption,
				expanded: c,
				onExpandedChange: l
			}) : null,
			a ? /* @__PURE__ */ _(yS, {
				medias: r,
				onIntrinsicDimensions: i,
				post: e,
				videoCoverPreview: n
			}) : null,
			e.redirectUrl && !a ? /* @__PURE__ */ _(bS, { url: e.redirectUrl }) : null,
			/* @__PURE__ */ _(xS, { hasRedirect: !!e.redirectUrl })
		]
	});
}, _S = ({ post: e }) => /* @__PURE__ */ v("header", {
	className: "sp-flex sp-items-center sp-gap-3 sp-p-4 sp-pb-0",
	children: [
		/* @__PURE__ */ _(X, {
			alt: e.username,
			className: "sp-h-10 sp-w-10 sp-shrink-0",
			src: e.profilePicture
		}),
		/* @__PURE__ */ v("div", {
			className: "sp-min-w-0 sp-flex-1",
			children: [/* @__PURE__ */ _("div", {
				className: "sp-truncate sp-text-base sp-font-semibold sp-leading-5",
				children: e.username
			}), /* @__PURE__ */ _("div", {
				className: "sp-text-sm sp-leading-5 sp-text-[#737373]",
				children: "Notification preview"
			})]
		}),
		/* @__PURE__ */ _(TS, {})
	]
}), vS = ({ caption: e, expanded: t, onExpandedChange: n }) => /* @__PURE__ */ _("div", {
	className: "sp-whitespace-pre-line sp-break-words sp-px-4 sp-pt-3 sp-text-base sp-leading-5 [&_a]:sp-text-[#1877f2] [&_a]:sp-no-underline",
	children: /* @__PURE__ */ _(Ep, {
		buttonClassName: "sp-bg-white sp-pl-1 sp-text-[#737373] sp-cursor-pointer",
		caption: e,
		charsPerLine: pS,
		collapsedLines: mS,
		contentClassName: "sp-whitespace-pre-line",
		expanded: t,
		onExpandedChange: n,
		renderCaption: ({ caption: e }) => /* @__PURE__ */ _(Y, { caption: e }),
		triggerLabel: "See more"
	})
}), yS = ({ medias: e, onIntrinsicDimensions: t, post: n, videoCoverPreview: r }) => {
	let i = e[0], a = e.length > 1, o = a ? "carousel" : n.type === "story" ? "story" : "feed", s = dm({
		media: i,
		platform: "OT",
		surface: Z(i) ? "video" : o
	}), c = (i, s, c) => {
		let l = Z(i), u = /* @__PURE__ */ _(Q, {
			className: "sp-h-full sp-w-full",
			coverScope: a ? "firstVideoOnly" : "singlePostOnly",
			isActive: c,
			media: i,
			mediaCount: e.length,
			mediaIndex: lm(e, s),
			measureWhenInactive: s === 0,
			onIntrinsicDimensions: t,
			platform: "OT",
			surface: l ? "video" : o,
			videoCoverPreview: l ? r : void 0
		});
		return n.redirectUrl ? /* @__PURE__ */ _("a", {
			className: "sp-block sp-h-full sp-w-full sp-text-inherit sp-no-underline",
			"data-other-notification-redirect": "true",
			href: n.redirectUrl,
			rel: "noreferrer",
			target: "_blank",
			children: u
		}) : u;
	};
	return /* @__PURE__ */ _("div", {
		className: "sp-mx-4 sp-mt-3",
		children: /* @__PURE__ */ _(Bp, {
			className: "sp-relative sp-w-full sp-rounded-lg",
			"data-uplift-media-frame-ratio": s.publishedRatio,
			style: { aspectRatio: s.publishedRatio },
			children: a ? /* @__PURE__ */ _(Ih, {
				ariaLabel: "Notification media carousel",
				arrowClassName: "sp-z-20",
				medias: e,
				renderSlide: (e, { index: t, isActive: n }) => c(e, t, n),
				showDots: !1
			}) : c(i, 0, !0)
		})
	});
}, bS = ({ url: e }) => /* @__PURE__ */ v("a", {
	className: "sp-mx-4 sp-mt-3 sp-flex sp-items-center sp-justify-between sp-rounded-lg sp-border sp-border-solid sp-border-[#d6d6d6] sp-px-3 sp-py-2 sp-text-sm sp-font-medium sp-leading-5 sp-text-[#1877f2] sp-no-underline",
	"data-other-notification-redirect": "true",
	href: e,
	rel: "noreferrer",
	target: "_blank",
	children: [/* @__PURE__ */ _("span", {
		className: "sp-truncate",
		children: wS(e)
	}), /* @__PURE__ */ _(ES, {})]
}), xS = ({ hasRedirect: e }) => /* @__PURE__ */ v("footer", {
	className: "sp-mt-4 sp-flex sp-items-center sp-justify-between sp-border-0 sp-border-t sp-border-solid sp-border-[#e6e6e6] sp-px-4 sp-py-3 sp-text-sm sp-font-medium sp-leading-none sp-text-[#737373]",
	children: [/* @__PURE__ */ _("span", { children: "Preview" }), e ? /* @__PURE__ */ _("span", { children: "Open link" }) : /* @__PURE__ */ _("span", { children: "Draft" })]
}), SS = (e) => e.type === "text" ? [] : e.medias.collection.length > 0 ? e.medias.collection : e.type === "image" || e.type === "video" ? [{
	isVideo: e.type === "video",
	thumbnailUrl: e.imageUrl,
	url: e.imageUrl
}] : [], CS = (e, t) => t ? e.type === "story" ? "other-notification-story-first-media" : e.type === "multiMedia" ? "other-notification-multimedia-first-media" : Z(t) ? "other-notification-video" : "other-notification-image" : "other-notification-text", wS = (e) => {
	try {
		return new URL(e).hostname.replace(/^www\./, "");
	} catch {
		return e;
	}
}, TS = () => /* @__PURE__ */ v("svg", {
	"aria-hidden": "true",
	className: "sp-h-6 sp-w-6 sp-text-[#737373]",
	fill: "currentColor",
	viewBox: "0 0 24 24",
	children: [
		/* @__PURE__ */ _("circle", {
			cx: "6",
			cy: "12",
			r: "1.5"
		}),
		/* @__PURE__ */ _("circle", {
			cx: "12",
			cy: "12",
			r: "1.5"
		}),
		/* @__PURE__ */ _("circle", {
			cx: "18",
			cy: "12",
			r: "1.5"
		})
	]
}), ES = () => /* @__PURE__ */ _("svg", {
	"aria-hidden": "true",
	className: "sp-h-4 sp-w-4 sp-shrink-0",
	fill: "none",
	viewBox: "0 0 24 24",
	children: /* @__PURE__ */ _("path", {
		d: "M10 5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-4m-7-9h7m0 0v7m0-7-9 9",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: "2"
	})
}), DS = (e) => {
	let t = Tp(e);
	return t ? OS(Tm(t)) !== null : !1;
}, OS = (e) => Um(e) ? "facebook" : Qh(e) ? "instagram" : Xg(e) ? "linkedin" : xv(e) ? "twitter" : Qv(e) ? "threads" : Iy(e) ? "pinterest" : ub(e) ? "tiktok" : Yb(e) ? "google-my-business" : Vx(e) ? "snapchat" : nS(e) ? "youtube" : hS(e) ? "other-notification" : null, kS = ({ post: e, trackEvent: t, className: n, videoCoverPreview: r, preferVideoCoverPreviewOverride: i }) => {
	let a = Tm(e), o = OS(a);
	return o === "facebook" ? /* @__PURE__ */ _(Wm, {
		post: a,
		className: n,
		trackEvent: t,
		videoCoverPreview: r
	}) : o === "instagram" ? /* @__PURE__ */ _($h, {
		post: a,
		className: n,
		trackEvent: t,
		videoCoverPreview: r
	}) : o === "linkedin" ? /* @__PURE__ */ _(Zg, {
		post: a,
		className: n,
		videoCoverPreview: r,
		preferVideoCoverPreviewOverride: i,
		trackEvent: t
	}) : o === "twitter" ? /* @__PURE__ */ _(Sv, {
		post: a,
		className: n,
		videoCoverPreview: r,
		trackEvent: t
	}) : o === "threads" ? /* @__PURE__ */ _($v, {
		post: a,
		className: n,
		trackEvent: t,
		videoCoverPreview: r
	}) : o === "pinterest" ? /* @__PURE__ */ _(Ly, {
		post: a,
		className: n,
		trackEvent: t,
		videoCoverPreview: r
	}) : o === "tiktok" ? /* @__PURE__ */ _(db, {
		post: a,
		className: n,
		trackEvent: t,
		videoCoverPreview: r
	}) : o === "google-my-business" ? /* @__PURE__ */ _(Xb, {
		post: a,
		className: n,
		trackEvent: t,
		videoCoverPreview: r
	}) : o === "snapchat" ? /* @__PURE__ */ _(Hx, {
		post: a,
		className: n,
		trackEvent: t,
		videoCoverPreview: r
	}) : o === "youtube" ? /* @__PURE__ */ _(rS, {
		post: a,
		className: n,
		trackEvent: t,
		videoCoverPreview: r
	}) : o === "other-notification" ? /* @__PURE__ */ _(gS, {
		post: a,
		className: n,
		trackEvent: t,
		videoCoverPreview: r
	}) : null;
}, AS = ({ post: e, trackEvent: t, className: n, env: r, videoCoverPreview: i, preferVideoCoverPreviewOverride: a, previewVariant: o = "legacy" }) => {
	let s = Tp(e);
	return /* @__PURE__ */ _(sp, {
		post: e || {},
		children: /* @__PURE__ */ _(jS, {
			post: s,
			trackEvent: t,
			className: n,
			videoCoverPreview: i,
			env: r,
			preferVideoCoverPreviewOverride: a,
			previewVariant: o,
			legacyContextPost: e
		}, e?.id)
	});
}, jS = ({ post: e, trackEvent: t, className: n, env: r, videoCoverPreview: i, preferVideoCoverPreviewOverride: a, previewVariant: o = "legacy", legacyContextPost: s }) => {
	if (e === null) throw Error("PreviewBuilder: null post, unknown platform");
	return dp(e) ? o === "uplift" ? kS({
		post: e,
		trackEvent: t,
		className: n,
		env: r,
		videoCoverPreview: i,
		preferVideoCoverPreviewOverride: a
	}) || /* @__PURE__ */ _(NS, { children: /* @__PURE__ */ _(wp, {
		className: n,
		copy: {
			title: "Post preview not available",
			message: "This post type is not available in the new preview yet."
		},
		post: e
	}) }) : /* @__PURE__ */ _(NS, { children: /* @__PURE__ */ _(Ks.Provider, {
		value: {
			post: s,
			className: n,
			env: r,
			videoCoverPreview: i,
			preferVideoCoverPreviewOverride: a,
			previewVariant: o
		},
		children: /* @__PURE__ */ _(MS, {
			post: e,
			trackEvent: t,
			className: n,
			env: r,
			videoCoverPreview: i
		})
	}) }) : /* @__PURE__ */ _(NS, { children: /* @__PURE__ */ _(wp, {
		className: n,
		post: e
	}) });
}, MS = ({ post: e, trackEvent: t, className: n, env: r, videoCoverPreview: i }) => {
	if (e === null) throw Error("PreviewBuilder: null post, unknown platform");
	let a = e.platform;
	switch (a) {
		case "IG": return /* @__PURE__ */ _(Fl, {
			post: e,
			className: n,
			env: r
		});
		case "FB": return /* @__PURE__ */ _(nu, { post: e });
		case "TW": return /* @__PURE__ */ _(gu, { post: e });
		case "LI": return /* @__PURE__ */ _(Vu, {
			post: e,
			trackEvent: t
		});
		case "GMB": return /* @__PURE__ */ _(rd, { post: e });
		case "YT": return /* @__PURE__ */ _(fd, { post: e });
		case "PI": return /* @__PURE__ */ _(Ed, { post: e });
		case "SC": return /* @__PURE__ */ _(Xd, { post: e });
		case "TT": return /* @__PURE__ */ _(Nf, {
			post: e,
			env: r,
			videoCoverPreview: i
		});
		case "TH": return /* @__PURE__ */ _(qf, { post: e });
		case "OT": return /* @__PURE__ */ _(op, { post: e });
		default: throw Error(`PreviewBuilder: unknown platform ${a}`);
	}
}, NS = N.div`
  font-family:
    "Gotham SSm A", "Gotham SSm B", "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`, PS = /^https?:\/\/sked-customer-uploads\.s3(\.[a-z0-9-]+)?\.amazonaws\.com\/(.+)$/, FS = "https://s3.amazonaws.com/sked-customer-uploads", IS = "https://customer-uploads.skedsocial.com";
function LS(e) {
	return !e || typeof e != "string" ? e : PS.test(e) ? e.replace(PS, "https://customer-uploads.skedsocial.com/$2") : e.startsWith(FS) ? e.replace(FS, IS) : e;
}
//#endregion
//#region lib/models/MediasModel.js
var RS = class {
	constructor(e) {
		this.medias = [e], e.mediaFiles && e.mediaFiles.length > 0 && (this.medias = e.mediaFiles.map((t, n) => n !== 0 || !e.thumbnailUrl || !BS(t) || !VS(e) ? t : {
			...t,
			thumbnailUrl: e.thumbnailUrl
		})), this.collection = this.buildCollection(this.medias), this.count = this.collection.length;
	}
	buildCollection(e) {
		return e.flatMap((e) => {
			let t = zS(e);
			if (!t) return [];
			let n = (t.toLowerCase().endsWith(".heic") || t.toLowerCase().endsWith(".heif")) && e.thumbnailUrl ? e.thumbnailUrl : t;
			return [{
				thumbnailUrl: LS(e.thumbnailUrl),
				fileName: e.fileName,
				pages: e.meta?.pages ?? e.pages,
				width: e.meta?.width ?? e.width,
				height: e.meta?.height ?? e.height,
				url: LS(n),
				type: e.type,
				isVideo: e.isVideo
			}];
		});
	}
};
function zS(e) {
	return e ? BS(e) ? e.url || e.originalUrl || "" : e.url || e.originalUrl || e.thumbnailUrl || "" : "";
}
function BS(e) {
	return e?.isVideo === !0;
}
function VS(e) {
	return e?.platform === "LI" || e?.platformType === "LI" || e?.platforms?.[0]?.platformType === "LI";
}
//#endregion
//#region lib/models/PostModel.js
var HS = class {
	constructor(e, t, n, r) {
		this.providedPost = e, this.id = e.post_id, this.stage = e.post_stage, this.caption = e.caption, this.currentStatusKey = e.post_status_key, this.rejectionReason = "", this.scheduledFor = e.when, this.image_url = LS(e.url), this.comment = e.firstcomment || e.first_comment, this.locationName = e.location && e.location.name, this.redirectUrl = e.redirectUrl ? e.redirectUrl : "", this.storyUrl = e.storyUrl ? e.storyUrl : "", this.storyLabel = e.storyLabel ? e.storyLabel : "", this.storyStickerHeight = e.storyStickerHeight ? e.storyStickerHeight : null, this.medias = new RS(e), this.callToAction = e.gmbCallToAction ? e.gmbCallToAction : "", this.event = e.gmbEvent ? e.gmbEvent : "", this.topicType = e.gmbTopicType ? e.gmbTopicType : null, this.offer = e.gmbOffer ? {
			...e.gmbOffer,
			redeemOnlineUrl: e.gmbOffer.redeemOnlineUrl || e.redirectUrl
		} : null, this.platform = e.platform, this.type = e.type, this.storyType = e.storyType || null, this.ytTitle = e.ytTitle || null, this.ytCategoryId = e.ytCategoryId || null, this.ytTags = e.ytTags || "", t && t.username ? (this.username = t.username, this.profilePicture = t.profile_picture_url, this.followedBy = t.followed_by) : e.username || e.profilePicture ? (this.username = e.username, this.profilePicture = e.profilePicture, this.followedBy = e.followed_by) : (this.username = "Failed to find account", this.profilePicture = "https://picsum.photos/id/1/200/200", this.followedBy = null), this.approvedKey = n, this.rejectedKey = r;
		let i = null, a = null;
		if (e.piBoards && e.piBoards.length > 0 && t.boards && t.boards.length > 0) {
			let n = t.boards.find((t) => t.id === e.piBoards[0]);
			if (n && (i = n.name, n.sections && n.sections.length > 0 && e.piSectionId)) {
				let t = n.sections.find((t) => t.id === e.piSectionId);
				t && (a = t.title);
			}
		}
		this.boardTitle = i || null, this.boardSectionTitle = a || null, this.piTitle = e.piTitle || null, this.postOptions = e.postOptions || null;
	}
	get status() {
		switch (this.currentStatusKey) {
			case this.approvedKey: return "approved";
			case this.rejectedKey: return "rejected";
			default: return "initial";
		}
	}
	approve() {
		this.currentStatusKey = this.approvedKey;
	}
	reject(e) {
		this.currentStatusKey = this.rejectedKey, this.rejectionReason = e;
	}
}, US = class {
	constructor(e, t) {
		let n = e.schedule ? e.schedule : e;
		this.providedPost = n, this.id = n._id, this.stage = "draft", n.scheduledFor ? this.stage = "scheduled" : n.queued && (this.stage = "queued"), this.caption = n.caption || "", this.currentStatusKey = n.normalizedPost_status_key, this.rejectionReason = "", this.scheduledFor = n.when, this.image_url = LS(n.url), this.comment = n.firstcomment || n.first_comment || "", this.locationName = n.location && n.location.name, this.redirectUrl = n.redirectUrl ? n.redirectUrl : "", this.storyUrl = n.storyUrl ? n.storyUrl : "", this.storyLabel = n.storyLabel ? n.storyLabel : "", this.storyStickerHeight = n.storyStickerHeight ? n.storyStickerHeight : null, this.callToAction = n.gmbCallToAction ? n.gmbCallToAction : "", this.event = n.gmbEvent ? n.gmbEvent : "", this.topicType = n.gmbTopicType ? n.gmbTopicType : null, this.offer = n.gmbOffer ? {
			...n.gmbOffer,
			redeemOnlineUrl: n.gmbOffer.redeemOnlineUrl || n.redirectUrl
		} : null, this.medias = new RS(n), this.platform = n.platformType || "IG", n.platforms && n.platforms.length > 0 && (this.platform = n.platforms[0].platformType), this.type = n.type, this.storyType = n.storyType || null, this.username = t.login, this.profilePicture = t.profilePictureUrl || "", this.followedBy = t.followed_by, this.ytTitle = n.ytTitle || null, this.ytCategoryId = n.ytCategoryId || null, this.ytTags = n.ytTags || "";
		let r = "", i = null;
		if (n.piBoards && n.piBoards.length > 0 && t.boards && t.boards.length > 0) {
			let e = t.boards.find((e) => e.id === n.piBoards[0]);
			if (e && (r = e.name, e.sections && e.sections.length > 0 && n.piSectionId)) {
				let t = e.sections.find((e) => e.id === n.piSectionId);
				t && (i = t.title);
			}
		}
		this.boardTitle = r || null, this.boardSectionTitle = i || null, this.piTitle = n.piTitle || null, this.postOptions = n.postOptions || null;
	}
};
//#endregion
export { lp as POST_PREVIEW_PLATFORM_NAMES, cp as POST_PREVIEW_SUPPORTED_TYPES_BY_PLATFORM, HS as PostModel, Y as RenderSkedCaption, ys as SkedCaptionPreview, US as SkedCorePostModel, AS as SkedPreview, DS as canRenderUpliftPreview, rm as canSelectVideoCoverForSelection, em as canSelectVideoCoverFrame, tm as canUploadVideoCover, im as canUploadVideoCoverForSelection, Zp as frameSelectVideoCoverPlatforms, pp as getEffectivePreviewPostType, up as getPostPreviewSupport, nm as getSelectableVideoCoverPlatforms, fp as getUnsupportedPostPreviewCopy, mp as hasDocumentMedia, hp as isDocumentPreviewMedia, dp as isPostPreviewSupported, am as isVideoCoverSelectorEligible, $p as normalizeVideoCoverPlatform, om as shouldGateVideoCoverPlayback, Qp as uploadVideoCoverPlatforms };

//# sourceMappingURL=sked-preview.es.js.map